(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode('.mobile[data-v-cfcaf47a]{background-color:#f1f1f1;min-height:100%;color:#333}@media screen and (min-width: 990px){.mobile[data-v-cfcaf47a]{position:relative;width:375px;margin:0 auto;overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch}}.advert[data-v-9dfdbba5]{position:relative;min-height:32px;background-color:#f6bb57;color:#fff;font-size:14px;line-height:32px;text-align:center;z-index:2;display:flex;align-items:center;justify-content:center;font-weight:700}.advertImage[data-v-9dfdbba5]{width:100%}.advertText[data-v-9dfdbba5]{position:absolute;left:0;right:0;top:0}.commodityList[data-v-9dfdbba5]{display:flex;justify-content:space-between;flex-wrap:wrap;padding:6px 6px 0}.commodity[data-v-9dfdbba5]{text-align:center;background-color:#fff;margin:6px;width:calc(50% - 12px)}.cover[data-v-9dfdbba5]{width:100%}.name[data-v-9dfdbba5]{font-size:14px;color:#333}@keyframes showDialog-91db3af7{form{bottom:-500px}to{bottom:0}}@keyframes hideDialog-91db3af7{form{bottom:0}to{bottom:-500px}}.dialog[data-v-91db3af7]{position:fixed;left:0;right:0;top:0;height:100dvh;background-color:#00000080;overflow:hidden;z-index:1000}@media screen and (min-width: 990px){.dialog[data-v-91db3af7]{position:absolute;height:667px}}.dialog.hidden[data-v-91db3af7]{display:none}.content[data-v-91db3af7]{position:absolute;left:0;right:0;bottom:0;padding:12px;background-color:#fff;border-radius:14px 14px 0 0}.content.show[data-v-91db3af7]{bottom:-500px;animation:showDialog-91db3af7 .5s linear normal forwards}.content.hide[data-v-91db3af7]{bottom:0;animation:hideDialog-91db3af7 .5s linear normal forwards}.scrollCrosswise[data-v-aec3bafe]{width:100%;height:60px;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch}.scroll[data-v-aec3bafe]::-webkit-scrollbar{width:4px;height:4px}.scroll[data-v-aec3bafe]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:inset 0 0 5px #0003;background:#f0f0f0}.scrollLengthways[data-v-aec3bafe]{width:100%;height:204px;overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch}.resources[data-v-aec3bafe]{white-space:nowrap}.resource[data-v-aec3bafe]{display:inline-block;width:40px;height:50px;margin-right:20px}.resourceItems[data-v-aec3bafe]{display:flex;justify-content:space-around;flex-wrap:wrap}.resourceItem[data-v-aec3bafe]{display:inline-block;width:64px;height:64px;margin:10px;background-color:#f7f7f7}.cover[data-v-aec3bafe]{width:100%;height:100%;cursor:pointer}.close[data-v-aec3bafe]{position:absolute;right:0;top:0;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/close.png);background-repeat:no-repeat;background-position:center;background-size:28px 28px;cursor:pointer}.scrollCrosswise[data-v-c0298e46]{width:100%;height:60px;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch}.scroll[data-v-c0298e46]::-webkit-scrollbar{width:4px;height:4px}.scroll[data-v-c0298e46]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:inset 0 0 5px #0003;background:#f0f0f0}.scrollLengthways[data-v-c0298e46]{padding-top:25px;width:100%;height:50dvh;overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch}.resources[data-v-c0298e46]{white-space:nowrap}.resource[data-v-c0298e46]{display:inline-block;width:40px;height:50px;margin-right:20px}.resourceItems[data-v-c0298e46]{display:flex;justify-content:space-around;flex-wrap:wrap}.resourceItem[data-v-c0298e46]{display:inline-block;width:64px;height:64px;margin:10px;background-color:#f7f7f7}.cover[data-v-c0298e46]{width:100%;height:100%;cursor:pointer}.close[data-v-c0298e46]{position:absolute;right:0;top:0;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/close.png);background-repeat:no-repeat;background-position:center;background-size:28px 28px;cursor:pointer}.scroll[data-v-125cc2df]{width:100%;max-height:480px;overflow-y:auto;-webkit-overflow-scrolling:touch}.scroll[data-v-125cc2df]::-webkit-scrollbar{width:4px;height:4px}.scroll[data-v-125cc2df]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:inset 0 0 5px #0003;background:#f0f0f0}.title[data-v-125cc2df]{font-size:14px;line-height:24px;padding:10px 0;font-weight:700}.blocks[data-v-125cc2df]{display:flex;justify-content:flex-start;flex-wrap:wrap}.block[data-v-125cc2df]{padding:4px 8px;margin-right:8px;margin-bottom:8px;background-color:#f8f8f8;border:2px solid transparent;cursor:pointer;border-radius:4px;font-size:12px}.block.current[data-v-125cc2df]{border-color:#8fbfff}.colors[data-v-125cc2df]{display:flex;justify-content:flex-start;flex-wrap:wrap}.color[data-v-125cc2df]{width:48px;height:32px;margin-right:8px;margin-bottom:8px;border:2px solid transparent;cursor:pointer;border-radius:16px}.color.current[data-v-125cc2df]{border-color:#8fbfff}.images[data-v-125cc2df]{white-space:nowrap}.image[data-v-125cc2df]{width:52px;height:70px;margin-right:8px;background-color:#f8f8f8;border:2px solid transparent;display:inline-block;border-radius:4px;cursor:pointer}.image.current[data-v-125cc2df]{border-color:#8fbfff}.image img[data-v-125cc2df]{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.scrollCrosswise[data-v-125cc2df]{width:100%;height:90px;overflow-x:auto;-webkit-overflow-scrolling:touch}.scrollCrosswise[data-v-125cc2df]::-webkit-scrollbar{width:4px;height:4px}.scrollCrosswise[data-v-125cc2df]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:inset 0 0 5px #0003;background:#f0f0f0}.select[data-v-125cc2df]{border:1px solid rgba(26,22,24);border-radius:2px;position:relative;min-width:60%;display:inline-block}.select select[data-v-125cc2df]{padding:8px 24px 8px 12px;width:100%;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;color:#333}.select select[data-v-125cc2df]:focus,.select select[data-v-125cc2df]:active{border:1px solid #333;color:#333}.select .down[data-v-125cc2df]{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:8px}.originPrice[data-v-125cc2df],.price[data-v-125cc2df]{margin-right:12px}.footer[data-v-125cc2df]{padding:12px 0 24px;background-color:#fff}.next[data-v-125cc2df]{background-color:#000;color:#fff;font-size:18px;height:46px;line-height:46px;border-radius:4px;text-align:center;cursor:pointer}.scroll[data-v-05d76919]{width:100%;height:204px;overflow-y:auto;-webkit-overflow-scrolling:touch}.scroll[data-v-05d76919]::-webkit-scrollbar{width:4px;height:4px}.scroll[data-v-05d76919]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:inset 0 0 5px #0003;background:#f0f0f0}.input[data-v-05d76919]{padding:8px}.input input[data-v-05d76919]{padding:6px 4px;border:none;height:32px;resize:none;font-size:14px}.switch[data-v-05d76919]{display:flex;justify-content:flex-start}.switchItem[data-v-05d76919]{padding:6px 10px;font-size:20px;font-weight:700;color:#d3d3d3;cursor:pointer}.switchItem.current[data-v-05d76919]{color:#000}.fonts[data-v-05d76919]{display:flex;justify-content:space-around;flex-wrap:wrap}.font[data-v-05d76919]{display:inline-block;width:60px;height:60px;margin:10px;background-color:#f7f7f7;border:2px solid #f7f7f7}.font.current[data-v-05d76919]{border-color:#8fbfff}.cover[data-v-05d76919]{width:100%;height:100%;cursor:pointer}.form[data-v-05d76919]{width:100%;height:204px;padding-top:10px}.colorScroll[data-v-05d76919]{width:100%;height:44px;overflow-y:auto;-webkit-overflow-scrolling:touch}.colorScroll[data-v-05d76919]::-webkit-scrollbar{width:4px;height:4px}.colorScroll[data-v-05d76919]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:inset 0 0 5px #0003;background:#f0f0f0}.colors[data-v-05d76919]{white-space:nowrap;padding:0 10px}.color[data-v-05d76919]{width:30px;height:30px;border:2px solid rgb(150,150,150);border-radius:17px;margin-right:16px;display:inline-block;cursor:pointer}.color.current[data-v-05d76919]{border-color:#8fbfff}.fontStyles[data-v-05d76919]{display:flex;justify-content:flex-start;padding:12px 10px}.fontStyle[data-v-05d76919]{width:30px;height:30px;margin-right:16px}.close[data-v-05d76919]{position:absolute;right:0;top:0;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/sure.png);background-repeat:no-repeat;background-position:center;background-size:28px 28px;cursor:pointer}.hidden[data-v-05d76919]{display:none}.viewCanvas[data-v-822caee2]{display:inline-block;overflow:hidden}.canvasPanel[data-v-822caee2]{transform-origin:0 0;overflow:hidden}.header[data-v-78a4362e]{font-size:16px;text-align:center;font-weight:700;padding:8px}.mobile[data-v-78a4362e]{text-align:center;position:relative}.describes[data-v-78a4362e]{position:absolute;right:0;top:12px}.describes .describe[data-v-78a4362e]{margin:4px 0}.describes img[data-v-78a4362e]{width:64px;height:64px;-o-object-fit:cover;object-fit:cover;cursor:pointer}.submit[data-v-78a4362e]{padding:12px;margin:16px 16px 24px;background-color:#000;color:#fff;text-align:center;border-radius:24px;cursor:pointer}.submit.isSubmit[data-v-78a4362e]{opacity:.5}.close[data-v-78a4362e]{position:absolute;right:16px;top:16px;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/close.png);background-position:center;background-size:32px 32px;background-repeat:no-repeat;cursor:pointer}.priviewCover[data-v-78a4362e]{position:absolute;left:0;right:0;top:0;bottom:0;background-color:#0000004d;z-index:1000}.priviewCover img[data-v-78a4362e]{width:80%;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.tools[data-v-ffb7298c]{position:absolute;right:0;bottom:170px;width:60px}.tool[data-v-ffb7298c]{width:100%;text-align:center;font-size:12px;cursor:pointer;display:flex;flex-direction:column;align-items:center}.icon[data-v-ffb7298c]{width:30px}.tool.portfolio[data-v-ffb7298c]{margin-bottom:20px}.tool.portfolio .icon[data-v-ffb7298c]{width:30px}.layers[data-v-ffb7298c]{position:fixed;right:58px;bottom:136px;background-color:#00000080;width:84px;padding:8px 0 4px 8px;max-height:252px;overflow-y:auto;-webkit-overflow-scrolling:touch}.layers[data-v-ffb7298c]::-webkit-scrollbar{width:4px;height:4px}.layers[data-v-ffb7298c]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:inset 0 0 5px #0003;background:#f0f0f0}.layer[data-v-ffb7298c]{width:66px;max-height:66px;margin-bottom:4px;background-color:#fff;cursor:pointer;border:1px solid #ffffff;text-align:center;overflow:hidden}.layer.current[data-v-ffb7298c]{border-color:#0ff}.cover[data-v-ffb7298c]{width:66px;height:66px;-o-object-fit:contain;object-fit:contain}.dialog[data-v-0e27394e]{position:fixed;left:0;right:0;top:calc(var(--vh) * 100);transform:translateY(-100%);padding:16px;background-color:#fff;z-index:110}.title[data-v-0e27394e]{text-align:center;font-size:20px;font-weight:700;padding-bottom:12px}.close[data-v-0e27394e]{position:absolute;right:16px;top:16px;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/close.png);background-position:center;background-size:32px 32px;background-repeat:no-repeat;cursor:pointer}.tools[data-v-0e27394e]{display:flex;justify-content:space-around}.tool[data-v-0e27394e]{text-align:center;cursor:pointer}.cover[data-v-0e27394e]{width:30px;height:30px}.dialog[data-v-3c767dd6]{position:fixed;left:0;right:0;top:calc(var(--vh) * 100);transform:translateY(-100%);padding:16px;background-color:#fff;z-index:110}.title[data-v-3c767dd6]{text-align:center;font-size:20px;font-weight:700;padding-bottom:12px}.close[data-v-3c767dd6]{position:absolute;right:16px;top:16px;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/close.png);background-position:center;background-size:32px 32px;background-repeat:no-repeat;cursor:pointer}.tools[data-v-3c767dd6]{display:flex;justify-content:space-around}.tool[data-v-3c767dd6]{text-align:center;cursor:pointer}.cover[data-v-3c767dd6]{width:30px;height:30px}.dialog[data-v-5ba9ec91]{position:fixed;left:0;right:0;top:calc(var(--vh) * 100);transform:translateY(-100%);padding:16px;background-color:#fff;z-index:110}.title[data-v-5ba9ec91]{text-align:center;font-size:20px;font-weight:700;padding-bottom:12px}.close[data-v-5ba9ec91]{position:absolute;right:16px;top:16px;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/close.png);background-position:center;background-size:32px 32px;background-repeat:no-repeat;cursor:pointer}.tools[data-v-5ba9ec91]{display:flex;justify-content:space-around}.tool[data-v-5ba9ec91]{text-align:center;cursor:pointer}.cover[data-v-5ba9ec91]{width:30px;height:30px}.navigates[data-v-114b478c]{position:fixed;left:0;right:0;top:calc(var(--vh) * 100);transform:translateY(-100%);background-color:#fff;display:flex;justify-content:space-around;padding:10px 0;z-index:100}@media screen and (min-width: 990px){.navigates[data-v-114b478c]{position:absolute}}.navigate[data-v-114b478c]{font-size:12px;color:#5c5c66;cursor:pointer;position:relative;text-align:center;display:flex;flex-direction:column;justify-content:center;align-items:center}.navigate .upload-btn[data-v-114b478c]{position:absolute;left:0;top:0;width:100%;height:100%;opacity:0}.navigate img[data-v-114b478c]{width:32px;height:32px}.canvasPrint[data-v-9b61dc3d]{display:none}.layers[data-v-d50059e2]{position:absolute;left:0;top:0;transform-origin:0 0}.layer[data-v-d50059e2]{position:absolute;cursor:pointer}.layer .border-item[data-v-d50059e2]{position:absolute;left:0;top:0;transform-origin:0 0}.layer.current .border-item[data-v-d50059e2]{outline:1px solid #e5e5e5}.panel[data-v-d50059e2]{position:relative;width:100%;height:100%;cursor:move}.delete[data-v-d50059e2]{width:32px;height:32px;border-radius:60px;border:1px solid #333333;background-size:25px 25px;background-position:center;background-color:#fff;background-repeat:no-repeat;position:absolute;left:0;top:0;cursor:pointer;transform-origin:left top}.copy[data-v-d50059e2]{width:32px;height:32px;border-radius:60px;border:1px solid #333333;background-size:22px 22px;background-position:center;background-color:#fff;background-repeat:no-repeat;position:absolute;left:0;bottom:0;cursor:pointer;transform-origin:left bottom}.replace[data-v-d50059e2]{width:32px;height:32px;border-radius:60px;border:1px solid #333333;background-size:27px 27px;background-position:center;background-color:#fff;background-repeat:no-repeat;position:absolute;right:0;top:0;cursor:pointer;transform-origin:right top}.scale[data-v-d50059e2]{width:32px;height:32px;border-radius:60px;border:1px solid #333333;background-size:20px 20px;background-position:center;background-color:#fff;background-repeat:no-repeat;position:absolute;right:0;bottom:0;cursor:pointer;transform-origin:right bottom}.rotate[data-v-d50059e2]{width:32px;height:32px;border-radius:60px;border:1px solid #333333;background-size:26px 26px;background-position:center;background-color:#fff;background-repeat:no-repeat;position:absolute;cursor:pointer}.panel[data-v-39e1603c]{width:100%;height:100dvh;position:relative;overflow:hidden}.mobile[data-v-39e1603c]{position:absolute;left:50%;top:50%;transform:translate(-50%,-55%)}@media screen and (min-width: 990px){.panel[data-v-39e1603c]{height:667px}}.loadingPanel[data-v-ba39abaf]{position:fixed;left:0;right:0;top:0;bottom:0;z-index:1000}.loading[data-v-ba39abaf]{width:28px;height:28px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/loading.gif);background-size:100% 100%;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.loadingPanel.hidden[data-v-ba39abaf]{display:none}.selector[data-v-1fd495c0]{padding:0 15px;display:inline-block;cursor:pointer;position:relative;position:absolute;left:0;z-index:100;width:100%;bottom:80px}.selector .selector-main[data-v-1fd495c0]{padding:6px 40px 6px 20px;border:1px solid #e5e5e5;border-radius:32px;background:#ffffff80;text-align:center}.selector .selector-main[data-v-1fd495c0]:after{content:"";width:16px;height:16px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/down.png);background-size:100% 100%;position:absolute;right:20px;top:50%;transform:translate(-12px,-50%)}.workbench-header[data-v-1fd495c0]{padding:10px 10px 0;position:absolute;top:0;left:0;width:100%;display:flex;justify-content:space-between;align-items:center;z-index:100}.workbench-header .logo[data-v-1fd495c0]{height:23px}.home[data-v-1fd495c0]{padding-left:10px;width:99.39px;cursor:pointer}.home img[data-v-1fd495c0]{width:36px;height:36px}.preview[data-v-1fd495c0]{padding:6px 24px;background-color:#000;color:#fff;cursor:pointer;border-radius:18px;z-index:100}.advert[data-v-2944ad6a]{position:fixed;left:0;right:0;top:0;min-height:32px;background-color:#f6bb57;color:#fff;font-size:14px;line-height:32px;text-align:center;z-index:100;display:flex;align-items:center;justify-content:center;font-weight:700}.advertImage[data-v-2944ad6a]{width:100%}.advertText[data-v-2944ad6a]{position:absolute;left:0;right:0;top:0}.header[data-v-2944ad6a]{position:relative;background-color:#2128be;font-size:24px;font-weight:600!important;color:#fff;padding:10px 12px;display:flex;justify-content:space-between;align-items:center}.header .right-btns[data-v-2944ad6a]{display:flex;align-items:center;gap:10px}.home[data-v-2944ad6a]{width:36px;height:36px;background-size:90% 90%;background-repeat:no-repeat;background-position:center;cursor:pointer}.shop[data-v-2944ad6a]{width:32px;height:32px;background-size:100% 100%;cursor:pointer}.apply[data-v-2944ad6a]{padding:4px 12px;background-color:#f6bb57;color:#fff;border-radius:16px;display:inline-block;font-size:14px;margin-bottom:8px;font-weight:700;cursor:pointer}.page[data-v-2944ad6a]{width:100%;height:100%;overflow-y:auto}.diyDesignList[data-v-2944ad6a]{padding:8px;background-color:#f2f2f2}.design[data-v-2944ad6a]{margin-bottom:12px;background-color:#fff;border-radius:8px;padding:8px 8px 8px 120px;height:120px;position:relative;color:#333}.cover[data-v-2944ad6a]{position:absolute;left:12px;top:8px;width:105px;height:105px}.checkbox[data-v-2944ad6a]{position:absolute;left:8px;top:50%;transform:translateY(-50%)}.price[data-v-2944ad6a]{position:absolute;right:8px;top:8px;color:#000;font-weight:bolder}.title[data-v-2944ad6a]{color:#000;font-weight:700;font-size:16px}.desc[data-v-2944ad6a]{font-size:12px;color:#6b6b6b;font-weight:700;line-height:16px;height:32px;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis}.quantity[data-v-2944ad6a]{position:relative;display:inline-block;padding:0 24px;height:24px;width:84px;border:1px solid #333333;color:#333;border-radius:2px;text-align:center;margin-top:4px}.quantitySub[data-v-2944ad6a]{position:absolute;left:0;top:0;width:24px;height:24px;line-height:18px;cursor:pointer}.quantityAdd[data-v-2944ad6a]{position:absolute;right:0;top:0;width:24px;height:24px;line-height:18px;cursor:pointer}.quantityNumber[data-v-2944ad6a]{position:absolute;left:24px;top:0;width:36px;height:22px;color:#333;font-size:14px;text-align:center;border:none}.quantityNumber[data-v-2944ad6a]:focus-visible{outline:none}.share[data-v-2944ad6a]{position:absolute;left:120px;bottom:8px;width:35px;height:35px;background-size:80% 80%;background-repeat:no-repeat;background-position:center;cursor:pointer}.delete[data-v-2944ad6a]{position:absolute;right:8px;bottom:8px;width:24px;height:24px;background-size:100% 100%;cursor:pointer}.addToShop[data-v-2944ad6a]{position:absolute;left:3px;top:8px;width:24px;height:24px;background-size:100% 100%;cursor:pointer}.floor[data-v-2944ad6a]{position:fixed;bottom:0;width:100%;background-color:#fff;justify-content:space-between;z-index:100;box-shadow:0 4px 6px #00000080;padding:10px 0;display:flex;flex-direction:column;background:#000;color:#fff;border-radius:15px 15px 0 0}.floor .floor-animate-rotating[data-v-2944ad6a]{animation:floorRotating-2944ad6a 1.5s linear infinite}.floor-title[data-v-2944ad6a]{padding:0 10px;color:#2e38e7;font-weight:700;font-size:12px}.floor-subtitle[data-v-2944ad6a]{padding:0 10px;margin-top:8px;font-weight:700;font-size:12px}.submit-btns[data-v-2944ad6a]{width:100%;margin-top:10px;padding:10px 10px 0;border-top:2px #2f2e2c solid}.submit-row[data-v-2944ad6a]{margin-top:10px;width:100%;display:flex;gap:15px;align-items:center}.icon-loading[data-v-2944ad6a]{fill:#000;margin-right:3px;width:22px;height:22px}@keyframes floorRotating-2944ad6a{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@media screen and (min-width: 990px){.floor[data-v-2944ad6a]{width:300px;top:unset;right:1%;display:inline-flex;flex-direction:column;align-items:center;justify-content:center;border-radius:15px;padding:14px 0;bottom:129px;z-index:1000}}@media screen and (min-width:1240px){.floor[data-v-2944ad6a]{right:8%}}@media screen and (min-width:1432px){.floor[data-v-2944ad6a]{right:15%}}@media screen and (min-width:1500px){.floor[data-v-2944ad6a]{right:18%}}@media screen and (min-width:2165px){.floor[data-v-2944ad6a]{right:27%}}.statistics[data-v-2944ad6a]{display:flex;align-items:center;font-weight:700;font-size:15px}.submit[data-v-2944ad6a]{flex-grow:1;border-radius:50px;padding:5px 13px;display:flex;align-items:center;background-color:#fcde4c;color:#000;font-size:16px;cursor:pointer;font-weight:700;justify-content:center}.submit-cart[data-v-2944ad6a]{width:39px;height:39px;display:flex;justify-content:center;align-items:center;background-color:#2e38e7;border-radius:100%}.icon-submit-cart[data-v-2944ad6a]{width:40px;color:#fff}.header[data-v-f9a6d7f7]{background-color:#242734;color:#fff;text-align:center;padding:0 0 12px;position:relative}.edit-banner[data-v-f9a6d7f7]{position:absolute;right:24px;top:24px;background-color:#fff;padding:4px 6px;border-radius:6px;color:#000;font-weight:700;font-size:14px}.banner[data-v-f9a6d7f7]{width:100%;height:146px;margin-bottom:32px}.banner img[data-v-f9a6d7f7]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.avatar img[data-v-f9a6d7f7]{width:64px;height:64px;background-color:#fff;border-radius:32px;position:absolute;left:50%;top:114px;transform:translate(-50%)}.nickname[data-v-f9a6d7f7]{font-size:18px;padding:12px 0}.description[data-v-f9a6d7f7]{font-size:12px;line-height:16px;padding:0 32px}.social-media[data-v-f9a6d7f7]{margin-top:15px;height:40px;padding:0 15px;display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:20px}.social-media img[data-v-f9a6d7f7]{width:35px;height:35px}.home[data-v-f9a6d7f7]{width:36px;height:26px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/home.png);background-size:100% 100%;position:absolute;right:12px;bottom:12px;cursor:pointer}.brokerage[data-v-f9a6d7f7]{width:36px;height:36px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/brokerage.png);background-size:100% 100%;position:absolute;right:8px;bottom:48px;cursor:pointer}.diyDesignList[data-v-f9a6d7f7]{display:flex;justify-content:space-between;flex-wrap:wrap;padding:0;background:#fff}.design[data-v-f9a6d7f7]{text-align:center;background-color:#fff;width:50%;position:relative}.cover[data-v-f9a6d7f7]{width:100%}.design-title[data-v-f9a6d7f7]{padding:4px 12px;font-size:16px;height:26px;line-height:16px;vertical-align:middle;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-bottom:8px}.dialog-close[data-v-f9a6d7f7]{position:absolute;right:4px;top:18px;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/close.png);background-position:center;background-size:24px 24px;background-repeat:no-repeat}.edit-icon-w[data-v-f9a6d7f7]{width:16px;height:16px;background-image:url(https://shirt-oss.s3.us-east-1.amazonaws.com/assets/edit-icon-w.png);background-size:100% 100%;display:inline-block;margin-left:4px;transform:translateY(2px)}.edit-icon[data-v-f9a6d7f7]{width:16px;height:16px;background-image:url(https://shirt-oss.s3.us-east-1.amazonaws.com/assets/edit-icon.png);background-size:100% 100%;display:inline-block;margin-left:4px;transform:translateY(2px)}.design-content[data-v-f9a6d7f7]{display:flex;justify-content:space-between;padding:0 12px}.design-price[data-v-f9a6d7f7]{font-size:12px;font-weight:700}.design-social[data-v-f9a6d7f7]{display:flex;justify-content:flex-end}.social-item[data-v-f9a6d7f7]{display:flex;align-items:center;font-size:12px;margin-right:8px}.social-item img[data-v-f9a6d7f7]{width:14px;margin-right:2px}.up[data-v-f9a6d7f7]{position:absolute;top:8px;left:8px;width:24px;height:24px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/up.png);background-size:100% 100%}.below[data-v-f9a6d7f7]{position:absolute;top:8px;left:8px;width:24px;height:24px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/below.png);background-size:100% 100%}.dialog[data-v-f9a6d7f7]{position:fixed;left:0;top:0;right:0;height:100vh;background-color:#00000080;z-index:100}.dialog-content[data-v-f9a6d7f7]{background-color:#fff;border-radius:8px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:calc(80% - 24px);max-width:276px;padding:24px 12px}.dialog-title[data-v-f9a6d7f7]{font-size:16px;font-weight:700;text-align:left}.dialog-message[data-v-f9a6d7f7]{font-size:12px;color:#ccc}.dialog-save[data-v-f9a6d7f7]{background-color:#000;height:32px;line-height:32px;font-size:14px;text-align:center;border-radius:16px;color:#fff;margin:12px 0}.dialog-cancel[data-v-f9a6d7f7]{text-align:center;font-size:14px}.dialog-avatar[data-v-f9a6d7f7]{text-align:center;margin:12px 0}.dialog-avatar img[data-v-f9a6d7f7]{width:64px;height:64px;border-radius:32px;margin:auto}.dialog-banner[data-v-f9a6d7f7]{text-align:center;margin:12px 0}.dialog-banner img[data-v-f9a6d7f7]{width:100%;height:auto;margin:auto}.dialog-banner img.banner-logo[data-v-f9a6d7f7]{width:64px;height:auto}.dialog-form[data-v-f9a6d7f7]{margin:24px 0}.dialog-form input[data-v-f9a6d7f7]{width:100%;padding:4px 8px;border:1px solid #333333}.page[data-v-a1e2eb5b]{background-color:#f6bb57}.introduce[data-v-a1e2eb5b]{padding:0 1px 12px}.introduce img[data-v-a1e2eb5b]{width:100%}.title[data-v-a1e2eb5b]{font-size:24px;line-height:32px;color:#fff;text-align:center}.form[data-v-a1e2eb5b]{margin:16px 12px;padding:4px 8px;background-color:#f9f5eb}.label[data-v-a1e2eb5b]{font-size:20px}.pic[data-v-a1e2eb5b]{width:64px;height:64px;border:1px solid lightgray;border-radius:8px;margin:12px auto;cursor:pointer;overflow:hidden}.pic img[data-v-a1e2eb5b]{width:100%;height:100%}.text[data-v-a1e2eb5b]{border:1px solid lightgray;border-radius:4px;height:40px;width:100%;font-size:16px;margin:12px 0}.apply[data-v-a1e2eb5b]{height:40px;line-height:36px;color:#fff;background-color:#f6bb57;font-size:20px;text-align:center;border-radius:8px;border:1px solid black;margin:20px 0;cursor:pointer}.header[data-v-70b0e729]{background-color:#242734;color:#fff;text-align:center;padding:0 0 12px;position:relative}.edit-banner[data-v-70b0e729]{position:absolute;right:24px;top:24px;background-color:#fff;padding:4px 6px;border-radius:6px;color:#000;font-weight:700;font-size:14px}.banner[data-v-70b0e729]{width:100%;height:146px;margin-bottom:32px}.banner img[data-v-70b0e729]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.avatar img[data-v-70b0e729]{width:64px;height:64px;background-color:#fff;border-radius:32px;position:absolute;left:50%;top:114px;transform:translate(-50%)}.nickname[data-v-70b0e729]{font-size:18px;padding:12px 0}.description[data-v-70b0e729]{font-size:12px;line-height:16px;padding:0 32px}.social-media[data-v-70b0e729]{margin-top:15px;height:40px;padding:0 15px;display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:20px}.social-media img[data-v-70b0e729]{width:35px;height:35px}.home[data-v-70b0e729]{width:36px;height:26px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/home.png);background-size:100% 100%;position:absolute;right:12px;bottom:12px;cursor:pointer}.brokerage[data-v-70b0e729]{width:36px;height:36px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/brokerage.png);background-size:100% 100%;position:absolute;right:8px;bottom:48px;cursor:pointer}.diyDesignList[data-v-70b0e729]{display:flex;justify-content:space-between;flex-wrap:wrap;padding:0;background:#fff}.design[data-v-70b0e729]{text-align:center;background-color:#fff;width:50%;position:relative}.cover[data-v-70b0e729]{width:100%}.design-title[data-v-70b0e729]{padding:4px 12px;font-size:16px;height:26px;line-height:16px;vertical-align:middle;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-bottom:8px}.dialog-close[data-v-70b0e729]{position:absolute;right:4px;top:18px;width:40px;height:40px;background-image:url(https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/close.png);background-position:center;background-size:24px 24px;background-repeat:no-repeat}.edit-icon-w[data-v-70b0e729]{width:16px;height:16px;background-image:url(https://shirt-oss.s3.us-east-1.amazonaws.com/assets/edit-icon-w.png);background-size:100% 100%;display:inline-block;margin-left:4px;transform:translateY(2px)}.edit-icon[data-v-70b0e729]{width:16px;height:16px;background-image:url(https://shirt-oss.s3.us-east-1.amazonaws.com/assets/edit-icon.png);background-size:100% 100%;display:inline-block;margin-left:4px;transform:translateY(2px)}.design-content[data-v-70b0e729]{display:flex;justify-content:space-between;padding:0 12px}.design-price[data-v-70b0e729]{font-size:12px;font-weight:700}.design-social[data-v-70b0e729]{display:flex;justify-content:flex-end}.social-item[data-v-70b0e729]{display:flex;align-items:center;font-size:12px;margin-right:8px}.social-item img[data-v-70b0e729]{width:14px;margin-right:2px}.up[data-v-70b0e729]{position:absolute;top:8px;left:8px;width:24px;height:24px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/up.png);background-size:100% 100%}.below[data-v-70b0e729]{position:absolute;top:8px;left:8px;width:24px;height:24px;background-image:url(https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/below.png);background-size:100% 100%}.dialog[data-v-70b0e729]{position:fixed;left:0;top:0;right:0;height:100vh;background-color:#00000080;z-index:100}.dialog-content[data-v-70b0e729]{background-color:#fff;border-radius:8px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:calc(80% - 24px);max-width:276px;padding:24px 12px}.dialog-title[data-v-70b0e729]{font-size:16px;font-weight:700;text-align:left}.dialog-message[data-v-70b0e729]{font-size:12px;color:#ccc}.dialog-save[data-v-70b0e729]{background-color:#000;height:32px;line-height:32px;font-size:14px;text-align:center;border-radius:16px;color:#fff;margin:12px 0}.dialog-cancel[data-v-70b0e729]{text-align:center;font-size:14px}.dialog-avatar[data-v-70b0e729]{text-align:center;margin:12px 0}.dialog-avatar img[data-v-70b0e729]{width:64px;height:64px;border-radius:32px;margin:auto}.dialog-banner[data-v-70b0e729]{text-align:center;margin:12px 0}.dialog-banner img[data-v-70b0e729]{width:100%;height:auto;margin:auto}.dialog-banner img.banner-logo[data-v-70b0e729]{width:64px;height:auto}.dialog-form[data-v-70b0e729]{margin:24px 0}.dialog-form input[data-v-70b0e729]{width:100%;padding:4px 8px;border:1px solid #333333}.shop-featured-page .type-select-box{position:relative}.shop-featured-page .type-select-box .type-select-el{appearance:none;-webkit-appearance:none;-moz-appearance:none}.shop-featured-page .type-select-box:after{content:"";position:absolute;display:block;top:20%;right:15px;width:11px;height:11px;border:1.5px rgba(0,0,0,.4) solid;border-top:none;border-right:none;transform:rotate(-45deg)}.shop-featured-page .shop-item{background:#fff}.shop-featured-page .shop-item:hover{box-shadow:0 2px 8px #00000026}.header[data-v-e2753e36]{background-color:#242734;position:relative;color:#fff;text-align:center;padding:12px}.collect[data-v-e2753e36]{display:flex;justify-content:space-between;font-size:16px;line-height:24px}.collect .collect-lable[data-v-e2753e36]{width:200px;padding-left:12px;text-align:left}.tabs[data-v-e2753e36]{display:flex;justify-content:space-around;background-color:#fff}.tabs .tab[data-v-e2753e36]{padding:8px 12px;cursor:pointer}.tabs .tab.current[data-v-e2753e36]{border-bottom:2px solid #242734}.list-panel[data-v-e2753e36]{background-color:#fff;margin-top:4px;padding:8px}:root{--vt-c-white:#fff;--vt-c-white-soft:#f8f8f8;--vt-c-white-mute:#f2f2f2;--vt-c-black:#181818;--vt-c-black-soft:#222;--vt-c-black-mute:#282828;--vt-c-indigo:#2c3e50;--vt-c-divider-light-1:#3c3c3c4a;--vt-c-divider-light-2:#3c3c3c1f;--vt-c-divider-dark-1:#545454a6;--vt-c-divider-dark-2:#5454547a;--vt-c-text-light-1:var(--vt-c-indigo);--vt-c-text-light-2:#3c3c3ca8;--vt-c-text-dark-1:var(--vt-c-white);--vt-c-text-dark-2:#ebebeba3;--color-background:var(--vt-c-white);--color-background-soft:var(--vt-c-white-soft);--color-background-mute:var(--vt-c-white-mute);--color-border:var(--vt-c-divider-light-2);--color-border-hover:var(--vt-c-divider-light-1);--color-heading:var(--vt-c-text-light-1);--color-text:var(--vt-c-text-light-1);--section-gap:160px}@media (prefers-color-scheme:dark){:root{--color-background:var(--vt-c-black);--color-background-soft:var(--vt-c-black-soft);--color-background-mute:var(--vt-c-black-mute);--color-border:var(--vt-c-divider-dark-2);--color-border-hover:var(--vt-c-divider-dark-1);--color-heading:var(--vt-c-text-dark-1);--color-text:var(--vt-c-text-dark-2)}}body{min-height:100vh;color:var(--color-text);background:var(--color-background);text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;font-size:15px;line-height:1.6;transition:color .5s,background-color .5s}@layer theme{:root,:host{--font-sans:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";--font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--color-red-500:oklch(.637 .237 25.331);--color-gray-300:oklch(.872 .01 258.338);--color-gray-500:oklch(.551 .027 264.364);--color-black:#000;--color-white:#fff;--spacing:.25rem;--text-sm:.875rem;--text-sm--line-height:calc(1.25/.875);--text-base:1rem;--text-base--line-height: 1.5 ;--text-xl:1.25rem;--text-xl--line-height:calc(1.75/1.25);--font-weight-semibold:600;--font-weight-bold:700;--font-weight-black:900;--radius-sm:.25rem;--radius-md:.375rem;--ease-in-out:cubic-bezier(.4,0,.2,1);--default-transition-duration:.15s;--default-transition-timing-function:cubic-bezier(.4,0,.2,1);--default-font-family:var(--font-sans);--default-font-feature-settings:var(--font-sans--font-feature-settings);--default-font-variation-settings:var(--font-sans--font-variation-settings);--default-mono-font-family:var(--font-mono);--default-mono-font-feature-settings:var(--font-mono--font-feature-settings);--default-mono-font-variation-settings:var(--font-mono--font-variation-settings)}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}body{line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::-moz-placeholder{opacity:1;color:color-mix(in oklab,currentColor 50%,transparent)}::placeholder{opacity:1;color:color-mix(in oklab,currentColor 50%,transparent)}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){-webkit-appearance:button;-moz-appearance:button;appearance:button}::file-selector-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}}@layer components;@layer utilities{.pointer-events-auto{pointer-events:auto}.pointer-events-none{pointer-events:none}.sr-only{clip:rect(0,0,0,0);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.absolute{position:absolute}.fixed{position:fixed}.relative{position:relative}.-inset-\\[10px\\]{top:-10px;right:-10px;bottom:-10px;left:-10px}.inset-0{inset:calc(var(--spacing)*0)}.inset-y-0{inset-block:calc(var(--spacing)*0)}.top-0{top:calc(var(--spacing)*0)}.top-\\[50\\%\\]{top:50%}.right-0{right:calc(var(--spacing)*0)}.bottom-\\[50\\%\\]{bottom:50%}.left-0{left:calc(var(--spacing)*0)}.left-1\\/2{left:50%}.left-\\[10px\\]{left:10px}.left-\\[50\\%\\]{left:50%}.z-10{z-index:10}.mx-auto{margin-inline:auto}.mt-1{margin-top:calc(var(--spacing)*1)}.mt-2{margin-top:calc(var(--spacing)*2)}.mt-\\[4px\\]{margin-top:4px}.mt-\\[8px\\]{margin-top:8px}.mt-\\[10px\\]{margin-top:10px}.mt-\\[12px\\]{margin-top:12px}.mt-\\[15px\\]{margin-top:15px}.mt-\\[16px\\]{margin-top:16px}.mt-\\[28px\\]{margin-top:28px}.mr-\\[4px\\]{margin-right:4px}.mb-\\[20px\\]{margin-bottom:20px}.-ml-\\[32px\\]{margin-left:-32px}.line-clamp-1{-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.block{display:block}.flex{display:flex}.grid{display:grid}.hidden{display:none}.inline-flex{display:inline-flex}.size-5{width:calc(var(--spacing)*5);height:calc(var(--spacing)*5)}.size-\\[24px\\]{width:24px;height:24px}.h-6{height:calc(var(--spacing)*6)}.h-\\[20px\\]{height:20px}.h-\\[28px\\]{height:28px}.h-\\[40px\\]{height:40px}.h-\\[58px\\]{height:58px}.h-\\[280px\\]{height:280px}.h-full{height:100%}.max-h-full{max-height:100%}.w-6{width:calc(var(--spacing)*6)}.w-\\[20px\\]{width:20px}.w-\\[28px\\]{width:28px}.w-\\[40px\\]{width:40px}.w-\\[58px\\]{width:58px}.w-\\[80\\%\\]{width:80%}.w-\\[93\\%\\]{width:93%}.w-\\[100dvw\\]{width:100dvw}.w-\\[384px\\]{width:384px}.w-full{width:100%}.max-w-\\[480px\\]{max-width:480px}.max-w-\\[1200px\\]{max-width:1200px}.max-w-full{max-width:100%}.flex-1{flex:1}.flex-grow{flex-grow:1}.-translate-x-1\\/2,.-translate-x-2\\/4{--tw-translate-x: -50% ;translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-x-0{--tw-translate-x:calc(var(--spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-x-full{--tw-translate-x:100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.-translate-y-\\[50\\%\\]{--tw-translate-y: -50% ;translate:var(--tw-translate-x)var(--tw-translate-y)}.rotate-\\[40deg\\]{rotate:40deg}.transform{transform:var(--tw-rotate-x)var(--tw-rotate-y)var(--tw-rotate-z)var(--tw-skew-x)var(--tw-skew-y)}.cursor-pointer{cursor:pointer}.resize{resize:both}.resize-none{resize:none}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-center{align-items:center}.justify-between{justify-content:space-between}.justify-center{justify-content:center}.gap-\\[6px\\]{gap:6px}.gap-\\[8px\\]{gap:8px}.gap-\\[10px\\]{gap:10px}.gap-\\[12px\\]{gap:12px}.gap-\\[15px\\]{gap:15px}.gap-\\[16px\\]{gap:16px}.gap-x-\\[12px\\]{-moz-column-gap:12px;column-gap:12px}.gap-y-\\[8px\\]{row-gap:8px}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.rounded-full{border-radius:3.40282e38px}.rounded-md{border-radius:var(--radius-md)}.rounded-sm{border-radius:var(--radius-sm)}.border{border-style:var(--tw-border-style);border-width:1px}.border-2,.border-\\[2px\\]{border-style:var(--tw-border-style);border-width:2px}.border-r{border-right-style:var(--tw-border-style);border-right-width:1px}.border-b{border-bottom-style:var(--tw-border-style);border-bottom-width:1px}.border-\\[rgba\\(46\\,56\\,231\\,0\\.5\\)\\]{border-color:#2e38e780}.border-black{border-color:var(--color-black)}.border-black\\/20{border-color:color-mix(in oklab,var(--color-black)20%,transparent)}.border-black\\/30{border-color:color-mix(in oklab,var(--color-black)30%,transparent)}.border-black\\/50{border-color:color-mix(in oklab,var(--color-black)50%,transparent)}.bg-\\[\\#2e38e7\\]{background-color:#2e38e7}.bg-\\[\\#242833\\]{background-color:#242833}.bg-\\[\\#f8f8f8\\]{background-color:#f8f8f8}.bg-\\[rgba\\(46\\,56\\,231\\,0\\.1\\)\\]{background-color:#2e38e71a}.bg-black\\/10{background-color:color-mix(in oklab,var(--color-black)10%,transparent)}.bg-gray-500\\/75{background-color:color-mix(in oklab,var(--color-gray-500)75%,transparent)}.bg-white{background-color:var(--color-white)}.fill-black{fill:var(--color-black)}.fill-white{fill:var(--color-white)}.p-\\[8px\\]{padding:8px}.p-\\[24px\\]{padding:24px}.px-3{padding-inline:calc(var(--spacing)*3)}.px-\\[4px\\]{padding-inline:4px}.px-\\[5px\\]{padding-inline:5px}.px-\\[6px\\]{padding-inline:6px}.px-\\[8px\\]{padding-inline:8px}.px-\\[12px\\]{padding-inline:12px}.px-\\[16px\\]{padding-inline:16px}.px-\\[20px\\]{padding-inline:20px}.px-\\[24px\\]{padding-inline:24px}.px-\\[32px\\]{padding-inline:32px}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-\\[2px\\]{padding-block:2px}.py-\\[4px\\]{padding-block:4px}.py-\\[6px\\]{padding-block:6px}.py-\\[8px\\]{padding-block:8px}.py-\\[12px\\]{padding-block:12px}.py-\\[20px\\]{padding-block:20px}.pt-10{padding-top:calc(var(--spacing)*10)}.pt-\\[16px\\]{padding-top:16px}.pt-\\[20px\\]{padding-top:20px}.pr-\\[8px\\]{padding-right:8px}.pr-\\[10px\\]{padding-right:10px}.pr-\\[40px\\]{padding-right:40px}.pb-\\[12px\\]{padding-bottom:12px}.pb-\\[30px\\]{padding-bottom:30px}.pl-\\[10px\\]{padding-left:10px}.pl-\\[40px\\]{padding-left:40px}.text-center{text-align:center}.text-base{font-size:var(--text-base);line-height:var(--tw-leading,var(--text-base--line-height))}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.text-xl{font-size:var(--text-xl);line-height:var(--tw-leading,var(--text-xl--line-height))}.text-\\[0\\.7rem\\]{font-size:.7rem}.text-\\[10px\\]{font-size:10px}.text-\\[11px\\]{font-size:11px}.text-\\[12px\\]{font-size:12px}.text-\\[13px\\]{font-size:13px}.text-\\[14px\\]{font-size:14px}.text-\\[16px\\]{font-size:16px}.text-\\[18px\\]{font-size:18px}.text-\\[20px\\]{font-size:20px}.text-\\[29px\\]{font-size:29px}.leading-\\[20px\\]{--tw-leading:20px;line-height:20px}.font-black{--tw-font-weight:var(--font-weight-black);font-weight:var(--font-weight-black)}.font-bold{--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.text-\\[\\#2e38e7\\]{color:#2e38e7}.text-black{color:var(--color-black)}.text-gray-300{color:var(--color-gray-300)}.text-red-500{color:var(--color-red-500)}.text-white{color:var(--color-white)}.italic{font-style:italic}.line-through{text-decoration-line:line-through}.opacity-0{opacity:0}.opacity-60{opacity:.6}.opacity-100{opacity:1}.outline{outline-style:var(--tw-outline-style);outline-width:1px}.outline-0{outline-style:var(--tw-outline-style);outline-width:0}.transition{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,-webkit-backdrop-filter,backdrop-filter;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-opacity{transition-property:opacity;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.duration-500{--tw-duration:.5s;transition-duration:.5s}.ease-in-out{--tw-ease:var(--ease-in-out);transition-timing-function:var(--ease-in-out)}@media (hover:hover){.hover\\:text-white:hover{color:var(--color-white)}.hover\\:opacity-80:hover{opacity:.8}}.focus\\:ring-2:focus{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(2px + var(--tw-ring-offset-width))var(--tw-ring-color,currentColor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus\\:ring-white:focus{--tw-ring-color:var(--color-white)}.focus\\:outline-none:focus{--tw-outline-style:none;outline-style:none}@media (width>=40rem){.sm\\:-ml-\\[40px\\]{margin-left:-40px}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:pr-\\[16px\\]{padding-right:16px}.sm\\:duration-700{--tw-duration:.7s;transition-duration:.7s}}@media (width>=48rem){.md\\:text-\\[12px\\]{font-size:12px}}@media (width>=64rem){.lg\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}}}.animate-rotating{animation:1.5s linear infinite rotating}@keyframes rotating{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@property --tw-rotate-x{syntax:"*";inherits:false;initial-value:rotateX(0)}@property --tw-rotate-y{syntax:"*";inherits:false;initial-value:rotateY(0)}@property --tw-rotate-z{syntax:"*";inherits:false;initial-value:rotateZ(0)}@property --tw-skew-x{syntax:"*";inherits:false;initial-value:skewX(0)}@property --tw-skew-y{syntax:"*";inherits:false;initial-value:skewY(0)}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-outline-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-duration{syntax:"*";inherits:false}@property --tw-ease{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}.main-account .log-out{position:relative}.main-account .log-out:after{--tw-translate-x: -50% ;width:80%;translate:var(--tw-translate-x)var(--tw-translate-y);border-bottom-style:var(--tw-border-style);content:"";border-bottom-width:2px;position:absolute;bottom:-4px;left:50%}.my-button:disabled{cursor:not-allowed;opacity:.4}/*! tailwindcss v4.0.14 | MIT License | https://tailwindcss.com */.edit-my-gallery input.my-checkbox{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:1.5px solid #000;outline:none;position:relative}.edit-my-gallery input.my-checkbox[type=checkbox]:checked{background-color:#2e38e7;border-color:#2e38e7}.edit-my-gallery input.my-checkbox[type=checkbox]:checked:after{--tw-translate-x: -50% ;--tw-translate-y:30%;translate:var(--tw-translate-x)var(--tw-translate-y);border-right-style:var(--tw-border-style);border-right-width:1px;border-bottom-style:var(--tw-border-style);content:"";border-color:#fff;border-bottom-width:1px;width:6px;height:10px;display:block;position:absolute;bottom:50%;left:50%;rotate:40deg}@property --tw-translate-x{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-y{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-z{syntax:"*";inherits:false;initial-value:0}@property --tw-border-style{syntax:"*";inherits:false;initial-value:solid}')),document.head.appendChild(t)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
var nx = Object.defineProperty;
var ix = (e, t, n) => t in e ? nx(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var wn = (e, t, n) => ix(e, typeof t != "symbol" ? t + "" : t, n);
const rx = ":root{--vt-c-white: #ffffff;--vt-c-white-soft: #f8f8f8;--vt-c-white-mute: #f2f2f2;--vt-c-black: #181818;--vt-c-black-soft: #222222;--vt-c-black-mute: #282828;--vt-c-indigo: #2c3e50;--vt-c-divider-light-1: rgba(60, 60, 60, .29);--vt-c-divider-light-2: rgba(60, 60, 60, .12);--vt-c-divider-dark-1: rgba(84, 84, 84, .65);--vt-c-divider-dark-2: rgba(84, 84, 84, .48);--vt-c-text-light-1: var(--vt-c-indigo);--vt-c-text-light-2: rgba(60, 60, 60, .66);--vt-c-text-dark-1: var(--vt-c-white);--vt-c-text-dark-2: rgba(235, 235, 235, .64)}:root{--color-background: var(--vt-c-white);--color-background-soft: var(--vt-c-white-soft);--color-background-mute: var(--vt-c-white-mute);--color-border: var(--vt-c-divider-light-2);--color-border-hover: var(--vt-c-divider-light-1);--color-heading: var(--vt-c-text-light-1);--color-text: var(--vt-c-text-light-1);--section-gap: 160px}@media (prefers-color-scheme: dark){:root{--color-background: var(--vt-c-black);--color-background-soft: var(--vt-c-black-soft);--color-background-mute: var(--vt-c-black-mute);--color-border: var(--vt-c-divider-dark-2);--color-border-hover: var(--vt-c-divider-dark-1);--color-heading: var(--vt-c-text-dark-1);--color-text: var(--vt-c-text-dark-2)}}body{min-height:100dvh;color:var(--color-text);background:var(--color-background);transition:color .5s,background-color .5s;line-height:1.6;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;font-size:15px;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.green{text-decoration:none;color:#00bd7e;transition:.4s;padding:3px}@media (hover: hover){a:hover{background-color:#00bd7e33}}@media (min-width: 1024px){body{display:flex;place-items:center}#app{display:grid;grid-template-columns:1fr 1fr;padding:0 2rem}}";
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Ac(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const et = {}, Rr = [], Jn = () => {
}, sx = () => !1, la = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Pc = (e) => e.startsWith("onUpdate:"), Kt = Object.assign, Nc = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, ox = Object.prototype.hasOwnProperty, Xe = (e, t) => ox.call(e, t), we = Array.isArray, Or = (e) => Ms(e) === "[object Map]", Wr = (e) => Ms(e) === "[object Set]", Hd = (e) => Ms(e) === "[object Date]", De = (e) => typeof e == "function", Dt = (e) => typeof e == "string", $n = (e) => typeof e == "symbol", st = (e) => e !== null && typeof e == "object", gp = (e) => (st(e) || De(e)) && De(e.then) && De(e.catch), mp = Object.prototype.toString, Ms = (e) => mp.call(e), ax = (e) => Ms(e).slice(8, -1), vp = (e) => Ms(e) === "[object Object]", Mc = (e) => Dt(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, ms = /* @__PURE__ */ Ac(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), ca = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, lx = /-(\w)/g, An = ca(
  (e) => e.replace(lx, (t, n) => n ? n.toUpperCase() : "")
), cx = /\B([A-Z])/g, lr = ca(
  (e) => e.replace(cx, "-$1").toLowerCase()
), ua = ca((e) => e.charAt(0).toUpperCase() + e.slice(1)), Ul = ca(
  (e) => e ? `on${ua(e)}` : ""
), Ni = (e, t) => !Object.is(e, t), Uo = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, yp = (e, t, n, s = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: s,
    value: n
  });
}, Yo = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
};
let Ud;
const fa = () => Ud || (Ud = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Lt(e) {
  if (we(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const s = e[n], o = Dt(s) ? hx(s) : Lt(s);
      if (o)
        for (const a in o)
          t[a] = o[a];
    }
    return t;
  } else if (Dt(e) || st(e))
    return e;
}
const ux = /;(?![^(]*\))/g, fx = /:([^]+)/, dx = /\/\*[^]*?\*\//g;
function hx(e) {
  const t = {};
  return e.replace(dx, "").split(ux).forEach((n) => {
    if (n) {
      const s = n.split(fx);
      s.length > 1 && (t[s[0].trim()] = s[1].trim());
    }
  }), t;
}
function _t(e) {
  let t = "";
  if (Dt(e))
    t = e;
  else if (we(e))
    for (let n = 0; n < e.length; n++) {
      const s = _t(e[n]);
      s && (t += s + " ");
    }
  else if (st(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const px = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", gx = /* @__PURE__ */ Ac(px);
function wp(e) {
  return !!e || e === "";
}
function mx(e, t) {
  if (e.length !== t.length) return !1;
  let n = !0;
  for (let s = 0; n && s < e.length; s++)
    n = Bs(e[s], t[s]);
  return n;
}
function Bs(e, t) {
  if (e === t) return !0;
  let n = Hd(e), s = Hd(t);
  if (n || s)
    return n && s ? e.getTime() === t.getTime() : !1;
  if (n = $n(e), s = $n(t), n || s)
    return e === t;
  if (n = we(e), s = we(t), n || s)
    return n && s ? mx(e, t) : !1;
  if (n = st(e), s = st(t), n || s) {
    if (!n || !s)
      return !1;
    const o = Object.keys(e).length, a = Object.keys(t).length;
    if (o !== a)
      return !1;
    for (const c in e) {
      const u = e.hasOwnProperty(c), d = t.hasOwnProperty(c);
      if (u && !d || !u && d || !Bs(e[c], t[c]))
        return !1;
    }
  }
  return String(e) === String(t);
}
function Bc(e, t) {
  return e.findIndex((n) => Bs(n, t));
}
const bp = (e) => !!(e && e.__v_isRef === !0), fe = (e) => Dt(e) ? e : e == null ? "" : we(e) || st(e) && (e.toString === mp || !De(e.toString)) ? bp(e) ? fe(e.value) : JSON.stringify(e, xp, 2) : String(e), xp = (e, t) => bp(t) ? xp(e, t.value) : Or(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [s, o], a) => (n[zl(s, a) + " =>"] = o, n),
    {}
  )
} : Wr(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => zl(n))
} : $n(t) ? zl(t) : st(t) && !we(t) && !vp(t) ? String(t) : t, zl = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $n(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let xn;
class _p {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = xn, !t && xn && (this.index = (xn.scopes || (xn.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].pause();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].resume();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = xn;
      try {
        return xn = this, t();
      } finally {
        xn = n;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    xn = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    xn = this.parent;
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let n, s;
      for (n = 0, s = this.effects.length; n < s; n++)
        this.effects[n].stop();
      for (this.effects.length = 0, n = 0, s = this.cleanups.length; n < s; n++)
        this.cleanups[n]();
      if (this.cleanups.length = 0, this.scopes) {
        for (n = 0, s = this.scopes.length; n < s; n++)
          this.scopes[n].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const o = this.parent.scopes.pop();
        o && o !== this && (this.parent.scopes[this.index] = o, o.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function vx(e) {
  return new _p(e);
}
function yx() {
  return xn;
}
let rt;
const Wl = /* @__PURE__ */ new WeakSet();
class Cp {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, xn && xn.active && xn.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Wl.has(this) && (Wl.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Lp(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, zd(this), Dp(this);
    const t = rt, n = Fn;
    rt = this, Fn = !0;
    try {
      return this.fn();
    } finally {
      Ip(this), rt = t, Fn = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Hc(t);
      this.deps = this.depsTail = void 0, zd(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Wl.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    cc(this) && this.run();
  }
  get dirty() {
    return cc(this);
  }
}
let Sp = 0, vs, ys;
function Lp(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = ys, ys = e;
    return;
  }
  e.next = vs, vs = e;
}
function Fc() {
  Sp++;
}
function $c() {
  if (--Sp > 0)
    return;
  if (ys) {
    let t = ys;
    for (ys = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; vs; ) {
    let t = vs;
    for (vs = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (s) {
          e || (e = s);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function Dp(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Ip(e) {
  let t, n = e.depsTail, s = n;
  for (; s; ) {
    const o = s.prevDep;
    s.version === -1 ? (s === n && (n = o), Hc(s), wx(s)) : t = s, s.dep.activeLink = s.prevActiveLink, s.prevActiveLink = void 0, s = o;
  }
  e.deps = t, e.depsTail = n;
}
function cc(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (Ep(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function Ep(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Cs))
    return;
  e.globalVersion = Cs;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !cc(e)) {
    e.flags &= -3;
    return;
  }
  const n = rt, s = Fn;
  rt = e, Fn = !0;
  try {
    Dp(e);
    const o = e.fn(e._value);
    (t.version === 0 || Ni(o, e._value)) && (e._value = o, t.version++);
  } catch (o) {
    throw t.version++, o;
  } finally {
    rt = n, Fn = s, Ip(e), e.flags &= -3;
  }
}
function Hc(e, t = !1) {
  const { dep: n, prevSub: s, nextSub: o } = e;
  if (s && (s.nextSub = o, e.prevSub = void 0), o && (o.prevSub = s, e.nextSub = void 0), n.subs === e && (n.subs = s, !s && n.computed)) {
    n.computed.flags &= -5;
    for (let a = n.computed.deps; a; a = a.nextDep)
      Hc(a, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function wx(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let Fn = !0;
const Tp = [];
function $i() {
  Tp.push(Fn), Fn = !1;
}
function Hi() {
  const e = Tp.pop();
  Fn = e === void 0 ? !0 : e;
}
function zd(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = rt;
    rt = void 0;
    try {
      t();
    } finally {
      rt = n;
    }
  }
}
let Cs = 0;
class bx {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class Uc {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0;
  }
  track(t) {
    if (!rt || !Fn || rt === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== rt)
      n = this.activeLink = new bx(rt, this), rt.deps ? (n.prevDep = rt.depsTail, rt.depsTail.nextDep = n, rt.depsTail = n) : rt.deps = rt.depsTail = n, kp(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const s = n.nextDep;
      s.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = s), n.prevDep = rt.depsTail, n.nextDep = void 0, rt.depsTail.nextDep = n, rt.depsTail = n, rt.deps === n && (rt.deps = s);
    }
    return n;
  }
  trigger(t) {
    this.version++, Cs++, this.notify(t);
  }
  notify(t) {
    Fc();
    try {
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      $c();
    }
  }
}
function kp(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let s = t.deps; s; s = s.nextDep)
        kp(s);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), e.dep.subs = e;
  }
}
const uc = /* @__PURE__ */ new WeakMap(), ir = Symbol(
  ""
), fc = Symbol(
  ""
), Ss = Symbol(
  ""
);
function qt(e, t, n) {
  if (Fn && rt) {
    let s = uc.get(e);
    s || uc.set(e, s = /* @__PURE__ */ new Map());
    let o = s.get(n);
    o || (s.set(n, o = new Uc()), o.map = s, o.key = n), o.track();
  }
}
function gi(e, t, n, s, o, a) {
  const c = uc.get(e);
  if (!c) {
    Cs++;
    return;
  }
  const u = (d) => {
    d && d.trigger();
  };
  if (Fc(), t === "clear")
    c.forEach(u);
  else {
    const d = we(e), h = d && Mc(n);
    if (d && n === "length") {
      const m = Number(s);
      c.forEach((v, b) => {
        (b === "length" || b === Ss || !$n(b) && b >= m) && u(v);
      });
    } else
      switch ((n !== void 0 || c.has(void 0)) && u(c.get(n)), h && u(c.get(Ss)), t) {
        case "add":
          d ? h && u(c.get("length")) : (u(c.get(ir)), Or(e) && u(c.get(fc)));
          break;
        case "delete":
          d || (u(c.get(ir)), Or(e) && u(c.get(fc)));
          break;
        case "set":
          Or(e) && u(c.get(ir));
          break;
      }
  }
  $c();
}
function Dr(e) {
  const t = Ye(e);
  return t === e ? t : (qt(t, "iterate", Ss), On(e) ? t : t.map(jt));
}
function da(e) {
  return qt(e = Ye(e), "iterate", Ss), e;
}
const xx = {
  __proto__: null,
  [Symbol.iterator]() {
    return ql(this, Symbol.iterator, jt);
  },
  concat(...e) {
    return Dr(this).concat(
      ...e.map((t) => we(t) ? Dr(t) : t)
    );
  },
  entries() {
    return ql(this, "entries", (e) => (e[1] = jt(e[1]), e));
  },
  every(e, t) {
    return ui(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return ui(this, "filter", e, t, (n) => n.map(jt), arguments);
  },
  find(e, t) {
    return ui(this, "find", e, t, jt, arguments);
  },
  findIndex(e, t) {
    return ui(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return ui(this, "findLast", e, t, jt, arguments);
  },
  findLastIndex(e, t) {
    return ui(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return ui(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return jl(this, "includes", e);
  },
  indexOf(...e) {
    return jl(this, "indexOf", e);
  },
  join(e) {
    return Dr(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return jl(this, "lastIndexOf", e);
  },
  map(e, t) {
    return ui(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return as(this, "pop");
  },
  push(...e) {
    return as(this, "push", e);
  },
  reduce(e, ...t) {
    return Wd(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Wd(this, "reduceRight", e, t);
  },
  shift() {
    return as(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return ui(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return as(this, "splice", e);
  },
  toReversed() {
    return Dr(this).toReversed();
  },
  toSorted(e) {
    return Dr(this).toSorted(e);
  },
  toSpliced(...e) {
    return Dr(this).toSpliced(...e);
  },
  unshift(...e) {
    return as(this, "unshift", e);
  },
  values() {
    return ql(this, "values", jt);
  }
};
function ql(e, t, n) {
  const s = da(e), o = s[t]();
  return s !== e && !On(e) && (o._next = o.next, o.next = () => {
    const a = o._next();
    return a.value && (a.value = n(a.value)), a;
  }), o;
}
const _x = Array.prototype;
function ui(e, t, n, s, o, a) {
  const c = da(e), u = c !== e && !On(e), d = c[t];
  if (d !== _x[t]) {
    const v = d.apply(e, a);
    return u ? jt(v) : v;
  }
  let h = n;
  c !== e && (u ? h = function(v, b) {
    return n.call(this, jt(v), b, e);
  } : n.length > 2 && (h = function(v, b) {
    return n.call(this, v, b, e);
  }));
  const m = d.call(c, h, s);
  return u && o ? o(m) : m;
}
function Wd(e, t, n, s) {
  const o = da(e);
  let a = n;
  return o !== e && (On(e) ? n.length > 3 && (a = function(c, u, d) {
    return n.call(this, c, u, d, e);
  }) : a = function(c, u, d) {
    return n.call(this, c, jt(u), d, e);
  }), o[t](a, ...s);
}
function jl(e, t, n) {
  const s = Ye(e);
  qt(s, "iterate", Ss);
  const o = s[t](...n);
  return (o === -1 || o === !1) && qc(n[0]) ? (n[0] = Ye(n[0]), s[t](...n)) : o;
}
function as(e, t, n = []) {
  $i(), Fc();
  const s = Ye(e)[t].apply(e, n);
  return $c(), Hi(), s;
}
const Cx = /* @__PURE__ */ Ac("__proto__,__v_isRef,__isVue"), Rp = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter($n)
);
function Sx(e) {
  $n(e) || (e = String(e));
  const t = Ye(this);
  return qt(t, "has", e), t.hasOwnProperty(e);
}
class Op {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, s) {
    if (n === "__v_skip") return t.__v_skip;
    const o = this._isReadonly, a = this._isShallow;
    if (n === "__v_isReactive")
      return !o;
    if (n === "__v_isReadonly")
      return o;
    if (n === "__v_isShallow")
      return a;
    if (n === "__v_raw")
      return s === (o ? a ? Px : Mp : a ? Np : Pp).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(s) ? t : void 0;
    const c = we(t);
    if (!o) {
      let d;
      if (c && (d = xx[n]))
        return d;
      if (n === "hasOwnProperty")
        return Sx;
    }
    const u = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      Gt(t) ? t : s
    );
    return ($n(n) ? Rp.has(n) : Cx(n)) || (o || qt(t, "get", n), a) ? u : Gt(u) ? c && Mc(n) ? u : u.value : st(u) ? o ? Fp(u) : ha(u) : u;
  }
}
class Ap extends Op {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, s, o) {
    let a = t[n];
    if (!this._isShallow) {
      const d = sr(a);
      if (!On(s) && !sr(s) && (a = Ye(a), s = Ye(s)), !we(t) && Gt(a) && !Gt(s))
        return d ? !1 : (a.value = s, !0);
    }
    const c = we(t) && Mc(n) ? Number(n) < t.length : Xe(t, n), u = Reflect.set(
      t,
      n,
      s,
      Gt(t) ? t : o
    );
    return t === Ye(o) && (c ? Ni(s, a) && gi(t, "set", n, s) : gi(t, "add", n, s)), u;
  }
  deleteProperty(t, n) {
    const s = Xe(t, n);
    t[n];
    const o = Reflect.deleteProperty(t, n);
    return o && s && gi(t, "delete", n, void 0), o;
  }
  has(t, n) {
    const s = Reflect.has(t, n);
    return (!$n(n) || !Rp.has(n)) && qt(t, "has", n), s;
  }
  ownKeys(t) {
    return qt(
      t,
      "iterate",
      we(t) ? "length" : ir
    ), Reflect.ownKeys(t);
  }
}
class Lx extends Op {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return !0;
  }
  deleteProperty(t, n) {
    return !0;
  }
}
const Dx = /* @__PURE__ */ new Ap(), Ix = /* @__PURE__ */ new Lx(), Ex = /* @__PURE__ */ new Ap(!0);
const dc = (e) => e, Ao = (e) => Reflect.getPrototypeOf(e);
function Tx(e, t, n) {
  return function(...s) {
    const o = this.__v_raw, a = Ye(o), c = Or(a), u = e === "entries" || e === Symbol.iterator && c, d = e === "keys" && c, h = o[e](...s), m = n ? dc : t ? hc : jt;
    return !t && qt(
      a,
      "iterate",
      d ? fc : ir
    ), {
      // iterator protocol
      next() {
        const { value: v, done: b } = h.next();
        return b ? { value: v, done: b } : {
          value: u ? [m(v[0]), m(v[1])] : m(v),
          done: b
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Po(e) {
  return function(...t) {
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function kx(e, t) {
  const n = {
    get(o) {
      const a = this.__v_raw, c = Ye(a), u = Ye(o);
      e || (Ni(o, u) && qt(c, "get", o), qt(c, "get", u));
      const { has: d } = Ao(c), h = t ? dc : e ? hc : jt;
      if (d.call(c, o))
        return h(a.get(o));
      if (d.call(c, u))
        return h(a.get(u));
      a !== c && a.get(o);
    },
    get size() {
      const o = this.__v_raw;
      return !e && qt(Ye(o), "iterate", ir), Reflect.get(o, "size", o);
    },
    has(o) {
      const a = this.__v_raw, c = Ye(a), u = Ye(o);
      return e || (Ni(o, u) && qt(c, "has", o), qt(c, "has", u)), o === u ? a.has(o) : a.has(o) || a.has(u);
    },
    forEach(o, a) {
      const c = this, u = c.__v_raw, d = Ye(u), h = t ? dc : e ? hc : jt;
      return !e && qt(d, "iterate", ir), u.forEach((m, v) => o.call(a, h(m), h(v), c));
    }
  };
  return Kt(
    n,
    e ? {
      add: Po("add"),
      set: Po("set"),
      delete: Po("delete"),
      clear: Po("clear")
    } : {
      add(o) {
        !t && !On(o) && !sr(o) && (o = Ye(o));
        const a = Ye(this);
        return Ao(a).has.call(a, o) || (a.add(o), gi(a, "add", o, o)), this;
      },
      set(o, a) {
        !t && !On(a) && !sr(a) && (a = Ye(a));
        const c = Ye(this), { has: u, get: d } = Ao(c);
        let h = u.call(c, o);
        h || (o = Ye(o), h = u.call(c, o));
        const m = d.call(c, o);
        return c.set(o, a), h ? Ni(a, m) && gi(c, "set", o, a) : gi(c, "add", o, a), this;
      },
      delete(o) {
        const a = Ye(this), { has: c, get: u } = Ao(a);
        let d = c.call(a, o);
        d || (o = Ye(o), d = c.call(a, o)), u && u.call(a, o);
        const h = a.delete(o);
        return d && gi(a, "delete", o, void 0), h;
      },
      clear() {
        const o = Ye(this), a = o.size !== 0, c = o.clear();
        return a && gi(
          o,
          "clear",
          void 0,
          void 0
        ), c;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((o) => {
    n[o] = Tx(o, e, t);
  }), n;
}
function zc(e, t) {
  const n = kx(e, t);
  return (s, o, a) => o === "__v_isReactive" ? !e : o === "__v_isReadonly" ? e : o === "__v_raw" ? s : Reflect.get(
    Xe(n, o) && o in s ? n : s,
    o,
    a
  );
}
const Rx = {
  get: /* @__PURE__ */ zc(!1, !1)
}, Ox = {
  get: /* @__PURE__ */ zc(!1, !0)
}, Ax = {
  get: /* @__PURE__ */ zc(!0, !1)
};
const Pp = /* @__PURE__ */ new WeakMap(), Np = /* @__PURE__ */ new WeakMap(), Mp = /* @__PURE__ */ new WeakMap(), Px = /* @__PURE__ */ new WeakMap();
function Nx(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Mx(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Nx(ax(e));
}
function ha(e) {
  return sr(e) ? e : Wc(
    e,
    !1,
    Dx,
    Rx,
    Pp
  );
}
function Bp(e) {
  return Wc(
    e,
    !1,
    Ex,
    Ox,
    Np
  );
}
function Fp(e) {
  return Wc(
    e,
    !0,
    Ix,
    Ax,
    Mp
  );
}
function Wc(e, t, n, s, o) {
  if (!st(e) || e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const a = o.get(e);
  if (a)
    return a;
  const c = Mx(e);
  if (c === 0)
    return e;
  const u = new Proxy(
    e,
    c === 2 ? s : n
  );
  return o.set(e, u), u;
}
function Ar(e) {
  return sr(e) ? Ar(e.__v_raw) : !!(e && e.__v_isReactive);
}
function sr(e) {
  return !!(e && e.__v_isReadonly);
}
function On(e) {
  return !!(e && e.__v_isShallow);
}
function qc(e) {
  return e ? !!e.__v_raw : !1;
}
function Ye(e) {
  const t = e && e.__v_raw;
  return t ? Ye(t) : e;
}
function $p(e) {
  return !Xe(e, "__v_skip") && Object.isExtensible(e) && yp(e, "__v_skip", !0), e;
}
const jt = (e) => st(e) ? ha(e) : e, hc = (e) => st(e) ? Fp(e) : e;
function Gt(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function dt(e) {
  return Hp(e, !1);
}
function Bx(e) {
  return Hp(e, !0);
}
function Hp(e, t) {
  return Gt(e) ? e : new Fx(e, t);
}
class Fx {
  constructor(t, n) {
    this.dep = new Uc(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : Ye(t), this._value = n ? t : jt(t), this.__v_isShallow = n;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, s = this.__v_isShallow || On(t) || sr(t);
    t = s ? t : Ye(t), Ni(t, n) && (this._rawValue = t, this._value = s ? t : jt(t), this.dep.trigger());
  }
}
function en(e) {
  return Gt(e) ? e.value : e;
}
const $x = {
  get: (e, t, n) => t === "__v_raw" ? e : en(Reflect.get(e, t, n)),
  set: (e, t, n, s) => {
    const o = e[t];
    return Gt(o) && !Gt(n) ? (o.value = n, !0) : Reflect.set(e, t, n, s);
  }
};
function Up(e) {
  return Ar(e) ? e : new Proxy(e, $x);
}
class Hx {
  constructor(t, n, s) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new Uc(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Cs - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = s;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    rt !== this)
      return Lp(this, !0), !0;
  }
  get value() {
    const t = this.dep.track();
    return Ep(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter && this.setter(t);
  }
}
function Ux(e, t, n = !1) {
  let s, o;
  return De(e) ? s = e : (s = e.get, o = e.set), new Hx(s, o, n);
}
const No = {}, Xo = /* @__PURE__ */ new WeakMap();
let tr;
function zx(e, t = !1, n = tr) {
  if (n) {
    let s = Xo.get(n);
    s || Xo.set(n, s = []), s.push(e);
  }
}
function Wx(e, t, n = et) {
  const { immediate: s, deep: o, once: a, scheduler: c, augmentJob: u, call: d } = n, h = (Y) => o ? Y : On(Y) || o === !1 || o === 0 ? mi(Y, 1) : mi(Y);
  let m, v, b, S, D = !1, A = !1;
  if (Gt(e) ? (v = () => e.value, D = On(e)) : Ar(e) ? (v = () => h(e), D = !0) : we(e) ? (A = !0, D = e.some((Y) => Ar(Y) || On(Y)), v = () => e.map((Y) => {
    if (Gt(Y))
      return Y.value;
    if (Ar(Y))
      return h(Y);
    if (De(Y))
      return d ? d(Y, 2) : Y();
  })) : De(e) ? t ? v = d ? () => d(e, 2) : e : v = () => {
    if (b) {
      $i();
      try {
        b();
      } finally {
        Hi();
      }
    }
    const Y = tr;
    tr = m;
    try {
      return d ? d(e, 3, [S]) : e(S);
    } finally {
      tr = Y;
    }
  } : v = Jn, t && o) {
    const Y = v, re = o === !0 ? 1 / 0 : o;
    v = () => mi(Y(), re);
  }
  const R = yx(), F = () => {
    m.stop(), R && R.active && Nc(R.effects, m);
  };
  if (a && t) {
    const Y = t;
    t = (...re) => {
      Y(...re), F();
    };
  }
  let K = A ? new Array(e.length).fill(No) : No;
  const G = (Y) => {
    if (!(!(m.flags & 1) || !m.dirty && !Y))
      if (t) {
        const re = m.run();
        if (o || D || (A ? re.some((be, ue) => Ni(be, K[ue])) : Ni(re, K))) {
          b && b();
          const be = tr;
          tr = m;
          try {
            const ue = [
              re,
              // pass undefined as the old value when it's changed for the first time
              K === No ? void 0 : A && K[0] === No ? [] : K,
              S
            ];
            d ? d(t, 3, ue) : (
              // @ts-expect-error
              t(...ue)
            ), K = re;
          } finally {
            tr = be;
          }
        }
      } else
        m.run();
  };
  return u && u(G), m = new Cp(v), m.scheduler = c ? () => c(G, !1) : G, S = (Y) => zx(Y, !1, m), b = m.onStop = () => {
    const Y = Xo.get(m);
    if (Y) {
      if (d)
        d(Y, 4);
      else
        for (const re of Y) re();
      Xo.delete(m);
    }
  }, t ? s ? G(!0) : K = m.run() : c ? c(G.bind(null, !0), !0) : m.run(), F.pause = m.pause.bind(m), F.resume = m.resume.bind(m), F.stop = F, F;
}
function mi(e, t = 1 / 0, n) {
  if (t <= 0 || !st(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, Gt(e))
    mi(e.value, t, n);
  else if (we(e))
    for (let s = 0; s < e.length; s++)
      mi(e[s], t, n);
  else if (Wr(e) || Or(e))
    e.forEach((s) => {
      mi(s, t, n);
    });
  else if (vp(e)) {
    for (const s in e)
      mi(e[s], t, n);
    for (const s of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, s) && mi(e[s], t, n);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Fs(e, t, n, s) {
  try {
    return s ? e(...s) : e();
  } catch (o) {
    pa(o, t, n);
  }
}
function Qn(e, t, n, s) {
  if (De(e)) {
    const o = Fs(e, t, n, s);
    return o && gp(o) && o.catch((a) => {
      pa(a, t, n);
    }), o;
  }
  if (we(e)) {
    const o = [];
    for (let a = 0; a < e.length; a++)
      o.push(Qn(e[a], t, n, s));
    return o;
  }
}
function pa(e, t, n, s = !0) {
  const o = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: c } = t && t.appContext.config || et;
  if (t) {
    let u = t.parent;
    const d = t.proxy, h = `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; u; ) {
      const m = u.ec;
      if (m) {
        for (let v = 0; v < m.length; v++)
          if (m[v](e, d, h) === !1)
            return;
      }
      u = u.parent;
    }
    if (a) {
      $i(), Fs(a, null, 10, [
        e,
        d,
        h
      ]), Hi();
      return;
    }
  }
  qx(e, n, o, s, c);
}
function qx(e, t, n, s = !0, o = !1) {
  if (o)
    throw e;
  console.error(e);
}
const Qt = [];
let Kn = -1;
const Pr = [];
let ki = null, Tr = 0;
const zp = /* @__PURE__ */ Promise.resolve();
let Jo = null;
function jc(e) {
  const t = Jo || zp;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function jx(e) {
  let t = Kn + 1, n = Qt.length;
  for (; t < n; ) {
    const s = t + n >>> 1, o = Qt[s], a = Ls(o);
    a < e || a === e && o.flags & 2 ? t = s + 1 : n = s;
  }
  return t;
}
function Vc(e) {
  if (!(e.flags & 1)) {
    const t = Ls(e), n = Qt[Qt.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= Ls(n) ? Qt.push(e) : Qt.splice(jx(t), 0, e), e.flags |= 1, Wp();
  }
}
function Wp() {
  Jo || (Jo = zp.then(jp));
}
function Vx(e) {
  we(e) ? Pr.push(...e) : ki && e.id === -1 ? ki.splice(Tr + 1, 0, e) : e.flags & 1 || (Pr.push(e), e.flags |= 1), Wp();
}
function qd(e, t, n = Kn + 1) {
  for (; n < Qt.length; n++) {
    const s = Qt[n];
    if (s && s.flags & 2) {
      if (e && s.id !== e.uid)
        continue;
      Qt.splice(n, 1), n--, s.flags & 4 && (s.flags &= -2), s(), s.flags & 4 || (s.flags &= -2);
    }
  }
}
function qp(e) {
  if (Pr.length) {
    const t = [...new Set(Pr)].sort(
      (n, s) => Ls(n) - Ls(s)
    );
    if (Pr.length = 0, ki) {
      ki.push(...t);
      return;
    }
    for (ki = t, Tr = 0; Tr < ki.length; Tr++) {
      const n = ki[Tr];
      n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2;
    }
    ki = null, Tr = 0;
  }
}
const Ls = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function jp(e) {
  try {
    for (Kn = 0; Kn < Qt.length; Kn++) {
      const t = Qt[Kn];
      t && !(t.flags & 8) && (t.flags & 4 && (t.flags &= -2), Fs(
        t,
        t.i,
        t.i ? 15 : 14
      ), t.flags & 4 || (t.flags &= -2));
    }
  } finally {
    for (; Kn < Qt.length; Kn++) {
      const t = Qt[Kn];
      t && (t.flags &= -2);
    }
    Kn = -1, Qt.length = 0, qp(), Jo = null, (Qt.length || Pr.length) && jp();
  }
}
let Pt = null, Vp = null;
function Zo(e) {
  const t = Pt;
  return Pt = e, Vp = e && e.type.__scopeId || null, t;
}
function vt(e, t = Pt, n) {
  if (!t || e._n)
    return e;
  const s = (...o) => {
    s._d && eh(-1);
    const a = Zo(t);
    let c;
    try {
      c = e(...o);
    } finally {
      Zo(a), s._d && eh(1);
    }
    return c;
  };
  return s._n = !0, s._c = !0, s._d = !0, s;
}
function gt(e, t) {
  if (Pt === null)
    return e;
  const n = ba(Pt), s = e.dirs || (e.dirs = []);
  for (let o = 0; o < t.length; o++) {
    let [a, c, u, d = et] = t[o];
    a && (De(a) && (a = {
      mounted: a,
      updated: a
    }), a.deep && mi(c), s.push({
      dir: a,
      instance: n,
      value: c,
      oldValue: void 0,
      arg: u,
      modifiers: d
    }));
  }
  return e;
}
function Xi(e, t, n, s) {
  const o = e.dirs, a = t && t.dirs;
  for (let c = 0; c < o.length; c++) {
    const u = o[c];
    a && (u.oldValue = a[c].value);
    let d = u.dir[s];
    d && ($i(), Qn(d, n, 8, [
      e.el,
      u,
      e,
      t
    ]), Hi());
  }
}
const Gx = Symbol("_vte"), Kx = (e) => e.__isTeleport;
function Gc(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, Gc(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Un(e, t) {
  return De(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    Kt({ name: e.name }, t, { setup: e })
  ) : e;
}
function Yx() {
  const e = V_();
  return e ? (e.appContext.config.idPrefix || "v") + "-" + e.ids[0] + e.ids[1]++ : "";
}
function Gp(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
function Qo(e, t, n, s, o = !1) {
  if (we(e)) {
    e.forEach(
      (D, A) => Qo(
        D,
        t && (we(t) ? t[A] : t),
        n,
        s,
        o
      )
    );
    return;
  }
  if (Nr(s) && !o) {
    s.shapeFlag & 512 && s.type.__asyncResolved && s.component.subTree.component && Qo(e, t, n, s.component.subTree);
    return;
  }
  const a = s.shapeFlag & 4 ? ba(s.component) : s.el, c = o ? null : a, { i: u, r: d } = e, h = t && t.r, m = u.refs === et ? u.refs = {} : u.refs, v = u.setupState, b = Ye(v), S = v === et ? () => !1 : (D) => Xe(b, D);
  if (h != null && h !== d && (Dt(h) ? (m[h] = null, S(h) && (v[h] = null)) : Gt(h) && (h.value = null)), De(d))
    Fs(d, u, 12, [c, m]);
  else {
    const D = Dt(d), A = Gt(d);
    if (D || A) {
      const R = () => {
        if (e.f) {
          const F = D ? S(d) ? v[d] : m[d] : d.value;
          o ? we(F) && Nc(F, a) : we(F) ? F.includes(a) || F.push(a) : D ? (m[d] = [a], S(d) && (v[d] = m[d])) : (d.value = [a], e.k && (m[e.k] = d.value));
        } else D ? (m[d] = c, S(d) && (v[d] = c)) : A && (d.value = c, e.k && (m[e.k] = c));
      };
      c ? (R.id = -1, bn(R, n)) : R();
    }
  }
}
fa().requestIdleCallback;
fa().cancelIdleCallback;
const Nr = (e) => !!e.type.__asyncLoader, Kp = (e) => e.type.__isKeepAlive;
function Xx(e, t) {
  Yp(e, "a", t);
}
function Jx(e, t) {
  Yp(e, "da", t);
}
function Yp(e, t, n = Ht) {
  const s = e.__wdc || (e.__wdc = () => {
    let o = n;
    for (; o; ) {
      if (o.isDeactivated)
        return;
      o = o.parent;
    }
    return e();
  });
  if (ga(t, s, n), n) {
    let o = n.parent;
    for (; o && o.parent; )
      Kp(o.parent.vnode) && Zx(s, t, n, o), o = o.parent;
  }
}
function Zx(e, t, n, s) {
  const o = ga(
    t,
    e,
    s,
    !0
    /* prepend */
  );
  ma(() => {
    Nc(s[t], o);
  }, n);
}
function ga(e, t, n = Ht, s = !1) {
  if (n) {
    const o = n[e] || (n[e] = []), a = t.__weh || (t.__weh = (...c) => {
      $i();
      const u = $s(n), d = Qn(t, n, e, c);
      return u(), Hi(), d;
    });
    return s ? o.unshift(a) : o.push(a), a;
  }
}
const yi = (e) => (t, n = Ht) => {
  (!Es || e === "sp") && ga(e, (...s) => t(...s), n);
}, Qx = yi("bm"), Zn = yi("m"), e_ = yi(
  "bu"
), t_ = yi("u"), n_ = yi(
  "bum"
), ma = yi("um"), i_ = yi(
  "sp"
), r_ = yi("rtg"), s_ = yi("rtc");
function o_(e, t = Ht) {
  ga("ec", e, t);
}
const a_ = "components";
function Ve(e, t) {
  return c_(a_, e, !0, t) || e;
}
const l_ = Symbol.for("v-ndc");
function c_(e, t, n = !0, s = !1) {
  const o = Pt || Ht;
  if (o) {
    const a = o.type;
    {
      const u = J_(
        a,
        !1
      );
      if (u && (u === t || u === An(t) || u === ua(An(t))))
        return a;
    }
    const c = (
      // local registration
      // check instance[type] first which is resolved for options API
      jd(o[e] || a[e], t) || // global registration
      jd(o.appContext[e], t)
    );
    return !c && s ? a : c;
  }
}
function jd(e, t) {
  return e && (e[t] || e[An(t)] || e[ua(An(t))]);
}
function ut(e, t, n, s) {
  let o;
  const a = n, c = we(e);
  if (c || Dt(e)) {
    const u = c && Ar(e);
    let d = !1;
    u && (d = !On(e), e = da(e)), o = new Array(e.length);
    for (let h = 0, m = e.length; h < m; h++)
      o[h] = t(
        d ? jt(e[h]) : e[h],
        h,
        void 0,
        a
      );
  } else if (typeof e == "number") {
    o = new Array(e);
    for (let u = 0; u < e; u++)
      o[u] = t(u + 1, u, void 0, a);
  } else if (st(e))
    if (e[Symbol.iterator])
      o = Array.from(
        e,
        (u, d) => t(u, d, void 0, a)
      );
    else {
      const u = Object.keys(e);
      o = new Array(u.length);
      for (let d = 0, h = u.length; d < h; d++) {
        const m = u[d];
        o[d] = t(e[m], m, d, a);
      }
    }
  else
    o = [];
  return o;
}
function va(e, t, n = {}, s, o) {
  if (Pt.ce || Pt.parent && Nr(Pt.parent) && Pt.parent.ce)
    return O(), fn(
      Ae,
      null,
      [_e("slot", n, s)],
      64
    );
  let a = e[t];
  a && a._c && (a._d = !1), O();
  const c = a && Xp(a(n)), u = n.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  c && c.key, d = fn(
    Ae,
    {
      key: (u && !$n(u) ? u : `_${t}`) + // #7256 force differentiate fallback content from actual content
      ""
    },
    c || [],
    c && e._ === 1 ? 64 : -2
  );
  return !o && d.scopeId && (d.slotScopeIds = [d.scopeId + "-s"]), a && a._c && (a._d = !0), d;
}
function Xp(e) {
  return e.some((t) => Is(t) ? !(t.type === Bi || t.type === Ae && !Xp(t.children)) : !0) ? e : null;
}
const pc = (e) => e ? mg(e) ? ba(e) : pc(e.parent) : null, ws = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ Kt(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => pc(e.parent),
    $root: (e) => pc(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => Zp(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      Vc(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = jc.bind(e.proxy)),
    $watch: (e) => k_.bind(e)
  })
), Vl = (e, t) => e !== et && !e.__isScriptSetup && Xe(e, t), u_ = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: s, data: o, props: a, accessCache: c, type: u, appContext: d } = e;
    let h;
    if (t[0] !== "$") {
      const S = c[t];
      if (S !== void 0)
        switch (S) {
          case 1:
            return s[t];
          case 2:
            return o[t];
          case 4:
            return n[t];
          case 3:
            return a[t];
        }
      else {
        if (Vl(s, t))
          return c[t] = 1, s[t];
        if (o !== et && Xe(o, t))
          return c[t] = 2, o[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (h = e.propsOptions[0]) && Xe(h, t)
        )
          return c[t] = 3, a[t];
        if (n !== et && Xe(n, t))
          return c[t] = 4, n[t];
        gc && (c[t] = 0);
      }
    }
    const m = ws[t];
    let v, b;
    if (m)
      return t === "$attrs" && qt(e.attrs, "get", ""), m(e);
    if (
      // css module (injected by vue-loader)
      (v = u.__cssModules) && (v = v[t])
    )
      return v;
    if (n !== et && Xe(n, t))
      return c[t] = 4, n[t];
    if (
      // global properties
      b = d.config.globalProperties, Xe(b, t)
    )
      return b[t];
  },
  set({ _: e }, t, n) {
    const { data: s, setupState: o, ctx: a } = e;
    return Vl(o, t) ? (o[t] = n, !0) : s !== et && Xe(s, t) ? (s[t] = n, !0) : Xe(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (a[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: s, appContext: o, propsOptions: a }
  }, c) {
    let u;
    return !!n[c] || e !== et && Xe(e, c) || Vl(t, c) || (u = a[0]) && Xe(u, c) || Xe(s, c) || Xe(ws, c) || Xe(o.config.globalProperties, c);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : Xe(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
function Vd(e) {
  return we(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
let gc = !0;
function f_(e) {
  const t = Zp(e), n = e.proxy, s = e.ctx;
  gc = !1, t.beforeCreate && Gd(t.beforeCreate, e, "bc");
  const {
    // state
    data: o,
    computed: a,
    methods: c,
    watch: u,
    provide: d,
    inject: h,
    // lifecycle
    created: m,
    beforeMount: v,
    mounted: b,
    beforeUpdate: S,
    updated: D,
    activated: A,
    deactivated: R,
    beforeDestroy: F,
    beforeUnmount: K,
    destroyed: G,
    unmounted: Y,
    render: re,
    renderTracked: be,
    renderTriggered: ue,
    errorCaptured: xe,
    serverPrefetch: Ee,
    // public API
    expose: lt,
    inheritAttrs: Z,
    // assets
    components: kt,
    directives: Ue,
    filters: Nt
  } = t;
  if (h && d_(h, s, null), c)
    for (const ke in c) {
      const Ce = c[ke];
      De(Ce) && (s[ke] = Ce.bind(n));
    }
  if (o) {
    const ke = o.call(n, n);
    st(ke) && (e.data = ha(ke));
  }
  if (gc = !0, a)
    for (const ke in a) {
      const Ce = a[ke], It = De(Ce) ? Ce.bind(n, n) : De(Ce.get) ? Ce.get.bind(n, n) : Jn, yt = !De(Ce) && De(Ce.set) ? Ce.set.bind(n) : Jn, Je = Ut({
        get: It,
        set: yt
      });
      Object.defineProperty(s, ke, {
        enumerable: !0,
        configurable: !0,
        get: () => Je.value,
        set: (tt) => Je.value = tt
      });
    }
  if (u)
    for (const ke in u)
      Jp(u[ke], s, n, ke);
  if (d) {
    const ke = De(d) ? d.call(n) : d;
    Reflect.ownKeys(ke).forEach((Ce) => {
      Mi(Ce, ke[Ce]);
    });
  }
  m && Gd(m, e, "c");
  function Pe(ke, Ce) {
    we(Ce) ? Ce.forEach((It) => ke(It.bind(n))) : Ce && ke(Ce.bind(n));
  }
  if (Pe(Qx, v), Pe(Zn, b), Pe(e_, S), Pe(t_, D), Pe(Xx, A), Pe(Jx, R), Pe(o_, xe), Pe(s_, be), Pe(r_, ue), Pe(n_, K), Pe(ma, Y), Pe(i_, Ee), we(lt))
    if (lt.length) {
      const ke = e.exposed || (e.exposed = {});
      lt.forEach((Ce) => {
        Object.defineProperty(ke, Ce, {
          get: () => n[Ce],
          set: (It) => n[Ce] = It
        });
      });
    } else e.exposed || (e.exposed = {});
  re && e.render === Jn && (e.render = re), Z != null && (e.inheritAttrs = Z), kt && (e.components = kt), Ue && (e.directives = Ue), Ee && Gp(e);
}
function d_(e, t, n = Jn) {
  we(e) && (e = mc(e));
  for (const s in e) {
    const o = e[s];
    let a;
    st(o) ? "default" in o ? a = un(
      o.from || s,
      o.default,
      !0
    ) : a = un(o.from || s) : a = un(o), Gt(a) ? Object.defineProperty(t, s, {
      enumerable: !0,
      configurable: !0,
      get: () => a.value,
      set: (c) => a.value = c
    }) : t[s] = a;
  }
}
function Gd(e, t, n) {
  Qn(
    we(e) ? e.map((s) => s.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function Jp(e, t, n, s) {
  let o = s.includes(".") ? fg(n, s) : () => n[s];
  if (Dt(e)) {
    const a = t[e];
    De(a) && Br(o, a);
  } else if (De(e))
    Br(o, e.bind(n));
  else if (st(e))
    if (we(e))
      e.forEach((a) => Jp(a, t, n, s));
    else {
      const a = De(e.handler) ? e.handler.bind(n) : t[e.handler];
      De(a) && Br(o, a, e);
    }
}
function Zp(e) {
  const t = e.type, { mixins: n, extends: s } = t, {
    mixins: o,
    optionsCache: a,
    config: { optionMergeStrategies: c }
  } = e.appContext, u = a.get(t);
  let d;
  return u ? d = u : !o.length && !n && !s ? d = t : (d = {}, o.length && o.forEach(
    (h) => ea(d, h, c, !0)
  ), ea(d, t, c)), st(t) && a.set(t, d), d;
}
function ea(e, t, n, s = !1) {
  const { mixins: o, extends: a } = t;
  a && ea(e, a, n, !0), o && o.forEach(
    (c) => ea(e, c, n, !0)
  );
  for (const c in t)
    if (!(s && c === "expose")) {
      const u = h_[c] || n && n[c];
      e[c] = u ? u(e[c], t[c]) : t[c];
    }
  return e;
}
const h_ = {
  data: Kd,
  props: Yd,
  emits: Yd,
  // objects
  methods: gs,
  computed: gs,
  // lifecycle
  beforeCreate: Zt,
  created: Zt,
  beforeMount: Zt,
  mounted: Zt,
  beforeUpdate: Zt,
  updated: Zt,
  beforeDestroy: Zt,
  beforeUnmount: Zt,
  destroyed: Zt,
  unmounted: Zt,
  activated: Zt,
  deactivated: Zt,
  errorCaptured: Zt,
  serverPrefetch: Zt,
  // assets
  components: gs,
  directives: gs,
  // watch
  watch: g_,
  // provide / inject
  provide: Kd,
  inject: p_
};
function Kd(e, t) {
  return t ? e ? function() {
    return Kt(
      De(e) ? e.call(this, this) : e,
      De(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function p_(e, t) {
  return gs(mc(e), mc(t));
}
function mc(e) {
  if (we(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function Zt(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function gs(e, t) {
  return e ? Kt(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Yd(e, t) {
  return e ? we(e) && we(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : Kt(
    /* @__PURE__ */ Object.create(null),
    Vd(e),
    Vd(t ?? {})
  ) : t;
}
function g_(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = Kt(/* @__PURE__ */ Object.create(null), e);
  for (const s in t)
    n[s] = Zt(e[s], t[s]);
  return n;
}
function Qp() {
  return {
    app: null,
    config: {
      isNativeTag: sx,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let m_ = 0;
function v_(e, t) {
  return function(s, o = null) {
    De(s) || (s = Kt({}, s)), o != null && !st(o) && (o = null);
    const a = Qp(), c = /* @__PURE__ */ new WeakSet(), u = [];
    let d = !1;
    const h = a.app = {
      _uid: m_++,
      _component: s,
      _props: o,
      _container: null,
      _context: a,
      _instance: null,
      version: Q_,
      get config() {
        return a.config;
      },
      set config(m) {
      },
      use(m, ...v) {
        return c.has(m) || (m && De(m.install) ? (c.add(m), m.install(h, ...v)) : De(m) && (c.add(m), m(h, ...v))), h;
      },
      mixin(m) {
        return a.mixins.includes(m) || a.mixins.push(m), h;
      },
      component(m, v) {
        return v ? (a.components[m] = v, h) : a.components[m];
      },
      directive(m, v) {
        return v ? (a.directives[m] = v, h) : a.directives[m];
      },
      mount(m, v, b) {
        if (!d) {
          const S = h._ceVNode || _e(s, o);
          return S.appContext = a, b === !0 ? b = "svg" : b === !1 && (b = void 0), e(S, m, b), d = !0, h._container = m, m.__vue_app__ = h, ba(S.component);
        }
      },
      onUnmount(m) {
        u.push(m);
      },
      unmount() {
        d && (Qn(
          u,
          h._instance,
          16
        ), e(null, h._container), delete h._container.__vue_app__);
      },
      provide(m, v) {
        return a.provides[m] = v, h;
      },
      runWithContext(m) {
        const v = Mr;
        Mr = h;
        try {
          return m();
        } finally {
          Mr = v;
        }
      }
    };
    return h;
  };
}
let Mr = null;
function Mi(e, t) {
  if (Ht) {
    let n = Ht.provides;
    const s = Ht.parent && Ht.parent.provides;
    s === n && (n = Ht.provides = Object.create(s)), n[e] = t;
  }
}
function un(e, t, n = !1) {
  const s = Ht || Pt;
  if (s || Mr) {
    const o = Mr ? Mr._context.provides : s ? s.parent == null ? s.vnode.appContext && s.vnode.appContext.provides : s.parent.provides : void 0;
    if (o && e in o)
      return o[e];
    if (arguments.length > 1)
      return n && De(t) ? t.call(s && s.proxy) : t;
  }
}
const eg = {}, tg = () => Object.create(eg), ng = (e) => Object.getPrototypeOf(e) === eg;
function y_(e, t, n, s = !1) {
  const o = {}, a = tg();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), ig(e, t, o, a);
  for (const c in e.propsOptions[0])
    c in o || (o[c] = void 0);
  n ? e.props = s ? o : Bp(o) : e.type.props ? e.props = o : e.props = a, e.attrs = a;
}
function w_(e, t, n, s) {
  const {
    props: o,
    attrs: a,
    vnode: { patchFlag: c }
  } = e, u = Ye(o), [d] = e.propsOptions;
  let h = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (s || c > 0) && !(c & 16)
  ) {
    if (c & 8) {
      const m = e.vnode.dynamicProps;
      for (let v = 0; v < m.length; v++) {
        let b = m[v];
        if (ya(e.emitsOptions, b))
          continue;
        const S = t[b];
        if (d)
          if (Xe(a, b))
            S !== a[b] && (a[b] = S, h = !0);
          else {
            const D = An(b);
            o[D] = vc(
              d,
              u,
              D,
              S,
              e,
              !1
            );
          }
        else
          S !== a[b] && (a[b] = S, h = !0);
      }
    }
  } else {
    ig(e, t, o, a) && (h = !0);
    let m;
    for (const v in u)
      (!t || // for camelCase
      !Xe(t, v) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((m = lr(v)) === v || !Xe(t, m))) && (d ? n && // for camelCase
      (n[v] !== void 0 || // for kebab-case
      n[m] !== void 0) && (o[v] = vc(
        d,
        u,
        v,
        void 0,
        e,
        !0
      )) : delete o[v]);
    if (a !== u)
      for (const v in a)
        (!t || !Xe(t, v)) && (delete a[v], h = !0);
  }
  h && gi(e.attrs, "set", "");
}
function ig(e, t, n, s) {
  const [o, a] = e.propsOptions;
  let c = !1, u;
  if (t)
    for (let d in t) {
      if (ms(d))
        continue;
      const h = t[d];
      let m;
      o && Xe(o, m = An(d)) ? !a || !a.includes(m) ? n[m] = h : (u || (u = {}))[m] = h : ya(e.emitsOptions, d) || (!(d in s) || h !== s[d]) && (s[d] = h, c = !0);
    }
  if (a) {
    const d = Ye(n), h = u || et;
    for (let m = 0; m < a.length; m++) {
      const v = a[m];
      n[v] = vc(
        o,
        d,
        v,
        h[v],
        e,
        !Xe(h, v)
      );
    }
  }
  return c;
}
function vc(e, t, n, s, o, a) {
  const c = e[n];
  if (c != null) {
    const u = Xe(c, "default");
    if (u && s === void 0) {
      const d = c.default;
      if (c.type !== Function && !c.skipFactory && De(d)) {
        const { propsDefaults: h } = o;
        if (n in h)
          s = h[n];
        else {
          const m = $s(o);
          s = h[n] = d.call(
            null,
            t
          ), m();
        }
      } else
        s = d;
      o.ce && o.ce._setProp(n, s);
    }
    c[
      0
      /* shouldCast */
    ] && (a && !u ? s = !1 : c[
      1
      /* shouldCastTrue */
    ] && (s === "" || s === lr(n)) && (s = !0));
  }
  return s;
}
const b_ = /* @__PURE__ */ new WeakMap();
function rg(e, t, n = !1) {
  const s = n ? b_ : t.propsCache, o = s.get(e);
  if (o)
    return o;
  const a = e.props, c = {}, u = [];
  let d = !1;
  if (!De(e)) {
    const m = (v) => {
      d = !0;
      const [b, S] = rg(v, t, !0);
      Kt(c, b), S && u.push(...S);
    };
    !n && t.mixins.length && t.mixins.forEach(m), e.extends && m(e.extends), e.mixins && e.mixins.forEach(m);
  }
  if (!a && !d)
    return st(e) && s.set(e, Rr), Rr;
  if (we(a))
    for (let m = 0; m < a.length; m++) {
      const v = An(a[m]);
      Xd(v) && (c[v] = et);
    }
  else if (a)
    for (const m in a) {
      const v = An(m);
      if (Xd(v)) {
        const b = a[m], S = c[v] = we(b) || De(b) ? { type: b } : Kt({}, b), D = S.type;
        let A = !1, R = !0;
        if (we(D))
          for (let F = 0; F < D.length; ++F) {
            const K = D[F], G = De(K) && K.name;
            if (G === "Boolean") {
              A = !0;
              break;
            } else G === "String" && (R = !1);
          }
        else
          A = De(D) && D.name === "Boolean";
        S[
          0
          /* shouldCast */
        ] = A, S[
          1
          /* shouldCastTrue */
        ] = R, (A || Xe(S, "default")) && u.push(v);
      }
    }
  const h = [c, u];
  return st(e) && s.set(e, h), h;
}
function Xd(e) {
  return e[0] !== "$" && !ms(e);
}
const sg = (e) => e[0] === "_" || e === "$stable", Kc = (e) => we(e) ? e.map(Yn) : [Yn(e)], x_ = (e, t, n) => {
  if (t._n)
    return t;
  const s = vt((...o) => Kc(t(...o)), n);
  return s._c = !1, s;
}, og = (e, t, n) => {
  const s = e._ctx;
  for (const o in e) {
    if (sg(o)) continue;
    const a = e[o];
    if (De(a))
      t[o] = x_(o, a, s);
    else if (a != null) {
      const c = Kc(a);
      t[o] = () => c;
    }
  }
}, ag = (e, t) => {
  const n = Kc(t);
  e.slots.default = () => n;
}, lg = (e, t, n) => {
  for (const s in t)
    (n || s !== "_") && (e[s] = t[s]);
}, __ = (e, t, n) => {
  const s = e.slots = tg();
  if (e.vnode.shapeFlag & 32) {
    const o = t._;
    o ? (lg(s, t, n), n && yp(s, "_", o, !0)) : og(t, s);
  } else t && ag(e, t);
}, C_ = (e, t, n) => {
  const { vnode: s, slots: o } = e;
  let a = !0, c = et;
  if (s.shapeFlag & 32) {
    const u = t._;
    u ? n && u === 1 ? a = !1 : lg(o, t, n) : (a = !t.$stable, og(t, o)), c = t;
  } else t && (ag(e, t), c = { default: 1 });
  if (a)
    for (const u in o)
      !sg(u) && c[u] == null && delete o[u];
}, bn = B_;
function S_(e) {
  return L_(e);
}
function L_(e, t) {
  const n = fa();
  n.__VUE__ = !0;
  const {
    insert: s,
    remove: o,
    patchProp: a,
    createElement: c,
    createText: u,
    createComment: d,
    setText: h,
    setElementText: m,
    parentNode: v,
    nextSibling: b,
    setScopeId: S = Jn,
    insertStaticContent: D
  } = e, A = (x, C, T, H = null, q = null, B = null, ee = void 0, X = null, J = !!C.dynamicChildren) => {
    if (x === C)
      return;
    x && !ls(x, C) && (H = U(x), tt(x, q, B, !0), x = null), C.patchFlag === -2 && (J = !1, C.dynamicChildren = null);
    const { type: j, ref: de, shapeFlag: ie } = C;
    switch (j) {
      case wa:
        R(x, C, T, H);
        break;
      case Bi:
        F(x, C, T, H);
        break;
      case zo:
        x == null && K(C, T, H, ee);
        break;
      case Ae:
        kt(
          x,
          C,
          T,
          H,
          q,
          B,
          ee,
          X,
          J
        );
        break;
      default:
        ie & 1 ? re(
          x,
          C,
          T,
          H,
          q,
          B,
          ee,
          X,
          J
        ) : ie & 6 ? Ue(
          x,
          C,
          T,
          H,
          q,
          B,
          ee,
          X,
          J
        ) : (ie & 64 || ie & 128) && j.process(
          x,
          C,
          T,
          H,
          q,
          B,
          ee,
          X,
          J,
          ae
        );
    }
    de != null && q && Qo(de, x && x.ref, B, C || x, !C);
  }, R = (x, C, T, H) => {
    if (x == null)
      s(
        C.el = u(C.children),
        T,
        H
      );
    else {
      const q = C.el = x.el;
      C.children !== x.children && h(q, C.children);
    }
  }, F = (x, C, T, H) => {
    x == null ? s(
      C.el = d(C.children || ""),
      T,
      H
    ) : C.el = x.el;
  }, K = (x, C, T, H) => {
    [x.el, x.anchor] = D(
      x.children,
      C,
      T,
      H,
      x.el,
      x.anchor
    );
  }, G = ({ el: x, anchor: C }, T, H) => {
    let q;
    for (; x && x !== C; )
      q = b(x), s(x, T, H), x = q;
    s(C, T, H);
  }, Y = ({ el: x, anchor: C }) => {
    let T;
    for (; x && x !== C; )
      T = b(x), o(x), x = T;
    o(C);
  }, re = (x, C, T, H, q, B, ee, X, J) => {
    C.type === "svg" ? ee = "svg" : C.type === "math" && (ee = "mathml"), x == null ? be(
      C,
      T,
      H,
      q,
      B,
      ee,
      X,
      J
    ) : Ee(
      x,
      C,
      q,
      B,
      ee,
      X,
      J
    );
  }, be = (x, C, T, H, q, B, ee, X) => {
    let J, j;
    const { props: de, shapeFlag: ie, transition: he, dirs: pe } = x;
    if (J = x.el = c(
      x.type,
      B,
      de && de.is,
      de
    ), ie & 8 ? m(J, x.children) : ie & 16 && xe(
      x.children,
      J,
      null,
      H,
      q,
      Gl(x, B),
      ee,
      X
    ), pe && Xi(x, null, H, "created"), ue(J, x, x.scopeId, ee, H), de) {
      for (const We in de)
        We !== "value" && !ms(We) && a(J, We, null, de[We], B, H);
      "value" in de && a(J, "value", null, de.value, B), (j = de.onVnodeBeforeMount) && Vn(j, H, x);
    }
    pe && Xi(x, null, H, "beforeMount");
    const Me = D_(q, he);
    Me && he.beforeEnter(J), s(J, C, T), ((j = de && de.onVnodeMounted) || Me || pe) && bn(() => {
      j && Vn(j, H, x), Me && he.enter(J), pe && Xi(x, null, H, "mounted");
    }, q);
  }, ue = (x, C, T, H, q) => {
    if (T && S(x, T), H)
      for (let B = 0; B < H.length; B++)
        S(x, H[B]);
    if (q) {
      let B = q.subTree;
      if (C === B || hg(B.type) && (B.ssContent === C || B.ssFallback === C)) {
        const ee = q.vnode;
        ue(
          x,
          ee,
          ee.scopeId,
          ee.slotScopeIds,
          q.parent
        );
      }
    }
  }, xe = (x, C, T, H, q, B, ee, X, J = 0) => {
    for (let j = J; j < x.length; j++) {
      const de = x[j] = X ? Ri(x[j]) : Yn(x[j]);
      A(
        null,
        de,
        C,
        T,
        H,
        q,
        B,
        ee,
        X
      );
    }
  }, Ee = (x, C, T, H, q, B, ee) => {
    const X = C.el = x.el;
    let { patchFlag: J, dynamicChildren: j, dirs: de } = C;
    J |= x.patchFlag & 16;
    const ie = x.props || et, he = C.props || et;
    let pe;
    if (T && Ji(T, !1), (pe = he.onVnodeBeforeUpdate) && Vn(pe, T, C, x), de && Xi(C, x, T, "beforeUpdate"), T && Ji(T, !0), (ie.innerHTML && he.innerHTML == null || ie.textContent && he.textContent == null) && m(X, ""), j ? lt(
      x.dynamicChildren,
      j,
      X,
      T,
      H,
      Gl(C, q),
      B
    ) : ee || Ce(
      x,
      C,
      X,
      null,
      T,
      H,
      Gl(C, q),
      B,
      !1
    ), J > 0) {
      if (J & 16)
        Z(X, ie, he, T, q);
      else if (J & 2 && ie.class !== he.class && a(X, "class", null, he.class, q), J & 4 && a(X, "style", ie.style, he.style, q), J & 8) {
        const Me = C.dynamicProps;
        for (let We = 0; We < Me.length; We++) {
          const Be = Me[We], Mt = ie[Be], Ot = he[Be];
          (Ot !== Mt || Be === "value") && a(X, Be, Mt, Ot, q, T);
        }
      }
      J & 1 && x.children !== C.children && m(X, C.children);
    } else !ee && j == null && Z(X, ie, he, T, q);
    ((pe = he.onVnodeUpdated) || de) && bn(() => {
      pe && Vn(pe, T, C, x), de && Xi(C, x, T, "updated");
    }, H);
  }, lt = (x, C, T, H, q, B, ee) => {
    for (let X = 0; X < C.length; X++) {
      const J = x[X], j = C[X], de = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        J.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (J.type === Ae || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !ls(J, j) || // - In the case of a component, it could contain anything.
        J.shapeFlag & 70) ? v(J.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          T
        )
      );
      A(
        J,
        j,
        de,
        null,
        H,
        q,
        B,
        ee,
        !0
      );
    }
  }, Z = (x, C, T, H, q) => {
    if (C !== T) {
      if (C !== et)
        for (const B in C)
          !ms(B) && !(B in T) && a(
            x,
            B,
            C[B],
            null,
            q,
            H
          );
      for (const B in T) {
        if (ms(B)) continue;
        const ee = T[B], X = C[B];
        ee !== X && B !== "value" && a(x, B, X, ee, q, H);
      }
      "value" in T && a(x, "value", C.value, T.value, q);
    }
  }, kt = (x, C, T, H, q, B, ee, X, J) => {
    const j = C.el = x ? x.el : u(""), de = C.anchor = x ? x.anchor : u("");
    let { patchFlag: ie, dynamicChildren: he, slotScopeIds: pe } = C;
    pe && (X = X ? X.concat(pe) : pe), x == null ? (s(j, T, H), s(de, T, H), xe(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      C.children || [],
      T,
      de,
      q,
      B,
      ee,
      X,
      J
    )) : ie > 0 && ie & 64 && he && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    x.dynamicChildren ? (lt(
      x.dynamicChildren,
      he,
      T,
      q,
      B,
      ee,
      X
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (C.key != null || q && C === q.subTree) && cg(
      x,
      C,
      !0
      /* shallow */
    )) : Ce(
      x,
      C,
      T,
      de,
      q,
      B,
      ee,
      X,
      J
    );
  }, Ue = (x, C, T, H, q, B, ee, X, J) => {
    C.slotScopeIds = X, x == null ? C.shapeFlag & 512 ? q.ctx.activate(
      C,
      T,
      H,
      ee,
      J
    ) : Nt(
      C,
      T,
      H,
      q,
      B,
      ee,
      J
    ) : ht(x, C, J);
  }, Nt = (x, C, T, H, q, B, ee) => {
    const X = x.component = j_(
      x,
      H,
      q
    );
    if (Kp(x) && (X.ctx.renderer = ae), G_(X, !1, ee), X.asyncDep) {
      if (q && q.registerDep(X, Pe, ee), !x.el) {
        const J = X.subTree = _e(Bi);
        F(null, J, C, T);
      }
    } else
      Pe(
        X,
        x,
        C,
        T,
        q,
        B,
        ee
      );
  }, ht = (x, C, T) => {
    const H = C.component = x.component;
    if (N_(x, C, T))
      if (H.asyncDep && !H.asyncResolved) {
        ke(H, C, T);
        return;
      } else
        H.next = C, H.update();
    else
      C.el = x.el, H.vnode = C;
  }, Pe = (x, C, T, H, q, B, ee) => {
    const X = () => {
      if (x.isMounted) {
        let { next: ie, bu: he, u: pe, parent: Me, vnode: We } = x;
        {
          const rn = ug(x);
          if (rn) {
            ie && (ie.el = We.el, ke(x, ie, ee)), rn.asyncDep.then(() => {
              x.isUnmounted || X();
            });
            return;
          }
        }
        let Be = ie, Mt;
        Ji(x, !1), ie ? (ie.el = We.el, ke(x, ie, ee)) : ie = We, he && Uo(he), (Mt = ie.props && ie.props.onVnodeBeforeUpdate) && Vn(Mt, Me, ie, We), Ji(x, !0);
        const Ot = Zd(x), nn = x.subTree;
        x.subTree = Ot, A(
          nn,
          Ot,
          // parent may have changed if it's in a teleport
          v(nn.el),
          // anchor may have changed if it's in a fragment
          U(nn),
          x,
          q,
          B
        ), ie.el = Ot.el, Be === null && M_(x, Ot.el), pe && bn(pe, q), (Mt = ie.props && ie.props.onVnodeUpdated) && bn(
          () => Vn(Mt, Me, ie, We),
          q
        );
      } else {
        let ie;
        const { el: he, props: pe } = C, { bm: Me, m: We, parent: Be, root: Mt, type: Ot } = x, nn = Nr(C);
        Ji(x, !1), Me && Uo(Me), !nn && (ie = pe && pe.onVnodeBeforeMount) && Vn(ie, Be, C), Ji(x, !0);
        {
          Mt.ce && Mt.ce._injectChildStyle(Ot);
          const rn = x.subTree = Zd(x);
          A(
            null,
            rn,
            T,
            H,
            x,
            q,
            B
          ), C.el = rn.el;
        }
        if (We && bn(We, q), !nn && (ie = pe && pe.onVnodeMounted)) {
          const rn = C;
          bn(
            () => Vn(ie, Be, rn),
            q
          );
        }
        (C.shapeFlag & 256 || Be && Nr(Be.vnode) && Be.vnode.shapeFlag & 256) && x.a && bn(x.a, q), x.isMounted = !0, C = T = H = null;
      }
    };
    x.scope.on();
    const J = x.effect = new Cp(X);
    x.scope.off();
    const j = x.update = J.run.bind(J), de = x.job = J.runIfDirty.bind(J);
    de.i = x, de.id = x.uid, J.scheduler = () => Vc(de), Ji(x, !0), j();
  }, ke = (x, C, T) => {
    C.component = x;
    const H = x.vnode.props;
    x.vnode = C, x.next = null, w_(x, C.props, H, T), C_(x, C.children, T), $i(), qd(x), Hi();
  }, Ce = (x, C, T, H, q, B, ee, X, J = !1) => {
    const j = x && x.children, de = x ? x.shapeFlag : 0, ie = C.children, { patchFlag: he, shapeFlag: pe } = C;
    if (he > 0) {
      if (he & 128) {
        yt(
          j,
          ie,
          T,
          H,
          q,
          B,
          ee,
          X,
          J
        );
        return;
      } else if (he & 256) {
        It(
          j,
          ie,
          T,
          H,
          q,
          B,
          ee,
          X,
          J
        );
        return;
      }
    }
    pe & 8 ? (de & 16 && wt(j, q, B), ie !== j && m(T, ie)) : de & 16 ? pe & 16 ? yt(
      j,
      ie,
      T,
      H,
      q,
      B,
      ee,
      X,
      J
    ) : wt(j, q, B, !0) : (de & 8 && m(T, ""), pe & 16 && xe(
      ie,
      T,
      H,
      q,
      B,
      ee,
      X,
      J
    ));
  }, It = (x, C, T, H, q, B, ee, X, J) => {
    x = x || Rr, C = C || Rr;
    const j = x.length, de = C.length, ie = Math.min(j, de);
    let he;
    for (he = 0; he < ie; he++) {
      const pe = C[he] = J ? Ri(C[he]) : Yn(C[he]);
      A(
        x[he],
        pe,
        T,
        null,
        q,
        B,
        ee,
        X,
        J
      );
    }
    j > de ? wt(
      x,
      q,
      B,
      !0,
      !1,
      ie
    ) : xe(
      C,
      T,
      H,
      q,
      B,
      ee,
      X,
      J,
      ie
    );
  }, yt = (x, C, T, H, q, B, ee, X, J) => {
    let j = 0;
    const de = C.length;
    let ie = x.length - 1, he = de - 1;
    for (; j <= ie && j <= he; ) {
      const pe = x[j], Me = C[j] = J ? Ri(C[j]) : Yn(C[j]);
      if (ls(pe, Me))
        A(
          pe,
          Me,
          T,
          null,
          q,
          B,
          ee,
          X,
          J
        );
      else
        break;
      j++;
    }
    for (; j <= ie && j <= he; ) {
      const pe = x[ie], Me = C[he] = J ? Ri(C[he]) : Yn(C[he]);
      if (ls(pe, Me))
        A(
          pe,
          Me,
          T,
          null,
          q,
          B,
          ee,
          X,
          J
        );
      else
        break;
      ie--, he--;
    }
    if (j > ie) {
      if (j <= he) {
        const pe = he + 1, Me = pe < de ? C[pe].el : H;
        for (; j <= he; )
          A(
            null,
            C[j] = J ? Ri(C[j]) : Yn(C[j]),
            T,
            Me,
            q,
            B,
            ee,
            X,
            J
          ), j++;
      }
    } else if (j > he)
      for (; j <= ie; )
        tt(x[j], q, B, !0), j++;
    else {
      const pe = j, Me = j, We = /* @__PURE__ */ new Map();
      for (j = Me; j <= he; j++) {
        const Bt = C[j] = J ? Ri(C[j]) : Yn(C[j]);
        Bt.key != null && We.set(Bt.key, j);
      }
      let Be, Mt = 0;
      const Ot = he - Me + 1;
      let nn = !1, rn = 0;
      const ei = new Array(Ot);
      for (j = 0; j < Ot; j++) ei[j] = 0;
      for (j = pe; j <= ie; j++) {
        const Bt = x[j];
        if (Mt >= Ot) {
          tt(Bt, q, B, !0);
          continue;
        }
        let sn;
        if (Bt.key != null)
          sn = We.get(Bt.key);
        else
          for (Be = Me; Be <= he; Be++)
            if (ei[Be - Me] === 0 && ls(Bt, C[Be])) {
              sn = Be;
              break;
            }
        sn === void 0 ? tt(Bt, q, B, !0) : (ei[sn - Me] = j + 1, sn >= rn ? rn = sn : nn = !0, A(
          Bt,
          C[sn],
          T,
          null,
          q,
          B,
          ee,
          X,
          J
        ), Mt++);
      }
      const ur = nn ? I_(ei) : Rr;
      for (Be = ur.length - 1, j = Ot - 1; j >= 0; j--) {
        const Bt = Me + j, sn = C[Bt], fr = Bt + 1 < de ? C[Bt + 1].el : H;
        ei[j] === 0 ? A(
          null,
          sn,
          T,
          fr,
          q,
          B,
          ee,
          X,
          J
        ) : nn && (Be < 0 || j !== ur[Be] ? Je(sn, T, fr, 2) : Be--);
      }
    }
  }, Je = (x, C, T, H, q = null) => {
    const { el: B, type: ee, transition: X, children: J, shapeFlag: j } = x;
    if (j & 6) {
      Je(x.component.subTree, C, T, H);
      return;
    }
    if (j & 128) {
      x.suspense.move(C, T, H);
      return;
    }
    if (j & 64) {
      ee.move(x, C, T, ae);
      return;
    }
    if (ee === Ae) {
      s(B, C, T);
      for (let ie = 0; ie < J.length; ie++)
        Je(J[ie], C, T, H);
      s(x.anchor, C, T);
      return;
    }
    if (ee === zo) {
      G(x, C, T);
      return;
    }
    if (H !== 2 && j & 1 && X)
      if (H === 0)
        X.beforeEnter(B), s(B, C, T), bn(() => X.enter(B), q);
      else {
        const { leave: ie, delayLeave: he, afterLeave: pe } = X, Me = () => s(B, C, T), We = () => {
          ie(B, () => {
            Me(), pe && pe();
          });
        };
        he ? he(B, Me, We) : We();
      }
    else
      s(B, C, T);
  }, tt = (x, C, T, H = !1, q = !1) => {
    const {
      type: B,
      props: ee,
      ref: X,
      children: J,
      dynamicChildren: j,
      shapeFlag: de,
      patchFlag: ie,
      dirs: he,
      cacheIndex: pe
    } = x;
    if (ie === -2 && (q = !1), X != null && Qo(X, null, T, x, !0), pe != null && (C.renderCache[pe] = void 0), de & 256) {
      C.ctx.deactivate(x);
      return;
    }
    const Me = de & 1 && he, We = !Nr(x);
    let Be;
    if (We && (Be = ee && ee.onVnodeBeforeUnmount) && Vn(Be, C, x), de & 6)
      Rt(x.component, T, H);
    else {
      if (de & 128) {
        x.suspense.unmount(T, H);
        return;
      }
      Me && Xi(x, null, C, "beforeUnmount"), de & 64 ? x.type.remove(
        x,
        C,
        T,
        ae,
        H
      ) : j && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !j.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (B !== Ae || ie > 0 && ie & 64) ? wt(
        j,
        C,
        T,
        !1,
        !0
      ) : (B === Ae && ie & 384 || !q && de & 16) && wt(J, C, T), H && ze(x);
    }
    (We && (Be = ee && ee.onVnodeUnmounted) || Me) && bn(() => {
      Be && Vn(Be, C, x), Me && Xi(x, null, C, "unmounted");
    }, T);
  }, ze = (x) => {
    const { type: C, el: T, anchor: H, transition: q } = x;
    if (C === Ae) {
      nt(T, H);
      return;
    }
    if (C === zo) {
      Y(x);
      return;
    }
    const B = () => {
      o(T), q && !q.persisted && q.afterLeave && q.afterLeave();
    };
    if (x.shapeFlag & 1 && q && !q.persisted) {
      const { leave: ee, delayLeave: X } = q, J = () => ee(T, B);
      X ? X(x.el, B, J) : J();
    } else
      B();
  }, nt = (x, C) => {
    let T;
    for (; x !== C; )
      T = b(x), o(x), x = T;
    o(C);
  }, Rt = (x, C, T) => {
    const { bum: H, scope: q, job: B, subTree: ee, um: X, m: J, a: j } = x;
    Jd(J), Jd(j), H && Uo(H), q.stop(), B && (B.flags |= 8, tt(ee, x, C, T)), X && bn(X, C), bn(() => {
      x.isUnmounted = !0;
    }, C), C && C.pendingBranch && !C.isUnmounted && x.asyncDep && !x.asyncResolved && x.suspenseId === C.pendingId && (C.deps--, C.deps === 0 && C.resolve());
  }, wt = (x, C, T, H = !1, q = !1, B = 0) => {
    for (let ee = B; ee < x.length; ee++)
      tt(x[ee], C, T, H, q);
  }, U = (x) => {
    if (x.shapeFlag & 6)
      return U(x.component.subTree);
    if (x.shapeFlag & 128)
      return x.suspense.next();
    const C = b(x.anchor || x.el), T = C && C[Gx];
    return T ? b(T) : C;
  };
  let te = !1;
  const Q = (x, C, T) => {
    x == null ? C._vnode && tt(C._vnode, null, null, !0) : A(
      C._vnode || null,
      x,
      C,
      null,
      null,
      null,
      T
    ), C._vnode = x, te || (te = !0, qd(), qp(), te = !1);
  }, ae = {
    p: A,
    um: tt,
    m: Je,
    r: ze,
    mt: Nt,
    mc: xe,
    pc: Ce,
    pbc: lt,
    n: U,
    o: e
  };
  return {
    render: Q,
    hydrate: void 0,
    createApp: v_(Q)
  };
}
function Gl({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function Ji({ effect: e, job: t }, n) {
  n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function D_(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function cg(e, t, n = !1) {
  const s = e.children, o = t.children;
  if (we(s) && we(o))
    for (let a = 0; a < s.length; a++) {
      const c = s[a];
      let u = o[a];
      u.shapeFlag & 1 && !u.dynamicChildren && ((u.patchFlag <= 0 || u.patchFlag === 32) && (u = o[a] = Ri(o[a]), u.el = c.el), !n && u.patchFlag !== -2 && cg(c, u)), u.type === wa && (u.el = c.el);
    }
}
function I_(e) {
  const t = e.slice(), n = [0];
  let s, o, a, c, u;
  const d = e.length;
  for (s = 0; s < d; s++) {
    const h = e[s];
    if (h !== 0) {
      if (o = n[n.length - 1], e[o] < h) {
        t[s] = o, n.push(s);
        continue;
      }
      for (a = 0, c = n.length - 1; a < c; )
        u = a + c >> 1, e[n[u]] < h ? a = u + 1 : c = u;
      h < e[n[a]] && (a > 0 && (t[s] = n[a - 1]), n[a] = s);
    }
  }
  for (a = n.length, c = n[a - 1]; a-- > 0; )
    n[a] = c, c = t[c];
  return n;
}
function ug(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : ug(t);
}
function Jd(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const E_ = Symbol.for("v-scx"), T_ = () => un(E_);
function ta(e, t) {
  return Yc(e, null, t);
}
function Br(e, t, n) {
  return Yc(e, t, n);
}
function Yc(e, t, n = et) {
  const { immediate: s, deep: o, flush: a, once: c } = n, u = Kt({}, n), d = t && s || !t && a !== "post";
  let h;
  if (Es) {
    if (a === "sync") {
      const S = T_();
      h = S.__watcherHandles || (S.__watcherHandles = []);
    } else if (!d) {
      const S = () => {
      };
      return S.stop = Jn, S.resume = Jn, S.pause = Jn, S;
    }
  }
  const m = Ht;
  u.call = (S, D, A) => Qn(S, m, D, A);
  let v = !1;
  a === "post" ? u.scheduler = (S) => {
    bn(S, m && m.suspense);
  } : a !== "sync" && (v = !0, u.scheduler = (S, D) => {
    D ? S() : Vc(S);
  }), u.augmentJob = (S) => {
    t && (S.flags |= 4), v && (S.flags |= 2, m && (S.id = m.uid, S.i = m));
  };
  const b = Wx(e, t, u);
  return Es && (h ? h.push(b) : d && b()), b;
}
function k_(e, t, n) {
  const s = this.proxy, o = Dt(e) ? e.includes(".") ? fg(s, e) : () => s[e] : e.bind(s, s);
  let a;
  De(t) ? a = t : (a = t.handler, n = t);
  const c = $s(this), u = Yc(o, a.bind(s), n);
  return c(), u;
}
function fg(e, t) {
  const n = t.split(".");
  return () => {
    let s = e;
    for (let o = 0; o < n.length && s; o++)
      s = s[n[o]];
    return s;
  };
}
const R_ = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${An(t)}Modifiers`] || e[`${lr(t)}Modifiers`];
function O_(e, t, ...n) {
  if (e.isUnmounted) return;
  const s = e.vnode.props || et;
  let o = n;
  const a = t.startsWith("update:"), c = a && R_(s, t.slice(7));
  c && (c.trim && (o = n.map((m) => Dt(m) ? m.trim() : m)), c.number && (o = n.map(Yo)));
  let u, d = s[u = Ul(t)] || // also try camelCase event handler (#2249)
  s[u = Ul(An(t))];
  !d && a && (d = s[u = Ul(lr(t))]), d && Qn(
    d,
    e,
    6,
    o
  );
  const h = s[u + "Once"];
  if (h) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[u])
      return;
    e.emitted[u] = !0, Qn(
      h,
      e,
      6,
      o
    );
  }
}
function dg(e, t, n = !1) {
  const s = t.emitsCache, o = s.get(e);
  if (o !== void 0)
    return o;
  const a = e.emits;
  let c = {}, u = !1;
  if (!De(e)) {
    const d = (h) => {
      const m = dg(h, t, !0);
      m && (u = !0, Kt(c, m));
    };
    !n && t.mixins.length && t.mixins.forEach(d), e.extends && d(e.extends), e.mixins && e.mixins.forEach(d);
  }
  return !a && !u ? (st(e) && s.set(e, null), null) : (we(a) ? a.forEach((d) => c[d] = null) : Kt(c, a), st(e) && s.set(e, c), c);
}
function ya(e, t) {
  return !e || !la(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), Xe(e, t[0].toLowerCase() + t.slice(1)) || Xe(e, lr(t)) || Xe(e, t));
}
function Zd(e) {
  const {
    type: t,
    vnode: n,
    proxy: s,
    withProxy: o,
    propsOptions: [a],
    slots: c,
    attrs: u,
    emit: d,
    render: h,
    renderCache: m,
    props: v,
    data: b,
    setupState: S,
    ctx: D,
    inheritAttrs: A
  } = e, R = Zo(e);
  let F, K;
  try {
    if (n.shapeFlag & 4) {
      const Y = o || s, re = Y;
      F = Yn(
        h.call(
          re,
          Y,
          m,
          v,
          S,
          b,
          D
        )
      ), K = u;
    } else {
      const Y = t;
      F = Yn(
        Y.length > 1 ? Y(
          v,
          { attrs: u, slots: c, emit: d }
        ) : Y(
          v,
          null
        )
      ), K = t.props ? u : A_(u);
    }
  } catch (Y) {
    bs.length = 0, pa(Y, e, 1), F = _e(Bi);
  }
  let G = F;
  if (K && A !== !1) {
    const Y = Object.keys(K), { shapeFlag: re } = G;
    Y.length && re & 7 && (a && Y.some(Pc) && (K = P_(
      K,
      a
    )), G = or(G, K, !1, !0));
  }
  return n.dirs && (G = or(G, null, !1, !0), G.dirs = G.dirs ? G.dirs.concat(n.dirs) : n.dirs), n.transition && Gc(G, n.transition), F = G, Zo(R), F;
}
const A_ = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || la(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, P_ = (e, t) => {
  const n = {};
  for (const s in e)
    (!Pc(s) || !(s.slice(9) in t)) && (n[s] = e[s]);
  return n;
};
function N_(e, t, n) {
  const { props: s, children: o, component: a } = e, { props: c, children: u, patchFlag: d } = t, h = a.emitsOptions;
  if (t.dirs || t.transition)
    return !0;
  if (n && d >= 0) {
    if (d & 1024)
      return !0;
    if (d & 16)
      return s ? Qd(s, c, h) : !!c;
    if (d & 8) {
      const m = t.dynamicProps;
      for (let v = 0; v < m.length; v++) {
        const b = m[v];
        if (c[b] !== s[b] && !ya(h, b))
          return !0;
      }
    }
  } else
    return (o || u) && (!u || !u.$stable) ? !0 : s === c ? !1 : s ? c ? Qd(s, c, h) : !0 : !!c;
  return !1;
}
function Qd(e, t, n) {
  const s = Object.keys(t);
  if (s.length !== Object.keys(e).length)
    return !0;
  for (let o = 0; o < s.length; o++) {
    const a = s[o];
    if (t[a] !== e[a] && !ya(n, a))
      return !0;
  }
  return !1;
}
function M_({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const s = t.subTree;
    if (s.suspense && s.suspense.activeBranch === e && (s.el = e.el), s === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const hg = (e) => e.__isSuspense;
function B_(e, t) {
  t && t.pendingBranch ? we(e) ? t.effects.push(...e) : t.effects.push(e) : Vx(e);
}
const Ae = Symbol.for("v-fgt"), wa = Symbol.for("v-txt"), Bi = Symbol.for("v-cmt"), zo = Symbol.for("v-stc"), bs = [];
let _n = null;
function O(e = !1) {
  bs.push(_n = e ? null : []);
}
function F_() {
  bs.pop(), _n = bs[bs.length - 1] || null;
}
let Ds = 1;
function eh(e, t = !1) {
  Ds += e, e < 0 && _n && t && (_n.hasOnce = !0);
}
function pg(e) {
  return e.dynamicChildren = Ds > 0 ? _n || Rr : null, F_(), Ds > 0 && _n && _n.push(e), e;
}
function P(e, t, n, s, o, a) {
  return pg(
    p(
      e,
      t,
      n,
      s,
      o,
      a,
      !0
    )
  );
}
function fn(e, t, n, s, o) {
  return pg(
    _e(
      e,
      t,
      n,
      s,
      o,
      !0
    )
  );
}
function Is(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function ls(e, t) {
  return e.type === t.type && e.key === t.key;
}
const gg = ({ key: e }) => e ?? null, Wo = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? Dt(e) || Gt(e) || De(e) ? { i: Pt, r: e, k: t, f: !!n } : e : null);
function p(e, t = null, n = null, s = 0, o = null, a = e === Ae ? 0 : 1, c = !1, u = !1) {
  const d = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && gg(t),
    ref: t && Wo(t),
    scopeId: Vp,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: a,
    patchFlag: s,
    dynamicProps: o,
    dynamicChildren: null,
    appContext: null,
    ctx: Pt
  };
  return u ? (Xc(d, n), a & 128 && e.normalize(d)) : n && (d.shapeFlag |= Dt(n) ? 8 : 16), Ds > 0 && // avoid a block node from tracking itself
  !c && // has current parent block
  _n && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (d.patchFlag > 0 || a & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  d.patchFlag !== 32 && _n.push(d), d;
}
const _e = $_;
function $_(e, t = null, n = null, s = 0, o = null, a = !1) {
  if ((!e || e === l_) && (e = Bi), Is(e)) {
    const u = or(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && Xc(u, n), Ds > 0 && !a && _n && (u.shapeFlag & 6 ? _n[_n.indexOf(e)] = u : _n.push(u)), u.patchFlag = -2, u;
  }
  if (Z_(e) && (e = e.__vccOpts), t) {
    t = H_(t);
    let { class: u, style: d } = t;
    u && !Dt(u) && (t.class = _t(u)), st(d) && (qc(d) && !we(d) && (d = Kt({}, d)), t.style = Lt(d));
  }
  const c = Dt(e) ? 1 : hg(e) ? 128 : Kx(e) ? 64 : st(e) ? 4 : De(e) ? 2 : 0;
  return p(
    e,
    t,
    n,
    s,
    o,
    c,
    a,
    !0
  );
}
function H_(e) {
  return e ? qc(e) || ng(e) ? Kt({}, e) : e : null;
}
function or(e, t, n = !1, s = !1) {
  const { props: o, ref: a, patchFlag: c, children: u, transition: d } = e, h = t ? z_(o || {}, t) : o, m = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: h,
    key: h && gg(h),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && a ? we(a) ? a.concat(Wo(t)) : [a, Wo(t)] : Wo(t)
    ) : a,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: u,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== Ae ? c === -1 ? 16 : c | 16 : c,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: d,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && or(e.ssContent),
    ssFallback: e.ssFallback && or(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return d && s && Gc(
    m,
    d.clone(m)
  ), m;
}
function tn(e = " ", t = 0) {
  return _e(wa, null, e, t);
}
function U_(e, t) {
  const n = _e(zo, null, e);
  return n.staticCount = t, n;
}
function le(e = "", t = !1) {
  return t ? (O(), fn(Bi, null, e)) : _e(Bi, null, e);
}
function Yn(e) {
  return e == null || typeof e == "boolean" ? _e(Bi) : we(e) ? _e(
    Ae,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : Is(e) ? Ri(e) : _e(wa, null, String(e));
}
function Ri(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : or(e);
}
function Xc(e, t) {
  let n = 0;
  const { shapeFlag: s } = e;
  if (t == null)
    t = null;
  else if (we(t))
    n = 16;
  else if (typeof t == "object")
    if (s & 65) {
      const o = t.default;
      o && (o._c && (o._d = !1), Xc(e, o()), o._c && (o._d = !0));
      return;
    } else {
      n = 32;
      const o = t._;
      !o && !ng(t) ? t._ctx = Pt : o === 3 && Pt && (Pt.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else De(t) ? (t = { default: t, _ctx: Pt }, n = 32) : (t = String(t), s & 64 ? (n = 16, t = [tn(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function z_(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    for (const o in s)
      if (o === "class")
        t.class !== s.class && (t.class = _t([t.class, s.class]));
      else if (o === "style")
        t.style = Lt([t.style, s.style]);
      else if (la(o)) {
        const a = t[o], c = s[o];
        c && a !== c && !(we(a) && a.includes(c)) && (t[o] = a ? [].concat(a, c) : c);
      } else o !== "" && (t[o] = s[o]);
  }
  return t;
}
function Vn(e, t, n, s = null) {
  Qn(e, t, 7, [
    n,
    s
  ]);
}
const W_ = Qp();
let q_ = 0;
function j_(e, t, n) {
  const s = e.type, o = (t ? t.appContext : e.appContext) || W_, a = {
    uid: q_++,
    vnode: e,
    type: s,
    parent: t,
    appContext: o,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new _p(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(o.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: rg(s, o),
    emitsOptions: dg(s, o),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: et,
    // inheritAttrs
    inheritAttrs: s.inheritAttrs,
    // state
    ctx: et,
    data: et,
    props: et,
    attrs: et,
    slots: et,
    refs: et,
    setupState: et,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return a.ctx = { _: a }, a.root = t ? t.root : a, a.emit = O_.bind(null, a), e.ce && e.ce(a), a;
}
let Ht = null;
const V_ = () => Ht || Pt;
let na, yc;
{
  const e = fa(), t = (n, s) => {
    let o;
    return (o = e[n]) || (o = e[n] = []), o.push(s), (a) => {
      o.length > 1 ? o.forEach((c) => c(a)) : o[0](a);
    };
  };
  na = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => Ht = n
  ), yc = t(
    "__VUE_SSR_SETTERS__",
    (n) => Es = n
  );
}
const $s = (e) => {
  const t = Ht;
  return na(e), e.scope.on(), () => {
    e.scope.off(), na(t);
  };
}, th = () => {
  Ht && Ht.scope.off(), na(null);
};
function mg(e) {
  return e.vnode.shapeFlag & 4;
}
let Es = !1;
function G_(e, t = !1, n = !1) {
  t && yc(t);
  const { props: s, children: o } = e.vnode, a = mg(e);
  y_(e, s, a, t), __(e, o, n);
  const c = a ? K_(e, t) : void 0;
  return t && yc(!1), c;
}
function K_(e, t) {
  const n = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, u_);
  const { setup: s } = n;
  if (s) {
    $i();
    const o = e.setupContext = s.length > 1 ? X_(e) : null, a = $s(e), c = Fs(
      s,
      e,
      0,
      [
        e.props,
        o
      ]
    ), u = gp(c);
    if (Hi(), a(), (u || e.sp) && !Nr(e) && Gp(e), u) {
      if (c.then(th, th), t)
        return c.then((d) => {
          nh(e, d);
        }).catch((d) => {
          pa(d, e, 0);
        });
      e.asyncDep = c;
    } else
      nh(e, c);
  } else
    vg(e);
}
function nh(e, t, n) {
  De(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : st(t) && (e.setupState = Up(t)), vg(e);
}
function vg(e, t, n) {
  const s = e.type;
  e.render || (e.render = s.render || Jn);
  {
    const o = $s(e);
    $i();
    try {
      f_(e);
    } finally {
      Hi(), o();
    }
  }
}
const Y_ = {
  get(e, t) {
    return qt(e, "get", ""), e[t];
  }
};
function X_(e) {
  const t = (n) => {
    e.exposed = n || {};
  };
  return {
    attrs: new Proxy(e.attrs, Y_),
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function ba(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Up($p(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in ws)
        return ws[n](e);
    },
    has(t, n) {
      return n in t || n in ws;
    }
  })) : e.proxy;
}
function J_(e, t = !0) {
  return De(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Z_(e) {
  return De(e) && "__vccOpts" in e;
}
const Ut = (e, t) => Ux(e, t, Es);
function Hs(e, t, n) {
  const s = arguments.length;
  return s === 2 ? st(t) && !we(t) ? Is(t) ? _e(e, null, [t]) : _e(e, t) : _e(e, null, t) : (s > 3 ? n = Array.prototype.slice.call(arguments, 2) : s === 3 && Is(n) && (n = [n]), _e(e, t, n));
}
const Q_ = "3.5.13";
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let wc;
const ih = typeof window < "u" && window.trustedTypes;
if (ih)
  try {
    wc = /* @__PURE__ */ ih.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch {
  }
const yg = wc ? (e) => wc.createHTML(e) : (e) => e, e2 = "http://www.w3.org/2000/svg", t2 = "http://www.w3.org/1998/Math/MathML", hi = typeof document < "u" ? document : null, rh = hi && /* @__PURE__ */ hi.createElement("template"), n2 = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, s) => {
    const o = t === "svg" ? hi.createElementNS(e2, e) : t === "mathml" ? hi.createElementNS(t2, e) : n ? hi.createElement(e, { is: n }) : hi.createElement(e);
    return e === "select" && s && s.multiple != null && o.setAttribute("multiple", s.multiple), o;
  },
  createText: (e) => hi.createTextNode(e),
  createComment: (e) => hi.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => hi.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, s, o, a) {
    const c = n ? n.previousSibling : t.lastChild;
    if (o && (o === a || o.nextSibling))
      for (; t.insertBefore(o.cloneNode(!0), n), !(o === a || !(o = o.nextSibling)); )
        ;
    else {
      rh.innerHTML = yg(
        s === "svg" ? `<svg>${e}</svg>` : s === "mathml" ? `<math>${e}</math>` : e
      );
      const u = rh.content;
      if (s === "svg" || s === "mathml") {
        const d = u.firstChild;
        for (; d.firstChild; )
          u.appendChild(d.firstChild);
        u.removeChild(d);
      }
      t.insertBefore(u, n);
    }
    return [
      // first
      c ? c.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, i2 = Symbol("_vtc");
function r2(e, t, n) {
  const s = e[i2];
  s && (t = (t ? [t, ...s] : [...s]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const sh = Symbol("_vod"), s2 = Symbol("_vsh"), o2 = Symbol(""), a2 = /(^|;)\s*display\s*:/;
function l2(e, t, n) {
  const s = e.style, o = Dt(n);
  let a = !1;
  if (n && !o) {
    if (t)
      if (Dt(t))
        for (const c of t.split(";")) {
          const u = c.slice(0, c.indexOf(":")).trim();
          n[u] == null && qo(s, u, "");
        }
      else
        for (const c in t)
          n[c] == null && qo(s, c, "");
    for (const c in n)
      c === "display" && (a = !0), qo(s, c, n[c]);
  } else if (o) {
    if (t !== n) {
      const c = s[o2];
      c && (n += ";" + c), s.cssText = n, a = a2.test(n);
    }
  } else t && e.removeAttribute("style");
  sh in e && (e[sh] = a ? s.display : "", e[s2] && (s.display = "none"));
}
const oh = /\s*!important$/;
function qo(e, t, n) {
  if (we(n))
    n.forEach((s) => qo(e, t, s));
  else if (n == null && (n = ""), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const s = c2(e, t);
    oh.test(n) ? e.setProperty(
      lr(s),
      n.replace(oh, ""),
      "important"
    ) : e[s] = n;
  }
}
const ah = ["Webkit", "Moz", "ms"], Kl = {};
function c2(e, t) {
  const n = Kl[t];
  if (n)
    return n;
  let s = An(t);
  if (s !== "filter" && s in e)
    return Kl[t] = s;
  s = ua(s);
  for (let o = 0; o < ah.length; o++) {
    const a = ah[o] + s;
    if (a in e)
      return Kl[t] = a;
  }
  return t;
}
const lh = "http://www.w3.org/1999/xlink";
function ch(e, t, n, s, o, a = gx(t)) {
  s && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(lh, t.slice(6, t.length)) : e.setAttributeNS(lh, t, n) : n == null || a && !wp(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    a ? "" : $n(n) ? String(n) : n
  );
}
function uh(e, t, n, s, o) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? yg(n) : n);
    return;
  }
  const a = e.tagName;
  if (t === "value" && a !== "PROGRESS" && // custom elements may use _value internally
  !a.includes("-")) {
    const u = a === "OPTION" ? e.getAttribute("value") || "" : e.value, d = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (u !== d || !("_value" in e)) && (e.value = d), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let c = !1;
  if (n === "" || n == null) {
    const u = typeof e[t];
    u === "boolean" ? n = wp(n) : n == null && u === "string" ? (n = "", c = !0) : u === "number" && (n = 0, c = !0);
  }
  try {
    e[t] = n;
  } catch {
  }
  c && e.removeAttribute(o || t);
}
function Ai(e, t, n, s) {
  e.addEventListener(t, n, s);
}
function u2(e, t, n, s) {
  e.removeEventListener(t, n, s);
}
const fh = Symbol("_vei");
function f2(e, t, n, s, o = null) {
  const a = e[fh] || (e[fh] = {}), c = a[t];
  if (s && c)
    c.value = s;
  else {
    const [u, d] = d2(t);
    if (s) {
      const h = a[t] = g2(
        s,
        o
      );
      Ai(e, u, h, d);
    } else c && (u2(e, u, c, d), a[t] = void 0);
  }
}
const dh = /(?:Once|Passive|Capture)$/;
function d2(e) {
  let t;
  if (dh.test(e)) {
    t = {};
    let s;
    for (; s = e.match(dh); )
      e = e.slice(0, e.length - s[0].length), t[s[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : lr(e.slice(2)), t];
}
let Yl = 0;
const h2 = /* @__PURE__ */ Promise.resolve(), p2 = () => Yl || (h2.then(() => Yl = 0), Yl = Date.now());
function g2(e, t) {
  const n = (s) => {
    if (!s._vts)
      s._vts = Date.now();
    else if (s._vts <= n.attached)
      return;
    Qn(
      m2(s, n.value),
      t,
      5,
      [s]
    );
  };
  return n.value = e, n.attached = p2(), n;
}
function m2(e, t) {
  if (we(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (s) => (o) => !o._stopped && s && s(o)
    );
  } else
    return t;
}
const hh = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, v2 = (e, t, n, s, o, a) => {
  const c = o === "svg";
  t === "class" ? r2(e, s, c) : t === "style" ? l2(e, n, s) : la(t) ? Pc(t) || f2(e, t, n, s, a) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : y2(e, t, s, c)) ? (uh(e, t, s), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && ch(e, t, s, c, a, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !Dt(s)) ? uh(e, An(t), s, a, t) : (t === "true-value" ? e._trueValue = s : t === "false-value" && (e._falseValue = s), ch(e, t, s, c));
};
function y2(e, t, n, s) {
  if (s)
    return !!(t === "innerHTML" || t === "textContent" || t in e && hh(t) && De(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const o = e.tagName;
    if (o === "IMG" || o === "VIDEO" || o === "CANVAS" || o === "SOURCE")
      return !1;
  }
  return hh(t) && Dt(n) ? !1 : t in e;
}
const Fr = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return we(t) ? (n) => Uo(t, n) : t;
};
function w2(e) {
  e.target.composing = !0;
}
function ph(e) {
  const t = e.target;
  t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
const vi = Symbol("_assign"), St = {
  created(e, { modifiers: { lazy: t, trim: n, number: s } }, o) {
    e[vi] = Fr(o);
    const a = s || o.props && o.props.type === "number";
    Ai(e, t ? "change" : "input", (c) => {
      if (c.target.composing) return;
      let u = e.value;
      n && (u = u.trim()), a && (u = Yo(u)), e[vi](u);
    }), n && Ai(e, "change", () => {
      e.value = e.value.trim();
    }), t || (Ai(e, "compositionstart", w2), Ai(e, "compositionend", ph), Ai(e, "change", ph));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: t }) {
    e.value = t ?? "";
  },
  beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: s, trim: o, number: a } }, c) {
    if (e[vi] = Fr(c), e.composing) return;
    const u = (a || e.type === "number") && !/^0\d/.test(e.value) ? Yo(e.value) : e.value, d = t ?? "";
    u !== d && (document.activeElement === e && e.type !== "range" && (s && t === n || o && e.value.trim() === d) || (e.value = d));
  }
}, b2 = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(e, t, n) {
    e[vi] = Fr(n), Ai(e, "change", () => {
      const s = e._modelValue, o = Ts(e), a = e.checked, c = e[vi];
      if (we(s)) {
        const u = Bc(s, o), d = u !== -1;
        if (a && !d)
          c(s.concat(o));
        else if (!a && d) {
          const h = [...s];
          h.splice(u, 1), c(h);
        }
      } else if (Wr(s)) {
        const u = new Set(s);
        a ? u.add(o) : u.delete(o), c(u);
      } else
        c(wg(e, a));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: gh,
  beforeUpdate(e, t, n) {
    e[vi] = Fr(n), gh(e, t, n);
  }
};
function gh(e, { value: t, oldValue: n }, s) {
  e._modelValue = t;
  let o;
  if (we(t))
    o = Bc(t, s.props.value) > -1;
  else if (Wr(t))
    o = t.has(s.props.value);
  else {
    if (t === n) return;
    o = Bs(t, wg(e, !0));
  }
  e.checked !== o && (e.checked = o);
}
const x2 = {
  // <select multiple> value need to be deep traversed
  deep: !0,
  created(e, { value: t, modifiers: { number: n } }, s) {
    const o = Wr(t);
    Ai(e, "change", () => {
      const a = Array.prototype.filter.call(e.options, (c) => c.selected).map(
        (c) => n ? Yo(Ts(c)) : Ts(c)
      );
      e[vi](
        e.multiple ? o ? new Set(a) : a : a[0]
      ), e._assigning = !0, jc(() => {
        e._assigning = !1;
      });
    }), e[vi] = Fr(s);
  },
  // set value in mounted & updated because <select> relies on its children
  // <option>s.
  mounted(e, { value: t }) {
    mh(e, t);
  },
  beforeUpdate(e, t, n) {
    e[vi] = Fr(n);
  },
  updated(e, { value: t }) {
    e._assigning || mh(e, t);
  }
};
function mh(e, t) {
  const n = e.multiple, s = we(t);
  if (!(n && !s && !Wr(t))) {
    for (let o = 0, a = e.options.length; o < a; o++) {
      const c = e.options[o], u = Ts(c);
      if (n)
        if (s) {
          const d = typeof u;
          d === "string" || d === "number" ? c.selected = t.some((h) => String(h) === String(u)) : c.selected = Bc(t, u) > -1;
        } else
          c.selected = t.has(u);
      else if (Bs(Ts(c), t)) {
        e.selectedIndex !== o && (e.selectedIndex = o);
        return;
      }
    }
    !n && e.selectedIndex !== -1 && (e.selectedIndex = -1);
  }
}
function Ts(e) {
  return "_value" in e ? e._value : e.value;
}
function wg(e, t) {
  const n = t ? "_trueValue" : "_falseValue";
  return n in e ? e[n] : t;
}
const _2 = /* @__PURE__ */ Kt({ patchProp: v2 }, n2);
let vh;
function C2() {
  return vh || (vh = S_(_2));
}
const Jc = (...e) => {
  const t = C2().createApp(...e), { mount: n } = t;
  return t.mount = (s) => {
    const o = L2(s);
    if (!o) return;
    const a = t._component;
    !De(a) && !a.render && !a.template && (a.template = o.innerHTML), o.nodeType === 1 && (o.textContent = "");
    const c = n(o, !1, S2(o));
    return o instanceof Element && (o.removeAttribute("v-cloak"), o.setAttribute("data-v-app", "")), c;
  }, t;
};
function S2(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function L2(e) {
  return Dt(e) ? document.querySelector(e) : e;
}
/*!
 * pinia v2.3.1
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */
const D2 = (
  /* istanbul ignore next */
  Symbol()
);
var yh;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(yh || (yh = {}));
function I2() {
  const e = vx(!0), t = e.run(() => dt({}));
  let n = [], s = [];
  const o = $p({
    install(a) {
      o._a = a, a.provide(D2, o), a.config.globalProperties.$pinia = o, s.forEach((c) => n.push(c)), s = [];
    },
    use(a) {
      return this._a ? n.push(a) : s.push(a), this;
    },
    _p: n,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: e,
    _s: /* @__PURE__ */ new Map(),
    state: t
  });
  return o;
}
/*!
  * vue-router v4.5.0
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */
const kr = typeof document < "u";
function bg(e) {
  return typeof e == "object" || "displayName" in e || "props" in e || "__vccOpts" in e;
}
function E2(e) {
  return e.__esModule || e[Symbol.toStringTag] === "Module" || // support CF with dynamic imports that do not
  // add the Module string tag
  e.default && bg(e.default);
}
const Ke = Object.assign;
function Xl(e, t) {
  const n = {};
  for (const s in t) {
    const o = t[s];
    n[s] = Hn(o) ? o.map(e) : e(o);
  }
  return n;
}
const xs = () => {
}, Hn = Array.isArray, xg = /#/g, T2 = /&/g, k2 = /\//g, R2 = /=/g, O2 = /\?/g, _g = /\+/g, A2 = /%5B/g, P2 = /%5D/g, Cg = /%5E/g, N2 = /%60/g, Sg = /%7B/g, M2 = /%7C/g, Lg = /%7D/g, B2 = /%20/g;
function Zc(e) {
  return encodeURI("" + e).replace(M2, "|").replace(A2, "[").replace(P2, "]");
}
function F2(e) {
  return Zc(e).replace(Sg, "{").replace(Lg, "}").replace(Cg, "^");
}
function bc(e) {
  return Zc(e).replace(_g, "%2B").replace(B2, "+").replace(xg, "%23").replace(T2, "%26").replace(N2, "`").replace(Sg, "{").replace(Lg, "}").replace(Cg, "^");
}
function $2(e) {
  return bc(e).replace(R2, "%3D");
}
function H2(e) {
  return Zc(e).replace(xg, "%23").replace(O2, "%3F");
}
function U2(e) {
  return e == null ? "" : H2(e).replace(k2, "%2F");
}
function ks(e) {
  try {
    return decodeURIComponent("" + e);
  } catch {
  }
  return "" + e;
}
const z2 = /\/$/, W2 = (e) => e.replace(z2, "");
function Jl(e, t, n = "/") {
  let s, o = {}, a = "", c = "";
  const u = t.indexOf("#");
  let d = t.indexOf("?");
  return u < d && u >= 0 && (d = -1), d > -1 && (s = t.slice(0, d), a = t.slice(d + 1, u > -1 ? u : t.length), o = e(a)), u > -1 && (s = s || t.slice(0, u), c = t.slice(u, t.length)), s = G2(s ?? t, n), {
    fullPath: s + (a && "?") + a + c,
    path: s,
    query: o,
    hash: ks(c)
  };
}
function q2(e, t) {
  const n = t.query ? e(t.query) : "";
  return t.path + (n && "?") + n + (t.hash || "");
}
function wh(e, t) {
  return !t || !e.toLowerCase().startsWith(t.toLowerCase()) ? e : e.slice(t.length) || "/";
}
function j2(e, t, n) {
  const s = t.matched.length - 1, o = n.matched.length - 1;
  return s > -1 && s === o && $r(t.matched[s], n.matched[o]) && Dg(t.params, n.params) && e(t.query) === e(n.query) && t.hash === n.hash;
}
function $r(e, t) {
  return (e.aliasOf || e) === (t.aliasOf || t);
}
function Dg(e, t) {
  if (Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (!V2(e[n], t[n]))
      return !1;
  return !0;
}
function V2(e, t) {
  return Hn(e) ? bh(e, t) : Hn(t) ? bh(t, e) : e === t;
}
function bh(e, t) {
  return Hn(t) ? e.length === t.length && e.every((n, s) => n === t[s]) : e.length === 1 && e[0] === t;
}
function G2(e, t) {
  if (e.startsWith("/"))
    return e;
  if (!e)
    return t;
  const n = t.split("/"), s = e.split("/"), o = s[s.length - 1];
  (o === ".." || o === ".") && s.push("");
  let a = n.length - 1, c, u;
  for (c = 0; c < s.length; c++)
    if (u = s[c], u !== ".")
      if (u === "..")
        a > 1 && a--;
      else
        break;
  return n.slice(0, a).join("/") + "/" + s.slice(c).join("/");
}
const Ei = {
  path: "/",
  // TODO: could we use a symbol in the future?
  name: void 0,
  params: {},
  query: {},
  hash: "",
  fullPath: "/",
  matched: [],
  meta: {},
  redirectedFrom: void 0
};
var Rs;
(function(e) {
  e.pop = "pop", e.push = "push";
})(Rs || (Rs = {}));
var _s;
(function(e) {
  e.back = "back", e.forward = "forward", e.unknown = "";
})(_s || (_s = {}));
function K2(e) {
  if (!e)
    if (kr) {
      const t = document.querySelector("base");
      e = t && t.getAttribute("href") || "/", e = e.replace(/^\w+:\/\/[^\/]+/, "");
    } else
      e = "/";
  return e[0] !== "/" && e[0] !== "#" && (e = "/" + e), W2(e);
}
const Y2 = /^[^#]+#/;
function X2(e, t) {
  return e.replace(Y2, "#") + t;
}
function J2(e, t) {
  const n = document.documentElement.getBoundingClientRect(), s = e.getBoundingClientRect();
  return {
    behavior: t.behavior,
    left: s.left - n.left - (t.left || 0),
    top: s.top - n.top - (t.top || 0)
  };
}
const xa = () => ({
  left: window.scrollX,
  top: window.scrollY
});
function Z2(e) {
  let t;
  if ("el" in e) {
    const n = e.el, s = typeof n == "string" && n.startsWith("#"), o = typeof n == "string" ? s ? document.getElementById(n.slice(1)) : document.querySelector(n) : n;
    if (!o)
      return;
    t = J2(o, e);
  } else
    t = e;
  "scrollBehavior" in document.documentElement.style ? window.scrollTo(t) : window.scrollTo(t.left != null ? t.left : window.scrollX, t.top != null ? t.top : window.scrollY);
}
function xh(e, t) {
  return (history.state ? history.state.position - t : -1) + e;
}
const xc = /* @__PURE__ */ new Map();
function Q2(e, t) {
  xc.set(e, t);
}
function eC(e) {
  const t = xc.get(e);
  return xc.delete(e), t;
}
let tC = () => location.protocol + "//" + location.host;
function Ig(e, t) {
  const { pathname: n, search: s, hash: o } = t, a = e.indexOf("#");
  if (a > -1) {
    let u = o.includes(e.slice(a)) ? e.slice(a).length : 1, d = o.slice(u);
    return d[0] !== "/" && (d = "/" + d), wh(d, "");
  }
  return wh(n, e) + s + o;
}
function nC(e, t, n, s) {
  let o = [], a = [], c = null;
  const u = ({ state: b }) => {
    const S = Ig(e, location), D = n.value, A = t.value;
    let R = 0;
    if (b) {
      if (n.value = S, t.value = b, c && c === D) {
        c = null;
        return;
      }
      R = A ? b.position - A.position : 0;
    } else
      s(S);
    o.forEach((F) => {
      F(n.value, D, {
        delta: R,
        type: Rs.pop,
        direction: R ? R > 0 ? _s.forward : _s.back : _s.unknown
      });
    });
  };
  function d() {
    c = n.value;
  }
  function h(b) {
    o.push(b);
    const S = () => {
      const D = o.indexOf(b);
      D > -1 && o.splice(D, 1);
    };
    return a.push(S), S;
  }
  function m() {
    const { history: b } = window;
    b.state && b.replaceState(Ke({}, b.state, { scroll: xa() }), "");
  }
  function v() {
    for (const b of a)
      b();
    a = [], window.removeEventListener("popstate", u), window.removeEventListener("beforeunload", m);
  }
  return window.addEventListener("popstate", u), window.addEventListener("beforeunload", m, {
    passive: !0
  }), {
    pauseListeners: d,
    listen: h,
    destroy: v
  };
}
function _h(e, t, n, s = !1, o = !1) {
  return {
    back: e,
    current: t,
    forward: n,
    replaced: s,
    position: window.history.length,
    scroll: o ? xa() : null
  };
}
function iC(e) {
  const { history: t, location: n } = window, s = {
    value: Ig(e, n)
  }, o = { value: t.state };
  o.value || a(s.value, {
    back: null,
    current: s.value,
    forward: null,
    // the length is off by one, we need to decrease it
    position: t.length - 1,
    replaced: !0,
    // don't add a scroll as the user may have an anchor, and we want
    // scrollBehavior to be triggered without a saved position
    scroll: null
  }, !0);
  function a(d, h, m) {
    const v = e.indexOf("#"), b = v > -1 ? (n.host && document.querySelector("base") ? e : e.slice(v)) + d : tC() + e + d;
    try {
      t[m ? "replaceState" : "pushState"](h, "", b), o.value = h;
    } catch (S) {
      console.error(S), n[m ? "replace" : "assign"](b);
    }
  }
  function c(d, h) {
    const m = Ke({}, t.state, _h(
      o.value.back,
      // keep back and forward entries but override current position
      d,
      o.value.forward,
      !0
    ), h, { position: o.value.position });
    a(d, m, !0), s.value = d;
  }
  function u(d, h) {
    const m = Ke(
      {},
      // use current history state to gracefully handle a wrong call to
      // history.replaceState
      // https://github.com/vuejs/router/issues/366
      o.value,
      t.state,
      {
        forward: d,
        scroll: xa()
      }
    );
    a(m.current, m, !0);
    const v = Ke({}, _h(s.value, d, null), { position: m.position + 1 }, h);
    a(d, v, !1), s.value = d;
  }
  return {
    location: s,
    state: o,
    push: u,
    replace: c
  };
}
function rC(e) {
  e = K2(e);
  const t = iC(e), n = nC(e, t.state, t.location, t.replace);
  function s(a, c = !0) {
    c || n.pauseListeners(), history.go(a);
  }
  const o = Ke({
    // it's overridden right after
    location: "",
    base: e,
    go: s,
    createHref: X2.bind(null, e)
  }, t, n);
  return Object.defineProperty(o, "location", {
    enumerable: !0,
    get: () => t.location.value
  }), Object.defineProperty(o, "state", {
    enumerable: !0,
    get: () => t.state.value
  }), o;
}
function sC(e) {
  return typeof e == "string" || e && typeof e == "object";
}
function Eg(e) {
  return typeof e == "string" || typeof e == "symbol";
}
const Tg = Symbol("");
var Ch;
(function(e) {
  e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})(Ch || (Ch = {}));
function Hr(e, t) {
  return Ke(new Error(), {
    type: e,
    [Tg]: !0
  }, t);
}
function fi(e, t) {
  return e instanceof Error && Tg in e && (t == null || !!(e.type & t));
}
const Sh = "[^/]+?", oC = {
  sensitive: !1,
  strict: !1,
  start: !0,
  end: !0
}, aC = /[.+*?^${}()[\]/\\]/g;
function lC(e, t) {
  const n = Ke({}, oC, t), s = [];
  let o = n.start ? "^" : "";
  const a = [];
  for (const h of e) {
    const m = h.length ? [] : [
      90
      /* PathScore.Root */
    ];
    n.strict && !h.length && (o += "/");
    for (let v = 0; v < h.length; v++) {
      const b = h[v];
      let S = 40 + (n.sensitive ? 0.25 : 0);
      if (b.type === 0)
        v || (o += "/"), o += b.value.replace(aC, "\\$&"), S += 40;
      else if (b.type === 1) {
        const { value: D, repeatable: A, optional: R, regexp: F } = b;
        a.push({
          name: D,
          repeatable: A,
          optional: R
        });
        const K = F || Sh;
        if (K !== Sh) {
          S += 10;
          try {
            new RegExp(`(${K})`);
          } catch (Y) {
            throw new Error(`Invalid custom RegExp for param "${D}" (${K}): ` + Y.message);
          }
        }
        let G = A ? `((?:${K})(?:/(?:${K}))*)` : `(${K})`;
        v || (G = // avoid an optional / if there are more segments e.g. /:p?-static
        // or /:p?-:p2
        R && h.length < 2 ? `(?:/${G})` : "/" + G), R && (G += "?"), o += G, S += 20, R && (S += -8), A && (S += -20), K === ".*" && (S += -50);
      }
      m.push(S);
    }
    s.push(m);
  }
  if (n.strict && n.end) {
    const h = s.length - 1;
    s[h][s[h].length - 1] += 0.7000000000000001;
  }
  n.strict || (o += "/?"), n.end ? o += "$" : n.strict && !o.endsWith("/") && (o += "(?:/|$)");
  const c = new RegExp(o, n.sensitive ? "" : "i");
  function u(h) {
    const m = h.match(c), v = {};
    if (!m)
      return null;
    for (let b = 1; b < m.length; b++) {
      const S = m[b] || "", D = a[b - 1];
      v[D.name] = S && D.repeatable ? S.split("/") : S;
    }
    return v;
  }
  function d(h) {
    let m = "", v = !1;
    for (const b of e) {
      (!v || !m.endsWith("/")) && (m += "/"), v = !1;
      for (const S of b)
        if (S.type === 0)
          m += S.value;
        else if (S.type === 1) {
          const { value: D, repeatable: A, optional: R } = S, F = D in h ? h[D] : "";
          if (Hn(F) && !A)
            throw new Error(`Provided param "${D}" is an array but it is not repeatable (* or + modifiers)`);
          const K = Hn(F) ? F.join("/") : F;
          if (!K)
            if (R)
              b.length < 2 && (m.endsWith("/") ? m = m.slice(0, -1) : v = !0);
            else
              throw new Error(`Missing required param "${D}"`);
          m += K;
        }
    }
    return m || "/";
  }
  return {
    re: c,
    score: s,
    keys: a,
    parse: u,
    stringify: d
  };
}
function cC(e, t) {
  let n = 0;
  for (; n < e.length && n < t.length; ) {
    const s = t[n] - e[n];
    if (s)
      return s;
    n++;
  }
  return e.length < t.length ? e.length === 1 && e[0] === 80 ? -1 : 1 : e.length > t.length ? t.length === 1 && t[0] === 80 ? 1 : -1 : 0;
}
function kg(e, t) {
  let n = 0;
  const s = e.score, o = t.score;
  for (; n < s.length && n < o.length; ) {
    const a = cC(s[n], o[n]);
    if (a)
      return a;
    n++;
  }
  if (Math.abs(o.length - s.length) === 1) {
    if (Lh(s))
      return 1;
    if (Lh(o))
      return -1;
  }
  return o.length - s.length;
}
function Lh(e) {
  const t = e[e.length - 1];
  return e.length > 0 && t[t.length - 1] < 0;
}
const uC = {
  type: 0,
  value: ""
}, fC = /[a-zA-Z0-9_]/;
function dC(e) {
  if (!e)
    return [[]];
  if (e === "/")
    return [[uC]];
  if (!e.startsWith("/"))
    throw new Error(`Invalid path "${e}"`);
  function t(S) {
    throw new Error(`ERR (${n})/"${h}": ${S}`);
  }
  let n = 0, s = n;
  const o = [];
  let a;
  function c() {
    a && o.push(a), a = [];
  }
  let u = 0, d, h = "", m = "";
  function v() {
    h && (n === 0 ? a.push({
      type: 0,
      value: h
    }) : n === 1 || n === 2 || n === 3 ? (a.length > 1 && (d === "*" || d === "+") && t(`A repeatable param (${h}) must be alone in its segment. eg: '/:ids+.`), a.push({
      type: 1,
      value: h,
      regexp: m,
      repeatable: d === "*" || d === "+",
      optional: d === "*" || d === "?"
    })) : t("Invalid state to consume buffer"), h = "");
  }
  function b() {
    h += d;
  }
  for (; u < e.length; ) {
    if (d = e[u++], d === "\\" && n !== 2) {
      s = n, n = 4;
      continue;
    }
    switch (n) {
      case 0:
        d === "/" ? (h && v(), c()) : d === ":" ? (v(), n = 1) : b();
        break;
      case 4:
        b(), n = s;
        break;
      case 1:
        d === "(" ? n = 2 : fC.test(d) ? b() : (v(), n = 0, d !== "*" && d !== "?" && d !== "+" && u--);
        break;
      case 2:
        d === ")" ? m[m.length - 1] == "\\" ? m = m.slice(0, -1) + d : n = 3 : m += d;
        break;
      case 3:
        v(), n = 0, d !== "*" && d !== "?" && d !== "+" && u--, m = "";
        break;
      default:
        t("Unknown state");
        break;
    }
  }
  return n === 2 && t(`Unfinished custom RegExp for param "${h}"`), v(), c(), o;
}
function hC(e, t, n) {
  const s = lC(dC(e.path), n), o = Ke(s, {
    record: e,
    parent: t,
    // these needs to be populated by the parent
    children: [],
    alias: []
  });
  return t && !o.record.aliasOf == !t.record.aliasOf && t.children.push(o), o;
}
function pC(e, t) {
  const n = [], s = /* @__PURE__ */ new Map();
  t = Th({ strict: !1, end: !0, sensitive: !1 }, t);
  function o(v) {
    return s.get(v);
  }
  function a(v, b, S) {
    const D = !S, A = Ih(v);
    A.aliasOf = S && S.record;
    const R = Th(t, v), F = [A];
    if ("alias" in v) {
      const Y = typeof v.alias == "string" ? [v.alias] : v.alias;
      for (const re of Y)
        F.push(
          // we need to normalize again to ensure the `mods` property
          // being non enumerable
          Ih(Ke({}, A, {
            // this allows us to hold a copy of the `components` option
            // so that async components cache is hold on the original record
            components: S ? S.record.components : A.components,
            path: re,
            // we might be the child of an alias
            aliasOf: S ? S.record : A
            // the aliases are always of the same kind as the original since they
            // are defined on the same record
          }))
        );
    }
    let K, G;
    for (const Y of F) {
      const { path: re } = Y;
      if (b && re[0] !== "/") {
        const be = b.record.path, ue = be[be.length - 1] === "/" ? "" : "/";
        Y.path = b.record.path + (re && ue + re);
      }
      if (K = hC(Y, b, R), S ? S.alias.push(K) : (G = G || K, G !== K && G.alias.push(K), D && v.name && !Eh(K) && c(v.name)), Rg(K) && d(K), A.children) {
        const be = A.children;
        for (let ue = 0; ue < be.length; ue++)
          a(be[ue], K, S && S.children[ue]);
      }
      S = S || K;
    }
    return G ? () => {
      c(G);
    } : xs;
  }
  function c(v) {
    if (Eg(v)) {
      const b = s.get(v);
      b && (s.delete(v), n.splice(n.indexOf(b), 1), b.children.forEach(c), b.alias.forEach(c));
    } else {
      const b = n.indexOf(v);
      b > -1 && (n.splice(b, 1), v.record.name && s.delete(v.record.name), v.children.forEach(c), v.alias.forEach(c));
    }
  }
  function u() {
    return n;
  }
  function d(v) {
    const b = vC(v, n);
    n.splice(b, 0, v), v.record.name && !Eh(v) && s.set(v.record.name, v);
  }
  function h(v, b) {
    let S, D = {}, A, R;
    if ("name" in v && v.name) {
      if (S = s.get(v.name), !S)
        throw Hr(1, {
          location: v
        });
      R = S.record.name, D = Ke(
        // paramsFromLocation is a new object
        Dh(
          b.params,
          // only keep params that exist in the resolved location
          // only keep optional params coming from a parent record
          S.keys.filter((G) => !G.optional).concat(S.parent ? S.parent.keys.filter((G) => G.optional) : []).map((G) => G.name)
        ),
        // discard any existing params in the current location that do not exist here
        // #1497 this ensures better active/exact matching
        v.params && Dh(v.params, S.keys.map((G) => G.name))
      ), A = S.stringify(D);
    } else if (v.path != null)
      A = v.path, S = n.find((G) => G.re.test(A)), S && (D = S.parse(A), R = S.record.name);
    else {
      if (S = b.name ? s.get(b.name) : n.find((G) => G.re.test(b.path)), !S)
        throw Hr(1, {
          location: v,
          currentLocation: b
        });
      R = S.record.name, D = Ke({}, b.params, v.params), A = S.stringify(D);
    }
    const F = [];
    let K = S;
    for (; K; )
      F.unshift(K.record), K = K.parent;
    return {
      name: R,
      path: A,
      params: D,
      matched: F,
      meta: mC(F)
    };
  }
  e.forEach((v) => a(v));
  function m() {
    n.length = 0, s.clear();
  }
  return {
    addRoute: a,
    resolve: h,
    removeRoute: c,
    clearRoutes: m,
    getRoutes: u,
    getRecordMatcher: o
  };
}
function Dh(e, t) {
  const n = {};
  for (const s of t)
    s in e && (n[s] = e[s]);
  return n;
}
function Ih(e) {
  const t = {
    path: e.path,
    redirect: e.redirect,
    name: e.name,
    meta: e.meta || {},
    aliasOf: e.aliasOf,
    beforeEnter: e.beforeEnter,
    props: gC(e),
    children: e.children || [],
    instances: {},
    leaveGuards: /* @__PURE__ */ new Set(),
    updateGuards: /* @__PURE__ */ new Set(),
    enterCallbacks: {},
    // must be declared afterwards
    // mods: {},
    components: "components" in e ? e.components || null : e.component && { default: e.component }
  };
  return Object.defineProperty(t, "mods", {
    value: {}
  }), t;
}
function gC(e) {
  const t = {}, n = e.props || !1;
  if ("component" in e)
    t.default = n;
  else
    for (const s in e.components)
      t[s] = typeof n == "object" ? n[s] : n;
  return t;
}
function Eh(e) {
  for (; e; ) {
    if (e.record.aliasOf)
      return !0;
    e = e.parent;
  }
  return !1;
}
function mC(e) {
  return e.reduce((t, n) => Ke(t, n.meta), {});
}
function Th(e, t) {
  const n = {};
  for (const s in e)
    n[s] = s in t ? t[s] : e[s];
  return n;
}
function vC(e, t) {
  let n = 0, s = t.length;
  for (; n !== s; ) {
    const a = n + s >> 1;
    kg(e, t[a]) < 0 ? s = a : n = a + 1;
  }
  const o = yC(e);
  return o && (s = t.lastIndexOf(o, s - 1)), s;
}
function yC(e) {
  let t = e;
  for (; t = t.parent; )
    if (Rg(t) && kg(e, t) === 0)
      return t;
}
function Rg({ record: e }) {
  return !!(e.name || e.components && Object.keys(e.components).length || e.redirect);
}
function wC(e) {
  const t = {};
  if (e === "" || e === "?")
    return t;
  const s = (e[0] === "?" ? e.slice(1) : e).split("&");
  for (let o = 0; o < s.length; ++o) {
    const a = s[o].replace(_g, " "), c = a.indexOf("="), u = ks(c < 0 ? a : a.slice(0, c)), d = c < 0 ? null : ks(a.slice(c + 1));
    if (u in t) {
      let h = t[u];
      Hn(h) || (h = t[u] = [h]), h.push(d);
    } else
      t[u] = d;
  }
  return t;
}
function kh(e) {
  let t = "";
  for (let n in e) {
    const s = e[n];
    if (n = $2(n), s == null) {
      s !== void 0 && (t += (t.length ? "&" : "") + n);
      continue;
    }
    (Hn(s) ? s.map((a) => a && bc(a)) : [s && bc(s)]).forEach((a) => {
      a !== void 0 && (t += (t.length ? "&" : "") + n, a != null && (t += "=" + a));
    });
  }
  return t;
}
function bC(e) {
  const t = {};
  for (const n in e) {
    const s = e[n];
    s !== void 0 && (t[n] = Hn(s) ? s.map((o) => o == null ? null : "" + o) : s == null ? s : "" + s);
  }
  return t;
}
const xC = Symbol(""), Rh = Symbol(""), Qc = Symbol(""), Og = Symbol(""), _c = Symbol("");
function cs() {
  let e = [];
  function t(s) {
    return e.push(s), () => {
      const o = e.indexOf(s);
      o > -1 && e.splice(o, 1);
    };
  }
  function n() {
    e = [];
  }
  return {
    add: t,
    list: () => e.slice(),
    reset: n
  };
}
function Oi(e, t, n, s, o, a = (c) => c()) {
  const c = s && // name is defined if record is because of the function overload
  (s.enterCallbacks[o] = s.enterCallbacks[o] || []);
  return () => new Promise((u, d) => {
    const h = (b) => {
      b === !1 ? d(Hr(4, {
        from: n,
        to: t
      })) : b instanceof Error ? d(b) : sC(b) ? d(Hr(2, {
        from: t,
        to: b
      })) : (c && // since enterCallbackArray is truthy, both record and name also are
      s.enterCallbacks[o] === c && typeof b == "function" && c.push(b), u());
    }, m = a(() => e.call(s && s.instances[o], t, n, h));
    let v = Promise.resolve(m);
    e.length < 3 && (v = v.then(h)), v.catch((b) => d(b));
  });
}
function Zl(e, t, n, s, o = (a) => a()) {
  const a = [];
  for (const c of e)
    for (const u in c.components) {
      let d = c.components[u];
      if (!(t !== "beforeRouteEnter" && !c.instances[u]))
        if (bg(d)) {
          const m = (d.__vccOpts || d)[t];
          m && a.push(Oi(m, n, s, c, u, o));
        } else {
          let h = d();
          a.push(() => h.then((m) => {
            if (!m)
              throw new Error(`Couldn't resolve component "${u}" at "${c.path}"`);
            const v = E2(m) ? m.default : m;
            c.mods[u] = m, c.components[u] = v;
            const S = (v.__vccOpts || v)[t];
            return S && Oi(S, n, s, c, u, o)();
          }));
        }
    }
  return a;
}
function Oh(e) {
  const t = un(Qc), n = un(Og), s = Ut(() => {
    const d = en(e.to);
    return t.resolve(d);
  }), o = Ut(() => {
    const { matched: d } = s.value, { length: h } = d, m = d[h - 1], v = n.matched;
    if (!m || !v.length)
      return -1;
    const b = v.findIndex($r.bind(null, m));
    if (b > -1)
      return b;
    const S = Ah(d[h - 2]);
    return (
      // we are dealing with nested routes
      h > 1 && // if the parent and matched route have the same path, this link is
      // referring to the empty child. Or we currently are on a different
      // child of the same parent
      Ah(m) === S && // avoid comparing the child with its parent
      v[v.length - 1].path !== S ? v.findIndex($r.bind(null, d[h - 2])) : b
    );
  }), a = Ut(() => o.value > -1 && DC(n.params, s.value.params)), c = Ut(() => o.value > -1 && o.value === n.matched.length - 1 && Dg(n.params, s.value.params));
  function u(d = {}) {
    if (LC(d)) {
      const h = t[en(e.replace) ? "replace" : "push"](
        en(e.to)
        // avoid uncaught errors are they are logged anyway
      ).catch(xs);
      return e.viewTransition && typeof document < "u" && "startViewTransition" in document && document.startViewTransition(() => h), h;
    }
    return Promise.resolve();
  }
  return {
    route: s,
    href: Ut(() => s.value.href),
    isActive: a,
    isExactActive: c,
    navigate: u
  };
}
function _C(e) {
  return e.length === 1 ? e[0] : e;
}
const CC = /* @__PURE__ */ Un({
  name: "RouterLink",
  compatConfig: { MODE: 3 },
  props: {
    to: {
      type: [String, Object],
      required: !0
    },
    replace: Boolean,
    activeClass: String,
    // inactiveClass: String,
    exactActiveClass: String,
    custom: Boolean,
    ariaCurrentValue: {
      type: String,
      default: "page"
    }
  },
  useLink: Oh,
  setup(e, { slots: t }) {
    const n = ha(Oh(e)), { options: s } = un(Qc), o = Ut(() => ({
      [Ph(e.activeClass, s.linkActiveClass, "router-link-active")]: n.isActive,
      // [getLinkClass(
      //   props.inactiveClass,
      //   options.linkInactiveClass,
      //   'router-link-inactive'
      // )]: !link.isExactActive,
      [Ph(e.exactActiveClass, s.linkExactActiveClass, "router-link-exact-active")]: n.isExactActive
    }));
    return () => {
      const a = t.default && _C(t.default(n));
      return e.custom ? a : Hs("a", {
        "aria-current": n.isExactActive ? e.ariaCurrentValue : null,
        href: n.href,
        // this would override user added attrs but Vue will still add
        // the listener, so we end up triggering both
        onClick: n.navigate,
        class: o.value
      }, a);
    };
  }
}), SC = CC;
function LC(e) {
  if (!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) && !e.defaultPrevented && !(e.button !== void 0 && e.button !== 0)) {
    if (e.currentTarget && e.currentTarget.getAttribute) {
      const t = e.currentTarget.getAttribute("target");
      if (/\b_blank\b/i.test(t))
        return;
    }
    return e.preventDefault && e.preventDefault(), !0;
  }
}
function DC(e, t) {
  for (const n in t) {
    const s = t[n], o = e[n];
    if (typeof s == "string") {
      if (s !== o)
        return !1;
    } else if (!Hn(o) || o.length !== s.length || s.some((a, c) => a !== o[c]))
      return !1;
  }
  return !0;
}
function Ah(e) {
  return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
const Ph = (e, t, n) => e ?? t ?? n, IC = /* @__PURE__ */ Un({
  name: "RouterView",
  // #674 we manually inherit them
  inheritAttrs: !1,
  props: {
    name: {
      type: String,
      default: "default"
    },
    route: Object
  },
  // Better compat for @vue/compat users
  // https://github.com/vuejs/router/issues/1315
  compatConfig: { MODE: 3 },
  setup(e, { attrs: t, slots: n }) {
    const s = un(_c), o = Ut(() => e.route || s.value), a = un(Rh, 0), c = Ut(() => {
      let h = en(a);
      const { matched: m } = o.value;
      let v;
      for (; (v = m[h]) && !v.components; )
        h++;
      return h;
    }), u = Ut(() => o.value.matched[c.value]);
    Mi(Rh, Ut(() => c.value + 1)), Mi(xC, u), Mi(_c, o);
    const d = dt();
    return Br(() => [d.value, u.value, e.name], ([h, m, v], [b, S, D]) => {
      m && (m.instances[v] = h, S && S !== m && h && h === b && (m.leaveGuards.size || (m.leaveGuards = S.leaveGuards), m.updateGuards.size || (m.updateGuards = S.updateGuards))), h && m && // if there is no instance but to and from are the same this might be
      // the first visit
      (!S || !$r(m, S) || !b) && (m.enterCallbacks[v] || []).forEach((A) => A(h));
    }, { flush: "post" }), () => {
      const h = o.value, m = e.name, v = u.value, b = v && v.components[m];
      if (!b)
        return Nh(n.default, { Component: b, route: h });
      const S = v.props[m], D = S ? S === !0 ? h.params : typeof S == "function" ? S(h) : S : null, R = Hs(b, Ke({}, D, t, {
        onVnodeUnmounted: (F) => {
          F.component.isUnmounted && (v.instances[m] = null);
        },
        ref: d
      }));
      return (
        // pass the vnode to the slot as a prop.
        // h and <component :is="..."> both accept vnodes
        Nh(n.default, { Component: R, route: h }) || R
      );
    };
  }
});
function Nh(e, t) {
  if (!e)
    return null;
  const n = e(t);
  return n.length === 1 ? n[0] : n;
}
const Ag = IC;
function EC(e) {
  const t = pC(e.routes, e), n = e.parseQuery || wC, s = e.stringifyQuery || kh, o = e.history, a = cs(), c = cs(), u = cs(), d = Bx(Ei);
  let h = Ei;
  kr && e.scrollBehavior && "scrollRestoration" in history && (history.scrollRestoration = "manual");
  const m = Xl.bind(null, (U) => "" + U), v = Xl.bind(null, U2), b = (
    // @ts-expect-error: intentionally avoid the type check
    Xl.bind(null, ks)
  );
  function S(U, te) {
    let Q, ae;
    return Eg(U) ? (Q = t.getRecordMatcher(U), ae = te) : ae = U, t.addRoute(ae, Q);
  }
  function D(U) {
    const te = t.getRecordMatcher(U);
    te && t.removeRoute(te);
  }
  function A() {
    return t.getRoutes().map((U) => U.record);
  }
  function R(U) {
    return !!t.getRecordMatcher(U);
  }
  function F(U, te) {
    if (te = Ke({}, te || d.value), typeof U == "string") {
      const T = Jl(n, U, te.path), H = t.resolve({ path: T.path }, te), q = o.createHref(T.fullPath);
      return Ke(T, H, {
        params: b(H.params),
        hash: ks(T.hash),
        redirectedFrom: void 0,
        href: q
      });
    }
    let Q;
    if (U.path != null)
      Q = Ke({}, U, {
        path: Jl(n, U.path, te.path).path
      });
    else {
      const T = Ke({}, U.params);
      for (const H in T)
        T[H] == null && delete T[H];
      Q = Ke({}, U, {
        params: v(T)
      }), te.params = v(te.params);
    }
    const ae = t.resolve(Q, te), $e = U.hash || "";
    ae.params = m(b(ae.params));
    const x = q2(s, Ke({}, U, {
      hash: F2($e),
      path: ae.path
    })), C = o.createHref(x);
    return Ke({
      fullPath: x,
      // keep the hash encoded so fullPath is effectively path + encodedQuery +
      // hash
      hash: $e,
      query: (
        // if the user is using a custom query lib like qs, we might have
        // nested objects, so we keep the query as is, meaning it can contain
        // numbers at `$route.query`, but at the point, the user will have to
        // use their own type anyway.
        // https://github.com/vuejs/router/issues/328#issuecomment-649481567
        s === kh ? bC(U.query) : U.query || {}
      )
    }, ae, {
      redirectedFrom: void 0,
      href: C
    });
  }
  function K(U) {
    return typeof U == "string" ? Jl(n, U, d.value.path) : Ke({}, U);
  }
  function G(U, te) {
    if (h !== U)
      return Hr(8, {
        from: te,
        to: U
      });
  }
  function Y(U) {
    return ue(U);
  }
  function re(U) {
    return Y(Ke(K(U), { replace: !0 }));
  }
  function be(U) {
    const te = U.matched[U.matched.length - 1];
    if (te && te.redirect) {
      const { redirect: Q } = te;
      let ae = typeof Q == "function" ? Q(U) : Q;
      return typeof ae == "string" && (ae = ae.includes("?") || ae.includes("#") ? ae = K(ae) : (
        // force empty params
        { path: ae }
      ), ae.params = {}), Ke({
        query: U.query,
        hash: U.hash,
        // avoid transferring params if the redirect has a path
        params: ae.path != null ? {} : U.params
      }, ae);
    }
  }
  function ue(U, te) {
    const Q = h = F(U), ae = d.value, $e = U.state, x = U.force, C = U.replace === !0, T = be(Q);
    if (T)
      return ue(
        Ke(K(T), {
          state: typeof T == "object" ? Ke({}, $e, T.state) : $e,
          force: x,
          replace: C
        }),
        // keep original redirectedFrom if it exists
        te || Q
      );
    const H = Q;
    H.redirectedFrom = te;
    let q;
    return !x && j2(s, ae, Q) && (q = Hr(16, { to: H, from: ae }), Je(
      ae,
      ae,
      // this is a push, the only way for it to be triggered from a
      // history.listen is with a redirect, which makes it become a push
      !0,
      // This cannot be the first navigation because the initial location
      // cannot be manually navigated to
      !1
    )), (q ? Promise.resolve(q) : lt(H, ae)).catch((B) => fi(B) ? (
      // navigation redirects still mark the router as ready
      fi(
        B,
        2
        /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */
      ) ? B : yt(B)
    ) : (
      // reject any unknown error
      Ce(B, H, ae)
    )).then((B) => {
      if (B) {
        if (fi(
          B,
          2
          /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */
        ))
          return ue(
            // keep options
            Ke({
              // preserve an existing replacement but allow the redirect to override it
              replace: C
            }, K(B.to), {
              state: typeof B.to == "object" ? Ke({}, $e, B.to.state) : $e,
              force: x
            }),
            // preserve the original redirectedFrom if any
            te || H
          );
      } else
        B = kt(H, ae, !0, C, $e);
      return Z(H, ae, B), B;
    });
  }
  function xe(U, te) {
    const Q = G(U, te);
    return Q ? Promise.reject(Q) : Promise.resolve();
  }
  function Ee(U) {
    const te = nt.values().next().value;
    return te && typeof te.runWithContext == "function" ? te.runWithContext(U) : U();
  }
  function lt(U, te) {
    let Q;
    const [ae, $e, x] = TC(U, te);
    Q = Zl(ae.reverse(), "beforeRouteLeave", U, te);
    for (const T of ae)
      T.leaveGuards.forEach((H) => {
        Q.push(Oi(H, U, te));
      });
    const C = xe.bind(null, U, te);
    return Q.push(C), wt(Q).then(() => {
      Q = [];
      for (const T of a.list())
        Q.push(Oi(T, U, te));
      return Q.push(C), wt(Q);
    }).then(() => {
      Q = Zl($e, "beforeRouteUpdate", U, te);
      for (const T of $e)
        T.updateGuards.forEach((H) => {
          Q.push(Oi(H, U, te));
        });
      return Q.push(C), wt(Q);
    }).then(() => {
      Q = [];
      for (const T of x)
        if (T.beforeEnter)
          if (Hn(T.beforeEnter))
            for (const H of T.beforeEnter)
              Q.push(Oi(H, U, te));
          else
            Q.push(Oi(T.beforeEnter, U, te));
      return Q.push(C), wt(Q);
    }).then(() => (U.matched.forEach((T) => T.enterCallbacks = {}), Q = Zl(x, "beforeRouteEnter", U, te, Ee), Q.push(C), wt(Q))).then(() => {
      Q = [];
      for (const T of c.list())
        Q.push(Oi(T, U, te));
      return Q.push(C), wt(Q);
    }).catch((T) => fi(
      T,
      8
      /* ErrorTypes.NAVIGATION_CANCELLED */
    ) ? T : Promise.reject(T));
  }
  function Z(U, te, Q) {
    u.list().forEach((ae) => Ee(() => ae(U, te, Q)));
  }
  function kt(U, te, Q, ae, $e) {
    const x = G(U, te);
    if (x)
      return x;
    const C = te === Ei, T = kr ? history.state : {};
    Q && (ae || C ? o.replace(U.fullPath, Ke({
      scroll: C && T && T.scroll
    }, $e)) : o.push(U.fullPath, $e)), d.value = U, Je(U, te, Q, C), yt();
  }
  let Ue;
  function Nt() {
    Ue || (Ue = o.listen((U, te, Q) => {
      if (!Rt.listening)
        return;
      const ae = F(U), $e = be(ae);
      if ($e) {
        ue(Ke($e, { replace: !0, force: !0 }), ae).catch(xs);
        return;
      }
      h = ae;
      const x = d.value;
      kr && Q2(xh(x.fullPath, Q.delta), xa()), lt(ae, x).catch((C) => fi(
        C,
        12
        /* ErrorTypes.NAVIGATION_CANCELLED */
      ) ? C : fi(
        C,
        2
        /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */
      ) ? (ue(
        Ke(K(C.to), {
          force: !0
        }),
        ae
        // avoid an uncaught rejection, let push call triggerError
      ).then((T) => {
        fi(
          T,
          20
          /* ErrorTypes.NAVIGATION_DUPLICATED */
        ) && !Q.delta && Q.type === Rs.pop && o.go(-1, !1);
      }).catch(xs), Promise.reject()) : (Q.delta && o.go(-Q.delta, !1), Ce(C, ae, x))).then((C) => {
        C = C || kt(
          // after navigation, all matched components are resolved
          ae,
          x,
          !1
        ), C && (Q.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
        // entry while a different route is displayed
        !fi(
          C,
          8
          /* ErrorTypes.NAVIGATION_CANCELLED */
        ) ? o.go(-Q.delta, !1) : Q.type === Rs.pop && fi(
          C,
          20
          /* ErrorTypes.NAVIGATION_DUPLICATED */
        ) && o.go(-1, !1)), Z(ae, x, C);
      }).catch(xs);
    }));
  }
  let ht = cs(), Pe = cs(), ke;
  function Ce(U, te, Q) {
    yt(U);
    const ae = Pe.list();
    return ae.length ? ae.forEach(($e) => $e(U, te, Q)) : console.error(U), Promise.reject(U);
  }
  function It() {
    return ke && d.value !== Ei ? Promise.resolve() : new Promise((U, te) => {
      ht.add([U, te]);
    });
  }
  function yt(U) {
    return ke || (ke = !U, Nt(), ht.list().forEach(([te, Q]) => U ? Q(U) : te()), ht.reset()), U;
  }
  function Je(U, te, Q, ae) {
    const { scrollBehavior: $e } = e;
    if (!kr || !$e)
      return Promise.resolve();
    const x = !Q && eC(xh(U.fullPath, 0)) || (ae || !Q) && history.state && history.state.scroll || null;
    return jc().then(() => $e(U, te, x)).then((C) => C && Z2(C)).catch((C) => Ce(C, U, te));
  }
  const tt = (U) => o.go(U);
  let ze;
  const nt = /* @__PURE__ */ new Set(), Rt = {
    currentRoute: d,
    listening: !0,
    addRoute: S,
    removeRoute: D,
    clearRoutes: t.clearRoutes,
    hasRoute: R,
    getRoutes: A,
    resolve: F,
    options: e,
    push: Y,
    replace: re,
    go: tt,
    back: () => tt(-1),
    forward: () => tt(1),
    beforeEach: a.add,
    beforeResolve: c.add,
    afterEach: u.add,
    onError: Pe.add,
    isReady: It,
    install(U) {
      const te = this;
      U.component("RouterLink", SC), U.component("RouterView", Ag), U.config.globalProperties.$router = te, Object.defineProperty(U.config.globalProperties, "$route", {
        enumerable: !0,
        get: () => en(d)
      }), kr && // used for the initial navigation client side to avoid pushing
      // multiple times when the router is used in multiple apps
      !ze && d.value === Ei && (ze = !0, Y(o.location).catch(($e) => {
      }));
      const Q = {};
      for (const $e in Ei)
        Object.defineProperty(Q, $e, {
          get: () => d.value[$e],
          enumerable: !0
        });
      U.provide(Qc, te), U.provide(Og, Bp(Q)), U.provide(_c, d);
      const ae = U.unmount;
      nt.add(U), U.unmount = function() {
        nt.delete(U), nt.size < 1 && (h = Ei, Ue && Ue(), Ue = null, d.value = Ei, ze = !1, ke = !1), ae();
      };
    }
  };
  function wt(U) {
    return U.reduce((te, Q) => te.then(() => Ee(Q)), Promise.resolve());
  }
  return Rt;
}
function TC(e, t) {
  const n = [], s = [], o = [], a = Math.max(t.matched.length, e.matched.length);
  for (let c = 0; c < a; c++) {
    const u = t.matched[c];
    u && (e.matched.find((h) => $r(h, u)) ? s.push(u) : n.push(u));
    const d = e.matched[c];
    d && (t.matched.find((h) => $r(h, d)) || o.push(d));
  }
  return [n, s, o];
}
const Pg = /* @__PURE__ */ Un({
  __name: "App",
  setup(e) {
    return (t, n) => (O(), fn(en(Ag)));
  }
});
function Ng(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: kC } = Object.prototype, { getPrototypeOf: eu } = Object, _a = /* @__PURE__ */ ((e) => (t) => {
  const n = kC.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), zn = (e) => (e = e.toLowerCase(), (t) => _a(t) === e), Ca = (e) => (t) => typeof t === e, { isArray: qr } = Array, Os = Ca("undefined");
function RC(e) {
  return e !== null && !Os(e) && e.constructor !== null && !Os(e.constructor) && Cn(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Mg = zn("ArrayBuffer");
function OC(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Mg(e.buffer), t;
}
const AC = Ca("string"), Cn = Ca("function"), Bg = Ca("number"), Sa = (e) => e !== null && typeof e == "object", PC = (e) => e === !0 || e === !1, jo = (e) => {
  if (_a(e) !== "object")
    return !1;
  const t = eu(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, NC = zn("Date"), MC = zn("File"), BC = zn("Blob"), FC = zn("FileList"), $C = (e) => Sa(e) && Cn(e.pipe), HC = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Cn(e.append) && ((t = _a(e)) === "formdata" || // detect form-data instance
  t === "object" && Cn(e.toString) && e.toString() === "[object FormData]"));
}, UC = zn("URLSearchParams"), [zC, WC, qC, jC] = ["ReadableStream", "Request", "Response", "Headers"].map(zn), VC = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Us(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let s, o;
  if (typeof e != "object" && (e = [e]), qr(e))
    for (s = 0, o = e.length; s < o; s++)
      t.call(null, e[s], s, e);
  else {
    const a = n ? Object.getOwnPropertyNames(e) : Object.keys(e), c = a.length;
    let u;
    for (s = 0; s < c; s++)
      u = a[s], t.call(null, e[u], u, e);
  }
}
function Fg(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s = n.length, o;
  for (; s-- > 0; )
    if (o = n[s], t === o.toLowerCase())
      return o;
  return null;
}
const nr = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, $g = (e) => !Os(e) && e !== nr;
function Cc() {
  const { caseless: e } = $g(this) && this || {}, t = {}, n = (s, o) => {
    const a = e && Fg(t, o) || o;
    jo(t[a]) && jo(s) ? t[a] = Cc(t[a], s) : jo(s) ? t[a] = Cc({}, s) : qr(s) ? t[a] = s.slice() : t[a] = s;
  };
  for (let s = 0, o = arguments.length; s < o; s++)
    arguments[s] && Us(arguments[s], n);
  return t;
}
const GC = (e, t, n, { allOwnKeys: s } = {}) => (Us(t, (o, a) => {
  n && Cn(o) ? e[a] = Ng(o, n) : e[a] = o;
}, { allOwnKeys: s }), e), KC = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), YC = (e, t, n, s) => {
  e.prototype = Object.create(t.prototype, s), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, XC = (e, t, n, s) => {
  let o, a, c;
  const u = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), a = o.length; a-- > 0; )
      c = o[a], (!s || s(c, e, t)) && !u[c] && (t[c] = e[c], u[c] = !0);
    e = n !== !1 && eu(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, JC = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const s = e.indexOf(t, n);
  return s !== -1 && s === n;
}, ZC = (e) => {
  if (!e) return null;
  if (qr(e)) return e;
  let t = e.length;
  if (!Bg(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, QC = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && eu(Uint8Array)), eS = (e, t) => {
  const s = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = s.next()) && !o.done; ) {
    const a = o.value;
    t.call(e, a[0], a[1]);
  }
}, tS = (e, t) => {
  let n;
  const s = [];
  for (; (n = e.exec(t)) !== null; )
    s.push(n);
  return s;
}, nS = zn("HTMLFormElement"), iS = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, o) {
    return s.toUpperCase() + o;
  }
), Mh = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), rS = zn("RegExp"), Hg = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), s = {};
  Us(n, (o, a) => {
    let c;
    (c = t(o, a, e)) !== !1 && (s[a] = c || o);
  }), Object.defineProperties(e, s);
}, sS = (e) => {
  Hg(e, (t, n) => {
    if (Cn(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = e[n];
    if (Cn(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, oS = (e, t) => {
  const n = {}, s = (o) => {
    o.forEach((a) => {
      n[a] = !0;
    });
  };
  return qr(e) ? s(e) : s(String(e).split(t)), n;
}, aS = () => {
}, lS = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Ql = "abcdefghijklmnopqrstuvwxyz", Bh = "0123456789", Ug = {
  DIGIT: Bh,
  ALPHA: Ql,
  ALPHA_DIGIT: Ql + Ql.toUpperCase() + Bh
}, cS = (e = 16, t = Ug.ALPHA_DIGIT) => {
  let n = "";
  const { length: s } = t;
  for (; e--; )
    n += t[Math.random() * s | 0];
  return n;
};
function uS(e) {
  return !!(e && Cn(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const fS = (e) => {
  const t = new Array(10), n = (s, o) => {
    if (Sa(s)) {
      if (t.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        t[o] = s;
        const a = qr(s) ? [] : {};
        return Us(s, (c, u) => {
          const d = n(c, o + 1);
          !Os(d) && (a[u] = d);
        }), t[o] = void 0, a;
      }
    }
    return s;
  };
  return n(e, 0);
}, dS = zn("AsyncFunction"), hS = (e) => e && (Sa(e) || Cn(e)) && Cn(e.then) && Cn(e.catch), zg = ((e, t) => e ? setImmediate : t ? ((n, s) => (nr.addEventListener("message", ({ source: o, data: a }) => {
  o === nr && a === n && s.length && s.shift()();
}, !1), (o) => {
  s.push(o), nr.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Cn(nr.postMessage)
), pS = typeof queueMicrotask < "u" ? queueMicrotask.bind(nr) : typeof process < "u" && process.nextTick || zg, M = {
  isArray: qr,
  isArrayBuffer: Mg,
  isBuffer: RC,
  isFormData: HC,
  isArrayBufferView: OC,
  isString: AC,
  isNumber: Bg,
  isBoolean: PC,
  isObject: Sa,
  isPlainObject: jo,
  isReadableStream: zC,
  isRequest: WC,
  isResponse: qC,
  isHeaders: jC,
  isUndefined: Os,
  isDate: NC,
  isFile: MC,
  isBlob: BC,
  isRegExp: rS,
  isFunction: Cn,
  isStream: $C,
  isURLSearchParams: UC,
  isTypedArray: QC,
  isFileList: FC,
  forEach: Us,
  merge: Cc,
  extend: GC,
  trim: VC,
  stripBOM: KC,
  inherits: YC,
  toFlatObject: XC,
  kindOf: _a,
  kindOfTest: zn,
  endsWith: JC,
  toArray: ZC,
  forEachEntry: eS,
  matchAll: tS,
  isHTMLForm: nS,
  hasOwnProperty: Mh,
  hasOwnProp: Mh,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Hg,
  freezeMethods: sS,
  toObjectSet: oS,
  toCamelCase: iS,
  noop: aS,
  toFiniteNumber: lS,
  findKey: Fg,
  global: nr,
  isContextDefined: $g,
  ALPHABET: Ug,
  generateString: cS,
  isSpecCompliantForm: uS,
  toJSONObject: fS,
  isAsyncFn: dS,
  isThenable: hS,
  setImmediate: zg,
  asap: pS
};
function Ie(e, t, n, s, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), s && (this.request = s), o && (this.response = o, this.status = o.status ? o.status : null);
}
M.inherits(Ie, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: M.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Wg = Ie.prototype, qg = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  qg[e] = { value: e };
});
Object.defineProperties(Ie, qg);
Object.defineProperty(Wg, "isAxiosError", { value: !0 });
Ie.from = (e, t, n, s, o, a) => {
  const c = Object.create(Wg);
  return M.toFlatObject(e, c, function(d) {
    return d !== Error.prototype;
  }, (u) => u !== "isAxiosError"), Ie.call(c, e.message, t, n, s, o), c.cause = e, c.name = e.name, a && Object.assign(c, a), c;
};
const gS = null;
function Sc(e) {
  return M.isPlainObject(e) || M.isArray(e);
}
function jg(e) {
  return M.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Fh(e, t, n) {
  return e ? e.concat(t).map(function(o, a) {
    return o = jg(o), !n && a ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function mS(e) {
  return M.isArray(e) && !e.some(Sc);
}
const vS = M.toFlatObject(M, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function La(e, t, n) {
  if (!M.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = M.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(A, R) {
    return !M.isUndefined(R[A]);
  });
  const s = n.metaTokens, o = n.visitor || m, a = n.dots, c = n.indexes, d = (n.Blob || typeof Blob < "u" && Blob) && M.isSpecCompliantForm(t);
  if (!M.isFunction(o))
    throw new TypeError("visitor must be a function");
  function h(D) {
    if (D === null) return "";
    if (M.isDate(D))
      return D.toISOString();
    if (!d && M.isBlob(D))
      throw new Ie("Blob is not supported. Use a Buffer instead.");
    return M.isArrayBuffer(D) || M.isTypedArray(D) ? d && typeof Blob == "function" ? new Blob([D]) : Buffer.from(D) : D;
  }
  function m(D, A, R) {
    let F = D;
    if (D && !R && typeof D == "object") {
      if (M.endsWith(A, "{}"))
        A = s ? A : A.slice(0, -2), D = JSON.stringify(D);
      else if (M.isArray(D) && mS(D) || (M.isFileList(D) || M.endsWith(A, "[]")) && (F = M.toArray(D)))
        return A = jg(A), F.forEach(function(G, Y) {
          !(M.isUndefined(G) || G === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            c === !0 ? Fh([A], Y, a) : c === null ? A : A + "[]",
            h(G)
          );
        }), !1;
    }
    return Sc(D) ? !0 : (t.append(Fh(R, A, a), h(D)), !1);
  }
  const v = [], b = Object.assign(vS, {
    defaultVisitor: m,
    convertValue: h,
    isVisitable: Sc
  });
  function S(D, A) {
    if (!M.isUndefined(D)) {
      if (v.indexOf(D) !== -1)
        throw Error("Circular reference detected in " + A.join("."));
      v.push(D), M.forEach(D, function(F, K) {
        (!(M.isUndefined(F) || F === null) && o.call(
          t,
          F,
          M.isString(K) ? K.trim() : K,
          A,
          b
        )) === !0 && S(F, A ? A.concat(K) : [K]);
      }), v.pop();
    }
  }
  if (!M.isObject(e))
    throw new TypeError("data must be an object");
  return S(e), t;
}
function $h(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(s) {
    return t[s];
  });
}
function tu(e, t) {
  this._pairs = [], e && La(e, this, t);
}
const Vg = tu.prototype;
Vg.append = function(t, n) {
  this._pairs.push([t, n]);
};
Vg.toString = function(t) {
  const n = t ? function(s) {
    return t.call(this, s, $h);
  } : $h;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function yS(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Gg(e, t, n) {
  if (!t)
    return e;
  const s = n && n.encode || yS;
  M.isFunction(n) && (n = {
    serialize: n
  });
  const o = n && n.serialize;
  let a;
  if (o ? a = o(t, n) : a = M.isURLSearchParams(t) ? t.toString() : new tu(t, n).toString(s), a) {
    const c = e.indexOf("#");
    c !== -1 && (e = e.slice(0, c)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class Hh {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, s) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    M.forEach(this.handlers, function(s) {
      s !== null && t(s);
    });
  }
}
const Kg = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, wS = typeof URLSearchParams < "u" ? URLSearchParams : tu, bS = typeof FormData < "u" ? FormData : null, xS = typeof Blob < "u" ? Blob : null, _S = {
  isBrowser: !0,
  classes: {
    URLSearchParams: wS,
    FormData: bS,
    Blob: xS
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, nu = typeof window < "u" && typeof document < "u", Lc = typeof navigator == "object" && navigator || void 0, CS = nu && (!Lc || ["ReactNative", "NativeScript", "NS"].indexOf(Lc.product) < 0), SS = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", LS = nu && window.location.href || "http://localhost", DS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: nu,
  hasStandardBrowserEnv: CS,
  hasStandardBrowserWebWorkerEnv: SS,
  navigator: Lc,
  origin: LS
}, Symbol.toStringTag, { value: "Module" })), Vt = {
  ...DS,
  ..._S
};
function IS(e, t) {
  return La(e, new Vt.classes.URLSearchParams(), Object.assign({
    visitor: function(n, s, o, a) {
      return Vt.isNode && M.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function ES(e) {
  return M.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function TS(e) {
  const t = {}, n = Object.keys(e);
  let s;
  const o = n.length;
  let a;
  for (s = 0; s < o; s++)
    a = n[s], t[a] = e[a];
  return t;
}
function Yg(e) {
  function t(n, s, o, a) {
    let c = n[a++];
    if (c === "__proto__") return !0;
    const u = Number.isFinite(+c), d = a >= n.length;
    return c = !c && M.isArray(o) ? o.length : c, d ? (M.hasOwnProp(o, c) ? o[c] = [o[c], s] : o[c] = s, !u) : ((!o[c] || !M.isObject(o[c])) && (o[c] = []), t(n, s, o[c], a) && M.isArray(o[c]) && (o[c] = TS(o[c])), !u);
  }
  if (M.isFormData(e) && M.isFunction(e.entries)) {
    const n = {};
    return M.forEachEntry(e, (s, o) => {
      t(ES(s), o, n, 0);
    }), n;
  }
  return null;
}
function kS(e, t, n) {
  if (M.isString(e))
    try {
      return (t || JSON.parse)(e), M.trim(e);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (0, JSON.stringify)(e);
}
const zs = {
  transitional: Kg,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const s = n.getContentType() || "", o = s.indexOf("application/json") > -1, a = M.isObject(t);
    if (a && M.isHTMLForm(t) && (t = new FormData(t)), M.isFormData(t))
      return o ? JSON.stringify(Yg(t)) : t;
    if (M.isArrayBuffer(t) || M.isBuffer(t) || M.isStream(t) || M.isFile(t) || M.isBlob(t) || M.isReadableStream(t))
      return t;
    if (M.isArrayBufferView(t))
      return t.buffer;
    if (M.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let u;
    if (a) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return IS(t, this.formSerializer).toString();
      if ((u = M.isFileList(t)) || s.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return La(
          u ? { "files[]": t } : t,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return a || o ? (n.setContentType("application/json", !1), kS(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || zs.transitional, s = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (M.isResponse(t) || M.isReadableStream(t))
      return t;
    if (t && M.isString(t) && (s && !this.responseType || o)) {
      const c = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (u) {
        if (c)
          throw u.name === "SyntaxError" ? Ie.from(u, Ie.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Vt.classes.FormData,
    Blob: Vt.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
M.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  zs.headers[e] = {};
});
const RS = M.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), OS = (e) => {
  const t = {};
  let n, s, o;
  return e && e.split(`
`).forEach(function(c) {
    o = c.indexOf(":"), n = c.substring(0, o).trim().toLowerCase(), s = c.substring(o + 1).trim(), !(!n || t[n] && RS[n]) && (n === "set-cookie" ? t[n] ? t[n].push(s) : t[n] = [s] : t[n] = t[n] ? t[n] + ", " + s : s);
  }), t;
}, Uh = Symbol("internals");
function us(e) {
  return e && String(e).trim().toLowerCase();
}
function Vo(e) {
  return e === !1 || e == null ? e : M.isArray(e) ? e.map(Vo) : String(e);
}
function AS(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(e); )
    t[s[1]] = s[2];
  return t;
}
const PS = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ec(e, t, n, s, o) {
  if (M.isFunction(s))
    return s.call(this, t, n);
  if (o && (t = n), !!M.isString(t)) {
    if (M.isString(s))
      return t.indexOf(s) !== -1;
    if (M.isRegExp(s))
      return s.test(t);
  }
}
function NS(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, s) => n.toUpperCase() + s);
}
function MS(e, t) {
  const n = M.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(e, s + n, {
      value: function(o, a, c) {
        return this[s].call(this, t, o, a, c);
      },
      configurable: !0
    });
  });
}
class dn {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const o = this;
    function a(u, d, h) {
      const m = us(d);
      if (!m)
        throw new Error("header name must be a non-empty string");
      const v = M.findKey(o, m);
      (!v || o[v] === void 0 || h === !0 || h === void 0 && o[v] !== !1) && (o[v || d] = Vo(u));
    }
    const c = (u, d) => M.forEach(u, (h, m) => a(h, m, d));
    if (M.isPlainObject(t) || t instanceof this.constructor)
      c(t, n);
    else if (M.isString(t) && (t = t.trim()) && !PS(t))
      c(OS(t), n);
    else if (M.isHeaders(t))
      for (const [u, d] of t.entries())
        a(d, u, s);
    else
      t != null && a(n, t, s);
    return this;
  }
  get(t, n) {
    if (t = us(t), t) {
      const s = M.findKey(this, t);
      if (s) {
        const o = this[s];
        if (!n)
          return o;
        if (n === !0)
          return AS(o);
        if (M.isFunction(n))
          return n.call(this, o, s);
        if (M.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = us(t), t) {
      const s = M.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!n || ec(this, this[s], s, n)));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let o = !1;
    function a(c) {
      if (c = us(c), c) {
        const u = M.findKey(s, c);
        u && (!n || ec(s, s[u], u, n)) && (delete s[u], o = !0);
      }
    }
    return M.isArray(t) ? t.forEach(a) : a(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length, o = !1;
    for (; s--; ) {
      const a = n[s];
      (!t || ec(this, this[a], a, t, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, s = {};
    return M.forEach(this, (o, a) => {
      const c = M.findKey(s, a);
      if (c) {
        n[c] = Vo(o), delete n[a];
        return;
      }
      const u = t ? NS(a) : String(a).trim();
      u !== a && delete n[a], n[u] = Vo(o), s[u] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return M.forEach(this, (s, o) => {
      s != null && s !== !1 && (n[o] = t && M.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return n.forEach((o) => s.set(o)), s;
  }
  static accessor(t) {
    const s = (this[Uh] = this[Uh] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(c) {
      const u = us(c);
      s[u] || (MS(o, c), s[u] = !0);
    }
    return M.isArray(t) ? t.forEach(a) : a(t), this;
  }
}
dn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
M.reduceDescriptors(dn.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(s) {
      this[n] = s;
    }
  };
});
M.freezeMethods(dn);
function tc(e, t) {
  const n = this || zs, s = t || n, o = dn.from(s.headers);
  let a = s.data;
  return M.forEach(e, function(u) {
    a = u.call(n, a, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), a;
}
function Xg(e) {
  return !!(e && e.__CANCEL__);
}
function jr(e, t, n) {
  Ie.call(this, e ?? "canceled", Ie.ERR_CANCELED, t, n), this.name = "CanceledError";
}
M.inherits(jr, Ie, {
  __CANCEL__: !0
});
function Jg(e, t, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? e(n) : t(new Ie(
    "Request failed with status code " + n.status,
    [Ie.ERR_BAD_REQUEST, Ie.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function BS(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function FS(e, t) {
  e = e || 10;
  const n = new Array(e), s = new Array(e);
  let o = 0, a = 0, c;
  return t = t !== void 0 ? t : 1e3, function(d) {
    const h = Date.now(), m = s[a];
    c || (c = h), n[o] = d, s[o] = h;
    let v = a, b = 0;
    for (; v !== o; )
      b += n[v++], v = v % e;
    if (o = (o + 1) % e, o === a && (a = (a + 1) % e), h - c < t)
      return;
    const S = m && h - m;
    return S ? Math.round(b * 1e3 / S) : void 0;
  };
}
function $S(e, t) {
  let n = 0, s = 1e3 / t, o, a;
  const c = (h, m = Date.now()) => {
    n = m, o = null, a && (clearTimeout(a), a = null), e.apply(null, h);
  };
  return [(...h) => {
    const m = Date.now(), v = m - n;
    v >= s ? c(h, m) : (o = h, a || (a = setTimeout(() => {
      a = null, c(o);
    }, s - v)));
  }, () => o && c(o)];
}
const ia = (e, t, n = 3) => {
  let s = 0;
  const o = FS(50, 250);
  return $S((a) => {
    const c = a.loaded, u = a.lengthComputable ? a.total : void 0, d = c - s, h = o(d), m = c <= u;
    s = c;
    const v = {
      loaded: c,
      total: u,
      progress: u ? c / u : void 0,
      bytes: d,
      rate: h || void 0,
      estimated: h && u && m ? (u - c) / h : void 0,
      event: a,
      lengthComputable: u != null,
      [t ? "download" : "upload"]: !0
    };
    e(v);
  }, n);
}, zh = (e, t) => {
  const n = e != null;
  return [(s) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: s
  }), t[1]];
}, Wh = (e) => (...t) => M.asap(() => e(...t)), HS = Vt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Vt.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Vt.origin),
  Vt.navigator && /(msie|trident)/i.test(Vt.navigator.userAgent)
) : () => !0, US = Vt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, s, o, a) {
      const c = [e + "=" + encodeURIComponent(t)];
      M.isNumber(n) && c.push("expires=" + new Date(n).toGMTString()), M.isString(s) && c.push("path=" + s), M.isString(o) && c.push("domain=" + o), a === !0 && c.push("secure"), document.cookie = c.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function zS(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function WS(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Zg(e, t) {
  return e && !zS(t) ? WS(e, t) : t;
}
const qh = (e) => e instanceof dn ? { ...e } : e;
function ar(e, t) {
  t = t || {};
  const n = {};
  function s(h, m, v, b) {
    return M.isPlainObject(h) && M.isPlainObject(m) ? M.merge.call({ caseless: b }, h, m) : M.isPlainObject(m) ? M.merge({}, m) : M.isArray(m) ? m.slice() : m;
  }
  function o(h, m, v, b) {
    if (M.isUndefined(m)) {
      if (!M.isUndefined(h))
        return s(void 0, h, v, b);
    } else return s(h, m, v, b);
  }
  function a(h, m) {
    if (!M.isUndefined(m))
      return s(void 0, m);
  }
  function c(h, m) {
    if (M.isUndefined(m)) {
      if (!M.isUndefined(h))
        return s(void 0, h);
    } else return s(void 0, m);
  }
  function u(h, m, v) {
    if (v in t)
      return s(h, m);
    if (v in e)
      return s(void 0, h);
  }
  const d = {
    url: a,
    method: a,
    data: a,
    baseURL: c,
    transformRequest: c,
    transformResponse: c,
    paramsSerializer: c,
    timeout: c,
    timeoutMessage: c,
    withCredentials: c,
    withXSRFToken: c,
    adapter: c,
    responseType: c,
    xsrfCookieName: c,
    xsrfHeaderName: c,
    onUploadProgress: c,
    onDownloadProgress: c,
    decompress: c,
    maxContentLength: c,
    maxBodyLength: c,
    beforeRedirect: c,
    transport: c,
    httpAgent: c,
    httpsAgent: c,
    cancelToken: c,
    socketPath: c,
    responseEncoding: c,
    validateStatus: u,
    headers: (h, m, v) => o(qh(h), qh(m), v, !0)
  };
  return M.forEach(Object.keys(Object.assign({}, e, t)), function(m) {
    const v = d[m] || o, b = v(e[m], t[m], m);
    M.isUndefined(b) && v !== u || (n[m] = b);
  }), n;
}
const Qg = (e) => {
  const t = ar({}, e);
  let { data: n, withXSRFToken: s, xsrfHeaderName: o, xsrfCookieName: a, headers: c, auth: u } = t;
  t.headers = c = dn.from(c), t.url = Gg(Zg(t.baseURL, t.url), e.params, e.paramsSerializer), u && c.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  );
  let d;
  if (M.isFormData(n)) {
    if (Vt.hasStandardBrowserEnv || Vt.hasStandardBrowserWebWorkerEnv)
      c.setContentType(void 0);
    else if ((d = c.getContentType()) !== !1) {
      const [h, ...m] = d ? d.split(";").map((v) => v.trim()).filter(Boolean) : [];
      c.setContentType([h || "multipart/form-data", ...m].join("; "));
    }
  }
  if (Vt.hasStandardBrowserEnv && (s && M.isFunction(s) && (s = s(t)), s || s !== !1 && HS(t.url))) {
    const h = o && a && US.read(a);
    h && c.set(o, h);
  }
  return t;
}, qS = typeof XMLHttpRequest < "u", jS = qS && function(e) {
  return new Promise(function(n, s) {
    const o = Qg(e);
    let a = o.data;
    const c = dn.from(o.headers).normalize();
    let { responseType: u, onUploadProgress: d, onDownloadProgress: h } = o, m, v, b, S, D;
    function A() {
      S && S(), D && D(), o.cancelToken && o.cancelToken.unsubscribe(m), o.signal && o.signal.removeEventListener("abort", m);
    }
    let R = new XMLHttpRequest();
    R.open(o.method.toUpperCase(), o.url, !0), R.timeout = o.timeout;
    function F() {
      if (!R)
        return;
      const G = dn.from(
        "getAllResponseHeaders" in R && R.getAllResponseHeaders()
      ), re = {
        data: !u || u === "text" || u === "json" ? R.responseText : R.response,
        status: R.status,
        statusText: R.statusText,
        headers: G,
        config: e,
        request: R
      };
      Jg(function(ue) {
        n(ue), A();
      }, function(ue) {
        s(ue), A();
      }, re), R = null;
    }
    "onloadend" in R ? R.onloadend = F : R.onreadystatechange = function() {
      !R || R.readyState !== 4 || R.status === 0 && !(R.responseURL && R.responseURL.indexOf("file:") === 0) || setTimeout(F);
    }, R.onabort = function() {
      R && (s(new Ie("Request aborted", Ie.ECONNABORTED, e, R)), R = null);
    }, R.onerror = function() {
      s(new Ie("Network Error", Ie.ERR_NETWORK, e, R)), R = null;
    }, R.ontimeout = function() {
      let Y = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const re = o.transitional || Kg;
      o.timeoutErrorMessage && (Y = o.timeoutErrorMessage), s(new Ie(
        Y,
        re.clarifyTimeoutError ? Ie.ETIMEDOUT : Ie.ECONNABORTED,
        e,
        R
      )), R = null;
    }, a === void 0 && c.setContentType(null), "setRequestHeader" in R && M.forEach(c.toJSON(), function(Y, re) {
      R.setRequestHeader(re, Y);
    }), M.isUndefined(o.withCredentials) || (R.withCredentials = !!o.withCredentials), u && u !== "json" && (R.responseType = o.responseType), h && ([b, D] = ia(h, !0), R.addEventListener("progress", b)), d && R.upload && ([v, S] = ia(d), R.upload.addEventListener("progress", v), R.upload.addEventListener("loadend", S)), (o.cancelToken || o.signal) && (m = (G) => {
      R && (s(!G || G.type ? new jr(null, e, R) : G), R.abort(), R = null);
    }, o.cancelToken && o.cancelToken.subscribe(m), o.signal && (o.signal.aborted ? m() : o.signal.addEventListener("abort", m)));
    const K = BS(o.url);
    if (K && Vt.protocols.indexOf(K) === -1) {
      s(new Ie("Unsupported protocol " + K + ":", Ie.ERR_BAD_REQUEST, e));
      return;
    }
    R.send(a || null);
  });
}, VS = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let s = new AbortController(), o;
    const a = function(h) {
      if (!o) {
        o = !0, u();
        const m = h instanceof Error ? h : this.reason;
        s.abort(m instanceof Ie ? m : new jr(m instanceof Error ? m.message : m));
      }
    };
    let c = t && setTimeout(() => {
      c = null, a(new Ie(`timeout ${t} of ms exceeded`, Ie.ETIMEDOUT));
    }, t);
    const u = () => {
      e && (c && clearTimeout(c), c = null, e.forEach((h) => {
        h.unsubscribe ? h.unsubscribe(a) : h.removeEventListener("abort", a);
      }), e = null);
    };
    e.forEach((h) => h.addEventListener("abort", a));
    const { signal: d } = s;
    return d.unsubscribe = () => M.asap(u), d;
  }
}, GS = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let s = 0, o;
  for (; s < n; )
    o = s + t, yield e.slice(s, o), s = o;
}, KS = async function* (e, t) {
  for await (const n of YS(e))
    yield* GS(n, t);
}, YS = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: s } = await t.read();
      if (n)
        break;
      yield s;
    }
  } finally {
    await t.cancel();
  }
}, jh = (e, t, n, s) => {
  const o = KS(e, t);
  let a = 0, c, u = (d) => {
    c || (c = !0, s && s(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: h, value: m } = await o.next();
        if (h) {
          u(), d.close();
          return;
        }
        let v = m.byteLength;
        if (n) {
          let b = a += v;
          n(b);
        }
        d.enqueue(new Uint8Array(m));
      } catch (h) {
        throw u(h), h;
      }
    },
    cancel(d) {
      return u(d), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, Da = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", em = Da && typeof ReadableStream == "function", XS = Da && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), tm = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, JS = em && tm(() => {
  let e = !1;
  const t = new Request(Vt.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Vh = 64 * 1024, Dc = em && tm(() => M.isReadableStream(new Response("").body)), ra = {
  stream: Dc && ((e) => e.body)
};
Da && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !ra[t] && (ra[t] = M.isFunction(e[t]) ? (n) => n[t]() : (n, s) => {
      throw new Ie(`Response type '${t}' is not supported`, Ie.ERR_NOT_SUPPORT, s);
    });
  });
})(new Response());
const ZS = async (e) => {
  if (e == null)
    return 0;
  if (M.isBlob(e))
    return e.size;
  if (M.isSpecCompliantForm(e))
    return (await new Request(Vt.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (M.isArrayBufferView(e) || M.isArrayBuffer(e))
    return e.byteLength;
  if (M.isURLSearchParams(e) && (e = e + ""), M.isString(e))
    return (await XS(e)).byteLength;
}, QS = async (e, t) => {
  const n = M.toFiniteNumber(e.getContentLength());
  return n ?? ZS(t);
}, e6 = Da && (async (e) => {
  let {
    url: t,
    method: n,
    data: s,
    signal: o,
    cancelToken: a,
    timeout: c,
    onDownloadProgress: u,
    onUploadProgress: d,
    responseType: h,
    headers: m,
    withCredentials: v = "same-origin",
    fetchOptions: b
  } = Qg(e);
  h = h ? (h + "").toLowerCase() : "text";
  let S = VS([o, a && a.toAbortSignal()], c), D;
  const A = S && S.unsubscribe && (() => {
    S.unsubscribe();
  });
  let R;
  try {
    if (d && JS && n !== "get" && n !== "head" && (R = await QS(m, s)) !== 0) {
      let re = new Request(t, {
        method: "POST",
        body: s,
        duplex: "half"
      }), be;
      if (M.isFormData(s) && (be = re.headers.get("content-type")) && m.setContentType(be), re.body) {
        const [ue, xe] = zh(
          R,
          ia(Wh(d))
        );
        s = jh(re.body, Vh, ue, xe);
      }
    }
    M.isString(v) || (v = v ? "include" : "omit");
    const F = "credentials" in Request.prototype;
    D = new Request(t, {
      ...b,
      signal: S,
      method: n.toUpperCase(),
      headers: m.normalize().toJSON(),
      body: s,
      duplex: "half",
      credentials: F ? v : void 0
    });
    let K = await fetch(D);
    const G = Dc && (h === "stream" || h === "response");
    if (Dc && (u || G && A)) {
      const re = {};
      ["status", "statusText", "headers"].forEach((Ee) => {
        re[Ee] = K[Ee];
      });
      const be = M.toFiniteNumber(K.headers.get("content-length")), [ue, xe] = u && zh(
        be,
        ia(Wh(u), !0)
      ) || [];
      K = new Response(
        jh(K.body, Vh, ue, () => {
          xe && xe(), A && A();
        }),
        re
      );
    }
    h = h || "text";
    let Y = await ra[M.findKey(ra, h) || "text"](K, e);
    return !G && A && A(), await new Promise((re, be) => {
      Jg(re, be, {
        data: Y,
        headers: dn.from(K.headers),
        status: K.status,
        statusText: K.statusText,
        config: e,
        request: D
      });
    });
  } catch (F) {
    throw A && A(), F && F.name === "TypeError" && /fetch/i.test(F.message) ? Object.assign(
      new Ie("Network Error", Ie.ERR_NETWORK, e, D),
      {
        cause: F.cause || F
      }
    ) : Ie.from(F, F && F.code, e, D);
  }
}), Ic = {
  http: gS,
  xhr: jS,
  fetch: e6
};
M.forEach(Ic, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Gh = (e) => `- ${e}`, t6 = (e) => M.isFunction(e) || e === null || e === !1, nm = {
  getAdapter: (e) => {
    e = M.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, s;
    const o = {};
    for (let a = 0; a < t; a++) {
      n = e[a];
      let c;
      if (s = n, !t6(n) && (s = Ic[(c = String(n)).toLowerCase()], s === void 0))
        throw new Ie(`Unknown adapter '${c}'`);
      if (s)
        break;
      o[c || "#" + a] = s;
    }
    if (!s) {
      const a = Object.entries(o).map(
        ([u, d]) => `adapter ${u} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let c = t ? a.length > 1 ? `since :
` + a.map(Gh).join(`
`) : " " + Gh(a[0]) : "as no adapter specified";
      throw new Ie(
        "There is no suitable adapter to dispatch the request " + c,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: Ic
};
function nc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new jr(null, e);
}
function Kh(e) {
  return nc(e), e.headers = dn.from(e.headers), e.data = tc.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), nm.getAdapter(e.adapter || zs.adapter)(e).then(function(s) {
    return nc(e), s.data = tc.call(
      e,
      e.transformResponse,
      s
    ), s.headers = dn.from(s.headers), s;
  }, function(s) {
    return Xg(s) || (nc(e), s && s.response && (s.response.data = tc.call(
      e,
      e.transformResponse,
      s.response
    ), s.response.headers = dn.from(s.response.headers))), Promise.reject(s);
  });
}
const im = "1.7.9", Ia = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Ia[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Yh = {};
Ia.transitional = function(t, n, s) {
  function o(a, c) {
    return "[Axios v" + im + "] Transitional option '" + a + "'" + c + (s ? ". " + s : "");
  }
  return (a, c, u) => {
    if (t === !1)
      throw new Ie(
        o(c, " has been removed" + (n ? " in " + n : "")),
        Ie.ERR_DEPRECATED
      );
    return n && !Yh[c] && (Yh[c] = !0, console.warn(
      o(
        c,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(a, c, u) : !0;
  };
};
Ia.spelling = function(t) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${t}`), !0);
};
function n6(e, t, n) {
  if (typeof e != "object")
    throw new Ie("options must be an object", Ie.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let o = s.length;
  for (; o-- > 0; ) {
    const a = s[o], c = t[a];
    if (c) {
      const u = e[a], d = u === void 0 || c(u, a, e);
      if (d !== !0)
        throw new Ie("option " + a + " must be " + d, Ie.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Ie("Unknown option " + a, Ie.ERR_BAD_OPTION);
  }
}
const Go = {
  assertOptions: n6,
  validators: Ia
}, Gn = Go.validators;
class rr {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Hh(),
      response: new Hh()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (s) {
      if (s instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? a && !String(s.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + a) : s.stack = a;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = ar(this.defaults, n);
    const { transitional: s, paramsSerializer: o, headers: a } = n;
    s !== void 0 && Go.assertOptions(s, {
      silentJSONParsing: Gn.transitional(Gn.boolean),
      forcedJSONParsing: Gn.transitional(Gn.boolean),
      clarifyTimeoutError: Gn.transitional(Gn.boolean)
    }, !1), o != null && (M.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : Go.assertOptions(o, {
      encode: Gn.function,
      serialize: Gn.function
    }, !0)), Go.assertOptions(n, {
      baseUrl: Gn.spelling("baseURL"),
      withXsrfToken: Gn.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let c = a && M.merge(
      a.common,
      a[n.method]
    );
    a && M.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (D) => {
        delete a[D];
      }
    ), n.headers = dn.concat(c, a);
    const u = [];
    let d = !0;
    this.interceptors.request.forEach(function(A) {
      typeof A.runWhen == "function" && A.runWhen(n) === !1 || (d = d && A.synchronous, u.unshift(A.fulfilled, A.rejected));
    });
    const h = [];
    this.interceptors.response.forEach(function(A) {
      h.push(A.fulfilled, A.rejected);
    });
    let m, v = 0, b;
    if (!d) {
      const D = [Kh.bind(this), void 0];
      for (D.unshift.apply(D, u), D.push.apply(D, h), b = D.length, m = Promise.resolve(n); v < b; )
        m = m.then(D[v++], D[v++]);
      return m;
    }
    b = u.length;
    let S = n;
    for (v = 0; v < b; ) {
      const D = u[v++], A = u[v++];
      try {
        S = D(S);
      } catch (R) {
        A.call(this, R);
        break;
      }
    }
    try {
      m = Kh.call(this, S);
    } catch (D) {
      return Promise.reject(D);
    }
    for (v = 0, b = h.length; v < b; )
      m = m.then(h[v++], h[v++]);
    return m;
  }
  getUri(t) {
    t = ar(this.defaults, t);
    const n = Zg(t.baseURL, t.url);
    return Gg(n, t.params, t.paramsSerializer);
  }
}
M.forEach(["delete", "get", "head", "options"], function(t) {
  rr.prototype[t] = function(n, s) {
    return this.request(ar(s || {}, {
      method: t,
      url: n,
      data: (s || {}).data
    }));
  };
});
M.forEach(["post", "put", "patch"], function(t) {
  function n(s) {
    return function(a, c, u) {
      return this.request(ar(u || {}, {
        method: t,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: c
      }));
    };
  }
  rr.prototype[t] = n(), rr.prototype[t + "Form"] = n(!0);
});
class iu {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const s = this;
    this.promise.then((o) => {
      if (!s._listeners) return;
      let a = s._listeners.length;
      for (; a-- > 0; )
        s._listeners[a](o);
      s._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const c = new Promise((u) => {
        s.subscribe(u), a = u;
      }).then(o);
      return c.cancel = function() {
        s.unsubscribe(a);
      }, c;
    }, t(function(a, c, u) {
      s.reason || (s.reason = new jr(a, c, u), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (s) => {
      t.abort(s);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new iu(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function i6(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function r6(e) {
  return M.isObject(e) && e.isAxiosError === !0;
}
const Ec = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ec).forEach(([e, t]) => {
  Ec[t] = e;
});
function rm(e) {
  const t = new rr(e), n = Ng(rr.prototype.request, t);
  return M.extend(n, rr.prototype, t, { allOwnKeys: !0 }), M.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return rm(ar(e, o));
  }, n;
}
const oe = rm(zs);
oe.Axios = rr;
oe.CanceledError = jr;
oe.CancelToken = iu;
oe.isCancel = Xg;
oe.VERSION = im;
oe.toFormData = La;
oe.AxiosError = Ie;
oe.Cancel = oe.CanceledError;
oe.all = function(t) {
  return Promise.all(t);
};
oe.spread = i6;
oe.isAxiosError = r6;
oe.mergeConfig = ar;
oe.AxiosHeaders = dn;
oe.formToJSON = (e) => Yg(M.isHTMLForm(e) ? new FormData(e) : e);
oe.getAdapter = nm.getAdapter;
oe.HttpStatusCode = Ec;
oe.default = oe;
var fs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, sa = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
sa.exports;
(function(e, t) {
  (function() {
    var n, s = "4.17.21", o = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", c = "Expected a function", u = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", h = 500, m = "__lodash_placeholder__", v = 1, b = 2, S = 4, D = 1, A = 2, R = 1, F = 2, K = 4, G = 8, Y = 16, re = 32, be = 64, ue = 128, xe = 256, Ee = 512, lt = 30, Z = "...", kt = 800, Ue = 16, Nt = 1, ht = 2, Pe = 3, ke = 1 / 0, Ce = 9007199254740991, It = 17976931348623157e292, yt = NaN, Je = 4294967295, tt = Je - 1, ze = Je >>> 1, nt = [
      ["ary", ue],
      ["bind", R],
      ["bindKey", F],
      ["curry", G],
      ["curryRight", Y],
      ["flip", Ee],
      ["partial", re],
      ["partialRight", be],
      ["rearg", xe]
    ], Rt = "[object Arguments]", wt = "[object Array]", U = "[object AsyncFunction]", te = "[object Boolean]", Q = "[object Date]", ae = "[object DOMException]", $e = "[object Error]", x = "[object Function]", C = "[object GeneratorFunction]", T = "[object Map]", H = "[object Number]", q = "[object Null]", B = "[object Object]", ee = "[object Promise]", X = "[object Proxy]", J = "[object RegExp]", j = "[object Set]", de = "[object String]", ie = "[object Symbol]", he = "[object Undefined]", pe = "[object WeakMap]", Me = "[object WeakSet]", We = "[object ArrayBuffer]", Be = "[object DataView]", Mt = "[object Float32Array]", Ot = "[object Float64Array]", nn = "[object Int8Array]", rn = "[object Int16Array]", ei = "[object Int32Array]", ur = "[object Uint8Array]", Bt = "[object Uint8ClampedArray]", sn = "[object Uint16Array]", fr = "[object Uint32Array]", Cm = /\b__p \+= '';/g, Sm = /\b(__p \+=) '' \+/g, Lm = /(__e\(.*?\)|\b__t\)) \+\n'';/g, uu = /&(?:amp|lt|gt|quot|#39);/g, fu = /[&<>"']/g, Dm = RegExp(uu.source), Im = RegExp(fu.source), Em = /<%-([\s\S]+?)%>/g, Tm = /<%([\s\S]+?)%>/g, du = /<%=([\s\S]+?)%>/g, km = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Rm = /^\w*$/, Om = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ta = /[\\^$.*+?()[\]{}|]/g, Am = RegExp(Ta.source), ka = /^\s+/, Pm = /\s/, Nm = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Mm = /\{\n\/\* \[wrapped with (.+)\] \*/, Bm = /,? & /, Fm = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, $m = /[()=,{}\[\]\/\s]/, Hm = /\\(\\)?/g, Um = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, hu = /\w*$/, zm = /^[-+]0x[0-9a-f]+$/i, Wm = /^0b[01]+$/i, qm = /^\[object .+?Constructor\]$/, jm = /^0o[0-7]+$/i, Vm = /^(?:0|[1-9]\d*)$/, Gm = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, qs = /($^)/, Km = /['\n\r\u2028\u2029\\]/g, js = "\\ud800-\\udfff", Ym = "\\u0300-\\u036f", Xm = "\\ufe20-\\ufe2f", Jm = "\\u20d0-\\u20ff", pu = Ym + Xm + Jm, gu = "\\u2700-\\u27bf", mu = "a-z\\xdf-\\xf6\\xf8-\\xff", Zm = "\\xac\\xb1\\xd7\\xf7", Qm = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", e0 = "\\u2000-\\u206f", t0 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", vu = "A-Z\\xc0-\\xd6\\xd8-\\xde", yu = "\\ufe0e\\ufe0f", wu = Zm + Qm + e0 + t0, Ra = "['’]", n0 = "[" + js + "]", bu = "[" + wu + "]", Vs = "[" + pu + "]", xu = "\\d+", i0 = "[" + gu + "]", _u = "[" + mu + "]", Cu = "[^" + js + wu + xu + gu + mu + vu + "]", Oa = "\\ud83c[\\udffb-\\udfff]", r0 = "(?:" + Vs + "|" + Oa + ")", Su = "[^" + js + "]", Aa = "(?:\\ud83c[\\udde6-\\uddff]){2}", Pa = "[\\ud800-\\udbff][\\udc00-\\udfff]", dr = "[" + vu + "]", Lu = "\\u200d", Du = "(?:" + _u + "|" + Cu + ")", s0 = "(?:" + dr + "|" + Cu + ")", Iu = "(?:" + Ra + "(?:d|ll|m|re|s|t|ve))?", Eu = "(?:" + Ra + "(?:D|LL|M|RE|S|T|VE))?", Tu = r0 + "?", ku = "[" + yu + "]?", o0 = "(?:" + Lu + "(?:" + [Su, Aa, Pa].join("|") + ")" + ku + Tu + ")*", a0 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", l0 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ru = ku + Tu + o0, c0 = "(?:" + [i0, Aa, Pa].join("|") + ")" + Ru, u0 = "(?:" + [Su + Vs + "?", Vs, Aa, Pa, n0].join("|") + ")", f0 = RegExp(Ra, "g"), d0 = RegExp(Vs, "g"), Na = RegExp(Oa + "(?=" + Oa + ")|" + u0 + Ru, "g"), h0 = RegExp([
      dr + "?" + _u + "+" + Iu + "(?=" + [bu, dr, "$"].join("|") + ")",
      s0 + "+" + Eu + "(?=" + [bu, dr + Du, "$"].join("|") + ")",
      dr + "?" + Du + "+" + Iu,
      dr + "+" + Eu,
      l0,
      a0,
      xu,
      c0
    ].join("|"), "g"), p0 = RegExp("[" + Lu + js + pu + yu + "]"), g0 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, m0 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], v0 = -1, ot = {};
    ot[Mt] = ot[Ot] = ot[nn] = ot[rn] = ot[ei] = ot[ur] = ot[Bt] = ot[sn] = ot[fr] = !0, ot[Rt] = ot[wt] = ot[We] = ot[te] = ot[Be] = ot[Q] = ot[$e] = ot[x] = ot[T] = ot[H] = ot[B] = ot[J] = ot[j] = ot[de] = ot[pe] = !1;
    var it = {};
    it[Rt] = it[wt] = it[We] = it[Be] = it[te] = it[Q] = it[Mt] = it[Ot] = it[nn] = it[rn] = it[ei] = it[T] = it[H] = it[B] = it[J] = it[j] = it[de] = it[ie] = it[ur] = it[Bt] = it[sn] = it[fr] = !0, it[$e] = it[x] = it[pe] = !1;
    var y0 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, w0 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, b0 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, x0 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, _0 = parseFloat, C0 = parseInt, Ou = typeof fs == "object" && fs && fs.Object === Object && fs, S0 = typeof self == "object" && self && self.Object === Object && self, Ft = Ou || S0 || Function("return this")(), Ma = t && !t.nodeType && t, Ui = Ma && !0 && e && !e.nodeType && e, Au = Ui && Ui.exports === Ma, Ba = Au && Ou.process, Sn = function() {
      try {
        var E = Ui && Ui.require && Ui.require("util").types;
        return E || Ba && Ba.binding && Ba.binding("util");
      } catch {
      }
    }(), Pu = Sn && Sn.isArrayBuffer, Nu = Sn && Sn.isDate, Mu = Sn && Sn.isMap, Bu = Sn && Sn.isRegExp, Fu = Sn && Sn.isSet, $u = Sn && Sn.isTypedArray;
    function hn(E, $, N) {
      switch (N.length) {
        case 0:
          return E.call($);
        case 1:
          return E.call($, N[0]);
        case 2:
          return E.call($, N[0], N[1]);
        case 3:
          return E.call($, N[0], N[1], N[2]);
      }
      return E.apply($, N);
    }
    function L0(E, $, N, se) {
      for (var Se = -1, je = E == null ? 0 : E.length; ++Se < je; ) {
        var Et = E[Se];
        $(se, Et, N(Et), E);
      }
      return se;
    }
    function Ln(E, $) {
      for (var N = -1, se = E == null ? 0 : E.length; ++N < se && $(E[N], N, E) !== !1; )
        ;
      return E;
    }
    function D0(E, $) {
      for (var N = E == null ? 0 : E.length; N-- && $(E[N], N, E) !== !1; )
        ;
      return E;
    }
    function Hu(E, $) {
      for (var N = -1, se = E == null ? 0 : E.length; ++N < se; )
        if (!$(E[N], N, E))
          return !1;
      return !0;
    }
    function wi(E, $) {
      for (var N = -1, se = E == null ? 0 : E.length, Se = 0, je = []; ++N < se; ) {
        var Et = E[N];
        $(Et, N, E) && (je[Se++] = Et);
      }
      return je;
    }
    function Gs(E, $) {
      var N = E == null ? 0 : E.length;
      return !!N && hr(E, $, 0) > -1;
    }
    function Fa(E, $, N) {
      for (var se = -1, Se = E == null ? 0 : E.length; ++se < Se; )
        if (N($, E[se]))
          return !0;
      return !1;
    }
    function ct(E, $) {
      for (var N = -1, se = E == null ? 0 : E.length, Se = Array(se); ++N < se; )
        Se[N] = $(E[N], N, E);
      return Se;
    }
    function bi(E, $) {
      for (var N = -1, se = $.length, Se = E.length; ++N < se; )
        E[Se + N] = $[N];
      return E;
    }
    function $a(E, $, N, se) {
      var Se = -1, je = E == null ? 0 : E.length;
      for (se && je && (N = E[++Se]); ++Se < je; )
        N = $(N, E[Se], Se, E);
      return N;
    }
    function I0(E, $, N, se) {
      var Se = E == null ? 0 : E.length;
      for (se && Se && (N = E[--Se]); Se--; )
        N = $(N, E[Se], Se, E);
      return N;
    }
    function Ha(E, $) {
      for (var N = -1, se = E == null ? 0 : E.length; ++N < se; )
        if ($(E[N], N, E))
          return !0;
      return !1;
    }
    var E0 = Ua("length");
    function T0(E) {
      return E.split("");
    }
    function k0(E) {
      return E.match(Fm) || [];
    }
    function Uu(E, $, N) {
      var se;
      return N(E, function(Se, je, Et) {
        if ($(Se, je, Et))
          return se = je, !1;
      }), se;
    }
    function Ks(E, $, N, se) {
      for (var Se = E.length, je = N + (se ? 1 : -1); se ? je-- : ++je < Se; )
        if ($(E[je], je, E))
          return je;
      return -1;
    }
    function hr(E, $, N) {
      return $ === $ ? z0(E, $, N) : Ks(E, zu, N);
    }
    function R0(E, $, N, se) {
      for (var Se = N - 1, je = E.length; ++Se < je; )
        if (se(E[Se], $))
          return Se;
      return -1;
    }
    function zu(E) {
      return E !== E;
    }
    function Wu(E, $) {
      var N = E == null ? 0 : E.length;
      return N ? Wa(E, $) / N : yt;
    }
    function Ua(E) {
      return function($) {
        return $ == null ? n : $[E];
      };
    }
    function za(E) {
      return function($) {
        return E == null ? n : E[$];
      };
    }
    function qu(E, $, N, se, Se) {
      return Se(E, function(je, Et, Qe) {
        N = se ? (se = !1, je) : $(N, je, Et, Qe);
      }), N;
    }
    function O0(E, $) {
      var N = E.length;
      for (E.sort($); N--; )
        E[N] = E[N].value;
      return E;
    }
    function Wa(E, $) {
      for (var N, se = -1, Se = E.length; ++se < Se; ) {
        var je = $(E[se]);
        je !== n && (N = N === n ? je : N + je);
      }
      return N;
    }
    function qa(E, $) {
      for (var N = -1, se = Array(E); ++N < E; )
        se[N] = $(N);
      return se;
    }
    function A0(E, $) {
      return ct($, function(N) {
        return [N, E[N]];
      });
    }
    function ju(E) {
      return E && E.slice(0, Yu(E) + 1).replace(ka, "");
    }
    function pn(E) {
      return function($) {
        return E($);
      };
    }
    function ja(E, $) {
      return ct($, function(N) {
        return E[N];
      });
    }
    function Vr(E, $) {
      return E.has($);
    }
    function Vu(E, $) {
      for (var N = -1, se = E.length; ++N < se && hr($, E[N], 0) > -1; )
        ;
      return N;
    }
    function Gu(E, $) {
      for (var N = E.length; N-- && hr($, E[N], 0) > -1; )
        ;
      return N;
    }
    function P0(E, $) {
      for (var N = E.length, se = 0; N--; )
        E[N] === $ && ++se;
      return se;
    }
    var N0 = za(y0), M0 = za(w0);
    function B0(E) {
      return "\\" + x0[E];
    }
    function F0(E, $) {
      return E == null ? n : E[$];
    }
    function pr(E) {
      return p0.test(E);
    }
    function $0(E) {
      return g0.test(E);
    }
    function H0(E) {
      for (var $, N = []; !($ = E.next()).done; )
        N.push($.value);
      return N;
    }
    function Va(E) {
      var $ = -1, N = Array(E.size);
      return E.forEach(function(se, Se) {
        N[++$] = [Se, se];
      }), N;
    }
    function Ku(E, $) {
      return function(N) {
        return E($(N));
      };
    }
    function xi(E, $) {
      for (var N = -1, se = E.length, Se = 0, je = []; ++N < se; ) {
        var Et = E[N];
        (Et === $ || Et === m) && (E[N] = m, je[Se++] = N);
      }
      return je;
    }
    function Ys(E) {
      var $ = -1, N = Array(E.size);
      return E.forEach(function(se) {
        N[++$] = se;
      }), N;
    }
    function U0(E) {
      var $ = -1, N = Array(E.size);
      return E.forEach(function(se) {
        N[++$] = [se, se];
      }), N;
    }
    function z0(E, $, N) {
      for (var se = N - 1, Se = E.length; ++se < Se; )
        if (E[se] === $)
          return se;
      return -1;
    }
    function W0(E, $, N) {
      for (var se = N + 1; se--; )
        if (E[se] === $)
          return se;
      return se;
    }
    function gr(E) {
      return pr(E) ? j0(E) : E0(E);
    }
    function Pn(E) {
      return pr(E) ? V0(E) : T0(E);
    }
    function Yu(E) {
      for (var $ = E.length; $-- && Pm.test(E.charAt($)); )
        ;
      return $;
    }
    var q0 = za(b0);
    function j0(E) {
      for (var $ = Na.lastIndex = 0; Na.test(E); )
        ++$;
      return $;
    }
    function V0(E) {
      return E.match(Na) || [];
    }
    function G0(E) {
      return E.match(h0) || [];
    }
    var K0 = function E($) {
      $ = $ == null ? Ft : mr.defaults(Ft.Object(), $, mr.pick(Ft, m0));
      var N = $.Array, se = $.Date, Se = $.Error, je = $.Function, Et = $.Math, Qe = $.Object, Ga = $.RegExp, Y0 = $.String, Dn = $.TypeError, Xs = N.prototype, X0 = je.prototype, vr = Qe.prototype, Js = $["__core-js_shared__"], Zs = X0.toString, Ze = vr.hasOwnProperty, J0 = 0, Xu = function() {
        var i = /[^.]+$/.exec(Js && Js.keys && Js.keys.IE_PROTO || "");
        return i ? "Symbol(src)_1." + i : "";
      }(), Qs = vr.toString, Z0 = Zs.call(Qe), Q0 = Ft._, ev = Ga(
        "^" + Zs.call(Ze).replace(Ta, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), eo = Au ? $.Buffer : n, _i = $.Symbol, to = $.Uint8Array, Ju = eo ? eo.allocUnsafe : n, no = Ku(Qe.getPrototypeOf, Qe), Zu = Qe.create, Qu = vr.propertyIsEnumerable, io = Xs.splice, ef = _i ? _i.isConcatSpreadable : n, Gr = _i ? _i.iterator : n, zi = _i ? _i.toStringTag : n, ro = function() {
        try {
          var i = Gi(Qe, "defineProperty");
          return i({}, "", {}), i;
        } catch {
        }
      }(), tv = $.clearTimeout !== Ft.clearTimeout && $.clearTimeout, nv = se && se.now !== Ft.Date.now && se.now, iv = $.setTimeout !== Ft.setTimeout && $.setTimeout, so = Et.ceil, oo = Et.floor, Ka = Qe.getOwnPropertySymbols, rv = eo ? eo.isBuffer : n, tf = $.isFinite, sv = Xs.join, ov = Ku(Qe.keys, Qe), Tt = Et.max, zt = Et.min, av = se.now, lv = $.parseInt, nf = Et.random, cv = Xs.reverse, Ya = Gi($, "DataView"), Kr = Gi($, "Map"), Xa = Gi($, "Promise"), yr = Gi($, "Set"), Yr = Gi($, "WeakMap"), Xr = Gi(Qe, "create"), ao = Yr && new Yr(), wr = {}, uv = Ki(Ya), fv = Ki(Kr), dv = Ki(Xa), hv = Ki(yr), pv = Ki(Yr), lo = _i ? _i.prototype : n, Jr = lo ? lo.valueOf : n, rf = lo ? lo.toString : n;
      function y(i) {
        if (pt(i) && !Le(i) && !(i instanceof Fe)) {
          if (i instanceof In)
            return i;
          if (Ze.call(i, "__wrapped__"))
            return sd(i);
        }
        return new In(i);
      }
      var br = /* @__PURE__ */ function() {
        function i() {
        }
        return function(r) {
          if (!ft(r))
            return {};
          if (Zu)
            return Zu(r);
          i.prototype = r;
          var l = new i();
          return i.prototype = n, l;
        };
      }();
      function co() {
      }
      function In(i, r) {
        this.__wrapped__ = i, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = n;
      }
      y.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Em,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Tm,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: du,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: y
        }
      }, y.prototype = co.prototype, y.prototype.constructor = y, In.prototype = br(co.prototype), In.prototype.constructor = In;
      function Fe(i) {
        this.__wrapped__ = i, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Je, this.__views__ = [];
      }
      function gv() {
        var i = new Fe(this.__wrapped__);
        return i.__actions__ = on(this.__actions__), i.__dir__ = this.__dir__, i.__filtered__ = this.__filtered__, i.__iteratees__ = on(this.__iteratees__), i.__takeCount__ = this.__takeCount__, i.__views__ = on(this.__views__), i;
      }
      function mv() {
        if (this.__filtered__) {
          var i = new Fe(this);
          i.__dir__ = -1, i.__filtered__ = !0;
        } else
          i = this.clone(), i.__dir__ *= -1;
        return i;
      }
      function vv() {
        var i = this.__wrapped__.value(), r = this.__dir__, l = Le(i), f = r < 0, g = l ? i.length : 0, w = T1(0, g, this.__views__), _ = w.start, L = w.end, k = L - _, z = f ? L : _ - 1, W = this.__iteratees__, V = W.length, ne = 0, ce = zt(k, this.__takeCount__);
        if (!l || !f && g == k && ce == k)
          return Ef(i, this.__actions__);
        var ve = [];
        e:
          for (; k-- && ne < ce; ) {
            z += r;
            for (var Re = -1, ye = i[z]; ++Re < V; ) {
              var Ne = W[Re], He = Ne.iteratee, vn = Ne.type, Jt = He(ye);
              if (vn == ht)
                ye = Jt;
              else if (!Jt) {
                if (vn == Nt)
                  continue e;
                break e;
              }
            }
            ve[ne++] = ye;
          }
        return ve;
      }
      Fe.prototype = br(co.prototype), Fe.prototype.constructor = Fe;
      function Wi(i) {
        var r = -1, l = i == null ? 0 : i.length;
        for (this.clear(); ++r < l; ) {
          var f = i[r];
          this.set(f[0], f[1]);
        }
      }
      function yv() {
        this.__data__ = Xr ? Xr(null) : {}, this.size = 0;
      }
      function wv(i) {
        var r = this.has(i) && delete this.__data__[i];
        return this.size -= r ? 1 : 0, r;
      }
      function bv(i) {
        var r = this.__data__;
        if (Xr) {
          var l = r[i];
          return l === d ? n : l;
        }
        return Ze.call(r, i) ? r[i] : n;
      }
      function xv(i) {
        var r = this.__data__;
        return Xr ? r[i] !== n : Ze.call(r, i);
      }
      function _v(i, r) {
        var l = this.__data__;
        return this.size += this.has(i) ? 0 : 1, l[i] = Xr && r === n ? d : r, this;
      }
      Wi.prototype.clear = yv, Wi.prototype.delete = wv, Wi.prototype.get = bv, Wi.prototype.has = xv, Wi.prototype.set = _v;
      function ti(i) {
        var r = -1, l = i == null ? 0 : i.length;
        for (this.clear(); ++r < l; ) {
          var f = i[r];
          this.set(f[0], f[1]);
        }
      }
      function Cv() {
        this.__data__ = [], this.size = 0;
      }
      function Sv(i) {
        var r = this.__data__, l = uo(r, i);
        if (l < 0)
          return !1;
        var f = r.length - 1;
        return l == f ? r.pop() : io.call(r, l, 1), --this.size, !0;
      }
      function Lv(i) {
        var r = this.__data__, l = uo(r, i);
        return l < 0 ? n : r[l][1];
      }
      function Dv(i) {
        return uo(this.__data__, i) > -1;
      }
      function Iv(i, r) {
        var l = this.__data__, f = uo(l, i);
        return f < 0 ? (++this.size, l.push([i, r])) : l[f][1] = r, this;
      }
      ti.prototype.clear = Cv, ti.prototype.delete = Sv, ti.prototype.get = Lv, ti.prototype.has = Dv, ti.prototype.set = Iv;
      function ni(i) {
        var r = -1, l = i == null ? 0 : i.length;
        for (this.clear(); ++r < l; ) {
          var f = i[r];
          this.set(f[0], f[1]);
        }
      }
      function Ev() {
        this.size = 0, this.__data__ = {
          hash: new Wi(),
          map: new (Kr || ti)(),
          string: new Wi()
        };
      }
      function Tv(i) {
        var r = Co(this, i).delete(i);
        return this.size -= r ? 1 : 0, r;
      }
      function kv(i) {
        return Co(this, i).get(i);
      }
      function Rv(i) {
        return Co(this, i).has(i);
      }
      function Ov(i, r) {
        var l = Co(this, i), f = l.size;
        return l.set(i, r), this.size += l.size == f ? 0 : 1, this;
      }
      ni.prototype.clear = Ev, ni.prototype.delete = Tv, ni.prototype.get = kv, ni.prototype.has = Rv, ni.prototype.set = Ov;
      function qi(i) {
        var r = -1, l = i == null ? 0 : i.length;
        for (this.__data__ = new ni(); ++r < l; )
          this.add(i[r]);
      }
      function Av(i) {
        return this.__data__.set(i, d), this;
      }
      function Pv(i) {
        return this.__data__.has(i);
      }
      qi.prototype.add = qi.prototype.push = Av, qi.prototype.has = Pv;
      function Nn(i) {
        var r = this.__data__ = new ti(i);
        this.size = r.size;
      }
      function Nv() {
        this.__data__ = new ti(), this.size = 0;
      }
      function Mv(i) {
        var r = this.__data__, l = r.delete(i);
        return this.size = r.size, l;
      }
      function Bv(i) {
        return this.__data__.get(i);
      }
      function Fv(i) {
        return this.__data__.has(i);
      }
      function $v(i, r) {
        var l = this.__data__;
        if (l instanceof ti) {
          var f = l.__data__;
          if (!Kr || f.length < o - 1)
            return f.push([i, r]), this.size = ++l.size, this;
          l = this.__data__ = new ni(f);
        }
        return l.set(i, r), this.size = l.size, this;
      }
      Nn.prototype.clear = Nv, Nn.prototype.delete = Mv, Nn.prototype.get = Bv, Nn.prototype.has = Fv, Nn.prototype.set = $v;
      function sf(i, r) {
        var l = Le(i), f = !l && Yi(i), g = !l && !f && Ii(i), w = !l && !f && !g && Sr(i), _ = l || f || g || w, L = _ ? qa(i.length, Y0) : [], k = L.length;
        for (var z in i)
          (r || Ze.call(i, z)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
          (z == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          g && (z == "offset" || z == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          w && (z == "buffer" || z == "byteLength" || z == "byteOffset") || // Skip index properties.
          oi(z, k))) && L.push(z);
        return L;
      }
      function of(i) {
        var r = i.length;
        return r ? i[al(0, r - 1)] : n;
      }
      function Hv(i, r) {
        return So(on(i), ji(r, 0, i.length));
      }
      function Uv(i) {
        return So(on(i));
      }
      function Ja(i, r, l) {
        (l !== n && !Mn(i[r], l) || l === n && !(r in i)) && ii(i, r, l);
      }
      function Zr(i, r, l) {
        var f = i[r];
        (!(Ze.call(i, r) && Mn(f, l)) || l === n && !(r in i)) && ii(i, r, l);
      }
      function uo(i, r) {
        for (var l = i.length; l--; )
          if (Mn(i[l][0], r))
            return l;
        return -1;
      }
      function zv(i, r, l, f) {
        return Ci(i, function(g, w, _) {
          r(f, g, l(g), _);
        }), f;
      }
      function af(i, r) {
        return i && qn(r, At(r), i);
      }
      function Wv(i, r) {
        return i && qn(r, ln(r), i);
      }
      function ii(i, r, l) {
        r == "__proto__" && ro ? ro(i, r, {
          configurable: !0,
          enumerable: !0,
          value: l,
          writable: !0
        }) : i[r] = l;
      }
      function Za(i, r) {
        for (var l = -1, f = r.length, g = N(f), w = i == null; ++l < f; )
          g[l] = w ? n : Ol(i, r[l]);
        return g;
      }
      function ji(i, r, l) {
        return i === i && (l !== n && (i = i <= l ? i : l), r !== n && (i = i >= r ? i : r)), i;
      }
      function En(i, r, l, f, g, w) {
        var _, L = r & v, k = r & b, z = r & S;
        if (l && (_ = g ? l(i, f, g, w) : l(i)), _ !== n)
          return _;
        if (!ft(i))
          return i;
        var W = Le(i);
        if (W) {
          if (_ = R1(i), !L)
            return on(i, _);
        } else {
          var V = Wt(i), ne = V == x || V == C;
          if (Ii(i))
            return Rf(i, L);
          if (V == B || V == Rt || ne && !g) {
            if (_ = k || ne ? {} : Xf(i), !L)
              return k ? b1(i, Wv(_, i)) : w1(i, af(_, i));
          } else {
            if (!it[V])
              return g ? i : {};
            _ = O1(i, V, L);
          }
        }
        w || (w = new Nn());
        var ce = w.get(i);
        if (ce)
          return ce;
        w.set(i, _), Ld(i) ? i.forEach(function(ye) {
          _.add(En(ye, r, l, ye, i, w));
        }) : Cd(i) && i.forEach(function(ye, Ne) {
          _.set(Ne, En(ye, r, l, Ne, i, w));
        });
        var ve = z ? k ? yl : vl : k ? ln : At, Re = W ? n : ve(i);
        return Ln(Re || i, function(ye, Ne) {
          Re && (Ne = ye, ye = i[Ne]), Zr(_, Ne, En(ye, r, l, Ne, i, w));
        }), _;
      }
      function qv(i) {
        var r = At(i);
        return function(l) {
          return lf(l, i, r);
        };
      }
      function lf(i, r, l) {
        var f = l.length;
        if (i == null)
          return !f;
        for (i = Qe(i); f--; ) {
          var g = l[f], w = r[g], _ = i[g];
          if (_ === n && !(g in i) || !w(_))
            return !1;
        }
        return !0;
      }
      function cf(i, r, l) {
        if (typeof i != "function")
          throw new Dn(c);
        return ss(function() {
          i.apply(n, l);
        }, r);
      }
      function Qr(i, r, l, f) {
        var g = -1, w = Gs, _ = !0, L = i.length, k = [], z = r.length;
        if (!L)
          return k;
        l && (r = ct(r, pn(l))), f ? (w = Fa, _ = !1) : r.length >= o && (w = Vr, _ = !1, r = new qi(r));
        e:
          for (; ++g < L; ) {
            var W = i[g], V = l == null ? W : l(W);
            if (W = f || W !== 0 ? W : 0, _ && V === V) {
              for (var ne = z; ne--; )
                if (r[ne] === V)
                  continue e;
              k.push(W);
            } else w(r, V, f) || k.push(W);
          }
        return k;
      }
      var Ci = Mf(Wn), uf = Mf(el, !0);
      function jv(i, r) {
        var l = !0;
        return Ci(i, function(f, g, w) {
          return l = !!r(f, g, w), l;
        }), l;
      }
      function fo(i, r, l) {
        for (var f = -1, g = i.length; ++f < g; ) {
          var w = i[f], _ = r(w);
          if (_ != null && (L === n ? _ === _ && !mn(_) : l(_, L)))
            var L = _, k = w;
        }
        return k;
      }
      function Vv(i, r, l, f) {
        var g = i.length;
        for (l = Te(l), l < 0 && (l = -l > g ? 0 : g + l), f = f === n || f > g ? g : Te(f), f < 0 && (f += g), f = l > f ? 0 : Id(f); l < f; )
          i[l++] = r;
        return i;
      }
      function ff(i, r) {
        var l = [];
        return Ci(i, function(f, g, w) {
          r(f, g, w) && l.push(f);
        }), l;
      }
      function $t(i, r, l, f, g) {
        var w = -1, _ = i.length;
        for (l || (l = P1), g || (g = []); ++w < _; ) {
          var L = i[w];
          r > 0 && l(L) ? r > 1 ? $t(L, r - 1, l, f, g) : bi(g, L) : f || (g[g.length] = L);
        }
        return g;
      }
      var Qa = Bf(), df = Bf(!0);
      function Wn(i, r) {
        return i && Qa(i, r, At);
      }
      function el(i, r) {
        return i && df(i, r, At);
      }
      function ho(i, r) {
        return wi(r, function(l) {
          return ai(i[l]);
        });
      }
      function Vi(i, r) {
        r = Li(r, i);
        for (var l = 0, f = r.length; i != null && l < f; )
          i = i[jn(r[l++])];
        return l && l == f ? i : n;
      }
      function hf(i, r, l) {
        var f = r(i);
        return Le(i) ? f : bi(f, l(i));
      }
      function Yt(i) {
        return i == null ? i === n ? he : q : zi && zi in Qe(i) ? E1(i) : U1(i);
      }
      function tl(i, r) {
        return i > r;
      }
      function Gv(i, r) {
        return i != null && Ze.call(i, r);
      }
      function Kv(i, r) {
        return i != null && r in Qe(i);
      }
      function Yv(i, r, l) {
        return i >= zt(r, l) && i < Tt(r, l);
      }
      function nl(i, r, l) {
        for (var f = l ? Fa : Gs, g = i[0].length, w = i.length, _ = w, L = N(w), k = 1 / 0, z = []; _--; ) {
          var W = i[_];
          _ && r && (W = ct(W, pn(r))), k = zt(W.length, k), L[_] = !l && (r || g >= 120 && W.length >= 120) ? new qi(_ && W) : n;
        }
        W = i[0];
        var V = -1, ne = L[0];
        e:
          for (; ++V < g && z.length < k; ) {
            var ce = W[V], ve = r ? r(ce) : ce;
            if (ce = l || ce !== 0 ? ce : 0, !(ne ? Vr(ne, ve) : f(z, ve, l))) {
              for (_ = w; --_; ) {
                var Re = L[_];
                if (!(Re ? Vr(Re, ve) : f(i[_], ve, l)))
                  continue e;
              }
              ne && ne.push(ve), z.push(ce);
            }
          }
        return z;
      }
      function Xv(i, r, l, f) {
        return Wn(i, function(g, w, _) {
          r(f, l(g), w, _);
        }), f;
      }
      function es(i, r, l) {
        r = Li(r, i), i = ed(i, r);
        var f = i == null ? i : i[jn(kn(r))];
        return f == null ? n : hn(f, i, l);
      }
      function pf(i) {
        return pt(i) && Yt(i) == Rt;
      }
      function Jv(i) {
        return pt(i) && Yt(i) == We;
      }
      function Zv(i) {
        return pt(i) && Yt(i) == Q;
      }
      function ts(i, r, l, f, g) {
        return i === r ? !0 : i == null || r == null || !pt(i) && !pt(r) ? i !== i && r !== r : Qv(i, r, l, f, ts, g);
      }
      function Qv(i, r, l, f, g, w) {
        var _ = Le(i), L = Le(r), k = _ ? wt : Wt(i), z = L ? wt : Wt(r);
        k = k == Rt ? B : k, z = z == Rt ? B : z;
        var W = k == B, V = z == B, ne = k == z;
        if (ne && Ii(i)) {
          if (!Ii(r))
            return !1;
          _ = !0, W = !1;
        }
        if (ne && !W)
          return w || (w = new Nn()), _ || Sr(i) ? Gf(i, r, l, f, g, w) : D1(i, r, k, l, f, g, w);
        if (!(l & D)) {
          var ce = W && Ze.call(i, "__wrapped__"), ve = V && Ze.call(r, "__wrapped__");
          if (ce || ve) {
            var Re = ce ? i.value() : i, ye = ve ? r.value() : r;
            return w || (w = new Nn()), g(Re, ye, l, f, w);
          }
        }
        return ne ? (w || (w = new Nn()), I1(i, r, l, f, g, w)) : !1;
      }
      function e1(i) {
        return pt(i) && Wt(i) == T;
      }
      function il(i, r, l, f) {
        var g = l.length, w = g, _ = !f;
        if (i == null)
          return !w;
        for (i = Qe(i); g--; ) {
          var L = l[g];
          if (_ && L[2] ? L[1] !== i[L[0]] : !(L[0] in i))
            return !1;
        }
        for (; ++g < w; ) {
          L = l[g];
          var k = L[0], z = i[k], W = L[1];
          if (_ && L[2]) {
            if (z === n && !(k in i))
              return !1;
          } else {
            var V = new Nn();
            if (f)
              var ne = f(z, W, k, i, r, V);
            if (!(ne === n ? ts(W, z, D | A, f, V) : ne))
              return !1;
          }
        }
        return !0;
      }
      function gf(i) {
        if (!ft(i) || M1(i))
          return !1;
        var r = ai(i) ? ev : qm;
        return r.test(Ki(i));
      }
      function t1(i) {
        return pt(i) && Yt(i) == J;
      }
      function n1(i) {
        return pt(i) && Wt(i) == j;
      }
      function i1(i) {
        return pt(i) && ko(i.length) && !!ot[Yt(i)];
      }
      function mf(i) {
        return typeof i == "function" ? i : i == null ? cn : typeof i == "object" ? Le(i) ? wf(i[0], i[1]) : yf(i) : Fd(i);
      }
      function rl(i) {
        if (!rs(i))
          return ov(i);
        var r = [];
        for (var l in Qe(i))
          Ze.call(i, l) && l != "constructor" && r.push(l);
        return r;
      }
      function r1(i) {
        if (!ft(i))
          return H1(i);
        var r = rs(i), l = [];
        for (var f in i)
          f == "constructor" && (r || !Ze.call(i, f)) || l.push(f);
        return l;
      }
      function sl(i, r) {
        return i < r;
      }
      function vf(i, r) {
        var l = -1, f = an(i) ? N(i.length) : [];
        return Ci(i, function(g, w, _) {
          f[++l] = r(g, w, _);
        }), f;
      }
      function yf(i) {
        var r = bl(i);
        return r.length == 1 && r[0][2] ? Zf(r[0][0], r[0][1]) : function(l) {
          return l === i || il(l, i, r);
        };
      }
      function wf(i, r) {
        return _l(i) && Jf(r) ? Zf(jn(i), r) : function(l) {
          var f = Ol(l, i);
          return f === n && f === r ? Al(l, i) : ts(r, f, D | A);
        };
      }
      function po(i, r, l, f, g) {
        i !== r && Qa(r, function(w, _) {
          if (g || (g = new Nn()), ft(w))
            s1(i, r, _, l, po, f, g);
          else {
            var L = f ? f(Sl(i, _), w, _ + "", i, r, g) : n;
            L === n && (L = w), Ja(i, _, L);
          }
        }, ln);
      }
      function s1(i, r, l, f, g, w, _) {
        var L = Sl(i, l), k = Sl(r, l), z = _.get(k);
        if (z) {
          Ja(i, l, z);
          return;
        }
        var W = w ? w(L, k, l + "", i, r, _) : n, V = W === n;
        if (V) {
          var ne = Le(k), ce = !ne && Ii(k), ve = !ne && !ce && Sr(k);
          W = k, ne || ce || ve ? Le(L) ? W = L : bt(L) ? W = on(L) : ce ? (V = !1, W = Rf(k, !0)) : ve ? (V = !1, W = Of(k, !0)) : W = [] : os(k) || Yi(k) ? (W = L, Yi(L) ? W = Ed(L) : (!ft(L) || ai(L)) && (W = Xf(k))) : V = !1;
        }
        V && (_.set(k, W), g(W, k, f, w, _), _.delete(k)), Ja(i, l, W);
      }
      function bf(i, r) {
        var l = i.length;
        if (l)
          return r += r < 0 ? l : 0, oi(r, l) ? i[r] : n;
      }
      function xf(i, r, l) {
        r.length ? r = ct(r, function(w) {
          return Le(w) ? function(_) {
            return Vi(_, w.length === 1 ? w[0] : w);
          } : w;
        }) : r = [cn];
        var f = -1;
        r = ct(r, pn(ge()));
        var g = vf(i, function(w, _, L) {
          var k = ct(r, function(z) {
            return z(w);
          });
          return { criteria: k, index: ++f, value: w };
        });
        return O0(g, function(w, _) {
          return y1(w, _, l);
        });
      }
      function o1(i, r) {
        return _f(i, r, function(l, f) {
          return Al(i, f);
        });
      }
      function _f(i, r, l) {
        for (var f = -1, g = r.length, w = {}; ++f < g; ) {
          var _ = r[f], L = Vi(i, _);
          l(L, _) && ns(w, Li(_, i), L);
        }
        return w;
      }
      function a1(i) {
        return function(r) {
          return Vi(r, i);
        };
      }
      function ol(i, r, l, f) {
        var g = f ? R0 : hr, w = -1, _ = r.length, L = i;
        for (i === r && (r = on(r)), l && (L = ct(i, pn(l))); ++w < _; )
          for (var k = 0, z = r[w], W = l ? l(z) : z; (k = g(L, W, k, f)) > -1; )
            L !== i && io.call(L, k, 1), io.call(i, k, 1);
        return i;
      }
      function Cf(i, r) {
        for (var l = i ? r.length : 0, f = l - 1; l--; ) {
          var g = r[l];
          if (l == f || g !== w) {
            var w = g;
            oi(g) ? io.call(i, g, 1) : ul(i, g);
          }
        }
        return i;
      }
      function al(i, r) {
        return i + oo(nf() * (r - i + 1));
      }
      function l1(i, r, l, f) {
        for (var g = -1, w = Tt(so((r - i) / (l || 1)), 0), _ = N(w); w--; )
          _[f ? w : ++g] = i, i += l;
        return _;
      }
      function ll(i, r) {
        var l = "";
        if (!i || r < 1 || r > Ce)
          return l;
        do
          r % 2 && (l += i), r = oo(r / 2), r && (i += i);
        while (r);
        return l;
      }
      function Oe(i, r) {
        return Ll(Qf(i, r, cn), i + "");
      }
      function c1(i) {
        return of(Lr(i));
      }
      function u1(i, r) {
        var l = Lr(i);
        return So(l, ji(r, 0, l.length));
      }
      function ns(i, r, l, f) {
        if (!ft(i))
          return i;
        r = Li(r, i);
        for (var g = -1, w = r.length, _ = w - 1, L = i; L != null && ++g < w; ) {
          var k = jn(r[g]), z = l;
          if (k === "__proto__" || k === "constructor" || k === "prototype")
            return i;
          if (g != _) {
            var W = L[k];
            z = f ? f(W, k, L) : n, z === n && (z = ft(W) ? W : oi(r[g + 1]) ? [] : {});
          }
          Zr(L, k, z), L = L[k];
        }
        return i;
      }
      var Sf = ao ? function(i, r) {
        return ao.set(i, r), i;
      } : cn, f1 = ro ? function(i, r) {
        return ro(i, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Nl(r),
          writable: !0
        });
      } : cn;
      function d1(i) {
        return So(Lr(i));
      }
      function Tn(i, r, l) {
        var f = -1, g = i.length;
        r < 0 && (r = -r > g ? 0 : g + r), l = l > g ? g : l, l < 0 && (l += g), g = r > l ? 0 : l - r >>> 0, r >>>= 0;
        for (var w = N(g); ++f < g; )
          w[f] = i[f + r];
        return w;
      }
      function h1(i, r) {
        var l;
        return Ci(i, function(f, g, w) {
          return l = r(f, g, w), !l;
        }), !!l;
      }
      function go(i, r, l) {
        var f = 0, g = i == null ? f : i.length;
        if (typeof r == "number" && r === r && g <= ze) {
          for (; f < g; ) {
            var w = f + g >>> 1, _ = i[w];
            _ !== null && !mn(_) && (l ? _ <= r : _ < r) ? f = w + 1 : g = w;
          }
          return g;
        }
        return cl(i, r, cn, l);
      }
      function cl(i, r, l, f) {
        var g = 0, w = i == null ? 0 : i.length;
        if (w === 0)
          return 0;
        r = l(r);
        for (var _ = r !== r, L = r === null, k = mn(r), z = r === n; g < w; ) {
          var W = oo((g + w) / 2), V = l(i[W]), ne = V !== n, ce = V === null, ve = V === V, Re = mn(V);
          if (_)
            var ye = f || ve;
          else z ? ye = ve && (f || ne) : L ? ye = ve && ne && (f || !ce) : k ? ye = ve && ne && !ce && (f || !Re) : ce || Re ? ye = !1 : ye = f ? V <= r : V < r;
          ye ? g = W + 1 : w = W;
        }
        return zt(w, tt);
      }
      function Lf(i, r) {
        for (var l = -1, f = i.length, g = 0, w = []; ++l < f; ) {
          var _ = i[l], L = r ? r(_) : _;
          if (!l || !Mn(L, k)) {
            var k = L;
            w[g++] = _ === 0 ? 0 : _;
          }
        }
        return w;
      }
      function Df(i) {
        return typeof i == "number" ? i : mn(i) ? yt : +i;
      }
      function gn(i) {
        if (typeof i == "string")
          return i;
        if (Le(i))
          return ct(i, gn) + "";
        if (mn(i))
          return rf ? rf.call(i) : "";
        var r = i + "";
        return r == "0" && 1 / i == -1 / 0 ? "-0" : r;
      }
      function Si(i, r, l) {
        var f = -1, g = Gs, w = i.length, _ = !0, L = [], k = L;
        if (l)
          _ = !1, g = Fa;
        else if (w >= o) {
          var z = r ? null : S1(i);
          if (z)
            return Ys(z);
          _ = !1, g = Vr, k = new qi();
        } else
          k = r ? [] : L;
        e:
          for (; ++f < w; ) {
            var W = i[f], V = r ? r(W) : W;
            if (W = l || W !== 0 ? W : 0, _ && V === V) {
              for (var ne = k.length; ne--; )
                if (k[ne] === V)
                  continue e;
              r && k.push(V), L.push(W);
            } else g(k, V, l) || (k !== L && k.push(V), L.push(W));
          }
        return L;
      }
      function ul(i, r) {
        return r = Li(r, i), i = ed(i, r), i == null || delete i[jn(kn(r))];
      }
      function If(i, r, l, f) {
        return ns(i, r, l(Vi(i, r)), f);
      }
      function mo(i, r, l, f) {
        for (var g = i.length, w = f ? g : -1; (f ? w-- : ++w < g) && r(i[w], w, i); )
          ;
        return l ? Tn(i, f ? 0 : w, f ? w + 1 : g) : Tn(i, f ? w + 1 : 0, f ? g : w);
      }
      function Ef(i, r) {
        var l = i;
        return l instanceof Fe && (l = l.value()), $a(r, function(f, g) {
          return g.func.apply(g.thisArg, bi([f], g.args));
        }, l);
      }
      function fl(i, r, l) {
        var f = i.length;
        if (f < 2)
          return f ? Si(i[0]) : [];
        for (var g = -1, w = N(f); ++g < f; )
          for (var _ = i[g], L = -1; ++L < f; )
            L != g && (w[g] = Qr(w[g] || _, i[L], r, l));
        return Si($t(w, 1), r, l);
      }
      function Tf(i, r, l) {
        for (var f = -1, g = i.length, w = r.length, _ = {}; ++f < g; ) {
          var L = f < w ? r[f] : n;
          l(_, i[f], L);
        }
        return _;
      }
      function dl(i) {
        return bt(i) ? i : [];
      }
      function hl(i) {
        return typeof i == "function" ? i : cn;
      }
      function Li(i, r) {
        return Le(i) ? i : _l(i, r) ? [i] : rd(Ge(i));
      }
      var p1 = Oe;
      function Di(i, r, l) {
        var f = i.length;
        return l = l === n ? f : l, !r && l >= f ? i : Tn(i, r, l);
      }
      var kf = tv || function(i) {
        return Ft.clearTimeout(i);
      };
      function Rf(i, r) {
        if (r)
          return i.slice();
        var l = i.length, f = Ju ? Ju(l) : new i.constructor(l);
        return i.copy(f), f;
      }
      function pl(i) {
        var r = new i.constructor(i.byteLength);
        return new to(r).set(new to(i)), r;
      }
      function g1(i, r) {
        var l = r ? pl(i.buffer) : i.buffer;
        return new i.constructor(l, i.byteOffset, i.byteLength);
      }
      function m1(i) {
        var r = new i.constructor(i.source, hu.exec(i));
        return r.lastIndex = i.lastIndex, r;
      }
      function v1(i) {
        return Jr ? Qe(Jr.call(i)) : {};
      }
      function Of(i, r) {
        var l = r ? pl(i.buffer) : i.buffer;
        return new i.constructor(l, i.byteOffset, i.length);
      }
      function Af(i, r) {
        if (i !== r) {
          var l = i !== n, f = i === null, g = i === i, w = mn(i), _ = r !== n, L = r === null, k = r === r, z = mn(r);
          if (!L && !z && !w && i > r || w && _ && k && !L && !z || f && _ && k || !l && k || !g)
            return 1;
          if (!f && !w && !z && i < r || z && l && g && !f && !w || L && l && g || !_ && g || !k)
            return -1;
        }
        return 0;
      }
      function y1(i, r, l) {
        for (var f = -1, g = i.criteria, w = r.criteria, _ = g.length, L = l.length; ++f < _; ) {
          var k = Af(g[f], w[f]);
          if (k) {
            if (f >= L)
              return k;
            var z = l[f];
            return k * (z == "desc" ? -1 : 1);
          }
        }
        return i.index - r.index;
      }
      function Pf(i, r, l, f) {
        for (var g = -1, w = i.length, _ = l.length, L = -1, k = r.length, z = Tt(w - _, 0), W = N(k + z), V = !f; ++L < k; )
          W[L] = r[L];
        for (; ++g < _; )
          (V || g < w) && (W[l[g]] = i[g]);
        for (; z--; )
          W[L++] = i[g++];
        return W;
      }
      function Nf(i, r, l, f) {
        for (var g = -1, w = i.length, _ = -1, L = l.length, k = -1, z = r.length, W = Tt(w - L, 0), V = N(W + z), ne = !f; ++g < W; )
          V[g] = i[g];
        for (var ce = g; ++k < z; )
          V[ce + k] = r[k];
        for (; ++_ < L; )
          (ne || g < w) && (V[ce + l[_]] = i[g++]);
        return V;
      }
      function on(i, r) {
        var l = -1, f = i.length;
        for (r || (r = N(f)); ++l < f; )
          r[l] = i[l];
        return r;
      }
      function qn(i, r, l, f) {
        var g = !l;
        l || (l = {});
        for (var w = -1, _ = r.length; ++w < _; ) {
          var L = r[w], k = f ? f(l[L], i[L], L, l, i) : n;
          k === n && (k = i[L]), g ? ii(l, L, k) : Zr(l, L, k);
        }
        return l;
      }
      function w1(i, r) {
        return qn(i, xl(i), r);
      }
      function b1(i, r) {
        return qn(i, Kf(i), r);
      }
      function vo(i, r) {
        return function(l, f) {
          var g = Le(l) ? L0 : zv, w = r ? r() : {};
          return g(l, i, ge(f, 2), w);
        };
      }
      function xr(i) {
        return Oe(function(r, l) {
          var f = -1, g = l.length, w = g > 1 ? l[g - 1] : n, _ = g > 2 ? l[2] : n;
          for (w = i.length > 3 && typeof w == "function" ? (g--, w) : n, _ && Xt(l[0], l[1], _) && (w = g < 3 ? n : w, g = 1), r = Qe(r); ++f < g; ) {
            var L = l[f];
            L && i(r, L, f, w);
          }
          return r;
        });
      }
      function Mf(i, r) {
        return function(l, f) {
          if (l == null)
            return l;
          if (!an(l))
            return i(l, f);
          for (var g = l.length, w = r ? g : -1, _ = Qe(l); (r ? w-- : ++w < g) && f(_[w], w, _) !== !1; )
            ;
          return l;
        };
      }
      function Bf(i) {
        return function(r, l, f) {
          for (var g = -1, w = Qe(r), _ = f(r), L = _.length; L--; ) {
            var k = _[i ? L : ++g];
            if (l(w[k], k, w) === !1)
              break;
          }
          return r;
        };
      }
      function x1(i, r, l) {
        var f = r & R, g = is(i);
        function w() {
          var _ = this && this !== Ft && this instanceof w ? g : i;
          return _.apply(f ? l : this, arguments);
        }
        return w;
      }
      function Ff(i) {
        return function(r) {
          r = Ge(r);
          var l = pr(r) ? Pn(r) : n, f = l ? l[0] : r.charAt(0), g = l ? Di(l, 1).join("") : r.slice(1);
          return f[i]() + g;
        };
      }
      function _r(i) {
        return function(r) {
          return $a(Md(Nd(r).replace(f0, "")), i, "");
        };
      }
      function is(i) {
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return new i();
            case 1:
              return new i(r[0]);
            case 2:
              return new i(r[0], r[1]);
            case 3:
              return new i(r[0], r[1], r[2]);
            case 4:
              return new i(r[0], r[1], r[2], r[3]);
            case 5:
              return new i(r[0], r[1], r[2], r[3], r[4]);
            case 6:
              return new i(r[0], r[1], r[2], r[3], r[4], r[5]);
            case 7:
              return new i(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
          }
          var l = br(i.prototype), f = i.apply(l, r);
          return ft(f) ? f : l;
        };
      }
      function _1(i, r, l) {
        var f = is(i);
        function g() {
          for (var w = arguments.length, _ = N(w), L = w, k = Cr(g); L--; )
            _[L] = arguments[L];
          var z = w < 3 && _[0] !== k && _[w - 1] !== k ? [] : xi(_, k);
          if (w -= z.length, w < l)
            return Wf(
              i,
              r,
              yo,
              g.placeholder,
              n,
              _,
              z,
              n,
              n,
              l - w
            );
          var W = this && this !== Ft && this instanceof g ? f : i;
          return hn(W, this, _);
        }
        return g;
      }
      function $f(i) {
        return function(r, l, f) {
          var g = Qe(r);
          if (!an(r)) {
            var w = ge(l, 3);
            r = At(r), l = function(L) {
              return w(g[L], L, g);
            };
          }
          var _ = i(r, l, f);
          return _ > -1 ? g[w ? r[_] : _] : n;
        };
      }
      function Hf(i) {
        return si(function(r) {
          var l = r.length, f = l, g = In.prototype.thru;
          for (i && r.reverse(); f--; ) {
            var w = r[f];
            if (typeof w != "function")
              throw new Dn(c);
            if (g && !_ && _o(w) == "wrapper")
              var _ = new In([], !0);
          }
          for (f = _ ? f : l; ++f < l; ) {
            w = r[f];
            var L = _o(w), k = L == "wrapper" ? wl(w) : n;
            k && Cl(k[0]) && k[1] == (ue | G | re | xe) && !k[4].length && k[9] == 1 ? _ = _[_o(k[0])].apply(_, k[3]) : _ = w.length == 1 && Cl(w) ? _[L]() : _.thru(w);
          }
          return function() {
            var z = arguments, W = z[0];
            if (_ && z.length == 1 && Le(W))
              return _.plant(W).value();
            for (var V = 0, ne = l ? r[V].apply(this, z) : W; ++V < l; )
              ne = r[V].call(this, ne);
            return ne;
          };
        });
      }
      function yo(i, r, l, f, g, w, _, L, k, z) {
        var W = r & ue, V = r & R, ne = r & F, ce = r & (G | Y), ve = r & Ee, Re = ne ? n : is(i);
        function ye() {
          for (var Ne = arguments.length, He = N(Ne), vn = Ne; vn--; )
            He[vn] = arguments[vn];
          if (ce)
            var Jt = Cr(ye), yn = P0(He, Jt);
          if (f && (He = Pf(He, f, g, ce)), w && (He = Nf(He, w, _, ce)), Ne -= yn, ce && Ne < z) {
            var xt = xi(He, Jt);
            return Wf(
              i,
              r,
              yo,
              ye.placeholder,
              l,
              He,
              xt,
              L,
              k,
              z - Ne
            );
          }
          var Bn = V ? l : this, ci = ne ? Bn[i] : i;
          return Ne = He.length, L ? He = z1(He, L) : ve && Ne > 1 && He.reverse(), W && k < Ne && (He.length = k), this && this !== Ft && this instanceof ye && (ci = Re || is(ci)), ci.apply(Bn, He);
        }
        return ye;
      }
      function Uf(i, r) {
        return function(l, f) {
          return Xv(l, i, r(f), {});
        };
      }
      function wo(i, r) {
        return function(l, f) {
          var g;
          if (l === n && f === n)
            return r;
          if (l !== n && (g = l), f !== n) {
            if (g === n)
              return f;
            typeof l == "string" || typeof f == "string" ? (l = gn(l), f = gn(f)) : (l = Df(l), f = Df(f)), g = i(l, f);
          }
          return g;
        };
      }
      function gl(i) {
        return si(function(r) {
          return r = ct(r, pn(ge())), Oe(function(l) {
            var f = this;
            return i(r, function(g) {
              return hn(g, f, l);
            });
          });
        });
      }
      function bo(i, r) {
        r = r === n ? " " : gn(r);
        var l = r.length;
        if (l < 2)
          return l ? ll(r, i) : r;
        var f = ll(r, so(i / gr(r)));
        return pr(r) ? Di(Pn(f), 0, i).join("") : f.slice(0, i);
      }
      function C1(i, r, l, f) {
        var g = r & R, w = is(i);
        function _() {
          for (var L = -1, k = arguments.length, z = -1, W = f.length, V = N(W + k), ne = this && this !== Ft && this instanceof _ ? w : i; ++z < W; )
            V[z] = f[z];
          for (; k--; )
            V[z++] = arguments[++L];
          return hn(ne, g ? l : this, V);
        }
        return _;
      }
      function zf(i) {
        return function(r, l, f) {
          return f && typeof f != "number" && Xt(r, l, f) && (l = f = n), r = li(r), l === n ? (l = r, r = 0) : l = li(l), f = f === n ? r < l ? 1 : -1 : li(f), l1(r, l, f, i);
        };
      }
      function xo(i) {
        return function(r, l) {
          return typeof r == "string" && typeof l == "string" || (r = Rn(r), l = Rn(l)), i(r, l);
        };
      }
      function Wf(i, r, l, f, g, w, _, L, k, z) {
        var W = r & G, V = W ? _ : n, ne = W ? n : _, ce = W ? w : n, ve = W ? n : w;
        r |= W ? re : be, r &= ~(W ? be : re), r & K || (r &= -4);
        var Re = [
          i,
          r,
          g,
          ce,
          V,
          ve,
          ne,
          L,
          k,
          z
        ], ye = l.apply(n, Re);
        return Cl(i) && td(ye, Re), ye.placeholder = f, nd(ye, i, r);
      }
      function ml(i) {
        var r = Et[i];
        return function(l, f) {
          if (l = Rn(l), f = f == null ? 0 : zt(Te(f), 292), f && tf(l)) {
            var g = (Ge(l) + "e").split("e"), w = r(g[0] + "e" + (+g[1] + f));
            return g = (Ge(w) + "e").split("e"), +(g[0] + "e" + (+g[1] - f));
          }
          return r(l);
        };
      }
      var S1 = yr && 1 / Ys(new yr([, -0]))[1] == ke ? function(i) {
        return new yr(i);
      } : Fl;
      function qf(i) {
        return function(r) {
          var l = Wt(r);
          return l == T ? Va(r) : l == j ? U0(r) : A0(r, i(r));
        };
      }
      function ri(i, r, l, f, g, w, _, L) {
        var k = r & F;
        if (!k && typeof i != "function")
          throw new Dn(c);
        var z = f ? f.length : 0;
        if (z || (r &= -97, f = g = n), _ = _ === n ? _ : Tt(Te(_), 0), L = L === n ? L : Te(L), z -= g ? g.length : 0, r & be) {
          var W = f, V = g;
          f = g = n;
        }
        var ne = k ? n : wl(i), ce = [
          i,
          r,
          l,
          f,
          g,
          W,
          V,
          w,
          _,
          L
        ];
        if (ne && $1(ce, ne), i = ce[0], r = ce[1], l = ce[2], f = ce[3], g = ce[4], L = ce[9] = ce[9] === n ? k ? 0 : i.length : Tt(ce[9] - z, 0), !L && r & (G | Y) && (r &= -25), !r || r == R)
          var ve = x1(i, r, l);
        else r == G || r == Y ? ve = _1(i, r, L) : (r == re || r == (R | re)) && !g.length ? ve = C1(i, r, l, f) : ve = yo.apply(n, ce);
        var Re = ne ? Sf : td;
        return nd(Re(ve, ce), i, r);
      }
      function jf(i, r, l, f) {
        return i === n || Mn(i, vr[l]) && !Ze.call(f, l) ? r : i;
      }
      function Vf(i, r, l, f, g, w) {
        return ft(i) && ft(r) && (w.set(r, i), po(i, r, n, Vf, w), w.delete(r)), i;
      }
      function L1(i) {
        return os(i) ? n : i;
      }
      function Gf(i, r, l, f, g, w) {
        var _ = l & D, L = i.length, k = r.length;
        if (L != k && !(_ && k > L))
          return !1;
        var z = w.get(i), W = w.get(r);
        if (z && W)
          return z == r && W == i;
        var V = -1, ne = !0, ce = l & A ? new qi() : n;
        for (w.set(i, r), w.set(r, i); ++V < L; ) {
          var ve = i[V], Re = r[V];
          if (f)
            var ye = _ ? f(Re, ve, V, r, i, w) : f(ve, Re, V, i, r, w);
          if (ye !== n) {
            if (ye)
              continue;
            ne = !1;
            break;
          }
          if (ce) {
            if (!Ha(r, function(Ne, He) {
              if (!Vr(ce, He) && (ve === Ne || g(ve, Ne, l, f, w)))
                return ce.push(He);
            })) {
              ne = !1;
              break;
            }
          } else if (!(ve === Re || g(ve, Re, l, f, w))) {
            ne = !1;
            break;
          }
        }
        return w.delete(i), w.delete(r), ne;
      }
      function D1(i, r, l, f, g, w, _) {
        switch (l) {
          case Be:
            if (i.byteLength != r.byteLength || i.byteOffset != r.byteOffset)
              return !1;
            i = i.buffer, r = r.buffer;
          case We:
            return !(i.byteLength != r.byteLength || !w(new to(i), new to(r)));
          case te:
          case Q:
          case H:
            return Mn(+i, +r);
          case $e:
            return i.name == r.name && i.message == r.message;
          case J:
          case de:
            return i == r + "";
          case T:
            var L = Va;
          case j:
            var k = f & D;
            if (L || (L = Ys), i.size != r.size && !k)
              return !1;
            var z = _.get(i);
            if (z)
              return z == r;
            f |= A, _.set(i, r);
            var W = Gf(L(i), L(r), f, g, w, _);
            return _.delete(i), W;
          case ie:
            if (Jr)
              return Jr.call(i) == Jr.call(r);
        }
        return !1;
      }
      function I1(i, r, l, f, g, w) {
        var _ = l & D, L = vl(i), k = L.length, z = vl(r), W = z.length;
        if (k != W && !_)
          return !1;
        for (var V = k; V--; ) {
          var ne = L[V];
          if (!(_ ? ne in r : Ze.call(r, ne)))
            return !1;
        }
        var ce = w.get(i), ve = w.get(r);
        if (ce && ve)
          return ce == r && ve == i;
        var Re = !0;
        w.set(i, r), w.set(r, i);
        for (var ye = _; ++V < k; ) {
          ne = L[V];
          var Ne = i[ne], He = r[ne];
          if (f)
            var vn = _ ? f(He, Ne, ne, r, i, w) : f(Ne, He, ne, i, r, w);
          if (!(vn === n ? Ne === He || g(Ne, He, l, f, w) : vn)) {
            Re = !1;
            break;
          }
          ye || (ye = ne == "constructor");
        }
        if (Re && !ye) {
          var Jt = i.constructor, yn = r.constructor;
          Jt != yn && "constructor" in i && "constructor" in r && !(typeof Jt == "function" && Jt instanceof Jt && typeof yn == "function" && yn instanceof yn) && (Re = !1);
        }
        return w.delete(i), w.delete(r), Re;
      }
      function si(i) {
        return Ll(Qf(i, n, ld), i + "");
      }
      function vl(i) {
        return hf(i, At, xl);
      }
      function yl(i) {
        return hf(i, ln, Kf);
      }
      var wl = ao ? function(i) {
        return ao.get(i);
      } : Fl;
      function _o(i) {
        for (var r = i.name + "", l = wr[r], f = Ze.call(wr, r) ? l.length : 0; f--; ) {
          var g = l[f], w = g.func;
          if (w == null || w == i)
            return g.name;
        }
        return r;
      }
      function Cr(i) {
        var r = Ze.call(y, "placeholder") ? y : i;
        return r.placeholder;
      }
      function ge() {
        var i = y.iteratee || Ml;
        return i = i === Ml ? mf : i, arguments.length ? i(arguments[0], arguments[1]) : i;
      }
      function Co(i, r) {
        var l = i.__data__;
        return N1(r) ? l[typeof r == "string" ? "string" : "hash"] : l.map;
      }
      function bl(i) {
        for (var r = At(i), l = r.length; l--; ) {
          var f = r[l], g = i[f];
          r[l] = [f, g, Jf(g)];
        }
        return r;
      }
      function Gi(i, r) {
        var l = F0(i, r);
        return gf(l) ? l : n;
      }
      function E1(i) {
        var r = Ze.call(i, zi), l = i[zi];
        try {
          i[zi] = n;
          var f = !0;
        } catch {
        }
        var g = Qs.call(i);
        return f && (r ? i[zi] = l : delete i[zi]), g;
      }
      var xl = Ka ? function(i) {
        return i == null ? [] : (i = Qe(i), wi(Ka(i), function(r) {
          return Qu.call(i, r);
        }));
      } : $l, Kf = Ka ? function(i) {
        for (var r = []; i; )
          bi(r, xl(i)), i = no(i);
        return r;
      } : $l, Wt = Yt;
      (Ya && Wt(new Ya(new ArrayBuffer(1))) != Be || Kr && Wt(new Kr()) != T || Xa && Wt(Xa.resolve()) != ee || yr && Wt(new yr()) != j || Yr && Wt(new Yr()) != pe) && (Wt = function(i) {
        var r = Yt(i), l = r == B ? i.constructor : n, f = l ? Ki(l) : "";
        if (f)
          switch (f) {
            case uv:
              return Be;
            case fv:
              return T;
            case dv:
              return ee;
            case hv:
              return j;
            case pv:
              return pe;
          }
        return r;
      });
      function T1(i, r, l) {
        for (var f = -1, g = l.length; ++f < g; ) {
          var w = l[f], _ = w.size;
          switch (w.type) {
            case "drop":
              i += _;
              break;
            case "dropRight":
              r -= _;
              break;
            case "take":
              r = zt(r, i + _);
              break;
            case "takeRight":
              i = Tt(i, r - _);
              break;
          }
        }
        return { start: i, end: r };
      }
      function k1(i) {
        var r = i.match(Mm);
        return r ? r[1].split(Bm) : [];
      }
      function Yf(i, r, l) {
        r = Li(r, i);
        for (var f = -1, g = r.length, w = !1; ++f < g; ) {
          var _ = jn(r[f]);
          if (!(w = i != null && l(i, _)))
            break;
          i = i[_];
        }
        return w || ++f != g ? w : (g = i == null ? 0 : i.length, !!g && ko(g) && oi(_, g) && (Le(i) || Yi(i)));
      }
      function R1(i) {
        var r = i.length, l = new i.constructor(r);
        return r && typeof i[0] == "string" && Ze.call(i, "index") && (l.index = i.index, l.input = i.input), l;
      }
      function Xf(i) {
        return typeof i.constructor == "function" && !rs(i) ? br(no(i)) : {};
      }
      function O1(i, r, l) {
        var f = i.constructor;
        switch (r) {
          case We:
            return pl(i);
          case te:
          case Q:
            return new f(+i);
          case Be:
            return g1(i, l);
          case Mt:
          case Ot:
          case nn:
          case rn:
          case ei:
          case ur:
          case Bt:
          case sn:
          case fr:
            return Of(i, l);
          case T:
            return new f();
          case H:
          case de:
            return new f(i);
          case J:
            return m1(i);
          case j:
            return new f();
          case ie:
            return v1(i);
        }
      }
      function A1(i, r) {
        var l = r.length;
        if (!l)
          return i;
        var f = l - 1;
        return r[f] = (l > 1 ? "& " : "") + r[f], r = r.join(l > 2 ? ", " : " "), i.replace(Nm, `{
/* [wrapped with ` + r + `] */
`);
      }
      function P1(i) {
        return Le(i) || Yi(i) || !!(ef && i && i[ef]);
      }
      function oi(i, r) {
        var l = typeof i;
        return r = r ?? Ce, !!r && (l == "number" || l != "symbol" && Vm.test(i)) && i > -1 && i % 1 == 0 && i < r;
      }
      function Xt(i, r, l) {
        if (!ft(l))
          return !1;
        var f = typeof r;
        return (f == "number" ? an(l) && oi(r, l.length) : f == "string" && r in l) ? Mn(l[r], i) : !1;
      }
      function _l(i, r) {
        if (Le(i))
          return !1;
        var l = typeof i;
        return l == "number" || l == "symbol" || l == "boolean" || i == null || mn(i) ? !0 : Rm.test(i) || !km.test(i) || r != null && i in Qe(r);
      }
      function N1(i) {
        var r = typeof i;
        return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? i !== "__proto__" : i === null;
      }
      function Cl(i) {
        var r = _o(i), l = y[r];
        if (typeof l != "function" || !(r in Fe.prototype))
          return !1;
        if (i === l)
          return !0;
        var f = wl(l);
        return !!f && i === f[0];
      }
      function M1(i) {
        return !!Xu && Xu in i;
      }
      var B1 = Js ? ai : Hl;
      function rs(i) {
        var r = i && i.constructor, l = typeof r == "function" && r.prototype || vr;
        return i === l;
      }
      function Jf(i) {
        return i === i && !ft(i);
      }
      function Zf(i, r) {
        return function(l) {
          return l == null ? !1 : l[i] === r && (r !== n || i in Qe(l));
        };
      }
      function F1(i) {
        var r = Eo(i, function(f) {
          return l.size === h && l.clear(), f;
        }), l = r.cache;
        return r;
      }
      function $1(i, r) {
        var l = i[1], f = r[1], g = l | f, w = g < (R | F | ue), _ = f == ue && l == G || f == ue && l == xe && i[7].length <= r[8] || f == (ue | xe) && r[7].length <= r[8] && l == G;
        if (!(w || _))
          return i;
        f & R && (i[2] = r[2], g |= l & R ? 0 : K);
        var L = r[3];
        if (L) {
          var k = i[3];
          i[3] = k ? Pf(k, L, r[4]) : L, i[4] = k ? xi(i[3], m) : r[4];
        }
        return L = r[5], L && (k = i[5], i[5] = k ? Nf(k, L, r[6]) : L, i[6] = k ? xi(i[5], m) : r[6]), L = r[7], L && (i[7] = L), f & ue && (i[8] = i[8] == null ? r[8] : zt(i[8], r[8])), i[9] == null && (i[9] = r[9]), i[0] = r[0], i[1] = g, i;
      }
      function H1(i) {
        var r = [];
        if (i != null)
          for (var l in Qe(i))
            r.push(l);
        return r;
      }
      function U1(i) {
        return Qs.call(i);
      }
      function Qf(i, r, l) {
        return r = Tt(r === n ? i.length - 1 : r, 0), function() {
          for (var f = arguments, g = -1, w = Tt(f.length - r, 0), _ = N(w); ++g < w; )
            _[g] = f[r + g];
          g = -1;
          for (var L = N(r + 1); ++g < r; )
            L[g] = f[g];
          return L[r] = l(_), hn(i, this, L);
        };
      }
      function ed(i, r) {
        return r.length < 2 ? i : Vi(i, Tn(r, 0, -1));
      }
      function z1(i, r) {
        for (var l = i.length, f = zt(r.length, l), g = on(i); f--; ) {
          var w = r[f];
          i[f] = oi(w, l) ? g[w] : n;
        }
        return i;
      }
      function Sl(i, r) {
        if (!(r === "constructor" && typeof i[r] == "function") && r != "__proto__")
          return i[r];
      }
      var td = id(Sf), ss = iv || function(i, r) {
        return Ft.setTimeout(i, r);
      }, Ll = id(f1);
      function nd(i, r, l) {
        var f = r + "";
        return Ll(i, A1(f, W1(k1(f), l)));
      }
      function id(i) {
        var r = 0, l = 0;
        return function() {
          var f = av(), g = Ue - (f - l);
          if (l = f, g > 0) {
            if (++r >= kt)
              return arguments[0];
          } else
            r = 0;
          return i.apply(n, arguments);
        };
      }
      function So(i, r) {
        var l = -1, f = i.length, g = f - 1;
        for (r = r === n ? f : r; ++l < r; ) {
          var w = al(l, g), _ = i[w];
          i[w] = i[l], i[l] = _;
        }
        return i.length = r, i;
      }
      var rd = F1(function(i) {
        var r = [];
        return i.charCodeAt(0) === 46 && r.push(""), i.replace(Om, function(l, f, g, w) {
          r.push(g ? w.replace(Hm, "$1") : f || l);
        }), r;
      });
      function jn(i) {
        if (typeof i == "string" || mn(i))
          return i;
        var r = i + "";
        return r == "0" && 1 / i == -1 / 0 ? "-0" : r;
      }
      function Ki(i) {
        if (i != null) {
          try {
            return Zs.call(i);
          } catch {
          }
          try {
            return i + "";
          } catch {
          }
        }
        return "";
      }
      function W1(i, r) {
        return Ln(nt, function(l) {
          var f = "_." + l[0];
          r & l[1] && !Gs(i, f) && i.push(f);
        }), i.sort();
      }
      function sd(i) {
        if (i instanceof Fe)
          return i.clone();
        var r = new In(i.__wrapped__, i.__chain__);
        return r.__actions__ = on(i.__actions__), r.__index__ = i.__index__, r.__values__ = i.__values__, r;
      }
      function q1(i, r, l) {
        (l ? Xt(i, r, l) : r === n) ? r = 1 : r = Tt(Te(r), 0);
        var f = i == null ? 0 : i.length;
        if (!f || r < 1)
          return [];
        for (var g = 0, w = 0, _ = N(so(f / r)); g < f; )
          _[w++] = Tn(i, g, g += r);
        return _;
      }
      function j1(i) {
        for (var r = -1, l = i == null ? 0 : i.length, f = 0, g = []; ++r < l; ) {
          var w = i[r];
          w && (g[f++] = w);
        }
        return g;
      }
      function V1() {
        var i = arguments.length;
        if (!i)
          return [];
        for (var r = N(i - 1), l = arguments[0], f = i; f--; )
          r[f - 1] = arguments[f];
        return bi(Le(l) ? on(l) : [l], $t(r, 1));
      }
      var G1 = Oe(function(i, r) {
        return bt(i) ? Qr(i, $t(r, 1, bt, !0)) : [];
      }), K1 = Oe(function(i, r) {
        var l = kn(r);
        return bt(l) && (l = n), bt(i) ? Qr(i, $t(r, 1, bt, !0), ge(l, 2)) : [];
      }), Y1 = Oe(function(i, r) {
        var l = kn(r);
        return bt(l) && (l = n), bt(i) ? Qr(i, $t(r, 1, bt, !0), n, l) : [];
      });
      function X1(i, r, l) {
        var f = i == null ? 0 : i.length;
        return f ? (r = l || r === n ? 1 : Te(r), Tn(i, r < 0 ? 0 : r, f)) : [];
      }
      function J1(i, r, l) {
        var f = i == null ? 0 : i.length;
        return f ? (r = l || r === n ? 1 : Te(r), r = f - r, Tn(i, 0, r < 0 ? 0 : r)) : [];
      }
      function Z1(i, r) {
        return i && i.length ? mo(i, ge(r, 3), !0, !0) : [];
      }
      function Q1(i, r) {
        return i && i.length ? mo(i, ge(r, 3), !0) : [];
      }
      function ey(i, r, l, f) {
        var g = i == null ? 0 : i.length;
        return g ? (l && typeof l != "number" && Xt(i, r, l) && (l = 0, f = g), Vv(i, r, l, f)) : [];
      }
      function od(i, r, l) {
        var f = i == null ? 0 : i.length;
        if (!f)
          return -1;
        var g = l == null ? 0 : Te(l);
        return g < 0 && (g = Tt(f + g, 0)), Ks(i, ge(r, 3), g);
      }
      function ad(i, r, l) {
        var f = i == null ? 0 : i.length;
        if (!f)
          return -1;
        var g = f - 1;
        return l !== n && (g = Te(l), g = l < 0 ? Tt(f + g, 0) : zt(g, f - 1)), Ks(i, ge(r, 3), g, !0);
      }
      function ld(i) {
        var r = i == null ? 0 : i.length;
        return r ? $t(i, 1) : [];
      }
      function ty(i) {
        var r = i == null ? 0 : i.length;
        return r ? $t(i, ke) : [];
      }
      function ny(i, r) {
        var l = i == null ? 0 : i.length;
        return l ? (r = r === n ? 1 : Te(r), $t(i, r)) : [];
      }
      function iy(i) {
        for (var r = -1, l = i == null ? 0 : i.length, f = {}; ++r < l; ) {
          var g = i[r];
          f[g[0]] = g[1];
        }
        return f;
      }
      function cd(i) {
        return i && i.length ? i[0] : n;
      }
      function ry(i, r, l) {
        var f = i == null ? 0 : i.length;
        if (!f)
          return -1;
        var g = l == null ? 0 : Te(l);
        return g < 0 && (g = Tt(f + g, 0)), hr(i, r, g);
      }
      function sy(i) {
        var r = i == null ? 0 : i.length;
        return r ? Tn(i, 0, -1) : [];
      }
      var oy = Oe(function(i) {
        var r = ct(i, dl);
        return r.length && r[0] === i[0] ? nl(r) : [];
      }), ay = Oe(function(i) {
        var r = kn(i), l = ct(i, dl);
        return r === kn(l) ? r = n : l.pop(), l.length && l[0] === i[0] ? nl(l, ge(r, 2)) : [];
      }), ly = Oe(function(i) {
        var r = kn(i), l = ct(i, dl);
        return r = typeof r == "function" ? r : n, r && l.pop(), l.length && l[0] === i[0] ? nl(l, n, r) : [];
      });
      function cy(i, r) {
        return i == null ? "" : sv.call(i, r);
      }
      function kn(i) {
        var r = i == null ? 0 : i.length;
        return r ? i[r - 1] : n;
      }
      function uy(i, r, l) {
        var f = i == null ? 0 : i.length;
        if (!f)
          return -1;
        var g = f;
        return l !== n && (g = Te(l), g = g < 0 ? Tt(f + g, 0) : zt(g, f - 1)), r === r ? W0(i, r, g) : Ks(i, zu, g, !0);
      }
      function fy(i, r) {
        return i && i.length ? bf(i, Te(r)) : n;
      }
      var dy = Oe(ud);
      function ud(i, r) {
        return i && i.length && r && r.length ? ol(i, r) : i;
      }
      function hy(i, r, l) {
        return i && i.length && r && r.length ? ol(i, r, ge(l, 2)) : i;
      }
      function py(i, r, l) {
        return i && i.length && r && r.length ? ol(i, r, n, l) : i;
      }
      var gy = si(function(i, r) {
        var l = i == null ? 0 : i.length, f = Za(i, r);
        return Cf(i, ct(r, function(g) {
          return oi(g, l) ? +g : g;
        }).sort(Af)), f;
      });
      function my(i, r) {
        var l = [];
        if (!(i && i.length))
          return l;
        var f = -1, g = [], w = i.length;
        for (r = ge(r, 3); ++f < w; ) {
          var _ = i[f];
          r(_, f, i) && (l.push(_), g.push(f));
        }
        return Cf(i, g), l;
      }
      function Dl(i) {
        return i == null ? i : cv.call(i);
      }
      function vy(i, r, l) {
        var f = i == null ? 0 : i.length;
        return f ? (l && typeof l != "number" && Xt(i, r, l) ? (r = 0, l = f) : (r = r == null ? 0 : Te(r), l = l === n ? f : Te(l)), Tn(i, r, l)) : [];
      }
      function yy(i, r) {
        return go(i, r);
      }
      function wy(i, r, l) {
        return cl(i, r, ge(l, 2));
      }
      function by(i, r) {
        var l = i == null ? 0 : i.length;
        if (l) {
          var f = go(i, r);
          if (f < l && Mn(i[f], r))
            return f;
        }
        return -1;
      }
      function xy(i, r) {
        return go(i, r, !0);
      }
      function _y(i, r, l) {
        return cl(i, r, ge(l, 2), !0);
      }
      function Cy(i, r) {
        var l = i == null ? 0 : i.length;
        if (l) {
          var f = go(i, r, !0) - 1;
          if (Mn(i[f], r))
            return f;
        }
        return -1;
      }
      function Sy(i) {
        return i && i.length ? Lf(i) : [];
      }
      function Ly(i, r) {
        return i && i.length ? Lf(i, ge(r, 2)) : [];
      }
      function Dy(i) {
        var r = i == null ? 0 : i.length;
        return r ? Tn(i, 1, r) : [];
      }
      function Iy(i, r, l) {
        return i && i.length ? (r = l || r === n ? 1 : Te(r), Tn(i, 0, r < 0 ? 0 : r)) : [];
      }
      function Ey(i, r, l) {
        var f = i == null ? 0 : i.length;
        return f ? (r = l || r === n ? 1 : Te(r), r = f - r, Tn(i, r < 0 ? 0 : r, f)) : [];
      }
      function Ty(i, r) {
        return i && i.length ? mo(i, ge(r, 3), !1, !0) : [];
      }
      function ky(i, r) {
        return i && i.length ? mo(i, ge(r, 3)) : [];
      }
      var Ry = Oe(function(i) {
        return Si($t(i, 1, bt, !0));
      }), Oy = Oe(function(i) {
        var r = kn(i);
        return bt(r) && (r = n), Si($t(i, 1, bt, !0), ge(r, 2));
      }), Ay = Oe(function(i) {
        var r = kn(i);
        return r = typeof r == "function" ? r : n, Si($t(i, 1, bt, !0), n, r);
      });
      function Py(i) {
        return i && i.length ? Si(i) : [];
      }
      function Ny(i, r) {
        return i && i.length ? Si(i, ge(r, 2)) : [];
      }
      function My(i, r) {
        return r = typeof r == "function" ? r : n, i && i.length ? Si(i, n, r) : [];
      }
      function Il(i) {
        if (!(i && i.length))
          return [];
        var r = 0;
        return i = wi(i, function(l) {
          if (bt(l))
            return r = Tt(l.length, r), !0;
        }), qa(r, function(l) {
          return ct(i, Ua(l));
        });
      }
      function fd(i, r) {
        if (!(i && i.length))
          return [];
        var l = Il(i);
        return r == null ? l : ct(l, function(f) {
          return hn(r, n, f);
        });
      }
      var By = Oe(function(i, r) {
        return bt(i) ? Qr(i, r) : [];
      }), Fy = Oe(function(i) {
        return fl(wi(i, bt));
      }), $y = Oe(function(i) {
        var r = kn(i);
        return bt(r) && (r = n), fl(wi(i, bt), ge(r, 2));
      }), Hy = Oe(function(i) {
        var r = kn(i);
        return r = typeof r == "function" ? r : n, fl(wi(i, bt), n, r);
      }), Uy = Oe(Il);
      function zy(i, r) {
        return Tf(i || [], r || [], Zr);
      }
      function Wy(i, r) {
        return Tf(i || [], r || [], ns);
      }
      var qy = Oe(function(i) {
        var r = i.length, l = r > 1 ? i[r - 1] : n;
        return l = typeof l == "function" ? (i.pop(), l) : n, fd(i, l);
      });
      function dd(i) {
        var r = y(i);
        return r.__chain__ = !0, r;
      }
      function jy(i, r) {
        return r(i), i;
      }
      function Lo(i, r) {
        return r(i);
      }
      var Vy = si(function(i) {
        var r = i.length, l = r ? i[0] : 0, f = this.__wrapped__, g = function(w) {
          return Za(w, i);
        };
        return r > 1 || this.__actions__.length || !(f instanceof Fe) || !oi(l) ? this.thru(g) : (f = f.slice(l, +l + (r ? 1 : 0)), f.__actions__.push({
          func: Lo,
          args: [g],
          thisArg: n
        }), new In(f, this.__chain__).thru(function(w) {
          return r && !w.length && w.push(n), w;
        }));
      });
      function Gy() {
        return dd(this);
      }
      function Ky() {
        return new In(this.value(), this.__chain__);
      }
      function Yy() {
        this.__values__ === n && (this.__values__ = Dd(this.value()));
        var i = this.__index__ >= this.__values__.length, r = i ? n : this.__values__[this.__index__++];
        return { done: i, value: r };
      }
      function Xy() {
        return this;
      }
      function Jy(i) {
        for (var r, l = this; l instanceof co; ) {
          var f = sd(l);
          f.__index__ = 0, f.__values__ = n, r ? g.__wrapped__ = f : r = f;
          var g = f;
          l = l.__wrapped__;
        }
        return g.__wrapped__ = i, r;
      }
      function Zy() {
        var i = this.__wrapped__;
        if (i instanceof Fe) {
          var r = i;
          return this.__actions__.length && (r = new Fe(this)), r = r.reverse(), r.__actions__.push({
            func: Lo,
            args: [Dl],
            thisArg: n
          }), new In(r, this.__chain__);
        }
        return this.thru(Dl);
      }
      function Qy() {
        return Ef(this.__wrapped__, this.__actions__);
      }
      var ew = vo(function(i, r, l) {
        Ze.call(i, l) ? ++i[l] : ii(i, l, 1);
      });
      function tw(i, r, l) {
        var f = Le(i) ? Hu : jv;
        return l && Xt(i, r, l) && (r = n), f(i, ge(r, 3));
      }
      function nw(i, r) {
        var l = Le(i) ? wi : ff;
        return l(i, ge(r, 3));
      }
      var iw = $f(od), rw = $f(ad);
      function sw(i, r) {
        return $t(Do(i, r), 1);
      }
      function ow(i, r) {
        return $t(Do(i, r), ke);
      }
      function aw(i, r, l) {
        return l = l === n ? 1 : Te(l), $t(Do(i, r), l);
      }
      function hd(i, r) {
        var l = Le(i) ? Ln : Ci;
        return l(i, ge(r, 3));
      }
      function pd(i, r) {
        var l = Le(i) ? D0 : uf;
        return l(i, ge(r, 3));
      }
      var lw = vo(function(i, r, l) {
        Ze.call(i, l) ? i[l].push(r) : ii(i, l, [r]);
      });
      function cw(i, r, l, f) {
        i = an(i) ? i : Lr(i), l = l && !f ? Te(l) : 0;
        var g = i.length;
        return l < 0 && (l = Tt(g + l, 0)), Ro(i) ? l <= g && i.indexOf(r, l) > -1 : !!g && hr(i, r, l) > -1;
      }
      var uw = Oe(function(i, r, l) {
        var f = -1, g = typeof r == "function", w = an(i) ? N(i.length) : [];
        return Ci(i, function(_) {
          w[++f] = g ? hn(r, _, l) : es(_, r, l);
        }), w;
      }), fw = vo(function(i, r, l) {
        ii(i, l, r);
      });
      function Do(i, r) {
        var l = Le(i) ? ct : vf;
        return l(i, ge(r, 3));
      }
      function dw(i, r, l, f) {
        return i == null ? [] : (Le(r) || (r = r == null ? [] : [r]), l = f ? n : l, Le(l) || (l = l == null ? [] : [l]), xf(i, r, l));
      }
      var hw = vo(function(i, r, l) {
        i[l ? 0 : 1].push(r);
      }, function() {
        return [[], []];
      });
      function pw(i, r, l) {
        var f = Le(i) ? $a : qu, g = arguments.length < 3;
        return f(i, ge(r, 4), l, g, Ci);
      }
      function gw(i, r, l) {
        var f = Le(i) ? I0 : qu, g = arguments.length < 3;
        return f(i, ge(r, 4), l, g, uf);
      }
      function mw(i, r) {
        var l = Le(i) ? wi : ff;
        return l(i, To(ge(r, 3)));
      }
      function vw(i) {
        var r = Le(i) ? of : c1;
        return r(i);
      }
      function yw(i, r, l) {
        (l ? Xt(i, r, l) : r === n) ? r = 1 : r = Te(r);
        var f = Le(i) ? Hv : u1;
        return f(i, r);
      }
      function ww(i) {
        var r = Le(i) ? Uv : d1;
        return r(i);
      }
      function bw(i) {
        if (i == null)
          return 0;
        if (an(i))
          return Ro(i) ? gr(i) : i.length;
        var r = Wt(i);
        return r == T || r == j ? i.size : rl(i).length;
      }
      function xw(i, r, l) {
        var f = Le(i) ? Ha : h1;
        return l && Xt(i, r, l) && (r = n), f(i, ge(r, 3));
      }
      var _w = Oe(function(i, r) {
        if (i == null)
          return [];
        var l = r.length;
        return l > 1 && Xt(i, r[0], r[1]) ? r = [] : l > 2 && Xt(r[0], r[1], r[2]) && (r = [r[0]]), xf(i, $t(r, 1), []);
      }), Io = nv || function() {
        return Ft.Date.now();
      };
      function Cw(i, r) {
        if (typeof r != "function")
          throw new Dn(c);
        return i = Te(i), function() {
          if (--i < 1)
            return r.apply(this, arguments);
        };
      }
      function gd(i, r, l) {
        return r = l ? n : r, r = i && r == null ? i.length : r, ri(i, ue, n, n, n, n, r);
      }
      function md(i, r) {
        var l;
        if (typeof r != "function")
          throw new Dn(c);
        return i = Te(i), function() {
          return --i > 0 && (l = r.apply(this, arguments)), i <= 1 && (r = n), l;
        };
      }
      var El = Oe(function(i, r, l) {
        var f = R;
        if (l.length) {
          var g = xi(l, Cr(El));
          f |= re;
        }
        return ri(i, f, r, l, g);
      }), vd = Oe(function(i, r, l) {
        var f = R | F;
        if (l.length) {
          var g = xi(l, Cr(vd));
          f |= re;
        }
        return ri(r, f, i, l, g);
      });
      function yd(i, r, l) {
        r = l ? n : r;
        var f = ri(i, G, n, n, n, n, n, r);
        return f.placeholder = yd.placeholder, f;
      }
      function wd(i, r, l) {
        r = l ? n : r;
        var f = ri(i, Y, n, n, n, n, n, r);
        return f.placeholder = wd.placeholder, f;
      }
      function bd(i, r, l) {
        var f, g, w, _, L, k, z = 0, W = !1, V = !1, ne = !0;
        if (typeof i != "function")
          throw new Dn(c);
        r = Rn(r) || 0, ft(l) && (W = !!l.leading, V = "maxWait" in l, w = V ? Tt(Rn(l.maxWait) || 0, r) : w, ne = "trailing" in l ? !!l.trailing : ne);
        function ce(xt) {
          var Bn = f, ci = g;
          return f = g = n, z = xt, _ = i.apply(ci, Bn), _;
        }
        function ve(xt) {
          return z = xt, L = ss(Ne, r), W ? ce(xt) : _;
        }
        function Re(xt) {
          var Bn = xt - k, ci = xt - z, $d = r - Bn;
          return V ? zt($d, w - ci) : $d;
        }
        function ye(xt) {
          var Bn = xt - k, ci = xt - z;
          return k === n || Bn >= r || Bn < 0 || V && ci >= w;
        }
        function Ne() {
          var xt = Io();
          if (ye(xt))
            return He(xt);
          L = ss(Ne, Re(xt));
        }
        function He(xt) {
          return L = n, ne && f ? ce(xt) : (f = g = n, _);
        }
        function vn() {
          L !== n && kf(L), z = 0, f = k = g = L = n;
        }
        function Jt() {
          return L === n ? _ : He(Io());
        }
        function yn() {
          var xt = Io(), Bn = ye(xt);
          if (f = arguments, g = this, k = xt, Bn) {
            if (L === n)
              return ve(k);
            if (V)
              return kf(L), L = ss(Ne, r), ce(k);
          }
          return L === n && (L = ss(Ne, r)), _;
        }
        return yn.cancel = vn, yn.flush = Jt, yn;
      }
      var Sw = Oe(function(i, r) {
        return cf(i, 1, r);
      }), Lw = Oe(function(i, r, l) {
        return cf(i, Rn(r) || 0, l);
      });
      function Dw(i) {
        return ri(i, Ee);
      }
      function Eo(i, r) {
        if (typeof i != "function" || r != null && typeof r != "function")
          throw new Dn(c);
        var l = function() {
          var f = arguments, g = r ? r.apply(this, f) : f[0], w = l.cache;
          if (w.has(g))
            return w.get(g);
          var _ = i.apply(this, f);
          return l.cache = w.set(g, _) || w, _;
        };
        return l.cache = new (Eo.Cache || ni)(), l;
      }
      Eo.Cache = ni;
      function To(i) {
        if (typeof i != "function")
          throw new Dn(c);
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return !i.call(this);
            case 1:
              return !i.call(this, r[0]);
            case 2:
              return !i.call(this, r[0], r[1]);
            case 3:
              return !i.call(this, r[0], r[1], r[2]);
          }
          return !i.apply(this, r);
        };
      }
      function Iw(i) {
        return md(2, i);
      }
      var Ew = p1(function(i, r) {
        r = r.length == 1 && Le(r[0]) ? ct(r[0], pn(ge())) : ct($t(r, 1), pn(ge()));
        var l = r.length;
        return Oe(function(f) {
          for (var g = -1, w = zt(f.length, l); ++g < w; )
            f[g] = r[g].call(this, f[g]);
          return hn(i, this, f);
        });
      }), Tl = Oe(function(i, r) {
        var l = xi(r, Cr(Tl));
        return ri(i, re, n, r, l);
      }), xd = Oe(function(i, r) {
        var l = xi(r, Cr(xd));
        return ri(i, be, n, r, l);
      }), Tw = si(function(i, r) {
        return ri(i, xe, n, n, n, r);
      });
      function kw(i, r) {
        if (typeof i != "function")
          throw new Dn(c);
        return r = r === n ? r : Te(r), Oe(i, r);
      }
      function Rw(i, r) {
        if (typeof i != "function")
          throw new Dn(c);
        return r = r == null ? 0 : Tt(Te(r), 0), Oe(function(l) {
          var f = l[r], g = Di(l, 0, r);
          return f && bi(g, f), hn(i, this, g);
        });
      }
      function Ow(i, r, l) {
        var f = !0, g = !0;
        if (typeof i != "function")
          throw new Dn(c);
        return ft(l) && (f = "leading" in l ? !!l.leading : f, g = "trailing" in l ? !!l.trailing : g), bd(i, r, {
          leading: f,
          maxWait: r,
          trailing: g
        });
      }
      function Aw(i) {
        return gd(i, 1);
      }
      function Pw(i, r) {
        return Tl(hl(r), i);
      }
      function Nw() {
        if (!arguments.length)
          return [];
        var i = arguments[0];
        return Le(i) ? i : [i];
      }
      function Mw(i) {
        return En(i, S);
      }
      function Bw(i, r) {
        return r = typeof r == "function" ? r : n, En(i, S, r);
      }
      function Fw(i) {
        return En(i, v | S);
      }
      function $w(i, r) {
        return r = typeof r == "function" ? r : n, En(i, v | S, r);
      }
      function Hw(i, r) {
        return r == null || lf(i, r, At(r));
      }
      function Mn(i, r) {
        return i === r || i !== i && r !== r;
      }
      var Uw = xo(tl), zw = xo(function(i, r) {
        return i >= r;
      }), Yi = pf(/* @__PURE__ */ function() {
        return arguments;
      }()) ? pf : function(i) {
        return pt(i) && Ze.call(i, "callee") && !Qu.call(i, "callee");
      }, Le = N.isArray, Ww = Pu ? pn(Pu) : Jv;
      function an(i) {
        return i != null && ko(i.length) && !ai(i);
      }
      function bt(i) {
        return pt(i) && an(i);
      }
      function qw(i) {
        return i === !0 || i === !1 || pt(i) && Yt(i) == te;
      }
      var Ii = rv || Hl, jw = Nu ? pn(Nu) : Zv;
      function Vw(i) {
        return pt(i) && i.nodeType === 1 && !os(i);
      }
      function Gw(i) {
        if (i == null)
          return !0;
        if (an(i) && (Le(i) || typeof i == "string" || typeof i.splice == "function" || Ii(i) || Sr(i) || Yi(i)))
          return !i.length;
        var r = Wt(i);
        if (r == T || r == j)
          return !i.size;
        if (rs(i))
          return !rl(i).length;
        for (var l in i)
          if (Ze.call(i, l))
            return !1;
        return !0;
      }
      function Kw(i, r) {
        return ts(i, r);
      }
      function Yw(i, r, l) {
        l = typeof l == "function" ? l : n;
        var f = l ? l(i, r) : n;
        return f === n ? ts(i, r, n, l) : !!f;
      }
      function kl(i) {
        if (!pt(i))
          return !1;
        var r = Yt(i);
        return r == $e || r == ae || typeof i.message == "string" && typeof i.name == "string" && !os(i);
      }
      function Xw(i) {
        return typeof i == "number" && tf(i);
      }
      function ai(i) {
        if (!ft(i))
          return !1;
        var r = Yt(i);
        return r == x || r == C || r == U || r == X;
      }
      function _d(i) {
        return typeof i == "number" && i == Te(i);
      }
      function ko(i) {
        return typeof i == "number" && i > -1 && i % 1 == 0 && i <= Ce;
      }
      function ft(i) {
        var r = typeof i;
        return i != null && (r == "object" || r == "function");
      }
      function pt(i) {
        return i != null && typeof i == "object";
      }
      var Cd = Mu ? pn(Mu) : e1;
      function Jw(i, r) {
        return i === r || il(i, r, bl(r));
      }
      function Zw(i, r, l) {
        return l = typeof l == "function" ? l : n, il(i, r, bl(r), l);
      }
      function Qw(i) {
        return Sd(i) && i != +i;
      }
      function eb(i) {
        if (B1(i))
          throw new Se(a);
        return gf(i);
      }
      function tb(i) {
        return i === null;
      }
      function nb(i) {
        return i == null;
      }
      function Sd(i) {
        return typeof i == "number" || pt(i) && Yt(i) == H;
      }
      function os(i) {
        if (!pt(i) || Yt(i) != B)
          return !1;
        var r = no(i);
        if (r === null)
          return !0;
        var l = Ze.call(r, "constructor") && r.constructor;
        return typeof l == "function" && l instanceof l && Zs.call(l) == Z0;
      }
      var Rl = Bu ? pn(Bu) : t1;
      function ib(i) {
        return _d(i) && i >= -9007199254740991 && i <= Ce;
      }
      var Ld = Fu ? pn(Fu) : n1;
      function Ro(i) {
        return typeof i == "string" || !Le(i) && pt(i) && Yt(i) == de;
      }
      function mn(i) {
        return typeof i == "symbol" || pt(i) && Yt(i) == ie;
      }
      var Sr = $u ? pn($u) : i1;
      function rb(i) {
        return i === n;
      }
      function sb(i) {
        return pt(i) && Wt(i) == pe;
      }
      function ob(i) {
        return pt(i) && Yt(i) == Me;
      }
      var ab = xo(sl), lb = xo(function(i, r) {
        return i <= r;
      });
      function Dd(i) {
        if (!i)
          return [];
        if (an(i))
          return Ro(i) ? Pn(i) : on(i);
        if (Gr && i[Gr])
          return H0(i[Gr]());
        var r = Wt(i), l = r == T ? Va : r == j ? Ys : Lr;
        return l(i);
      }
      function li(i) {
        if (!i)
          return i === 0 ? i : 0;
        if (i = Rn(i), i === ke || i === -1 / 0) {
          var r = i < 0 ? -1 : 1;
          return r * It;
        }
        return i === i ? i : 0;
      }
      function Te(i) {
        var r = li(i), l = r % 1;
        return r === r ? l ? r - l : r : 0;
      }
      function Id(i) {
        return i ? ji(Te(i), 0, Je) : 0;
      }
      function Rn(i) {
        if (typeof i == "number")
          return i;
        if (mn(i))
          return yt;
        if (ft(i)) {
          var r = typeof i.valueOf == "function" ? i.valueOf() : i;
          i = ft(r) ? r + "" : r;
        }
        if (typeof i != "string")
          return i === 0 ? i : +i;
        i = ju(i);
        var l = Wm.test(i);
        return l || jm.test(i) ? C0(i.slice(2), l ? 2 : 8) : zm.test(i) ? yt : +i;
      }
      function Ed(i) {
        return qn(i, ln(i));
      }
      function cb(i) {
        return i ? ji(Te(i), -9007199254740991, Ce) : i === 0 ? i : 0;
      }
      function Ge(i) {
        return i == null ? "" : gn(i);
      }
      var ub = xr(function(i, r) {
        if (rs(r) || an(r)) {
          qn(r, At(r), i);
          return;
        }
        for (var l in r)
          Ze.call(r, l) && Zr(i, l, r[l]);
      }), Td = xr(function(i, r) {
        qn(r, ln(r), i);
      }), Oo = xr(function(i, r, l, f) {
        qn(r, ln(r), i, f);
      }), fb = xr(function(i, r, l, f) {
        qn(r, At(r), i, f);
      }), db = si(Za);
      function hb(i, r) {
        var l = br(i);
        return r == null ? l : af(l, r);
      }
      var pb = Oe(function(i, r) {
        i = Qe(i);
        var l = -1, f = r.length, g = f > 2 ? r[2] : n;
        for (g && Xt(r[0], r[1], g) && (f = 1); ++l < f; )
          for (var w = r[l], _ = ln(w), L = -1, k = _.length; ++L < k; ) {
            var z = _[L], W = i[z];
            (W === n || Mn(W, vr[z]) && !Ze.call(i, z)) && (i[z] = w[z]);
          }
        return i;
      }), gb = Oe(function(i) {
        return i.push(n, Vf), hn(kd, n, i);
      });
      function mb(i, r) {
        return Uu(i, ge(r, 3), Wn);
      }
      function vb(i, r) {
        return Uu(i, ge(r, 3), el);
      }
      function yb(i, r) {
        return i == null ? i : Qa(i, ge(r, 3), ln);
      }
      function wb(i, r) {
        return i == null ? i : df(i, ge(r, 3), ln);
      }
      function bb(i, r) {
        return i && Wn(i, ge(r, 3));
      }
      function xb(i, r) {
        return i && el(i, ge(r, 3));
      }
      function _b(i) {
        return i == null ? [] : ho(i, At(i));
      }
      function Cb(i) {
        return i == null ? [] : ho(i, ln(i));
      }
      function Ol(i, r, l) {
        var f = i == null ? n : Vi(i, r);
        return f === n ? l : f;
      }
      function Sb(i, r) {
        return i != null && Yf(i, r, Gv);
      }
      function Al(i, r) {
        return i != null && Yf(i, r, Kv);
      }
      var Lb = Uf(function(i, r, l) {
        r != null && typeof r.toString != "function" && (r = Qs.call(r)), i[r] = l;
      }, Nl(cn)), Db = Uf(function(i, r, l) {
        r != null && typeof r.toString != "function" && (r = Qs.call(r)), Ze.call(i, r) ? i[r].push(l) : i[r] = [l];
      }, ge), Ib = Oe(es);
      function At(i) {
        return an(i) ? sf(i) : rl(i);
      }
      function ln(i) {
        return an(i) ? sf(i, !0) : r1(i);
      }
      function Eb(i, r) {
        var l = {};
        return r = ge(r, 3), Wn(i, function(f, g, w) {
          ii(l, r(f, g, w), f);
        }), l;
      }
      function Tb(i, r) {
        var l = {};
        return r = ge(r, 3), Wn(i, function(f, g, w) {
          ii(l, g, r(f, g, w));
        }), l;
      }
      var kb = xr(function(i, r, l) {
        po(i, r, l);
      }), kd = xr(function(i, r, l, f) {
        po(i, r, l, f);
      }), Rb = si(function(i, r) {
        var l = {};
        if (i == null)
          return l;
        var f = !1;
        r = ct(r, function(w) {
          return w = Li(w, i), f || (f = w.length > 1), w;
        }), qn(i, yl(i), l), f && (l = En(l, v | b | S, L1));
        for (var g = r.length; g--; )
          ul(l, r[g]);
        return l;
      });
      function Ob(i, r) {
        return Rd(i, To(ge(r)));
      }
      var Ab = si(function(i, r) {
        return i == null ? {} : o1(i, r);
      });
      function Rd(i, r) {
        if (i == null)
          return {};
        var l = ct(yl(i), function(f) {
          return [f];
        });
        return r = ge(r), _f(i, l, function(f, g) {
          return r(f, g[0]);
        });
      }
      function Pb(i, r, l) {
        r = Li(r, i);
        var f = -1, g = r.length;
        for (g || (g = 1, i = n); ++f < g; ) {
          var w = i == null ? n : i[jn(r[f])];
          w === n && (f = g, w = l), i = ai(w) ? w.call(i) : w;
        }
        return i;
      }
      function Nb(i, r, l) {
        return i == null ? i : ns(i, r, l);
      }
      function Mb(i, r, l, f) {
        return f = typeof f == "function" ? f : n, i == null ? i : ns(i, r, l, f);
      }
      var Od = qf(At), Ad = qf(ln);
      function Bb(i, r, l) {
        var f = Le(i), g = f || Ii(i) || Sr(i);
        if (r = ge(r, 4), l == null) {
          var w = i && i.constructor;
          g ? l = f ? new w() : [] : ft(i) ? l = ai(w) ? br(no(i)) : {} : l = {};
        }
        return (g ? Ln : Wn)(i, function(_, L, k) {
          return r(l, _, L, k);
        }), l;
      }
      function Fb(i, r) {
        return i == null ? !0 : ul(i, r);
      }
      function $b(i, r, l) {
        return i == null ? i : If(i, r, hl(l));
      }
      function Hb(i, r, l, f) {
        return f = typeof f == "function" ? f : n, i == null ? i : If(i, r, hl(l), f);
      }
      function Lr(i) {
        return i == null ? [] : ja(i, At(i));
      }
      function Ub(i) {
        return i == null ? [] : ja(i, ln(i));
      }
      function zb(i, r, l) {
        return l === n && (l = r, r = n), l !== n && (l = Rn(l), l = l === l ? l : 0), r !== n && (r = Rn(r), r = r === r ? r : 0), ji(Rn(i), r, l);
      }
      function Wb(i, r, l) {
        return r = li(r), l === n ? (l = r, r = 0) : l = li(l), i = Rn(i), Yv(i, r, l);
      }
      function qb(i, r, l) {
        if (l && typeof l != "boolean" && Xt(i, r, l) && (r = l = n), l === n && (typeof r == "boolean" ? (l = r, r = n) : typeof i == "boolean" && (l = i, i = n)), i === n && r === n ? (i = 0, r = 1) : (i = li(i), r === n ? (r = i, i = 0) : r = li(r)), i > r) {
          var f = i;
          i = r, r = f;
        }
        if (l || i % 1 || r % 1) {
          var g = nf();
          return zt(i + g * (r - i + _0("1e-" + ((g + "").length - 1))), r);
        }
        return al(i, r);
      }
      var jb = _r(function(i, r, l) {
        return r = r.toLowerCase(), i + (l ? Pd(r) : r);
      });
      function Pd(i) {
        return Pl(Ge(i).toLowerCase());
      }
      function Nd(i) {
        return i = Ge(i), i && i.replace(Gm, N0).replace(d0, "");
      }
      function Vb(i, r, l) {
        i = Ge(i), r = gn(r);
        var f = i.length;
        l = l === n ? f : ji(Te(l), 0, f);
        var g = l;
        return l -= r.length, l >= 0 && i.slice(l, g) == r;
      }
      function Gb(i) {
        return i = Ge(i), i && Im.test(i) ? i.replace(fu, M0) : i;
      }
      function Kb(i) {
        return i = Ge(i), i && Am.test(i) ? i.replace(Ta, "\\$&") : i;
      }
      var Yb = _r(function(i, r, l) {
        return i + (l ? "-" : "") + r.toLowerCase();
      }), Xb = _r(function(i, r, l) {
        return i + (l ? " " : "") + r.toLowerCase();
      }), Jb = Ff("toLowerCase");
      function Zb(i, r, l) {
        i = Ge(i), r = Te(r);
        var f = r ? gr(i) : 0;
        if (!r || f >= r)
          return i;
        var g = (r - f) / 2;
        return bo(oo(g), l) + i + bo(so(g), l);
      }
      function Qb(i, r, l) {
        i = Ge(i), r = Te(r);
        var f = r ? gr(i) : 0;
        return r && f < r ? i + bo(r - f, l) : i;
      }
      function e3(i, r, l) {
        i = Ge(i), r = Te(r);
        var f = r ? gr(i) : 0;
        return r && f < r ? bo(r - f, l) + i : i;
      }
      function t3(i, r, l) {
        return l || r == null ? r = 0 : r && (r = +r), lv(Ge(i).replace(ka, ""), r || 0);
      }
      function n3(i, r, l) {
        return (l ? Xt(i, r, l) : r === n) ? r = 1 : r = Te(r), ll(Ge(i), r);
      }
      function i3() {
        var i = arguments, r = Ge(i[0]);
        return i.length < 3 ? r : r.replace(i[1], i[2]);
      }
      var r3 = _r(function(i, r, l) {
        return i + (l ? "_" : "") + r.toLowerCase();
      });
      function s3(i, r, l) {
        return l && typeof l != "number" && Xt(i, r, l) && (r = l = n), l = l === n ? Je : l >>> 0, l ? (i = Ge(i), i && (typeof r == "string" || r != null && !Rl(r)) && (r = gn(r), !r && pr(i)) ? Di(Pn(i), 0, l) : i.split(r, l)) : [];
      }
      var o3 = _r(function(i, r, l) {
        return i + (l ? " " : "") + Pl(r);
      });
      function a3(i, r, l) {
        return i = Ge(i), l = l == null ? 0 : ji(Te(l), 0, i.length), r = gn(r), i.slice(l, l + r.length) == r;
      }
      function l3(i, r, l) {
        var f = y.templateSettings;
        l && Xt(i, r, l) && (r = n), i = Ge(i), r = Oo({}, r, f, jf);
        var g = Oo({}, r.imports, f.imports, jf), w = At(g), _ = ja(g, w), L, k, z = 0, W = r.interpolate || qs, V = "__p += '", ne = Ga(
          (r.escape || qs).source + "|" + W.source + "|" + (W === du ? Um : qs).source + "|" + (r.evaluate || qs).source + "|$",
          "g"
        ), ce = "//# sourceURL=" + (Ze.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++v0 + "]") + `
`;
        i.replace(ne, function(ye, Ne, He, vn, Jt, yn) {
          return He || (He = vn), V += i.slice(z, yn).replace(Km, B0), Ne && (L = !0, V += `' +
__e(` + Ne + `) +
'`), Jt && (k = !0, V += `';
` + Jt + `;
__p += '`), He && (V += `' +
((__t = (` + He + `)) == null ? '' : __t) +
'`), z = yn + ye.length, ye;
        }), V += `';
`;
        var ve = Ze.call(r, "variable") && r.variable;
        if (!ve)
          V = `with (obj) {
` + V + `
}
`;
        else if ($m.test(ve))
          throw new Se(u);
        V = (k ? V.replace(Cm, "") : V).replace(Sm, "$1").replace(Lm, "$1;"), V = "function(" + (ve || "obj") + `) {
` + (ve ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (L ? ", __e = _.escape" : "") + (k ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + V + `return __p
}`;
        var Re = Bd(function() {
          return je(w, ce + "return " + V).apply(n, _);
        });
        if (Re.source = V, kl(Re))
          throw Re;
        return Re;
      }
      function c3(i) {
        return Ge(i).toLowerCase();
      }
      function u3(i) {
        return Ge(i).toUpperCase();
      }
      function f3(i, r, l) {
        if (i = Ge(i), i && (l || r === n))
          return ju(i);
        if (!i || !(r = gn(r)))
          return i;
        var f = Pn(i), g = Pn(r), w = Vu(f, g), _ = Gu(f, g) + 1;
        return Di(f, w, _).join("");
      }
      function d3(i, r, l) {
        if (i = Ge(i), i && (l || r === n))
          return i.slice(0, Yu(i) + 1);
        if (!i || !(r = gn(r)))
          return i;
        var f = Pn(i), g = Gu(f, Pn(r)) + 1;
        return Di(f, 0, g).join("");
      }
      function h3(i, r, l) {
        if (i = Ge(i), i && (l || r === n))
          return i.replace(ka, "");
        if (!i || !(r = gn(r)))
          return i;
        var f = Pn(i), g = Vu(f, Pn(r));
        return Di(f, g).join("");
      }
      function p3(i, r) {
        var l = lt, f = Z;
        if (ft(r)) {
          var g = "separator" in r ? r.separator : g;
          l = "length" in r ? Te(r.length) : l, f = "omission" in r ? gn(r.omission) : f;
        }
        i = Ge(i);
        var w = i.length;
        if (pr(i)) {
          var _ = Pn(i);
          w = _.length;
        }
        if (l >= w)
          return i;
        var L = l - gr(f);
        if (L < 1)
          return f;
        var k = _ ? Di(_, 0, L).join("") : i.slice(0, L);
        if (g === n)
          return k + f;
        if (_ && (L += k.length - L), Rl(g)) {
          if (i.slice(L).search(g)) {
            var z, W = k;
            for (g.global || (g = Ga(g.source, Ge(hu.exec(g)) + "g")), g.lastIndex = 0; z = g.exec(W); )
              var V = z.index;
            k = k.slice(0, V === n ? L : V);
          }
        } else if (i.indexOf(gn(g), L) != L) {
          var ne = k.lastIndexOf(g);
          ne > -1 && (k = k.slice(0, ne));
        }
        return k + f;
      }
      function g3(i) {
        return i = Ge(i), i && Dm.test(i) ? i.replace(uu, q0) : i;
      }
      var m3 = _r(function(i, r, l) {
        return i + (l ? " " : "") + r.toUpperCase();
      }), Pl = Ff("toUpperCase");
      function Md(i, r, l) {
        return i = Ge(i), r = l ? n : r, r === n ? $0(i) ? G0(i) : k0(i) : i.match(r) || [];
      }
      var Bd = Oe(function(i, r) {
        try {
          return hn(i, n, r);
        } catch (l) {
          return kl(l) ? l : new Se(l);
        }
      }), v3 = si(function(i, r) {
        return Ln(r, function(l) {
          l = jn(l), ii(i, l, El(i[l], i));
        }), i;
      });
      function y3(i) {
        var r = i == null ? 0 : i.length, l = ge();
        return i = r ? ct(i, function(f) {
          if (typeof f[1] != "function")
            throw new Dn(c);
          return [l(f[0]), f[1]];
        }) : [], Oe(function(f) {
          for (var g = -1; ++g < r; ) {
            var w = i[g];
            if (hn(w[0], this, f))
              return hn(w[1], this, f);
          }
        });
      }
      function w3(i) {
        return qv(En(i, v));
      }
      function Nl(i) {
        return function() {
          return i;
        };
      }
      function b3(i, r) {
        return i == null || i !== i ? r : i;
      }
      var x3 = Hf(), _3 = Hf(!0);
      function cn(i) {
        return i;
      }
      function Ml(i) {
        return mf(typeof i == "function" ? i : En(i, v));
      }
      function C3(i) {
        return yf(En(i, v));
      }
      function S3(i, r) {
        return wf(i, En(r, v));
      }
      var L3 = Oe(function(i, r) {
        return function(l) {
          return es(l, i, r);
        };
      }), D3 = Oe(function(i, r) {
        return function(l) {
          return es(i, l, r);
        };
      });
      function Bl(i, r, l) {
        var f = At(r), g = ho(r, f);
        l == null && !(ft(r) && (g.length || !f.length)) && (l = r, r = i, i = this, g = ho(r, At(r)));
        var w = !(ft(l) && "chain" in l) || !!l.chain, _ = ai(i);
        return Ln(g, function(L) {
          var k = r[L];
          i[L] = k, _ && (i.prototype[L] = function() {
            var z = this.__chain__;
            if (w || z) {
              var W = i(this.__wrapped__), V = W.__actions__ = on(this.__actions__);
              return V.push({ func: k, args: arguments, thisArg: i }), W.__chain__ = z, W;
            }
            return k.apply(i, bi([this.value()], arguments));
          });
        }), i;
      }
      function I3() {
        return Ft._ === this && (Ft._ = Q0), this;
      }
      function Fl() {
      }
      function E3(i) {
        return i = Te(i), Oe(function(r) {
          return bf(r, i);
        });
      }
      var T3 = gl(ct), k3 = gl(Hu), R3 = gl(Ha);
      function Fd(i) {
        return _l(i) ? Ua(jn(i)) : a1(i);
      }
      function O3(i) {
        return function(r) {
          return i == null ? n : Vi(i, r);
        };
      }
      var A3 = zf(), P3 = zf(!0);
      function $l() {
        return [];
      }
      function Hl() {
        return !1;
      }
      function N3() {
        return {};
      }
      function M3() {
        return "";
      }
      function B3() {
        return !0;
      }
      function F3(i, r) {
        if (i = Te(i), i < 1 || i > Ce)
          return [];
        var l = Je, f = zt(i, Je);
        r = ge(r), i -= Je;
        for (var g = qa(f, r); ++l < i; )
          r(l);
        return g;
      }
      function $3(i) {
        return Le(i) ? ct(i, jn) : mn(i) ? [i] : on(rd(Ge(i)));
      }
      function H3(i) {
        var r = ++J0;
        return Ge(i) + r;
      }
      var U3 = wo(function(i, r) {
        return i + r;
      }, 0), z3 = ml("ceil"), W3 = wo(function(i, r) {
        return i / r;
      }, 1), q3 = ml("floor");
      function j3(i) {
        return i && i.length ? fo(i, cn, tl) : n;
      }
      function V3(i, r) {
        return i && i.length ? fo(i, ge(r, 2), tl) : n;
      }
      function G3(i) {
        return Wu(i, cn);
      }
      function K3(i, r) {
        return Wu(i, ge(r, 2));
      }
      function Y3(i) {
        return i && i.length ? fo(i, cn, sl) : n;
      }
      function X3(i, r) {
        return i && i.length ? fo(i, ge(r, 2), sl) : n;
      }
      var J3 = wo(function(i, r) {
        return i * r;
      }, 1), Z3 = ml("round"), Q3 = wo(function(i, r) {
        return i - r;
      }, 0);
      function ex(i) {
        return i && i.length ? Wa(i, cn) : 0;
      }
      function tx(i, r) {
        return i && i.length ? Wa(i, ge(r, 2)) : 0;
      }
      return y.after = Cw, y.ary = gd, y.assign = ub, y.assignIn = Td, y.assignInWith = Oo, y.assignWith = fb, y.at = db, y.before = md, y.bind = El, y.bindAll = v3, y.bindKey = vd, y.castArray = Nw, y.chain = dd, y.chunk = q1, y.compact = j1, y.concat = V1, y.cond = y3, y.conforms = w3, y.constant = Nl, y.countBy = ew, y.create = hb, y.curry = yd, y.curryRight = wd, y.debounce = bd, y.defaults = pb, y.defaultsDeep = gb, y.defer = Sw, y.delay = Lw, y.difference = G1, y.differenceBy = K1, y.differenceWith = Y1, y.drop = X1, y.dropRight = J1, y.dropRightWhile = Z1, y.dropWhile = Q1, y.fill = ey, y.filter = nw, y.flatMap = sw, y.flatMapDeep = ow, y.flatMapDepth = aw, y.flatten = ld, y.flattenDeep = ty, y.flattenDepth = ny, y.flip = Dw, y.flow = x3, y.flowRight = _3, y.fromPairs = iy, y.functions = _b, y.functionsIn = Cb, y.groupBy = lw, y.initial = sy, y.intersection = oy, y.intersectionBy = ay, y.intersectionWith = ly, y.invert = Lb, y.invertBy = Db, y.invokeMap = uw, y.iteratee = Ml, y.keyBy = fw, y.keys = At, y.keysIn = ln, y.map = Do, y.mapKeys = Eb, y.mapValues = Tb, y.matches = C3, y.matchesProperty = S3, y.memoize = Eo, y.merge = kb, y.mergeWith = kd, y.method = L3, y.methodOf = D3, y.mixin = Bl, y.negate = To, y.nthArg = E3, y.omit = Rb, y.omitBy = Ob, y.once = Iw, y.orderBy = dw, y.over = T3, y.overArgs = Ew, y.overEvery = k3, y.overSome = R3, y.partial = Tl, y.partialRight = xd, y.partition = hw, y.pick = Ab, y.pickBy = Rd, y.property = Fd, y.propertyOf = O3, y.pull = dy, y.pullAll = ud, y.pullAllBy = hy, y.pullAllWith = py, y.pullAt = gy, y.range = A3, y.rangeRight = P3, y.rearg = Tw, y.reject = mw, y.remove = my, y.rest = kw, y.reverse = Dl, y.sampleSize = yw, y.set = Nb, y.setWith = Mb, y.shuffle = ww, y.slice = vy, y.sortBy = _w, y.sortedUniq = Sy, y.sortedUniqBy = Ly, y.split = s3, y.spread = Rw, y.tail = Dy, y.take = Iy, y.takeRight = Ey, y.takeRightWhile = Ty, y.takeWhile = ky, y.tap = jy, y.throttle = Ow, y.thru = Lo, y.toArray = Dd, y.toPairs = Od, y.toPairsIn = Ad, y.toPath = $3, y.toPlainObject = Ed, y.transform = Bb, y.unary = Aw, y.union = Ry, y.unionBy = Oy, y.unionWith = Ay, y.uniq = Py, y.uniqBy = Ny, y.uniqWith = My, y.unset = Fb, y.unzip = Il, y.unzipWith = fd, y.update = $b, y.updateWith = Hb, y.values = Lr, y.valuesIn = Ub, y.without = By, y.words = Md, y.wrap = Pw, y.xor = Fy, y.xorBy = $y, y.xorWith = Hy, y.zip = Uy, y.zipObject = zy, y.zipObjectDeep = Wy, y.zipWith = qy, y.entries = Od, y.entriesIn = Ad, y.extend = Td, y.extendWith = Oo, Bl(y, y), y.add = U3, y.attempt = Bd, y.camelCase = jb, y.capitalize = Pd, y.ceil = z3, y.clamp = zb, y.clone = Mw, y.cloneDeep = Fw, y.cloneDeepWith = $w, y.cloneWith = Bw, y.conformsTo = Hw, y.deburr = Nd, y.defaultTo = b3, y.divide = W3, y.endsWith = Vb, y.eq = Mn, y.escape = Gb, y.escapeRegExp = Kb, y.every = tw, y.find = iw, y.findIndex = od, y.findKey = mb, y.findLast = rw, y.findLastIndex = ad, y.findLastKey = vb, y.floor = q3, y.forEach = hd, y.forEachRight = pd, y.forIn = yb, y.forInRight = wb, y.forOwn = bb, y.forOwnRight = xb, y.get = Ol, y.gt = Uw, y.gte = zw, y.has = Sb, y.hasIn = Al, y.head = cd, y.identity = cn, y.includes = cw, y.indexOf = ry, y.inRange = Wb, y.invoke = Ib, y.isArguments = Yi, y.isArray = Le, y.isArrayBuffer = Ww, y.isArrayLike = an, y.isArrayLikeObject = bt, y.isBoolean = qw, y.isBuffer = Ii, y.isDate = jw, y.isElement = Vw, y.isEmpty = Gw, y.isEqual = Kw, y.isEqualWith = Yw, y.isError = kl, y.isFinite = Xw, y.isFunction = ai, y.isInteger = _d, y.isLength = ko, y.isMap = Cd, y.isMatch = Jw, y.isMatchWith = Zw, y.isNaN = Qw, y.isNative = eb, y.isNil = nb, y.isNull = tb, y.isNumber = Sd, y.isObject = ft, y.isObjectLike = pt, y.isPlainObject = os, y.isRegExp = Rl, y.isSafeInteger = ib, y.isSet = Ld, y.isString = Ro, y.isSymbol = mn, y.isTypedArray = Sr, y.isUndefined = rb, y.isWeakMap = sb, y.isWeakSet = ob, y.join = cy, y.kebabCase = Yb, y.last = kn, y.lastIndexOf = uy, y.lowerCase = Xb, y.lowerFirst = Jb, y.lt = ab, y.lte = lb, y.max = j3, y.maxBy = V3, y.mean = G3, y.meanBy = K3, y.min = Y3, y.minBy = X3, y.stubArray = $l, y.stubFalse = Hl, y.stubObject = N3, y.stubString = M3, y.stubTrue = B3, y.multiply = J3, y.nth = fy, y.noConflict = I3, y.noop = Fl, y.now = Io, y.pad = Zb, y.padEnd = Qb, y.padStart = e3, y.parseInt = t3, y.random = qb, y.reduce = pw, y.reduceRight = gw, y.repeat = n3, y.replace = i3, y.result = Pb, y.round = Z3, y.runInContext = E, y.sample = vw, y.size = bw, y.snakeCase = r3, y.some = xw, y.sortedIndex = yy, y.sortedIndexBy = wy, y.sortedIndexOf = by, y.sortedLastIndex = xy, y.sortedLastIndexBy = _y, y.sortedLastIndexOf = Cy, y.startCase = o3, y.startsWith = a3, y.subtract = Q3, y.sum = ex, y.sumBy = tx, y.template = l3, y.times = F3, y.toFinite = li, y.toInteger = Te, y.toLength = Id, y.toLower = c3, y.toNumber = Rn, y.toSafeInteger = cb, y.toString = Ge, y.toUpper = u3, y.trim = f3, y.trimEnd = d3, y.trimStart = h3, y.truncate = p3, y.unescape = g3, y.uniqueId = H3, y.upperCase = m3, y.upperFirst = Pl, y.each = hd, y.eachRight = pd, y.first = cd, Bl(y, function() {
        var i = {};
        return Wn(y, function(r, l) {
          Ze.call(y.prototype, l) || (i[l] = r);
        }), i;
      }(), { chain: !1 }), y.VERSION = s, Ln(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(i) {
        y[i].placeholder = y;
      }), Ln(["drop", "take"], function(i, r) {
        Fe.prototype[i] = function(l) {
          l = l === n ? 1 : Tt(Te(l), 0);
          var f = this.__filtered__ && !r ? new Fe(this) : this.clone();
          return f.__filtered__ ? f.__takeCount__ = zt(l, f.__takeCount__) : f.__views__.push({
            size: zt(l, Je),
            type: i + (f.__dir__ < 0 ? "Right" : "")
          }), f;
        }, Fe.prototype[i + "Right"] = function(l) {
          return this.reverse()[i](l).reverse();
        };
      }), Ln(["filter", "map", "takeWhile"], function(i, r) {
        var l = r + 1, f = l == Nt || l == Pe;
        Fe.prototype[i] = function(g) {
          var w = this.clone();
          return w.__iteratees__.push({
            iteratee: ge(g, 3),
            type: l
          }), w.__filtered__ = w.__filtered__ || f, w;
        };
      }), Ln(["head", "last"], function(i, r) {
        var l = "take" + (r ? "Right" : "");
        Fe.prototype[i] = function() {
          return this[l](1).value()[0];
        };
      }), Ln(["initial", "tail"], function(i, r) {
        var l = "drop" + (r ? "" : "Right");
        Fe.prototype[i] = function() {
          return this.__filtered__ ? new Fe(this) : this[l](1);
        };
      }), Fe.prototype.compact = function() {
        return this.filter(cn);
      }, Fe.prototype.find = function(i) {
        return this.filter(i).head();
      }, Fe.prototype.findLast = function(i) {
        return this.reverse().find(i);
      }, Fe.prototype.invokeMap = Oe(function(i, r) {
        return typeof i == "function" ? new Fe(this) : this.map(function(l) {
          return es(l, i, r);
        });
      }), Fe.prototype.reject = function(i) {
        return this.filter(To(ge(i)));
      }, Fe.prototype.slice = function(i, r) {
        i = Te(i);
        var l = this;
        return l.__filtered__ && (i > 0 || r < 0) ? new Fe(l) : (i < 0 ? l = l.takeRight(-i) : i && (l = l.drop(i)), r !== n && (r = Te(r), l = r < 0 ? l.dropRight(-r) : l.take(r - i)), l);
      }, Fe.prototype.takeRightWhile = function(i) {
        return this.reverse().takeWhile(i).reverse();
      }, Fe.prototype.toArray = function() {
        return this.take(Je);
      }, Wn(Fe.prototype, function(i, r) {
        var l = /^(?:filter|find|map|reject)|While$/.test(r), f = /^(?:head|last)$/.test(r), g = y[f ? "take" + (r == "last" ? "Right" : "") : r], w = f || /^find/.test(r);
        g && (y.prototype[r] = function() {
          var _ = this.__wrapped__, L = f ? [1] : arguments, k = _ instanceof Fe, z = L[0], W = k || Le(_), V = function(Ne) {
            var He = g.apply(y, bi([Ne], L));
            return f && ne ? He[0] : He;
          };
          W && l && typeof z == "function" && z.length != 1 && (k = W = !1);
          var ne = this.__chain__, ce = !!this.__actions__.length, ve = w && !ne, Re = k && !ce;
          if (!w && W) {
            _ = Re ? _ : new Fe(this);
            var ye = i.apply(_, L);
            return ye.__actions__.push({ func: Lo, args: [V], thisArg: n }), new In(ye, ne);
          }
          return ve && Re ? i.apply(this, L) : (ye = this.thru(V), ve ? f ? ye.value()[0] : ye.value() : ye);
        });
      }), Ln(["pop", "push", "shift", "sort", "splice", "unshift"], function(i) {
        var r = Xs[i], l = /^(?:push|sort|unshift)$/.test(i) ? "tap" : "thru", f = /^(?:pop|shift)$/.test(i);
        y.prototype[i] = function() {
          var g = arguments;
          if (f && !this.__chain__) {
            var w = this.value();
            return r.apply(Le(w) ? w : [], g);
          }
          return this[l](function(_) {
            return r.apply(Le(_) ? _ : [], g);
          });
        };
      }), Wn(Fe.prototype, function(i, r) {
        var l = y[r];
        if (l) {
          var f = l.name + "";
          Ze.call(wr, f) || (wr[f] = []), wr[f].push({ name: r, func: l });
        }
      }), wr[yo(n, F).name] = [{
        name: "wrapper",
        func: n
      }], Fe.prototype.clone = gv, Fe.prototype.reverse = mv, Fe.prototype.value = vv, y.prototype.at = Vy, y.prototype.chain = Gy, y.prototype.commit = Ky, y.prototype.next = Yy, y.prototype.plant = Jy, y.prototype.reverse = Zy, y.prototype.toJSON = y.prototype.valueOf = y.prototype.value = Qy, y.prototype.first = y.prototype.head, Gr && (y.prototype[Gr] = Xy), y;
    }, mr = K0();
    Ui ? ((Ui.exports = mr)._ = mr, Ma._ = mr) : Ft._ = mr;
  }).call(fs);
})(sa, sa.exports);
var I = sa.exports;
const ru = "pixvoices.com", Ct = "//shirt-oss.s3.us-east-1.amazonaws.com", me = "//api.pixvoices.com/web", at = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, o] of t)
    n[s] = o;
  return n;
}, s6 = {}, o6 = { class: "mobile" };
function a6(e, t) {
  return O(), P("div", o6, [
    va(e.$slots, "default", {}, void 0, !0)
  ]);
}
const cr = /* @__PURE__ */ at(s6, [["render", a6], ["__scopeId", "data-v-cfcaf47a"]]);
function l6(e, t, n) {
  const s = /* @__PURE__ */ new Date();
  s.setDate(s.getDate() + n);
  const o = "";
  document.cookie = `${e}=${decodeURIComponent(t)}${o};path=/;domain=.${ru}`;
}
function Tc(e) {
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(e).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
}
async function c6({ shopifyID: e }) {
  return new Promise((t) => {
    oe.request({
      method: "GET",
      url: me + `/users/userID?shopifyID=${e}`,
      data: {}
    }).then((n) => {
      n && n.status === 200 && n.data && n.data.code === 200 && (l6("userID", n.data.data.userID), t(n.data.data.userID)), t();
    });
  });
}
async function qe() {
  const e = Tc("userID");
  if (e)
    return e;
  const t = Tc("shopifyID");
  return t ? await c6({
    shopifyID: t
  }) : 0;
}
async function Xh() {
  const e = Tc("shopID");
  return e || 0;
}
async function Ur() {
  window.location.href = `https://${ru}/account/login?backurl=${encodeURIComponent(window.location.href)}`;
}
function u6(e) {
  const { param: t, success: n, error: s } = e;
  oe.request({
    method: "GET",
    url: me + `/font/all?flag=${t.flag}`,
    data: {}
  }).then((o) => {
    o && o.status === 200 && o.data && o.data.code === 200 ? n(o.data.data) : s && s();
  });
}
function f6(e) {
  return new Promise((t) => {
    oe.request({
      method: "GET",
      url: me + `/diydesign/detail?id=${e.diyDesignID}`,
      data: {}
    }).then((n) => {
      n && n.status === 200 && n.data && n.data.code === 200 ? t(n.data.data) : t();
    });
  });
}
async function d6() {
  return new Promise((e) => {
    oe.request({
      method: "GET",
      url: me + "/commodity/all",
      data: {}
    }).then((t) => {
      t && t.status === 200 && t.data && t.data.code === 200 ? e(t.data.data) : e();
    });
  });
}
async function h6({ commodityID: e }) {
  return new Promise((t) => {
    oe.request({
      method: "GET",
      url: me + "/commodityoption/all?commodityID=" + e,
      data: {}
    }).then((n) => {
      n && n.status === 200 && n.data && n.data.code === 200 ? t(n.data.data) : t();
    });
  });
}
async function ic({ commodityID: e, commodityOptions: t }) {
  return new Promise((n) => {
    oe.request({
      method: "POST",
      url: me + "/commoditysku/detail",
      data: {
        commodityID: e,
        commodityOptionsJSON: JSON.stringify(t)
      }
    }).then((s) => {
      s && s.status === 200 && s.data && s.data.code === 200 ? n(s.data.data) : n();
    });
  });
}
function sm(e) {
  const t = Number(I.get(e, "target", 0)), n = I.get(e, "targetID", 0);
  t && (t === 1 ? window.location.href = "/pages/diy-commodity" : t === 2 ? window.location.href = "/pages/mydiydesign" : t === 3 ? window.location.href = "/pages/shopApply" : t === 4 ? window.location.href = `/pages/mydiyshop?shopID=${n}` : t === 5 && (window.location.href = `/pages/diy-workbench?commodityID=${n}`));
}
const p6 = {
  name: "Commodity",
  components: {
    MobileLayout: cr
  },
  data() {
    return {
      commodityList: [],
      advertCover: "",
      advertText: "",
      advertOptions: {}
    };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    async init() {
      this.loadAdvert();
      const e = await d6();
      e && (this.commodityList = e);
    },
    loadAdvert() {
      oe.request({
        method: "GET",
        url: me + "/advert/detail?type=2",
        data: {}
      }).then((e) => {
        e && e.status === 200 && e.data && e.data.code === 200 && (this.advertCover = I.get(e, ["data", "data", "cover"], ""), this.advertText = I.get(e, ["data", "data", "text"], ""), this.advertOptions = I.get(e, ["data", "data"], {}));
      });
    },
    handleAdvert() {
      sm(this.advertOptions);
    }
  }
}, g6 = { class: "page" }, m6 = ["src"], v6 = {
  key: 1,
  class: "advertText"
}, y6 = { class: "commodityList" }, w6 = ["href"], b6 = ["src"], x6 = { class: "name" };
function _6(e, t, n, s, o, a) {
  const c = Ve("MobileLayout");
  return O(), P("div", null, [
    _e(c, null, {
      default: vt(() => [
        p("div", g6, [
          o.advertCover || o.advertText ? (O(), P("div", {
            key: 0,
            class: "advert",
            onClick: t[0] || (t[0] = (...u) => a.handleAdvert && a.handleAdvert(...u))
          }, [
            o.advertCover ? (O(), P("img", {
              key: 0,
              class: "advertImage",
              src: o.advertCover
            }, null, 8, m6)) : le("", !0),
            o.advertText ? (O(), P("div", v6, fe(o.advertText), 1)) : le("", !0)
          ])) : le("", !0),
          p("div", y6, [
            (O(!0), P(Ae, null, ut(o.commodityList, (u) => (O(), P("a", {
              key: u.id,
              href: `/pages/diy-workbench?commodityID=${u.id}`,
              class: "commodity"
            }, [
              p("img", {
                src: u.url,
                class: "cover"
              }, null, 8, b6),
              p("div", x6, fe(u.name), 1)
            ], 8, w6))), 128))
          ])
        ])
      ]),
      _: 1
    })
  ]);
}
const C6 = /* @__PURE__ */ at(p6, [["render", _6], ["__scopeId", "data-v-9dfdbba5"]]), S6 = {
  name: "CanvasView",
  props: {
    isShow: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClose(e) {
      e.stopPropagation(), this.$emit("handleClose");
    }
  }
};
function L6(e, t, n, s, o, a) {
  return O(), P("div", {
    class: _t(["dialog", { hidden: !n.isShow }]),
    onClick: t[1] || (t[1] = (...c) => a.handleClose && a.handleClose(...c)),
    onTouchstart: t[2] || (t[2] = (c) => {
      c.stopPropagation();
    }),
    onMousedown: t[3] || (t[3] = (c) => {
      c.stopPropagation();
    })
  }, [
    p("div", {
      class: _t(["content", { show: n.isShow, hide: !n.isShow }]),
      onClick: t[0] || (t[0] = (c) => {
        c.stopPropagation();
      })
    }, [
      va(e.$slots, "default", {}, void 0, !0)
    ], 2)
  ], 34);
}
const Ws = /* @__PURE__ */ at(S6, [["render", L6], ["__scopeId", "data-v-91db3af7"]]), Jh = 20;
let Mo = 1, rc = 1, ds = 1, Bo = 1, Ir = !1;
const D6 = {
  name: "DialogResource",
  components: {
    Dialog: Ws
  },
  props: {},
  data() {
    return {
      isShow: !1,
      currentResourceID: 0,
      resourceList: [],
      resourceItemList: []
    };
  },
  methods: {
    async init() {
      this.resourceList.length || (Mo = 1, rc = 1, await this.loadResource()), this.resourceItemList.length || (ds = 1, Bo = 1, this.loadResourceItem());
    },
    async loadResource(e) {
      if (!(Ir || rc <= this.resourceList.length))
        return Ir = !0, e && e(), new Promise((t) => {
          oe.get(me + `/resource/list?pageSize=${Jh}&currentPage=${Mo}`, {}).then((n) => {
            n && n.data && n.data.code === 200 && (Mo > 1 ? this.resourceList = this.resourceList.concat(n.data.data) : (this.resourceList = n.data.data, this.resourceList.length > 0 && (this.currentResourceID = this.resourceList[0].id)), rc = n.data.total), Ir = !1, t();
          });
        });
    },
    loadResourceItem() {
      !this.currentResourceID || Ir || Bo <= this.resourceItemList.length || (Ir = !0, oe.get(me + `/resourceitem/list?pageSize=${Jh}&currentPage=${ds}&resourceID=${this.currentResourceID}`, {}).then((e) => {
        e && e.data && e.data.code === 200 && (ds > 1 ? this.resourceItemList = this.resourceItemList.concat(e.data.data) : this.resourceItemList = e.data.data, Bo = e.data.total), Ir = !1;
      }));
    },
    resourceScroll(e) {
      const t = e.target.clientWidth, n = e.target.scrollLeft, s = e.target.scrollWidth;
      t + n >= s - 32 && this.loadResource(() => {
        Mo += 1;
      });
    },
    resourceItemScroll(e) {
      const t = e.target.clientHeight, n = e.target.scrollTop, s = e.target.scrollHeight;
      t + n >= s - 32 && (ds += 1, this.loadResourceItem());
    },
    handleResource(e) {
      this.currentResourceID = e, ds = 1, Bo = 1, this.resourceItemList = [], this.loadResourceItem();
    },
    handleImageLayer(e) {
      this.$emit("handleImageLayer", I.get(e, "cover", ""));
    },
    async handleShow() {
      await this.init(), this.isShow = !0;
    },
    handleClose() {
      this.isShow = !1, this.$emit("handleClose");
    }
  }
}, I6 = { class: "resources" }, E6 = ["onClick"], T6 = ["src"], k6 = { class: "resourceItems" }, R6 = ["onClick"], O6 = ["src"];
function A6(e, t, n, s, o, a) {
  const c = Ve("Dialog");
  return O(), fn(c, {
    isShow: o.isShow,
    onHandleClose: a.handleClose
  }, {
    default: vt(() => [
      p("div", {
        class: "scroll scrollCrosswise",
        onScroll: t[0] || (t[0] = (...u) => a.resourceScroll && a.resourceScroll(...u))
      }, [
        p("div", I6, [
          (O(!0), P(Ae, null, ut(o.resourceList, (u) => (O(), P("div", {
            onClick: (d) => a.handleResource(u.id),
            class: "resource"
          }, [
            p("img", {
              class: "cover",
              src: u.cover
            }, null, 8, T6)
          ], 8, E6))), 256))
        ])
      ], 32),
      p("div", {
        class: "scroll scrollLengthways",
        onScroll: t[1] || (t[1] = (...u) => a.resourceItemScroll && a.resourceItemScroll(...u))
      }, [
        p("div", k6, [
          (O(!0), P(Ae, null, ut(o.resourceItemList, (u) => (O(), P("div", {
            class: "resourceItem",
            onClick: (d) => a.handleImageLayer(u)
          }, [
            p("img", {
              class: "cover",
              src: u.cover
            }, null, 8, O6)
          ], 8, R6))), 256))
        ])
      ], 32),
      p("div", {
        class: "close",
        onClick: t[2] || (t[2] = (...u) => a.handleClose && a.handleClose(...u))
      })
    ]),
    _: 1
  }, 8, ["isShow", "onHandleClose"]);
}
const P6 = /* @__PURE__ */ at(D6, [["render", A6], ["__scopeId", "data-v-aec3bafe"]]), N6 = {
  name: "DialogDiyTemplates",
  components: {
    Dialog: Ws
  },
  props: {},
  data() {
    return {
      isShow: !1,
      currentResourceID: 0,
      resourceList: [],
      diydesignFeaturedList: [],
      diydesignFeaturedLoading: !1
    };
  },
  methods: {
    async init(e) {
      console.log(e, "commodityID-89777"), this.getDataList(e);
    },
    async getDataList(e) {
      this.diydesignFeaturedLoading = !0, this.diydesignFeaturedList = [];
      const t = new URLSearchParams({ commodityID: e }).toString();
      oe.request({
        method: "GET",
        url: `${me}/diydesignFeatured?` + t,
        data: {}
      }).then((n) => {
        console.log(n.data, "res.data"), n && n.status === 200 && n.data && n.data.code === 200 && (this.diydesignFeaturedList = n.data.data), this.diydesignFeaturedLoading = !1;
      }).catch((n) => {
        console.error("Error fetching data:", n), this.diydesignFeaturedLoading = !1;
      });
    },
    resourceScroll(e) {
      const t = e.target.clientWidth, n = e.target.scrollLeft, s = e.target.scrollWidth;
      t + n >= s - 32 && this.loadResource(() => {
      });
    },
    resourceItemScroll(e) {
      const t = e.target.clientHeight, n = e.target.scrollTop, s = e.target.scrollHeight;
      t + n >= s - 32 && this.loadResourceItem();
    },
    handleResource(e) {
      this.currentResourceID = e, this.resourceItemList = [], this.loadResourceItem();
    },
    handleImageLayer(e) {
      this.$emit("handleImageLayer", e), this.handleClose();
    },
    async handleShow(e) {
      await this.init(e), this.isShow = !0;
    },
    handleClose() {
      this.isShow = !1, this.$emit("handleClose");
    }
  }
}, M6 = { class: "scroll scrollLengthways" }, B6 = {
  key: 0,
  class: "grid grid-cols-2"
}, F6 = ["onClick"], $6 = ["src"], H6 = {
  key: 1,
  class: "h-full flex justify-center items-center"
}, U6 = {
  key: 0,
  class: "flex justify-center items-center"
}, z6 = { key: 1 };
function W6(e, t, n, s, o, a) {
  const c = Ve("Dialog");
  return O(), fn(c, {
    isShow: o.isShow,
    onHandleClose: a.handleClose
  }, {
    default: vt(() => [
      p("div", M6, [
        o.diydesignFeaturedList.length ? (O(), P("div", B6, [
          (O(!0), P(Ae, null, ut(o.diydesignFeaturedList, (u) => (O(), P("div", {
            class: "",
            onClick: (d) => a.handleImageLayer(u)
          }, [
            p("img", {
              class: "w-full",
              src: u.coverUrl
            }, null, 8, $6)
          ], 8, F6))), 256))
        ])) : (O(), P("div", H6, [
          o.diydesignFeaturedLoading ? (O(), P("span", U6, t[1] || (t[1] = [
            p("svg", {
              t: "1696395089207",
              class: "icon mr-[4px] animate-rotating fill-black w-[20px] h-[20px]",
              viewBox: "0 0 1024 1024",
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              "p-id": "15559",
              width: "1em",
              height: "1em"
            }, [
              p("path", {
                d: "M512 74.666667c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32V106.666667c0-17.066667-14.933333-32-32-32zM693.333333 362.666667c8.533333 0 17.066667-2.133333 23.466667-8.533334l104.533333-104.533333c12.8-12.8 12.8-32 0-44.8-12.8-12.8-32-12.8-44.8 0l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 4.266667 6.4 12.8 8.533333 21.333333 8.533334zM917.333333 480h-149.333333c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32zM714.666667 669.866667c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333zM512 736c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-149.333333c0-17.066667-14.933333-32-32-32zM309.333333 669.866667l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333l104.533334-104.533333c12.8-12.8 12.8-32 0-44.8s-36.266667-12.8-46.933334 0zM288 512c0-17.066667-14.933333-32-32-32H106.666667c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32zM247.466667 202.666667c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333z",
                "p-id": "15560"
              })
            ], -1),
            p("span", null, " Loading...", -1)
          ]))) : (O(), P("span", z6, "No Data"))
        ]))
      ]),
      p("div", {
        class: "close",
        onClick: t[0] || (t[0] = (...u) => a.handleClose && a.handleClose(...u))
      })
    ]),
    _: 1
  }, 8, ["isShow", "onHandleClose"]);
}
const q6 = /* @__PURE__ */ at(N6, [["render", W6], ["__scopeId", "data-v-c0298e46"]]);
let Zh;
const j6 = {
  name: "DialogOption",
  components: {
    Dialog: Ws
  },
  props: {
    commodityOptionList: {
      type: Array,
      default: []
    },
    selectOptionList: {
      type: Array,
      default: []
    },
    options: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      isShow: !1,
      selectOptionMap: {},
      visibleCommodityOptionList: [],
      discountSecond: 0
    };
  },
  computed: {
    originPrice: function() {
      if (this.options && this.options.price)
        return Number(this.options.price.price);
    },
    discountPrice: function() {
      if (this.options && this.options.price) {
        const e = Number(this.options.price.price), t = Number(this.options.price.discountPercent) / 100;
        return e * (1 - t);
      }
      return 0;
    },
    discountTime: function() {
      if (this.discountSecond) {
        const e = parseInt(this.discountSecond / 60 / 60 / 24), t = parseInt((this.discountSecond - e * 60 * 60 * 24) / 60 / 60), n = parseInt((this.discountSecond - e * 60 * 60 * 24 - t * 60 * 60) / 60), s = this.discountSecond - e * 60 * 60 * 24 - t * 60 * 60 - n * 60;
        return `${e}day ${t}: ${n}:${s}`;
      }
      return "";
    }
  },
  methods: {
    resetMap() {
      const e = {};
      for (let t = 0; t < I.size(this.selectOptionList); t++) {
        const { commodityOptionID: n, commodityOptionValueID: s } = this.selectOptionList[t];
        e[n] = s;
      }
      this.selectOptionMap = e;
    },
    resetVisibleCommodityOptionList() {
      const e = [];
      for (let t = 0; t < I.size(this.commodityOptionList); t++) {
        const n = this.commodityOptionList[t], s = I.get(n, "controllerCommodityOptionID", 0);
        if (s && I.has(this.selectOptionMap, s)) {
          const o = I.filter(I.get(n, "values", []), (a) => I.includes(I.get(a, "controllerCommodityOptionValueID", []), Number(this.selectOptionMap[s])));
          e.push({
            ...n,
            values: o
          });
        } else
          e.push(n);
      }
      this.visibleCommodityOptionList = e;
    },
    resetTime() {
      if (this.options && this.options.price && this.options.price.discountTime) {
        const e = new Date(this.options.price.discountTime);
        this.discountSecond = parseInt((e.getTime() - (/* @__PURE__ */ new Date()).getTime()) / 1e3), clearInterval(Zh), Zh = setInterval(() => {
          this.discountSecond >= 0 && (this.discountSecond -= 1);
        }, 1e3);
      }
    },
    handleSelect(e, t, n) {
      this.selectOptionMap[e] = t, this.handleSelectChange(n);
    },
    handleSelectChange(e) {
      this.resetVisibleCommodityOptionList(), e === 0 ? this.resetDefaultOptions() : this.resetOptions();
    },
    handleShow() {
      this.resetMap(), this.resetVisibleCommodityOptionList(), this.resetTime(), this.isShow = !0;
    },
    handleClose() {
      this.isShow = !1;
    },
    async handleConfirm() {
      this.handleClose();
    },
    initDefaultOptions() {
      var t;
      this.selectOptionMap[I.get(this.commodityOptionList, [0, "commodityOptionID"])] = I.get(this.commodityOptionList, [0, "values", 0, "id"], ""), this.resetVisibleCommodityOptionList();
      for (let n = 0; n < I.size(this.visibleCommodityOptionList); n++) {
        const s = this.visibleCommodityOptionList[n];
        this.selectOptionMap[s == null ? void 0 : s.commodityOptionID] = (t = s == null ? void 0 : s.values[0]) == null ? void 0 : t.id;
      }
      const e = [];
      for (const n in this.selectOptionMap)
        e.push({
          commodityOptionID: Number(n),
          commodityOptionValueID: this.selectOptionMap[n]
        });
      return e;
    },
    resetDefaultOptions() {
      var e;
      for (let t = 0; t < I.size(this.visibleCommodityOptionList); t++) {
        const n = this.visibleCommodityOptionList[t];
        t > 0 && (this.selectOptionMap[n == null ? void 0 : n.commodityOptionID] = (e = n == null ? void 0 : n.values[0]) == null ? void 0 : e.id);
      }
      this.resetOptions();
    },
    resetOptions() {
      const e = [];
      for (const t in this.selectOptionMap)
        e.push({
          commodityOptionID: t,
          commodityOptionValueID: this.selectOptionMap[t]
        });
      this.$emit("handleSelectOptions", e);
    }
  }
}, V6 = { class: "scroll" }, G6 = { key: 0 }, K6 = { class: "title" }, Y6 = { class: "select" }, X6 = ["onUpdate:modelValue", "onChange"], J6 = ["value"], Z6 = { key: 1 }, Q6 = { class: "title" }, eL = { class: "colors" }, tL = ["onClick"], nL = { key: 2 }, iL = { class: "title" }, rL = { class: "scrollCrosswise" }, sL = { class: "images" }, oL = ["onClick"], aL = ["src"], lL = { key: 3 }, cL = { class: "title" }, uL = { class: "blocks" }, fL = ["onClick"], dL = {
  key: 0,
  class: "tips"
}, hL = {
  key: 0,
  class: "originPrice"
}, pL = { class: "price" }, gL = { key: 1 }, mL = { class: "footer" };
function vL(e, t, n, s, o, a) {
  const c = Ve("Dialog");
  return O(), fn(c, {
    isShow: o.isShow,
    onHandleClose: a.handleClose
  }, {
    default: vt(() => [
      p("div", V6, [
        (O(!0), P(Ae, null, ut(o.visibleCommodityOptionList, (u, d) => (O(), P(Ae, null, [
          u.commodityOptionType === 1 ? (O(), P("div", G6, [
            p("div", K6, fe(u.commodityOptionName), 1),
            p("div", Y6, [
              gt(p("select", {
                "onUpdate:modelValue": (h) => o.selectOptionMap[u.commodityOptionID] = h,
                onChange: (h) => a.handleSelectChange(d)
              }, [
                (O(!0), P(Ae, null, ut(u.values, (h) => (O(), P("option", {
                  key: h.id,
                  value: h.id
                }, fe(h.value), 9, J6))), 128))
              ], 40, X6), [
                [x2, o.selectOptionMap[u.commodityOptionID]]
              ]),
              t[1] || (t[1] = p("svg", {
                "aria-hidden": "true",
                focusable: "false",
                class: "down",
                viewBox: "0 0 10 6"
              }, [
                p("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z",
                  fill: "currentColor"
                })
              ], -1))
            ])
          ])) : u.commodityOptionType === 2 ? (O(), P("div", Z6, [
            p("div", Q6, fe(u.commodityOptionName), 1),
            p("div", eL, [
              (O(!0), P(Ae, null, ut(u.values, (h) => (O(), P("div", {
                class: _t(["color", { current: h.id === o.selectOptionMap[u.commodityOptionID] }]),
                style: Lt(`background-color:${h.value}`),
                onClick: (m) => a.handleSelect(u.commodityOptionID, h.id, d)
              }, null, 14, tL))), 256))
            ])
          ])) : u.commodityOptionType === 3 ? (O(), P("div", nL, [
            p("div", iL, fe(u.commodityOptionName), 1),
            p("div", rL, [
              p("div", sL, [
                (O(!0), P(Ae, null, ut(u.values, (h) => (O(), P("div", {
                  class: _t(["image", { current: h.id === o.selectOptionMap[u.commodityOptionID] }]),
                  onClick: (m) => a.handleSelect(u.commodityOptionID, h.id, d)
                }, [
                  p("img", {
                    class: "cover",
                    src: h.cover
                  }, null, 8, aL)
                ], 10, oL))), 256))
              ])
            ])
          ])) : (O(), P("div", lL, [
            p("div", cL, fe(u.commodityOptionName), 1),
            p("div", uL, [
              (O(!0), P(Ae, null, ut(u.values, (h) => (O(), P("div", {
                class: _t(["block", { current: h.id === o.selectOptionMap[u.commodityOptionID] }]),
                onClick: (m) => a.handleSelect(u.commodityOptionID, h.id, d)
              }, fe(h.value), 11, fL))), 256))
            ])
          ]))
        ], 64))), 256))
      ]),
      a.discountPrice ? (O(), P("div", dL, [
        n.options.price.discountPercent ? (O(), P("del", hL, fe(a.originPrice) + " USD", 1)) : le("", !0),
        p("strong", pL, fe(a.discountPrice) + " USD", 1),
        a.discountTime ? (O(), P("span", gL, fe(a.discountTime), 1)) : le("", !0)
      ])) : le("", !0),
      p("div", mL, [
        p("div", {
          class: "next",
          onClick: t[0] || (t[0] = (...u) => a.handleConfirm && a.handleConfirm(...u))
        }, "Next")
      ])
    ]),
    _: 1
  }, 8, ["isShow", "onHandleClose"]);
}
const yL = /* @__PURE__ */ at(j6, [["render", vL], ["__scopeId", "data-v-125cc2df"]]), wL = 20;
let Qh = 1, Fo = 1, sc = !1;
const bL = {
  name: "DialogFont",
  components: {
    Dialog: Ws
  },
  props: {
    layerList: {
      type: Array,
      default: []
    },
    currentLayerID: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      isShow: !1,
      switchType: 0,
      text: "",
      fontList: [],
      colorList: [
        "#ffffff",
        "#000000",
        "#a3a3a3",
        "#E73295",
        "#f40255",
        "#eb1d65",
        "#ff8ca2",
        "#fdccc4",
        "#8002ff",
        "#943cfd",
        "#9765ff",
        "#c194fd",
        "#f2c9ff",
        "#324efe",
        "#4080ff",
        "#38c0ff",
        "#7fd9ff",
        "#bbeaff",
        "#5a9c23",
        "#85d228",
        "#a7e760",
        "#c8f095",
        "#02d49f",
        "#a5fee9",
        "#e4440c",
        "#ff8000",
        "#f49805",
        "#ffc80a",
        "#ffebb5",
        "#2d3d4e",
        "#61768c",
        "#919eb0",
        "#cfd6dc",
        "#efefef",
        "#615f63",
        "#a09e9e",
        "#d6d5d7",
        "#efedf1"
      ]
    };
  },
  computed: {
    fontFamily: function() {
      for (let e = 0; e < this.layerList.length; e++)
        if (this.layerList[e].id === this.currentLayerID)
          return this.layerList[e].fontFamily;
      return "";
    },
    fontColor: function() {
      for (let e = 0; e < this.layerList.length; e++)
        if (this.layerList[e].id === this.currentLayerID)
          return this.layerList[e].fontColor;
      return "";
    }
  },
  methods: {
    init() {
      this.fontList.length || (this.fontList = [], Fo = 1, this.loadFont());
    },
    loadFont() {
      sc || Qh <= this.fontList.length || (sc = !0, oe.get(me + `/font/list?pageSize=${wL}&currentPage=${Fo}`, {}).then((e) => {
        e && e.data && e.data.code === 200 && (Fo > 1 ? this.fontList = this.fontList.concat(e.data.data) : this.fontList = e.data.data, Qh = e.data.total), sc = !1;
      }));
    },
    fontScroll(e) {
      const t = e.target.clientHeight, n = e.target.scrollTop, s = e.target.scrollHeight;
      t + n >= s && (Fo += 1, this.loadFont());
    },
    textChange(e) {
      this.$emit("handleEdit", {
        id: this.currentLayerID,
        param: {
          itemData: I.get(e, "target.value", "")
        }
      });
    },
    textBlur() {
      window.scroll(0, 0);
    },
    handleFamily(e) {
      this.$emit("handleEdit", {
        id: this.currentLayerID,
        param: {
          fontFamily: e
        }
      });
    },
    handleColor(e) {
      this.$emit("handleEdit", {
        id: this.currentLayerID,
        param: {
          fontColor: e
        }
      });
    },
    handleAlign(e) {
      this.$emit("handleEdit", {
        id: this.currentLayerID,
        param: {
          textAlign: e
        }
      });
    },
    handleBold() {
      const e = I.find(this.layerList, (t) => t.id === this.currentLayerID);
      e && this.$emit("handleEdit", {
        id: this.currentLayerID,
        param: {
          fontBold: !I.get(e, "fontBold", !1)
        }
      });
    },
    handleItalic() {
      const e = I.find(this.layerList, (t) => t.id === this.currentLayerID);
      e && this.$emit("handleEdit", {
        id: this.currentLayerID,
        param: {
          fontItalic: !I.get(e, "fontItalic", !1)
        }
      });
    },
    handleLineThrough() {
      const e = I.find(this.layerList, (t) => t.id === this.currentLayerID);
      e && this.$emit("handleEdit", {
        id: this.currentLayerID,
        param: {
          fontLineThrough: !I.get(e, "fontLineThrough", !1)
        }
      });
    },
    handleSwitch(e) {
      this.switchType = e;
    },
    handleShow() {
      this.init(), this.isShow = !0;
    },
    handleClose() {
      this.isShow = !1;
    }
  }
}, xL = { class: "input" }, _L = { class: "switch" }, CL = { class: "fonts" }, SL = ["onClick"], LL = ["src"], DL = { class: "colorScroll" }, IL = { class: "colors" }, EL = ["onClick"], TL = { class: "fontStyles" };
function kL(e, t, n, s, o, a) {
  const c = Ve("Dialog");
  return O(), fn(c, {
    isShow: o.isShow,
    onHandleClose: a.handleClose,
    onClick: t[13] || (t[13] = (u) => {
      u.stopPropagation();
    })
  }, {
    default: vt(() => [
      p("div", xL, [
        gt(p("input", {
          "onUpdate:modelValue": t[0] || (t[0] = (u) => o.text = u),
          placeholder: "please input",
          onInput: t[1] || (t[1] = (...u) => a.textChange && a.textChange(...u)),
          onBlur: t[2] || (t[2] = (...u) => a.textBlur && a.textBlur(...u))
        }, null, 544), [
          [St, o.text]
        ])
      ]),
      p("div", _L, [
        p("div", {
          class: _t(["switchItem", { current: o.switchType === 0 }]),
          onClick: t[3] || (t[3] = (u) => a.handleSwitch(0))
        }, "Font", 2),
        p("div", {
          class: _t(["switchItem", { current: o.switchType === 1 }]),
          onClick: t[4] || (t[4] = (u) => a.handleSwitch(1))
        }, "Style", 2)
      ]),
      p("div", {
        class: _t(["scroll", { hidden: o.switchType !== 0 }]),
        onScroll: t[5] || (t[5] = (...u) => a.fontScroll && a.fontScroll(...u))
      }, [
        p("div", CL, [
          (O(!0), P(Ae, null, ut(o.fontList, (u) => (O(), P("div", {
            class: _t(["font", { current: a.fontFamily === u.flag }]),
            onClick: (d) => a.handleFamily(u.flag)
          }, [
            p("img", {
              class: "cover",
              src: u.thumbnailUrl
            }, null, 8, LL)
          ], 10, SL))), 256))
        ])
      ], 34),
      p("div", {
        class: _t(["form", { hidden: o.switchType !== 1 }])
      }, [
        p("div", DL, [
          p("div", IL, [
            (O(!0), P(Ae, null, ut(o.colorList, (u) => (O(), P("div", {
              class: _t(["color", { current: a.fontColor === u }]),
              style: Lt({ backgroundColor: u }),
              onClick: (d) => a.handleColor(u)
            }, null, 14, EL))), 256))
          ])
        ]),
        p("div", TL, [
          p("img", {
            class: "fontStyle",
            src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/textEditAlignLeft.svg",
            onClick: t[6] || (t[6] = (u) => a.handleAlign("left"))
          }),
          p("img", {
            class: "fontStyle",
            src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/textEditAlignCenter.svg",
            onClick: t[7] || (t[7] = (u) => a.handleAlign("center"))
          }),
          p("img", {
            class: "fontStyle",
            src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/textEditAlignRight.svg",
            onClick: t[8] || (t[8] = (u) => a.handleAlign("right"))
          }),
          p("img", {
            class: "fontStyle",
            src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/textEditBold.svg",
            onClick: t[9] || (t[9] = (u) => a.handleBold())
          }),
          p("img", {
            class: "fontStyle",
            src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/textEditItalic.svg",
            onClick: t[10] || (t[10] = (u) => a.handleItalic())
          }),
          p("img", {
            class: "fontStyle",
            src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/textEditLineThrough.svg",
            onClick: t[11] || (t[11] = (u) => a.handleLineThrough())
          })
        ])
      ], 2),
      p("div", {
        class: "close",
        onClick: t[12] || (t[12] = (...u) => a.handleClose && a.handleClose(...u))
      })
    ]),
    _: 1
  }, 8, ["isShow", "onHandleClose"]);
}
const RL = /* @__PURE__ */ at(bL, [["render", kL], ["__scopeId", "data-v-05d76919"]]), Xn = 240, OL = {
  name: "CanvasView",
  props: {
    width: {
      type: [Number, String],
      default: 375
    },
    height: {
      type: [Number, String],
      default: 667
    }
  },
  data() {
    return {};
  },
  computed: {
    viewStyle: function() {
      const e = Xn / this.width;
      return `width:${this.width * e}px;height:${this.height * e}px;`;
    },
    canvasStyle: function() {
      const e = Xn / this.width;
      return `width:${this.width}px;height:${this.height}px;transform: scale(${e},${e});`;
    }
  }
};
function AL(e, t, n, s, o, a) {
  return O(), P("div", {
    style: Lt(a.viewStyle),
    class: "viewCanvas"
  }, [
    p("div", {
      style: Lt(a.canvasStyle),
      class: "canvasPanel"
    }, [
      va(e.$slots, "default", {}, void 0, !0)
    ], 4)
  ], 4);
}
const su = /* @__PURE__ */ at(OL, [["render", AL], ["__scopeId", "data-v-822caee2"]]), PL = {
  name: "DialogPreview",
  components: {
    CanvasView: su,
    Dialog: Ws
  },
  data() {
    return {
      isShow: !1,
      showCoverImage: ""
    };
  },
  props: {
    options: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isSubmit: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    width: function() {
      return I.has(this.options, "material") ? I.get(this.options, "material.width", 0) : 0;
    },
    height: function() {
      return I.has(this.options, "material") ? I.get(this.options, "material.height", 0) : 0;
    }
  },
  mounted: function() {
    this.init();
  },
  methods: {
    init() {
      const e = this.$refs.canvasElement;
      this.canvasContext = e.getContext("2d");
    },
    async drawCanvas(e) {
      this.canvasContext && (this.canvasContext.clearRect(0, 0, this.width, this.height), this.canvasContext.drawImage(e, 0, 0, this.width, this.height));
    },
    async handleSubmit() {
      this.isSubmit || this.$emit("handleSubmit");
    },
    async handleShow(e) {
      await this.drawCanvas(e), this.isShow = !0;
    },
    handleClose() {
      this.isShow = !1;
    },
    getImageBlob: async function() {
      return new Promise((e) => {
        const s = document.createElement("canvas");
        s.width = 800, s.height = 800;
        const o = s.getContext("2d");
        o.fillStyle = "RGB(255, 255, 255)", o.fillRect(0, 0, 800, 800);
        const a = 760, c = a / this.height * this.width, u = 20, d = (800 - c) / 2;
        o.drawImage(this.$refs.canvasElement, d, u, c, a), s.toBlob((h) => {
          e(h);
        }, "image/jpeg");
      });
    },
    handleCoverImage(e) {
      this.showCoverImage = e;
    },
    closeCoverImage() {
      this.showCoverImage = "";
    }
  }
}, NL = { class: "mobile" }, ML = ["width", "height"], BL = {
  key: 0,
  class: "describes"
}, FL = ["src"], $L = ["src"], HL = ["src"], UL = ["src"];
function zL(e, t, n, s, o, a) {
  const c = Ve("CanvasView"), u = Ve("Dialog");
  return O(), P(Ae, null, [
    _e(u, {
      isShow: o.isShow,
      onHandleClose: a.handleClose
    }, {
      default: vt(() => [
        t[6] || (t[6] = p("div", { class: "header" }, "preview", -1)),
        p("div", {
          class: "close",
          onClick: t[0] || (t[0] = (...d) => a.handleClose && a.handleClose(...d))
        }),
        p("div", NL, [
          _e(c, {
            width: a.width,
            height: a.height
          }, {
            default: vt(() => [
              p("canvas", {
                width: a.width,
                height: a.height,
                ref: "canvasElement"
              }, null, 8, ML)
            ]),
            _: 1
          }, 8, ["width", "height"]),
          n.options.describe ? (O(), P("div", BL, [
            n.options.describe.cover1 ? (O(), P("div", {
              key: 0,
              class: "describe",
              onClick: t[1] || (t[1] = () => {
                a.handleCoverImage(n.options.describe.cover1);
              })
            }, [
              p("img", {
                src: n.options.describe.cover1
              }, null, 8, FL)
            ])) : le("", !0),
            n.options.describe.cover2 ? (O(), P("div", {
              key: 1,
              class: "describe",
              onClick: t[2] || (t[2] = () => {
                a.handleCoverImage(n.options.describe.cover2);
              })
            }, [
              p("img", {
                src: n.options.describe.cover2
              }, null, 8, $L)
            ])) : le("", !0),
            n.options.describe.cover3 ? (O(), P("div", {
              key: 2,
              class: "describe",
              onClick: t[3] || (t[3] = () => {
                a.handleCoverImage(n.options.describe.cover3);
              })
            }, [
              p("img", {
                src: n.options.describe.cover3
              }, null, 8, HL)
            ])) : le("", !0)
          ])) : le("", !0)
        ]),
        p("div", {
          class: _t(["submit", { isSubmit: n.isSubmit }]),
          onClick: t[4] || (t[4] = (...d) => a.handleSubmit && a.handleSubmit(...d))
        }, "print", 2)
      ]),
      _: 1
    }, 8, ["isShow", "onHandleClose"]),
    o.showCoverImage ? (O(), P("div", {
      key: 0,
      class: "priviewCover",
      onClick: t[5] || (t[5] = (...d) => a.closeCoverImage && a.closeCoverImage(...d))
    }, [
      p("img", { src: o.showCoverImage }, null, 8, UL)
    ])) : le("", !0)
  ], 64);
}
const WL = /* @__PURE__ */ at(PL, [["render", zL], ["__scopeId", "data-v-78a4362e"]]), qL = {
  name: "Tools",
  props: {
    layerList: {
      type: Array,
      default: []
    },
    currentLayerID: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      isShowLayers: !1,
      ossCdnDmain: Ct
    };
  },
  methods: {
    handleLayers() {
      this.isShowLayers = !this.isShowLayers;
    },
    handleLayer(e) {
      this.$emit("handleLayer", e);
    },
    handleMydiy() {
      window.location.href = "/pages/mydiydesign";
    }
  }
}, jL = { class: "tools" }, VL = ["src"], GL = ["src"], KL = {
  key: 0,
  class: "layers"
}, YL = ["onClick"], XL = ["src"], JL = { key: 1 };
function ZL(e, t, n, s, o, a) {
  return O(), P("div", {
    onTouchstart: t[2] || (t[2] = (c) => {
      c.stopPropagation();
    }),
    onMousedown: t[3] || (t[3] = (c) => {
      c.stopPropagation();
    }),
    onClick: t[4] || (t[4] = (c) => {
      c.stopPropagation();
    })
  }, [
    p("div", jL, [
      p("div", {
        class: "tool portfolio",
        onClick: t[0] || (t[0] = (...c) => a.handleMydiy && a.handleMydiy(...c))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/mydiy.png",
          class: "icon"
        }, null, 8, VL),
        t[5] || (t[5] = p("div", null, "Portfolio", -1))
      ]),
      p("div", {
        class: "tool",
        onClick: t[1] || (t[1] = (...c) => a.handleLayers && a.handleLayers(...c))
      }, [
        p("img", {
          src: o.ossCdnDmain + (o.isShowLayers, "/assets/layer.png"),
          class: "icon"
        }, null, 8, GL),
        t[6] || (t[6] = p("div", null, "layers", -1))
      ])
    ]),
    o.isShowLayers ? (O(), P("div", KL, [
      (O(!0), P(Ae, null, ut(n.layerList, (c) => (O(), P("div", {
        class: _t(["layer", { current: c.id === n.currentLayerID }]),
        onClick: (u) => a.handleLayer(c.id)
      }, [
        c.itemType === 2 ? (O(), P("img", {
          key: 0,
          src: c.itemData,
          class: "cover"
        }, null, 8, XL)) : (O(), P("div", JL, fe(c.itemData), 1))
      ], 10, YL))), 256))
    ])) : le("", !0)
  ], 32);
}
const QL = /* @__PURE__ */ at(qL, [["render", ZL], ["__scopeId", "data-v-ffb7298c"]]);
async function ep(e, t, n) {
  return new Promise((s, o) => {
    const a = new FormData(), c = new File([e], t, { type: e.type });
    a.append("file", c), a.append("folder", "user"), a.append("withoutResize", 1), oe.post(me + "/upload", a, {
      "Content-type": "multipart/form-data"
    }).then((u) => {
      u && u.status === 200 && u.data.code === 200 && u.data.data.filename ? s(u.data.data.filename) : s("");
    }).catch(() => {
      s("");
    });
  });
}
async function eD(e, t, n) {
  return new Promise((s, o) => {
    const a = new FormData(), c = new File([e], t, { type: e.type });
    a.append("file", c), a.append("folder", n), a.append("withoutResize", 1), oe.post(me + "/upload", a, {
      "Content-type": "multipart/form-data"
    }).then((u) => {
      u && u.status === 200 && u.data.code === 200 && u.data.data.filename ? s(u.data.data.filename) : s("");
    }).catch(() => {
      s("");
    });
  });
}
async function As(e, t, n) {
  return new Promise((s, o) => {
    const a = new FormData(), c = new File([e], t, { type: e.type });
    a.append("file", c), a.append("folder", n), a.append("withoutResize", 1), oe.post(me + "/uploadToShop", a, {
      "Content-type": "multipart/form-data"
    }).then((u) => {
      u && u.status === 200 && u.data.code === 200 && u.data.data.filename ? s(u.data.data.filename) : s("");
    }).catch(() => {
      s("");
    });
  });
}
function zr(e) {
  return e.slice(e.lastIndexOf(".") + 1);
}
const tD = {
  name: "NavigateLayers",
  data() {
    return {};
  },
  props: {
    layerList: {
      type: Array,
      default: []
    },
    currentLayerID: {
      type: [Number, String],
      default: ""
    }
  },
  computed: {
    maxZIndex() {
      const e = I.maxBy(this.layerList, function(t) {
        return t.zIndex;
      });
      return I.get(e, "zIndex", 0);
    },
    minZIndex() {
      const e = I.minBy(this.layerList, function(t) {
        return t.zIndex;
      });
      return I.get(e, "zIndex", 0);
    }
  },
  methods: {
    handleTopBest() {
      I.size(this.layerList) > 1 && this.$emit("handleEdit", {
        zIndex: this.maxZIndex + 1
      });
    },
    handleBottomBest() {
      I.size(this.layerList) > 1 && this.$emit("handleEdit", {
        zIndex: this.minZIndex - 1
      });
    },
    handleTop() {
      if (I.size(this.layerList) > 1) {
        for (let e = 0; e < I.size(this.layerList); e++)
          if (this.layerList[e].id === this.currentLayerID) {
            this.$emit("handleEdit", {
              zIndex: this.layerList[e].zIndex + 1
            });
            break;
          }
      }
    },
    handleBottom() {
      if (I.size(this.layerList) > 1) {
        for (let e = 0; e < I.size(this.layerList); e++)
          if (this.layerList[e].id === this.currentLayerID) {
            this.$emit("handleEdit", {
              zIndex: this.layerList[e].zIndex - 1
            });
            break;
          }
      }
    },
    handleClose() {
      this.$emit("close");
    }
  }
}, nD = { class: "dialog" }, iD = { class: "tools" };
function rD(e, t, n, s, o, a) {
  return O(), P("div", nD, [
    t[9] || (t[9] = p("div", { class: "title" }, "Layer", -1)),
    p("div", {
      class: "close",
      onClick: t[0] || (t[0] = (...c) => a.handleClose && a.handleClose(...c))
    }),
    p("div", iD, [
      p("div", {
        class: "tool",
        onClick: t[1] || (t[1] = (...c) => a.handleTopBest && a.handleTopBest(...c))
      }, t[5] || (t[5] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/layerTopBest.png"
        }, null, -1),
        p("div", null, "Top", -1)
      ])),
      p("div", {
        class: "tool",
        onClick: t[2] || (t[2] = (...c) => a.handleBottomBest && a.handleBottomBest(...c))
      }, t[6] || (t[6] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/layerBottomBest.png"
        }, null, -1),
        p("div", null, "Bottom", -1)
      ])),
      p("div", {
        class: "tool",
        onClick: t[3] || (t[3] = (...c) => a.handleTop && a.handleTop(...c))
      }, t[7] || (t[7] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/layerTop.png"
        }, null, -1),
        p("div", null, "Bring Forword", -1)
      ])),
      p("div", {
        class: "tool",
        onClick: t[4] || (t[4] = (...c) => a.handleBottom && a.handleBottom(...c))
      }, t[8] || (t[8] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/layerBottom.png"
        }, null, -1),
        p("div", null, "Sent Backword", -1)
      ]))
    ])
  ]);
}
const sD = /* @__PURE__ */ at(tD, [["render", rD], ["__scopeId", "data-v-0e27394e"]]), oD = {
  name: "NavigateFlip",
  data() {
    return {};
  },
  props: {
    isFlip: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleLengthways() {
      this.$emit("handleEdit", {
        isFlip: this.isFlip ? 0 : 1
      });
    },
    handleCrosswise() {
      this.$emit("handleEdit", {
        isFlip: this.isFlip ? 0 : 2
      });
    },
    handleClose() {
      this.$emit("close");
    }
  }
}, aD = { class: "dialog" }, lD = { class: "tools" };
function cD(e, t, n, s, o, a) {
  return O(), P("div", aD, [
    t[5] || (t[5] = p("div", { class: "title" }, "Flip", -1)),
    p("div", {
      class: "close",
      onClick: t[0] || (t[0] = (...c) => a.handleClose && a.handleClose(...c))
    }),
    p("div", lD, [
      p("div", {
        class: "tool",
        onClick: t[1] || (t[1] = (...c) => a.handleLengthways && a.handleLengthways(...c))
      }, t[3] || (t[3] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/flipLengthways.png"
        }, null, -1),
        p("div", null, "Horizontal", -1)
      ])),
      p("div", {
        class: "tool",
        onClick: t[2] || (t[2] = (...c) => a.handleCrosswise && a.handleCrosswise(...c))
      }, t[4] || (t[4] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/flipcrosswise.png"
        }, null, -1),
        p("div", null, "Vertical", -1)
      ]))
    ])
  ]);
}
const uD = /* @__PURE__ */ at(oD, [["render", cD], ["__scopeId", "data-v-3c767dd6"]]), fD = {
  name: "NavigateMove",
  data() {
    return {};
  },
  props: {
    layerList: {
      type: Array,
      default: []
    },
    currentLayerID: {
      type: [Number, String],
      default: ""
    }
  },
  methods: {
    handleUp() {
      for (let e = 0; e < I.size(this.layerList); e++)
        if (this.layerList[e].id === this.currentLayerID) {
          this.$emit("handleEdit", {
            itemY: this.layerList[e].itemY - 1
          });
          break;
        }
    },
    handleDown() {
      for (let e = 0; e < I.size(this.layerList); e++)
        if (this.layerList[e].id === this.currentLayerID) {
          this.$emit("handleEdit", {
            itemY: this.layerList[e].itemY + 1
          });
          break;
        }
    },
    handleLeft() {
      for (let e = 0; e < I.size(this.layerList); e++)
        if (this.layerList[e].id === this.currentLayerID) {
          this.$emit("handleEdit", {
            itemX: this.layerList[e].itemX - 1
          });
          break;
        }
    },
    handleRight() {
      for (let e = 0; e < I.size(this.layerList); e++)
        if (this.layerList[e].id === this.currentLayerID) {
          this.$emit("handleEdit", {
            itemX: this.layerList[e].itemX + 1
          });
          break;
        }
    },
    handleClose() {
      this.$emit("close");
    }
  }
}, dD = { class: "dialog" }, hD = { class: "tools" };
function pD(e, t, n, s, o, a) {
  return O(), P("div", dD, [
    t[9] || (t[9] = p("div", { class: "title" }, "Move", -1)),
    p("div", {
      class: "close",
      onClick: t[0] || (t[0] = (...c) => a.handleClose && a.handleClose(...c))
    }),
    p("div", hD, [
      p("div", {
        class: "tool",
        onClick: t[1] || (t[1] = (...c) => a.handleUp && a.handleUp(...c))
      }, t[5] || (t[5] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/moveUp.png"
        }, null, -1),
        p("div", null, "Top", -1)
      ])),
      p("div", {
        class: "tool",
        onClick: t[2] || (t[2] = (...c) => a.handleDown && a.handleDown(...c))
      }, t[6] || (t[6] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/moveDown.png"
        }, null, -1),
        p("div", null, "Bottom", -1)
      ])),
      p("div", {
        class: "tool",
        onClick: t[3] || (t[3] = (...c) => a.handleLeft && a.handleLeft(...c))
      }, t[7] || (t[7] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/moveLeft.png"
        }, null, -1),
        p("div", null, "Left", -1)
      ])),
      p("div", {
        class: "tool",
        onClick: t[4] || (t[4] = (...c) => a.handleRight && a.handleRight(...c))
      }, t[8] || (t[8] = [
        p("img", {
          class: "cover",
          src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/moveRight.png"
        }, null, -1),
        p("div", null, "Right", -1)
      ]))
    ])
  ]);
}
const gD = /* @__PURE__ */ at(fD, [["render", pD], ["__scopeId", "data-v-5ba9ec91"]]);
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */
function tp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function $o(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tp(Object(n), !0).forEach(function(s) {
      yD(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tp(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function mD(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function np(e, t) {
  for (var n = 0; n < t.length; n++) {
    var s = t[n];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, om(s.key), s);
  }
}
function vD(e, t, n) {
  return np(e.prototype, t), np(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function yD(e, t, n) {
  return t = om(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function oa() {
  return oa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, oa.apply(this, arguments);
}
function wD(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var s = n.call(e, t || "default");
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function om(e) {
  var t = wD(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var am = { exports: {} };
(function(e) {
  typeof window > "u" || function(t) {
    var n = t.HTMLCanvasElement && t.HTMLCanvasElement.prototype, s = t.Blob && function() {
      try {
        return !!new Blob();
      } catch {
        return !1;
      }
    }(), o = s && t.Uint8Array && function() {
      try {
        return new Blob([new Uint8Array(100)]).size === 100;
      } catch {
        return !1;
      }
    }(), a = t.BlobBuilder || t.WebKitBlobBuilder || t.MozBlobBuilder || t.MSBlobBuilder, c = /^data:((.*?)(;charset=.*?)?)(;base64)?,/, u = (s || a) && t.atob && t.ArrayBuffer && t.Uint8Array && function(d) {
      var h, m, v, b, S, D, A, R, F;
      if (h = d.match(c), !h)
        throw new Error("invalid data URI");
      for (m = h[2] ? h[1] : "text/plain" + (h[3] || ";charset=US-ASCII"), v = !!h[4], b = d.slice(h[0].length), v ? S = atob(b) : S = decodeURIComponent(b), D = new ArrayBuffer(S.length), A = new Uint8Array(D), R = 0; R < S.length; R += 1)
        A[R] = S.charCodeAt(R);
      return s ? new Blob([o ? A : D], {
        type: m
      }) : (F = new a(), F.append(D), F.getBlob(m));
    };
    t.HTMLCanvasElement && !n.toBlob && (n.mozGetAsFile ? n.toBlob = function(d, h, m) {
      var v = this;
      setTimeout(function() {
        m && n.toDataURL && u ? d(u(v.toDataURL(h, m))) : d(v.mozGetAsFile("blob", h));
      });
    } : n.toDataURL && u && (n.msToBlob ? n.toBlob = function(d, h, m) {
      var v = this;
      setTimeout(function() {
        (h && h !== "image/png" || m) && n.toDataURL && u ? d(u(v.toDataURL(h, m))) : d(v.msToBlob(h));
      });
    } : n.toBlob = function(d, h, m) {
      var v = this;
      setTimeout(function() {
        d(u(v.toDataURL(h, m)));
      });
    })), e.exports ? e.exports = u : t.dataURLtoBlob = u;
  }(window);
})(am);
var ip = am.exports, bD = function(t) {
  return typeof Blob > "u" ? !1 : t instanceof Blob || Object.prototype.toString.call(t) === "[object Blob]";
}, rp = {
  /**
   * Indicates if output the original image instead of the compressed one
   * when the size of the compressed image is greater than the original one's
   * @type {boolean}
   */
  strict: !0,
  /**
   * Indicates if read the image's Exif Orientation information,
   * and then rotate or flip the image automatically.
   * @type {boolean}
   */
  checkOrientation: !0,
  /**
   * Indicates if retain the image's Exif information after compressed.
   * @type {boolean}
  */
  retainExif: !1,
  /**
   * The max width of the output image.
   * @type {number}
   */
  maxWidth: 1 / 0,
  /**
   * The max height of the output image.
   * @type {number}
   */
  maxHeight: 1 / 0,
  /**
   * The min width of the output image.
   * @type {number}
   */
  minWidth: 0,
  /**
   * The min height of the output image.
   * @type {number}
   */
  minHeight: 0,
  /**
   * The width of the output image.
   * If not specified, the natural width of the source image will be used.
   * @type {number}
   */
  width: void 0,
  /**
   * The height of the output image.
   * If not specified, the natural height of the source image will be used.
   * @type {number}
   */
  height: void 0,
  /**
   * Sets how the size of the image should be resized to the container
   * specified by the `width` and `height` options.
   * @type {string}
   */
  resize: "none",
  /**
   * The quality of the output image.
   * It must be a number between `0` and `1`,
   * and only available for `image/jpeg` and `image/webp` images.
   * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
   * @type {number}
   */
  quality: 0.8,
  /**
   * The mime type of the output image.
   * By default, the original mime type of the source image file will be used.
   * @type {string}
   */
  mimeType: "auto",
  /**
   * Files whose file type is included in this list,
   * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
   * @type {string｜Array}
   */
  convertTypes: ["image/png"],
  /**
   * PNG files over this size (5 MB by default) will be converted to JPEGs.
   * To disable this, just set the value to `Infinity`.
   * @type {number}
   */
  convertSize: 5e6,
  /**
   * The hook function to execute before draw the image into the canvas for compression.
   * @type {Function}
   * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
   * @param {HTMLCanvasElement} canvas - The canvas for compression.
   * @example
   * function (context, canvas) {
   *   context.fillStyle = '#fff';
   * }
   */
  beforeDraw: null,
  /**
   * The hook function to execute after drew the image into the canvas for compression.
   * @type {Function}
   * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
   * @param {HTMLCanvasElement} canvas - The canvas for compression.
   * @example
   * function (context, canvas) {
   *   context.filter = 'grayscale(100%)';
   * }
   */
  drew: null,
  /**
   * The hook function to execute when success to compress the image.
   * @type {Function}
   * @param {File} file - The compressed image File object.
   * @example
   * function (file) {
   *   console.log(file);
   * }
   */
  success: null,
  /**
   * The hook function to execute when fail to compress the image.
   * @type {Function}
   * @param {Error} err - An Error object.
   * @example
   * function (err) {
   *   console.log(err.message);
   * }
   */
  error: null
}, xD = typeof window < "u" && typeof window.document < "u", Fi = xD ? window : {}, aa = function(t) {
  return t > 0 && t < 1 / 0;
}, _D = Array.prototype.slice;
function ou(e) {
  return Array.from ? Array.from(e) : _D.call(e);
}
var CD = /^image\/.+$/;
function kc(e) {
  return CD.test(e);
}
function SD(e) {
  var t = kc(e) ? e.substr(6) : "";
  return t === "jpeg" && (t = "jpg"), ".".concat(t);
}
var lm = String.fromCharCode;
function LD(e, t, n) {
  var s = "", o;
  for (n += t, o = t; o < n; o += 1)
    s += lm(e.getUint8(o));
  return s;
}
var DD = Fi.btoa;
function sp(e, t) {
  for (var n = [], s = 8192, o = new Uint8Array(e); o.length > 0; )
    n.push(lm.apply(null, ou(o.subarray(0, s)))), o = o.subarray(s);
  return "data:".concat(t, ";base64,").concat(DD(n.join("")));
}
function ID(e) {
  var t = new DataView(e), n;
  try {
    var s, o, a;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var c = t.byteLength, u = 2; u + 1 < c; ) {
        if (t.getUint8(u) === 255 && t.getUint8(u + 1) === 225) {
          o = u;
          break;
        }
        u += 1;
      }
    if (o) {
      var d = o + 4, h = o + 10;
      if (LD(t, d, 4) === "Exif") {
        var m = t.getUint16(h);
        if (s = m === 18761, (s || m === 19789) && t.getUint16(h + 2, s) === 42) {
          var v = t.getUint32(h + 4, s);
          v >= 8 && (a = h + v);
        }
      }
    }
    if (a) {
      var b = t.getUint16(a, s), S, D;
      for (D = 0; D < b; D += 1)
        if (S = a + D * 12 + 2, t.getUint16(S, s) === 274) {
          S += 8, n = t.getUint16(S, s), t.setUint16(S, 1, s);
          break;
        }
    }
  } catch {
    n = 1;
  }
  return n;
}
function ED(e) {
  var t = 0, n = 1, s = 1;
  switch (e) {
    case 2:
      n = -1;
      break;
    case 3:
      t = -180;
      break;
    case 4:
      s = -1;
      break;
    case 5:
      t = 90, s = -1;
      break;
    case 6:
      t = 90;
      break;
    case 7:
      t = 90, n = -1;
      break;
    case 8:
      t = -90;
      break;
  }
  return {
    rotate: t,
    scaleX: n,
    scaleY: s
  };
}
var TD = /\.\d*(?:0|9){12}\d*$/;
function op(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return TD.test(e) ? Math.round(e * t) / t : e;
}
function hs(e) {
  var t = e.aspectRatio, n = e.height, s = e.width, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none", a = aa(s), c = aa(n);
  if (a && c) {
    var u = n * t;
    (o === "contain" || o === "none") && u > s || o === "cover" && u < s ? n = s / t : s = n * t;
  } else a ? n = s / t : c && (s = n * t);
  return {
    width: s,
    height: n
  };
}
function kD(e) {
  for (var t = ou(new Uint8Array(e)), n = t.length, s = [], o = 0; o + 3 < n; ) {
    var a = t[o], c = t[o + 1];
    if (a === 255 && c === 218)
      break;
    if (a === 255 && c === 216)
      o += 2;
    else {
      var u = t[o + 2] * 256 + t[o + 3], d = o + u + 2, h = t.slice(o, d);
      s.push(h), o = d;
    }
  }
  return s.reduce(function(m, v) {
    return v[0] === 255 && v[1] === 225 ? m.concat(v) : m;
  }, []);
}
function RD(e, t) {
  var n = ou(new Uint8Array(e));
  if (n[2] !== 255 || n[3] !== 224)
    return e;
  var s = n[4] * 256 + n[5], o = [255, 216].concat(t, n.slice(4 + s));
  return new Uint8Array(o);
}
var OD = Fi.ArrayBuffer, oc = Fi.FileReader, Zi = Fi.URL || Fi.webkitURL, AD = /\.\w+$/, PD = Fi.Compressor, ND = /* @__PURE__ */ function() {
  function e(t, n) {
    mD(this, e), this.file = t, this.exif = [], this.image = new Image(), this.options = $o($o({}, rp), n), this.aborted = !1, this.result = null, this.init();
  }
  return vD(e, [{
    key: "init",
    value: function() {
      var n = this, s = this.file, o = this.options;
      if (!bD(s)) {
        this.fail(new Error("The first argument must be a File or Blob object."));
        return;
      }
      var a = s.type;
      if (!kc(a)) {
        this.fail(new Error("The first argument must be an image File or Blob object."));
        return;
      }
      if (!Zi || !oc) {
        this.fail(new Error("The current browser does not support image compression."));
        return;
      }
      OD || (o.checkOrientation = !1, o.retainExif = !1);
      var c = a === "image/jpeg", u = c && o.checkOrientation, d = c && o.retainExif;
      if (Zi && !u && !d)
        this.load({
          url: Zi.createObjectURL(s)
        });
      else {
        var h = new oc();
        this.reader = h, h.onload = function(m) {
          var v = m.target, b = v.result, S = {}, D = 1;
          u && (D = ID(b), D > 1 && oa(S, ED(D))), d && (n.exif = kD(b)), u || d ? !Zi || D > 1 ? S.url = sp(b, a) : S.url = Zi.createObjectURL(s) : S.url = b, n.load(S);
        }, h.onabort = function() {
          n.fail(new Error("Aborted to read the image with FileReader."));
        }, h.onerror = function() {
          n.fail(new Error("Failed to read the image with FileReader."));
        }, h.onloadend = function() {
          n.reader = null;
        }, u || d ? h.readAsArrayBuffer(s) : h.readAsDataURL(s);
      }
    }
  }, {
    key: "load",
    value: function(n) {
      var s = this, o = this.file, a = this.image;
      a.onload = function() {
        s.draw($o($o({}, n), {}, {
          naturalWidth: a.naturalWidth,
          naturalHeight: a.naturalHeight
        }));
      }, a.onabort = function() {
        s.fail(new Error("Aborted to load the image."));
      }, a.onerror = function() {
        s.fail(new Error("Failed to load the image."));
      }, Fi.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(Fi.navigator.userAgent) && (a.crossOrigin = "anonymous"), a.alt = o.name, a.src = n.url;
    }
  }, {
    key: "draw",
    value: function(n) {
      var s = this, o = n.naturalWidth, a = n.naturalHeight, c = n.rotate, u = c === void 0 ? 0 : c, d = n.scaleX, h = d === void 0 ? 1 : d, m = n.scaleY, v = m === void 0 ? 1 : m, b = this.file, S = this.image, D = this.options, A = document.createElement("canvas"), R = A.getContext("2d"), F = Math.abs(u) % 180 === 90, K = (D.resize === "contain" || D.resize === "cover") && aa(D.width) && aa(D.height), G = Math.max(D.maxWidth, 0) || 1 / 0, Y = Math.max(D.maxHeight, 0) || 1 / 0, re = Math.max(D.minWidth, 0) || 0, be = Math.max(D.minHeight, 0) || 0, ue = o / a, xe = D.width, Ee = D.height;
      if (F) {
        var lt = [Y, G];
        G = lt[0], Y = lt[1];
        var Z = [be, re];
        re = Z[0], be = Z[1];
        var kt = [Ee, xe];
        xe = kt[0], Ee = kt[1];
      }
      K && (ue = xe / Ee);
      var Ue = hs({
        aspectRatio: ue,
        width: G,
        height: Y
      }, "contain");
      G = Ue.width, Y = Ue.height;
      var Nt = hs({
        aspectRatio: ue,
        width: re,
        height: be
      }, "cover");
      if (re = Nt.width, be = Nt.height, K) {
        var ht = hs({
          aspectRatio: ue,
          width: xe,
          height: Ee
        }, D.resize);
        xe = ht.width, Ee = ht.height;
      } else {
        var Pe = hs({
          aspectRatio: ue,
          width: xe,
          height: Ee
        }), ke = Pe.width;
        xe = ke === void 0 ? o : ke;
        var Ce = Pe.height;
        Ee = Ce === void 0 ? a : Ce;
      }
      xe = Math.floor(op(Math.min(Math.max(xe, re), G))), Ee = Math.floor(op(Math.min(Math.max(Ee, be), Y)));
      var It = -xe / 2, yt = -Ee / 2, Je = xe, tt = Ee, ze = [];
      if (K) {
        var nt = 0, Rt = 0, wt = o, U = a, te = hs({
          aspectRatio: ue,
          width: o,
          height: a
        }, {
          contain: "cover",
          cover: "contain"
        }[D.resize]);
        wt = te.width, U = te.height, nt = (o - wt) / 2, Rt = (a - U) / 2, ze.push(nt, Rt, wt, U);
      }
      if (ze.push(It, yt, Je, tt), F) {
        var Q = [Ee, xe];
        xe = Q[0], Ee = Q[1];
      }
      A.width = xe, A.height = Ee, kc(D.mimeType) || (D.mimeType = b.type);
      var ae = "transparent";
      b.size > D.convertSize && D.convertTypes.indexOf(D.mimeType) >= 0 && (D.mimeType = "image/jpeg");
      var $e = D.mimeType === "image/jpeg";
      if ($e && (ae = "#fff"), R.fillStyle = ae, R.fillRect(0, 0, xe, Ee), D.beforeDraw && D.beforeDraw.call(this, R, A), !this.aborted && (R.save(), R.translate(xe / 2, Ee / 2), R.rotate(u * Math.PI / 180), R.scale(h, v), R.drawImage.apply(R, [S].concat(ze)), R.restore(), D.drew && D.drew.call(this, R, A), !this.aborted)) {
        var x = function(T) {
          if (!s.aborted) {
            var H = function(X) {
              return s.done({
                naturalWidth: o,
                naturalHeight: a,
                result: X
              });
            };
            if (T && $e && D.retainExif && s.exif && s.exif.length > 0) {
              var q = function(X) {
                return H(ip(sp(RD(X, s.exif), D.mimeType)));
              };
              if (T.arrayBuffer)
                T.arrayBuffer().then(q).catch(function() {
                  s.fail(new Error("Failed to read the compressed image with Blob.arrayBuffer()."));
                });
              else {
                var B = new oc();
                s.reader = B, B.onload = function(ee) {
                  var X = ee.target;
                  q(X.result);
                }, B.onabort = function() {
                  s.fail(new Error("Aborted to read the compressed image with FileReader."));
                }, B.onerror = function() {
                  s.fail(new Error("Failed to read the compressed image with FileReader."));
                }, B.onloadend = function() {
                  s.reader = null;
                }, B.readAsArrayBuffer(T);
              }
            } else
              H(T);
          }
        };
        A.toBlob ? A.toBlob(x, D.mimeType, D.quality) : x(ip(A.toDataURL(D.mimeType, D.quality)));
      }
    }
  }, {
    key: "done",
    value: function(n) {
      var s = n.naturalWidth, o = n.naturalHeight, a = n.result, c = this.file, u = this.image, d = this.options;
      if (Zi && u.src.indexOf("blob:") === 0 && Zi.revokeObjectURL(u.src), a)
        if (d.strict && !d.retainExif && a.size > c.size && d.mimeType === c.type && !(d.width > s || d.height > o || d.minWidth > s || d.minHeight > o || d.maxWidth < s || d.maxHeight < o))
          a = c;
        else {
          var h = /* @__PURE__ */ new Date();
          a.lastModified = h.getTime(), a.lastModifiedDate = h, a.name = c.name, a.name && a.type !== c.type && (a.name = a.name.replace(AD, SD(a.type)));
        }
      else
        a = c;
      this.result = a, d.success && d.success.call(this, a);
    }
  }, {
    key: "fail",
    value: function(n) {
      var s = this.options;
      if (s.error)
        s.error.call(this, n);
      else
        throw n;
    }
  }, {
    key: "abort",
    value: function() {
      this.aborted || (this.aborted = !0, this.reader ? this.reader.abort() : this.image.complete ? this.fail(new Error("The compression process has been aborted.")) : (this.image.onload = null, this.image.onabort()));
    }
    /**
     * Get the no conflict compressor class.
     * @returns {Compressor} The compressor class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Compressor = PD, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(n) {
      oa(rp, n);
    }
  }]), e;
}();
const MD = {
  name: "NavigateBottom",
  components: {
    NavigateLayers: sD,
    NavigateFlip: uD,
    NavigateMove: gD
  },
  props: {
    layerList: {
      type: Array,
      default: []
    },
    currentLayerID: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      isShowNavigateLayers: !1,
      isShowNavigateFlip: !1,
      isShowNavigateMove: !1,
      domain: ru,
      ossCdnDmain: Ct,
      uploadLoading: !1
    };
  },
  computed: {
    layerType() {
      if (this.currentLayerID && I.size(this.layerList)) {
        for (let e = 0; e < I.size(this.layerList); e++)
          if (this.layerList[e].id === this.currentLayerID)
            return this.layerList[e].itemType;
      }
      return 0;
    },
    isFlip() {
      if (this.currentLayerID && I.size(this.layerList)) {
        for (let e = 0; e < I.size(this.layerList); e++)
          if (this.layerList[e].id === this.currentLayerID)
            return this.layerList[e].isFlip;
      }
      return 0;
    }
  },
  methods: {
    handleRescouce() {
      this.$emit("handleRescouce");
    },
    handleTemplates() {
      this.$emit("handleTemplates");
    },
    handleFont() {
      this.$emit("handleFont");
    },
    handleUpload(e) {
      var n;
      const t = (n = e.target) == null ? void 0 : n.files[0];
      if (this.$emit("handleShowLoading"), this.uploadLoading = !0, t) {
        const s = zr(t.name), o = this;
        new ND(t, {
          quality: 0.6,
          // The compression process is asynchronous,
          // which means you have to access the `result` in the `success` hook function.
          async success(a) {
            const c = await eD(a, `${(/* @__PURE__ */ new Date()).getTime()}.${s}`, "user");
            c ? o.$emit("handleImageLayer", c) : o.$emit("handleHideLoading");
          },
          error(a) {
            console.log(a.message), o.$emit("handleHideLoading");
          }
        });
      } else
        this.$emit("handleHideLoading");
      this.uploadLoading = !1;
    },
    handleLayers() {
      this.isShowNavigateLayers = !0;
    },
    handleCloseLayers() {
      this.isShowNavigateLayers = !1;
    },
    handleFlip() {
      this.isShowNavigateFlip = !0;
    },
    handleCloseFlip() {
      this.isShowNavigateFlip = !1;
    },
    handleMove() {
      this.isShowNavigateMove = !0;
    },
    handleCloseMove() {
      this.isShowNavigateMove = !1;
    },
    handleEdit(e) {
      this.$emit("handleEdit", {
        id: this.currentLayerID,
        param: e
      });
    }
  }
}, BD = {
  key: 0,
  class: "navigates"
}, FD = { class: "navigate" }, $D = ["src"], HD = ["src"], UD = ["src"], zD = ["src"], WD = {
  key: 1,
  class: "navigates"
}, qD = ["src"], jD = ["src"], VD = ["src"], GD = {
  key: 2,
  class: "navigates"
}, KD = ["src"], YD = ["src"], XD = { class: "navigate" }, JD = ["src"], ZD = ["src"];
function QD(e, t, n, s, o, a) {
  const c = Ve("NavigateLayers"), u = Ve("NavigateFlip"), d = Ve("NavigateMove");
  return O(), P("div", {
    onTouchstart: t[11] || (t[11] = (h) => {
      h.stopPropagation();
    }),
    onMousedown: t[12] || (t[12] = (h) => {
      h.stopPropagation();
    })
  }, [
    a.layerType === 2 ? (O(), P("div", BD, [
      p("div", FD, [
        p("img", {
          src: o.ossCdnDmain + "/assets/upload.png"
        }, null, 8, $D),
        t[13] || (t[13] = p("div", null, "upload", -1)),
        o.uploadLoading ? le("", !0) : (O(), P("input", {
          key: 0,
          onChange: t[0] || (t[0] = (...h) => a.handleUpload && a.handleUpload(...h)),
          class: "upload-btn",
          type: "file",
          accept: "image/*"
        }, null, 32))
      ]),
      p("div", {
        class: "navigate",
        onClick: t[1] || (t[1] = (...h) => a.handleLayers && a.handleLayers(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/layer.png"
        }, null, 8, HD),
        t[14] || (t[14] = p("div", null, "layer", -1))
      ]),
      p("div", {
        class: "navigate",
        onClick: t[2] || (t[2] = (...h) => a.handleFlip && a.handleFlip(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/flip.png"
        }, null, 8, UD),
        t[15] || (t[15] = p("div", null, "flip", -1))
      ]),
      p("div", {
        class: "navigate",
        onClick: t[3] || (t[3] = (...h) => a.handleMove && a.handleMove(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/move.png"
        }, null, 8, zD),
        t[16] || (t[16] = p("div", null, "move", -1))
      ])
    ])) : a.layerType === 1 ? (O(), P("div", WD, [
      p("div", {
        class: "navigate",
        onClick: t[4] || (t[4] = (...h) => a.handleLayers && a.handleLayers(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/layer.png"
        }, null, 8, qD),
        t[17] || (t[17] = p("div", null, "layer", -1))
      ]),
      p("div", {
        class: "navigate",
        onClick: t[5] || (t[5] = (...h) => a.handleFlip && a.handleFlip(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/flip.png"
        }, null, 8, jD),
        t[18] || (t[18] = p("div", null, "flip", -1))
      ]),
      p("div", {
        class: "navigate",
        onClick: t[6] || (t[6] = (...h) => a.handleMove && a.handleMove(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/move.png"
        }, null, 8, VD),
        t[19] || (t[19] = p("div", null, "move", -1))
      ])
    ])) : (O(), P("div", GD, [
      p("div", {
        class: "navigate",
        onClick: t[7] || (t[7] = (...h) => a.handleRescouce && a.handleRescouce(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/sticker.png"
        }, null, 8, KD),
        t[20] || (t[20] = p("div", null, "sticker", -1))
      ]),
      p("div", {
        class: "navigate",
        onClick: t[8] || (t[8] = (...h) => a.handleFont && a.handleFont(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/text.png"
        }, null, 8, YD),
        t[21] || (t[21] = p("div", null, "text", -1))
      ]),
      p("div", XD, [
        p("img", {
          src: o.ossCdnDmain + "/assets/upload.png"
        }, null, 8, JD),
        t[22] || (t[22] = p("div", null, "upload", -1)),
        o.uploadLoading ? le("", !0) : (O(), P("input", {
          key: 0,
          onChange: t[9] || (t[9] = (...h) => a.handleUpload && a.handleUpload(...h)),
          class: "upload-btn",
          type: "file",
          accept: "image/*"
        }, null, 32))
      ]),
      p("div", {
        class: "navigate",
        onClick: t[10] || (t[10] = (...h) => a.handleTemplates && a.handleTemplates(...h))
      }, [
        p("img", {
          src: o.ossCdnDmain + "/assets/temp.png"
        }, null, 8, ZD),
        t[23] || (t[23] = p("div", null, "Templates", -1))
      ])
    ])),
    o.isShowNavigateLayers ? (O(), fn(c, {
      key: 3,
      currentLayerID: n.currentLayerID,
      layerList: n.layerList,
      onHandleEdit: a.handleEdit,
      onClose: a.handleCloseLayers
    }, null, 8, ["currentLayerID", "layerList", "onHandleEdit", "onClose"])) : le("", !0),
    o.isShowNavigateFlip ? (O(), fn(u, {
      key: 4,
      isFlip: a.isFlip,
      onHandleEdit: a.handleEdit,
      onClose: a.handleCloseFlip
    }, null, 8, ["isFlip", "onHandleEdit", "onClose"])) : le("", !0),
    o.isShowNavigateMove ? (O(), fn(d, {
      key: 5,
      currentLayerID: n.currentLayerID,
      layerList: n.layerList,
      onHandleEdit: a.handleEdit,
      onClose: a.handleCloseMove
    }, null, 8, ["currentLayerID", "layerList", "onHandleEdit", "onClose"])) : le("", !0)
  ], 32);
}
const eI = /* @__PURE__ */ at(MD, [["render", QD], ["__scopeId", "data-v-114b478c"]]), Ps = /* @__PURE__ */ new Map();
window.imageMap = Ps;
async function Rc(e) {
  const t = [];
  for (let n = 0; n < e.length; n++)
    window.imageMap.get(e[n]) || t.push(e[n]);
  if (t.length)
    for (let n = 0; n < t.length; n++)
      await tI(t[n]);
}
async function tI(e) {
  const t = document.createElement("img");
  return t.crossOrigin = "anonymous", new Promise((n) => {
    t.onload = () => {
      window.imageMap.set(e, t), n();
    }, t.onerror = () => {
      window.imageMap.set(e, ""), console.error(`加载图片出错:${e}`), n();
    }, t.src = `${e}?t=${(/* @__PURE__ */ new Date()).getTime()}`;
  });
}
const nI = {
  name: "CanvasPrint",
  components: {
    CanvasView: su
  },
  data() {
    return {
      canvasContext: null,
      width: 0,
      height: 0
    };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    init() {
      const e = this.$refs.canvasElement;
      this.canvasContext = e.getContext("2d");
    },
    async drawCanvas(e, t, n = 1) {
      if (I.has(t, "material"))
        this.width = I.get(t, "material.width", 0) * n, this.height = I.get(t, "material.height", 0) * n;
      else
        return;
      if (this.canvasContext && (this.canvasContext.clearRect(0, 0, this.width, this.height), this.canvasContext.drawImage(e, 0, 0, this.width, this.height)), I.has(t, "material")) {
        const s = I.get(t, "material.width", 0) * n, o = I.get(t, "material.height", 0) * n, a = I.get(t, "material.url", "");
        s && o && a && (await Rc([a]), this.drawMaterialImage({
          materialUrl: a,
          materialWidth: s,
          materialHeight: o
        }));
      }
      if (I.has(t, "background")) {
        const s = I.get(t, "background.width", 0) * n, o = I.get(t, "background.height", 0) * n, a = I.get(t, "background.url", "");
        s && o && a && (await Rc([a]), this.drawBackImage({
          backgroundUrl: a,
          backgroundWidth: s,
          backgroundHeight: o
        }));
      }
    },
    drawMaterialImage: function({
      materialUrl: e,
      materialWidth: t,
      materialHeight: n
    }) {
      if (this.canvasContext) {
        const s = Ps.get(e);
        s ? (this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(s, 0, 0, t, n), this.canvasContext.restore()) : console.error("材质图片绘制异常", e);
      }
    },
    drawBackImage: function({
      backgroundUrl: e,
      backgroundWidth: t,
      backgroundHeight: n
    }) {
      if (this.canvasContext) {
        const s = Ps.get(e);
        s ? (this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(s, 0, 0, t, n), this.canvasContext.restore()) : console.error("型号图片绘制异常", e);
      }
    },
    getCanvasRef: function() {
      return this.$refs.canvasElement;
    }
  }
}, iI = ["width", "height"];
function rI(e, t, n, s, o, a) {
  const c = Ve("CanvasView");
  return O(), P("div", null, [
    _e(c, {
      width: o.width,
      height: o.height
    }, {
      default: vt(() => [
        p("canvas", {
          width: o.width,
          height: o.height,
          ref: "canvasElement"
        }, null, 8, iI)
      ]),
      _: 1
    }, 8, ["width", "height"])
  ]);
}
const sI = /* @__PURE__ */ at(nI, [["render", rI]]);
class oI {
  constructor() {
    wn(this, "fontSize", 24);
    wn(this, "fontFamily", "SimSun");
    wn(this, "text", "");
    wn(this, "textAlign", "left");
    wn(this, "fontColor", "");
    wn(this, "x", 0);
    wn(this, "y", 0);
    wn(this, "width", 0);
    wn(this, "height", 0);
    wn(this, "isBold", !1);
    wn(this, "isItalic", !1);
    wn(this, "isLineThrough", !1);
  }
}
function aI(e, t) {
  const n = new oI();
  Object.assign(n, t), t.fontColor.length > 0 && (e.fillStyle = t.fontColor);
  let s = t.isBold ? "bold " : "", o = t.isItalic ? "italic " : "";
  e.font = o + s + parseInt(t.fontSize) + "px " + t.fontFamily, e.textAlign = t.textAlign;
  const a = t.text.split(`
`);
  for (let c = 0; c < a.length; c++)
    lI(e, a[c], c, t);
}
function lI(e, t, n, s) {
  const o = e.measureText(t), a = n * s.fontSize, c = s.y + a;
  let u = s.x;
  switch (s.textAlign) {
    case "right":
      u += s.width;
      break;
    case "center":
      u += s.width / 2;
      break;
  }
  if (e.textBaseline = "top", e.fillText(t, u, c), s.isLineThrough) {
    e.beginPath();
    const d = o.width;
    let h = s.x, m = s.fontSize * 0.08;
    switch (s.textAlign) {
      case "right":
        h += s.width - d;
        break;
      case "center":
        h += (s.width - d) / 2;
        break;
    }
    e.rect(h, c + s.fontSize / 2 - m / 2, d, m), e.fill();
  }
}
const cm = /* @__PURE__ */ new Map();
window.textMap = cm;
async function cI(e) {
  const t = [];
  for (let s = 0; s < e.length; s++)
    e[s] && !window.textMap.get(e[s]) && t.push(e[s]);
  if (!t.length)
    return;
  const n = await fI(t);
  for (let s = 0; s < n.length; s++) {
    const o = n[s].flag, a = n[s].fontUrl;
    await uI(o, a), cm.set(o, a);
  }
}
async function uI(e, t) {
  return new Promise((n) => {
    new FontFace(e, `url(${t})`).load().then((o) => {
      document.fonts.add(o);
    }).then(() => {
      n();
    });
  });
}
function fI(e) {
  const t = e.join(",");
  return new Promise((n, s) => {
    u6({
      param: {
        flag: t
      },
      success: (o) => {
        n(o);
      },
      error: () => {
        s(new Error("获取字体失败"));
      }
    });
  });
}
const dI = {
  name: "CanvasPrint",
  components: {
    CanvasView: su
  },
  data() {
    return {
      canvasContext: null,
      width: 0,
      height: 0
    };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    init() {
      const e = this.$refs.canvasElement;
      this.canvasContext = e.getContext("2d");
    },
    async drawCanvas({ options: e, originOptions: t, maskUrl: n, layerList: s, canvasScale: o = 1 }) {
      let a;
      if (I.has(e, "material"))
        this.width = I.get(e, "material.width", 0) * o, this.height = I.get(e, "material.height", 0) * o, this.canvasContext.clearRect(0, 0, this.width, this.height), a = document.createElement("canvas"), a.width = this.width, a.height = this.height;
      else
        return !1;
      const c = this.parseLayerList(s), u = [], d = [];
      for (let v = 0; v < c.length; v++)
        c[v].itemType === 1 ? d.push(c[v].fontFamily) : u.push(c[v].itemData);
      u.push(n), await Rc(u), await cI(d);
      const h = a.getContext("2d");
      let m = this.drawLayersByCrosswise(h, e, t, c, o);
      return this.drawMask(h, n, e, o), this.canvasContext.drawImage(a, 0, 0, this.width, this.height), m;
    },
    parseLayerList: function(e) {
      let t = [], n = {}, s = [];
      for (let o = 0; o < e.length; o++) {
        let a = e[o];
        if (!a)
          continue;
        let c = parseInt(a.zIndex);
        n[c] || (n[c] = [], s.push(c)), n[c].push(a);
      }
      s.sort(function(o, a) {
        return o - a;
      });
      for (let o = 0; o < s.length; o++) {
        let a = s[o], c = n[a];
        t.push.apply(t, c);
      }
      return t;
    },
    drawLayersByCrosswise: function(e, t, n, s, o = 1) {
      let a = !0;
      e.globalCompositeOperation = "source-over";
      let c = 1;
      const u = I.get(t, "mask.width", 0);
      I.get(t, "mask.height", 0);
      const d = I.get(t, "mask.gapLeft", 0), h = I.get(t, "mask.gapRight", 0), m = I.get(t, "mask.gapTop", 0);
      I.get(t, "mask.gapBottom", 0);
      const v = I.get(n, "mask.width", 0);
      I.get(n, "mask.height", 0);
      const b = I.get(n, "mask.gapLeft", 0), S = I.get(n, "mask.gapRight", 0), D = I.get(n, "mask.gapTop", 0);
      I.get(n, "mask.gapBottom", 0), v && u && (c = (u - d - h) / (v - b - S));
      for (let A = 0; A < s.length; A++) {
        let R = s[A];
        if (!R)
          continue;
        e.save();
        let F = parseInt(R.itemType), K = R.itemData, G = parseFloat(R.itemW), Y = parseFloat(R.itemH), re = parseFloat(R.itemX), be = parseFloat(R.itemY), ue = parseFloat(R.rotate), xe = parseFloat(R.scaleNum), Ee = parseFloat(R.opacity), lt = parseInt(R.isFlip), Z = R.textAlign, kt = R.fontBold || !1, Ue = R.fontItalic || !1, Nt = R.fontLineThrough || !1, ht = Ps.get(K);
        if (Ee || (Ee = 1), xe < 0) {
          const ze = G + re * 2, nt = Y + be * 2;
          e.translate(ze, nt), e.scale(-1, -1);
        }
        e.globalAlpha = Ee;
        let Pe = Math.abs(xe), ke = G, Ce = Y;
        if (F === 2) {
          if (Pe > 1) {
            let ze = ke * (Pe - 1) / 2, nt = Ce * (Pe - 1) / 2;
            re -= ze, be -= nt;
          } else if (Pe < 1) {
            let ze = ke * (1 - Pe) / 2, nt = Ce * (1 - Pe) / 2;
            re += ze, be += nt;
          }
          G = G * Pe, Y = Y * Pe;
        }
        const It = (re - b) * c + d, yt = (be - D) * c + m, Je = G * c, tt = Y * c;
        if (ue !== 0) {
          let ze = (It + Je / 2) * o, nt = (yt + tt / 2) * o;
          e.translate(ze, nt), e.rotate(ue * Math.PI / 180), e.translate(ze * -1, nt * -1);
        }
        if (lt === 1 || lt === 2) {
          let ze = 0;
          lt === 1 ? (ze = Je + It * 2, e.translate(ze, 0), e.scale(-1, 1)) : (ze = tt + yt * 2, e.translate(0, ze), e.scale(1, -1));
        }
        if (F === 1) {
          let ze = R.fontFamily;
          ze || (ze = "SimSun");
          let nt = R.fontColor;
          nt || (nt = "blue");
          let Rt = 24;
          Rt = Rt * Pe, aI(e, {
            text: K,
            x: It * o,
            y: yt * o,
            width: Je * o,
            height: tt * o,
            fontColor: nt,
            fontFamily: ze,
            fontSize: Rt,
            textAlign: Z,
            isBold: kt,
            isItalic: Ue,
            isLineThrough: Nt
          });
        } else F === 2 && (ht ? e.drawImage(
          ht,
          It * o,
          yt * o,
          Je * o,
          tt * o
        ) : a = !1);
        e.restore();
      }
      return e.restore(), a;
    },
    drawMask: function(e, t, n, s = 1) {
      if (!t)
        return;
      const o = I.get(n, "mask.width", 0) * s, a = I.get(n, "mask.height", 0) * s, c = Ps.get(t);
      c && (e.globalCompositeOperation = "destination-in", e.drawImage(c, 0, 0, o, a), e.globalCompositeOperation = "source-over", e.restore());
    },
    getCanvasRef: function() {
      return this.$refs.canvasElement;
    },
    getImageBlob: async function() {
      return new Promise((e) => {
        this.$refs.canvasElement.toBlob((t) => {
          e(t);
        });
      });
    }
  }
}, hI = { class: "canvasPrint" }, pI = ["width", "height"];
function gI(e, t, n, s, o, a) {
  const c = Ve("CanvasView");
  return O(), P("div", hI, [
    _e(c, {
      width: o.width,
      height: o.height
    }, {
      default: vt(() => [
        p("canvas", {
          width: o.width,
          height: o.height,
          ref: "canvasElement"
        }, null, 8, pI)
      ]),
      _: 1
    }, 8, ["width", "height"])
  ]);
}
const mI = /* @__PURE__ */ at(dI, [["render", gI], ["__scopeId", "data-v-9b61dc3d"]]);
function mt(e) {
  const t = new RegExp("(^|&)" + e + "=([^&]*)(&|$)", "i"), n = window.location.search.substr(1).match(t);
  return n != null ? unescape(n[2]) : null;
}
function vI(e, t, n) {
  let s = Math.atan2(t.y - e.y, t.x - e.x) * 180 / Math.PI, o = Math.atan2(n.y - e.y, n.x - e.x) * 180 / Math.PI, a;
  return s = s <= -90 ? 360 + s : s, o = o <= -90 ? 360 + o : o, a = Math.floor(o - s), a = a < 0 ? a + 360 : a, a;
}
let ap = 0;
function lp(e, t) {
  const n = (/* @__PURE__ */ new Date()).getTime();
  n - ap > t && (e(), ap = n);
}
let di = null;
function yI(e, t, n, s, o) {
  var a = o * Math.PI / 180, c = n - e, u = s - t, d = e + (c * Math.cos(a) - u * Math.sin(a)), h = t + (c * Math.sin(a) + u * Math.cos(a));
  return { x: d, y: h };
}
const wI = {
  name: "CanvasHandles",
  props: {
    width: {
      type: [Number, String],
      default: 375
    },
    height: {
      type: [Number, String],
      default: 667
    },
    layerList: {
      type: Array,
      default: []
    },
    canvasScale: {
      type: Number,
      default: 1
    },
    currentLayerID: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      ossCdnDmain: Ct
    };
  },
  computed: {
    layers: function() {
      return I.sortBy(this.layerList, (e) => e.zIndex);
    },
    viewStyle: function() {
      const e = Xn / this.width;
      return `width:${this.width * e}px;height:${this.height * e}px;`;
    },
    currentLayer: function() {
      return I.find(this.layerList, (e) => Number(e.id) === Number(this.currentLayerID));
    },
    rotateStyle: function() {
      const t = I.find(this.layerList, (d) => Number(d.id) === Number(this.currentLayerID)), n = I.get(t, "scaleNum", 1), s = I.get(t, "rotate", 0), o = Number(I.get(t, "itemW", 0)), a = Number(I.get(t, "itemH", 0));
      let c = Number(I.get(t, "itemX", 0)) / n - (o - o / n) / 2 + o / 2 - 32 / 2, u = Number(I.get(t, "itemY", 0)) / n - (a - a / n) / 2 + a + 32;
      if (s > 0) {
        const d = {
          x: Number(I.get(t, "itemX", 0)) / n - (o - o / n) / 2 + o / 2,
          y: Number(I.get(t, "itemY", 0)) / n - (a - a / n) / 2 + a / 2
        }, h = yI(d.x, d.y, c, u, s);
        c = h.x, u = h.y;
      }
      return `background-image: url('${Ct}/assets/route.png');left:${c}px;top:${u}px;transform:rotate(${s}deg)`;
    }
  },
  mounted: function() {
    document.addEventListener("touchmove", (e) => {
      lp(() => {
        if (e && e.changedTouches && I.size(e.changedTouches)) {
          const t = e.changedTouches[0];
          di && di({
            clientX: t.clientX,
            clientY: t.clientY
          });
        }
      }, 50);
    }), document.addEventListener("mousemove", (e) => {
      di && lp(() => {
        di({
          clientX: e.clientX,
          clientY: e.clientY
        });
      }, 50);
    }), document.addEventListener("touchend", () => {
      di = null;
    }), document.addEventListener("mouseup", () => {
      di = null;
    });
  },
  methods: {
    parseLayerWidth(e) {
      const t = Xn / this.width;
      return e.itemW * t;
    },
    parseLayerHeight(e) {
      const t = Xn / this.width;
      return e.itemH * t;
    },
    parseLayerStyle(e) {
      const t = Xn / this.width, n = this.parseLayerWidth(e) * this.canvasScale, s = this.parseLayerHeight(e) * this.canvasScale, o = e.itemX * t * this.canvasScale, a = e.itemY * t * this.canvasScale;
      return `left:${o}px;top:${a}px;width:${n}px;height:${s}px;transform: scale(${e.scaleNum}) rotate(${e.rotate}deg);`;
    },
    handleLayer(e) {
      this.$emit("handleLayer", e);
    },
    handleDelete(e) {
      this.$emit("handleDelete", e);
    },
    handleCopy(e) {
      this.$emit("handleCopy", e);
    },
    handleReplace(e) {
      this.$emit("handleReplace", e);
    },
    handleMove(e, t) {
      const n = this.width / Xn;
      if (t) {
        const s = I.cloneDeep(t);
        di = ({ clientX: o, clientY: a }) => {
          const c = (o - e.clientX) * n / this.canvasScale, u = (a - e.clientY) * n / this.canvasScale;
          this.$emit("handleEdit", {
            id: I.get(s, "id", 0),
            param: {
              itemX: I.get(s, "itemX", 0) + c,
              itemY: I.get(s, "itemY", 0) + u
            }
          });
        };
      }
    },
    handleTouchMove(e, t) {
      if (e && e.changedTouches && I.size(e.changedTouches)) {
        const n = e.changedTouches[0];
        this.handleMove(n, t);
      }
    },
    handleScale(e, t) {
      const n = this.width / Xn;
      if (t) {
        const s = I.cloneDeep(t), { itemW: o, scaleNum: a } = s;
        di = ({ clientX: c, clientY: u }) => {
          const d = (c - e.clientX) / this.canvasScale, h = (u - e.clientY) / this.canvasScale, m = Math.max(d, h), v = o * a, S = Math.max(v + m * n * 2, 20) / v * a;
          this.$emit("handleEdit", {
            id: I.get(s, "id", 0),
            param: {
              scaleNum: S
            }
          });
        };
      }
    },
    handleTouchScale(e, t) {
      if (e && e.changedTouches && I.size(e.changedTouches)) {
        const n = e.changedTouches[0];
        this.handleScale(n, t);
      }
    },
    handleRotate(e, t) {
      const n = this.$refs.canvasHandlesEl;
      let s, o;
      if (n) {
        const a = n.getBoundingClientRect();
        s = a.left, o = a.top;
      } else
        return;
      if (t) {
        const a = I.cloneDeep(t), { itemW: c, itemH: u, itemX: d, itemY: h, scaleNum: m } = a;
        di = ({ clientX: v, clientY: b }) => {
          const S = {
            x: s + (d + c / 2) / m,
            y: o + (h + u / 2) / m
          }, A = vI(S, {
            x: e.clientX,
            y: e.clientY
          }, {
            x: v,
            y: b
          }) + I.get(a, "rotate", 0);
          this.$emit("handleEdit", {
            id: I.get(a, "id", 0),
            param: {
              rotate: A < 0 ? A + 360 : A
            }
          });
        };
      }
    },
    handleTouchRotate(e, t) {
      if (e && e.changedTouches && I.size(e.changedTouches)) {
        const n = e.changedTouches[0];
        this.handleRotate(n, t);
      }
    }
  }
}, bI = ["onClick"], xI = ["onMousedown", "onTouchstart"], _I = ["onClick"], CI = ["onClick"], SI = ["onClick"], LI = ["onMousedown", "onTouchstart"];
function DI(e, t, n, s, o, a) {
  return O(), P("div", {
    id: "canvasHandles",
    ref: "canvasHandlesEl",
    class: "layers",
    style: Lt(a.viewStyle),
    onClick: t[2] || (t[2] = (c) => {
      c.stopPropagation();
    })
  }, [
    (O(!0), P(Ae, null, ut(a.layers, (c) => (O(), P("div", {
      class: _t(["layer", { current: c.id === n.currentLayerID }]),
      style: Lt(a.parseLayerStyle(c)),
      onClick: (u) => {
        u.stopPropagation(), this.handleLayer(c.id);
      }
    }, [
      p("div", {
        class: "border-item",
        style: Lt(`transform: scale(${1 / c.scaleNum});width:${c.scaleNum * 100}%;height:${c.scaleNum * 100}%`)
      }, null, 4),
      c.id === n.currentLayerID ? (O(), P("div", {
        key: 0,
        class: "panel",
        onMousedown: (u) => {
          u.stopPropagation(), this.handleMove(u, c);
        },
        onTouchstart: (u) => {
          u.stopPropagation(), this.handleTouchMove(u, c);
        }
      }, [
        p("div", {
          class: "delete",
          style: Lt(`transform: scale(${1 / c.scaleNum}) translate(-50%, -50%);background-image: url('${o.ossCdnDmain}/assets/delete.png')`),
          onClick: (u) => {
            u.stopPropagation(), this.handleDelete(c.id);
          }
        }, null, 12, _I),
        p("div", {
          class: "copy",
          style: Lt(`transform: scale(${1 / c.scaleNum}) translate(-50%, 50%);background-image: url('${o.ossCdnDmain}/assets/copy.png')`),
          onClick: (u) => {
            u.stopPropagation(), this.handleCopy(c.id);
          }
        }, null, 12, CI),
        p("div", {
          class: "replace",
          style: Lt(`transform: scale(${1 / c.scaleNum}) translate(50%, -50%);background-image: url('${o.ossCdnDmain}/assets/change.png')`),
          onClick: (u) => {
            u.stopPropagation(), this.handleReplace(c.id);
          }
        }, null, 12, SI),
        p("div", {
          class: "scale",
          style: Lt(`transform: scale(${1 / c.scaleNum}) translate(50%, 50%);background-image: url('${o.ossCdnDmain}/assets/zoon.png')`),
          onMousedown: (u) => {
            u.stopPropagation(), this.handleScale(u, c);
          },
          onTouchstart: (u) => {
            u.stopPropagation(), this.handleTouchScale(u, c);
          }
        }, null, 44, LI)
      ], 40, xI)) : le("", !0)
    ], 14, bI))), 256)),
    n.currentLayerID ? (O(), P("div", {
      key: 0,
      class: "rotate",
      style: Lt(a.rotateStyle),
      onMousedown: t[0] || (t[0] = (c) => {
        c.stopPropagation(), this.handleRotate(c, this.currentLayer);
      }),
      onTouchstart: t[1] || (t[1] = (c) => {
        c.stopPropagation(), this.handleTouchRotate(c, this.currentLayer);
      })
    }, null, 36)) : le("", !0)
  ], 4);
}
const II = /* @__PURE__ */ at(wI, [["render", DI], ["__scopeId", "data-v-d50059e2"]]);
function EI(e, t) {
  if (t) {
    const n = I.get(e, "material.width", 0), s = I.get(e, "material.height", 0), o = Math.max(n, s);
    if (o > 1800)
      return 1800 / o;
  }
  return 1;
}
const TI = {
  name: "CanvasMobile",
  components: {
    CanvasCover: sI,
    CanvasPrint: mI,
    CanvasHandles: II
  },
  data() {
    return {
      layerList: [],
      currentLayerID: 0,
      canvasScale: 1,
      width: 0,
      height: 0
    };
  },
  methods: {
    async drawCanvas({ options: e, originOptions: t, layerList: n, currentLayerID: s, isMini: o = !0 }) {
      var c, u, d;
      const a = EI(e, o);
      if (this.canvasScale = a, this.layerList = n, this.currentLayerID = s, I.has(e, "material") && (this.width = I.get(e, "material.width", 0) * a, this.height = I.get(e, "material.height", 0) * a), I.has(e, "mask")) {
        const h = I.get(e, "mask.designUrl", "");
        await ((c = this.$refs.canvasDesign) == null ? void 0 : c.drawCanvas({
          maskUrl: h,
          options: e,
          originOptions: t,
          layerList: n,
          canvasScale: a
        }));
        const m = (u = this.$refs.canvasDesign) == null ? void 0 : u.getCanvasRef();
        await ((d = this.$refs.canvasCover) == null ? void 0 : d.drawCanvas(m, e, a));
      }
    },
    async drawPrintCanvas({ options: e, originOptions: t, layerList: n, isMini: s = !0 }) {
      var o;
      if (I.has(e, "material") && (this.width = I.get(e, "material.width", 0), this.height = I.get(e, "material.height", 0)), I.has(e, "mask")) {
        const a = I.get(e, "mask.printUrl", "");
        await ((o = this.$refs.canvasPrint) == null ? void 0 : o.drawCanvas({
          maskUrl: a,
          options: e,
          originOptions: t,
          layerList: n,
          canvasScale: 1
        }));
      }
    },
    handleLayer(e) {
      this.$emit("handleLayer", e);
    },
    handleDelete(e) {
      this.$emit("handleDelete", e);
    },
    handleCopy(e) {
      this.$emit("handleCopy", e);
    },
    handleReplace(e) {
      this.$emit("handleReplace", e);
    },
    handleEdit(e) {
      this.$emit("handleEdit", e);
    },
    getCanvasRef() {
      var e;
      return (e = this.$refs.canvasDesign) == null ? void 0 : e.getCanvasRef();
    },
    getCoverCanvas() {
      var e;
      return (e = this.$refs.canvasCover) == null ? void 0 : e.getCanvasRef();
    },
    async getImageBlob() {
      var e;
      return await ((e = this.$refs.canvasDesign) == null ? void 0 : e.getImageBlob());
    },
    getPrintCanvasRef() {
      var e;
      return (e = this.$refs.canvasPrint) == null ? void 0 : e.getCanvasRef();
    },
    async getPrintImageBlob() {
      var e;
      return await ((e = this.$refs.canvasPrint) == null ? void 0 : e.getImageBlob());
    }
  }
}, kI = { class: "panel" }, RI = { class: "mobile" };
function OI(e, t, n, s, o, a) {
  const c = Ve("CanvasCover"), u = Ve("CanvasPrint"), d = Ve("CanvasHandles");
  return O(), P("div", kI, [
    p("div", RI, [
      _e(c, { ref: "canvasCover" }, null, 512),
      _e(u, { ref: "canvasDesign" }, null, 512),
      _e(u, { ref: "canvasPrint" }, null, 512),
      _e(d, {
        width: o.width,
        height: o.height,
        layerList: o.layerList,
        canvasScale: o.canvasScale,
        currentLayerID: o.currentLayerID,
        onHandleLayer: a.handleLayer,
        onHandleDelete: a.handleDelete,
        onHandleCopy: a.handleCopy,
        onHandleReplace: a.handleReplace,
        onHandleEdit: a.handleEdit
      }, null, 8, ["width", "height", "layerList", "canvasScale", "currentLayerID", "onHandleLayer", "onHandleDelete", "onHandleCopy", "onHandleReplace", "onHandleEdit"])
    ])
  ]);
}
const AI = /* @__PURE__ */ at(TI, [["render", OI], ["__scopeId", "data-v-39e1603c"]]), PI = {
  name: "Loading",
  props: {
    isShow: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {};
  }
};
function NI(e, t, n, s, o, a) {
  return O(), P("div", {
    class: _t(["loadingPanel", { hidden: !n.isShow }])
  }, t[0] || (t[0] = [
    p("div", { class: "loading" }, null, -1)
  ]), 2);
}
const um = /* @__PURE__ */ at(PI, [["render", NI], ["__scopeId", "data-v-ba39abaf"]]), MI = "https://shirt-oss.s3.us-east-1.amazonaws.com/static/shopGuide.png", BI = "https://shirt-oss.s3.us-east-1.amazonaws.com/assets/pixvoices-logo.png";
function cp(e, t) {
  let n = {};
  if (window.localStorage.commodityStorage && (n = JSON.parse(window.localStorage.getItem("commodityStorage"))), n[e]) {
    const s = n[e];
    s.push(t), I.size(s) > 9 && s.splice(0, 1), window.localStorage.setItem("commodityStorage", JSON.stringify({
      ...n,
      [e]: JSON.stringify(s)
    }));
  }
  window.localStorage.setItem("commodityStorage", JSON.stringify({
    ...n,
    [e]: [t]
  }));
}
function FI(e, t) {
  if (window.localStorage.commodityStorage && window.localStorage.commodityStorage[e]) {
    const s = JSON.parse(window.localStorage.getItem("commodityStorage"))[e];
    if (I.size(s))
      return JSON.parse(s[I.size(s) - 1]);
  }
  return null;
}
let Ti = null;
const $I = {
  name: "Workbench",
  components: {
    CanvasMobile: AI,
    DialogResource: P6,
    DialogDiyTemplates: q6,
    DialogFont: RL,
    DialogOption: yL,
    DialogPreview: WL,
    MobileLayout: cr,
    Tools: QL,
    NavigateBottom: eI,
    Loading: um
  },
  data() {
    return {
      commodityID: 0,
      commodityOptionList: [],
      selectOptionList: [],
      selectOptionName: "",
      options: {},
      originOptions: {},
      layerList: [],
      currentLayerID: 0,
      shopID: 0,
      isSubmit: !1,
      isShowLoading: !1,
      ossCdnDmain: Ct,
      workbenchLogo: BI
    };
  },
  mounted: async function() {
    setTimeout(async () => {
      this.handleShowLoading(), await this.init(), this.handleHideLoading();
    }, 500), document.addEventListener("click", () => {
      this.unselect();
    }), document.addEventListener("touchstart", () => {
      this.unselect();
    });
  },
  computed: {
    width: function() {
      return I.has(this.options, "material") ? I.get(this.options, "material.width", 0) : 0;
    },
    height: function() {
      return I.has(this.options, "material") ? I.get(this.options, "material.height", 0) : 0;
    },
    maxZIndex() {
      const e = I.maxBy(this.layerList, function(t) {
        return t.zIndex;
      });
      return I.get(e, "zIndex", 0);
    }
  },
  methods: {
    async init() {
      this.commodityID = mt("commodityID");
      const e = FI(this.commodityID);
      if (e && confirm("Whether to use history records?")) {
        await this.loadCommodityOptionList(), await this.initByData(e), this.showDialogOption();
        return;
      }
      const t = mt("diyDesignID");
      if (t) {
        const n = await f6({
          diyDesignID: t
        });
        if (n) {
          this.commodityID = I.get(n, ["options", "commodityID"], mt("commodityID")), this.shopID = I.get(n, "shopID", 0).toString(), await this.loadCommodityOptionList(), await this.initByData(n), this.showDialogOption();
          return;
        }
      }
      await this.loadCommodityOptionList(), await this.initByDefault(), this.showDialogOption();
    },
    unselect() {
      this.currentLayerID = 0, this.drawCanvas();
    },
    async loadCommodityOptionList() {
      if (this.commodityID) {
        const e = await h6({ commodityID: this.commodityID });
        e && (this.commodityOptionList = e);
      }
    },
    async initByData(e) {
      const t = I.get(e, "selectOptionList", []), n = I.get(e, "layerList", []);
      this.selectOptionList = t;
      const s = await ic({
        commodityID: this.commodityID,
        commodityOptions: t
      });
      this.originOptions = s, this.options = I.cloneDeep(s), this.layerList = n, this.selectOptionName = I.get(s, "material.name", ""), this.drawCanvas({
        originOptions: s,
        options: this.options,
        layerList: n
      }), await this.$refs.canvasMobile.drawCanvas({
        options: this.options,
        originOptions: s,
        layerList: n,
        currentLayerID: 0
      });
    },
    async initByTemplateData(e) {
      console.log(e.json, "data.json"), this.isShowLoading = !0, fetch(e.json, {
        method: "GET"
      }).then((t) => t.json()).then(async (t) => {
        console.log(t, "data");
        const n = I.get(t, "layerList", []);
        this.layerList = n, this.drawCanvas({
          originOptions: this.originOptions,
          options: this.options,
          layerList: n
        }), await this.$refs.canvasMobile.drawCanvas({
          options: this.options,
          originOptions: this.originOptions,
          layerList: n,
          currentLayerID: 0
        }), setTimeout(() => {
          this.isShowLoading = !1;
        }, 500);
      }).catch((t) => {
        this.isShowLoading = !1;
      });
    },
    async initByDefault() {
      if (this.$refs.dialogOption) {
        const e = this.$refs.dialogOption.initDefaultOptions();
        this.selectOptionList = e;
        const t = await ic({
          commodityID: this.commodityID,
          commodityOptions: e
        });
        this.originOptions = I.cloneDeep(t), t && (this.originOptions = t, this.options = I.cloneDeep(t), this.selectOptionName = I.get(t, "material.name", ""), this.drawCanvas());
      }
    },
    async selectOptions(e) {
      if (this.handleShowLoading(), this.selectOptionList = e, await this.resetOptions(e), !await qe()) {
        Ur();
        return;
      }
      this.handleHideLoading();
    },
    async resetOptions(e) {
      const t = await ic({
        commodityID: this.commodityID,
        commodityOptions: e
      });
      t && (this.options = t, this.selectOptionName = I.get(t, "material.name", ""), await this.drawCanvas());
    },
    showDialogResource() {
      this.$refs.dialogResource && this.$refs.dialogResource.handleShow();
    },
    showDialogTemplates() {
      this.$refs.dialogDiyTemplates && this.$refs.dialogDiyTemplates.handleShow(this.commodityID);
    },
    showDialogFont() {
      this.$refs.dialogFont && (setTimeout(() => {
        const e = (/* @__PURE__ */ new Date()).getTime(), t = this.width / Xn, n = this.width / 2 / t, s = 99;
        let o = (this.width - n) / 2, a = (this.height - s) / 2;
        this.layerList.push({
          id: e,
          itemW: n,
          itemH: s,
          itemX: o,
          itemY: a,
          itemData: "",
          isFlip: 0,
          itemType: 1,
          scaleNum: t,
          opacity: 1,
          rotate: 0,
          fontFamily: "",
          fontColor: "#324efe",
          textAlign: "center",
          fontBold: !1,
          fontItalic: !1,
          fontLineThrough: !1,
          zIndex: this.maxZIndex
        }), this.currentLayerID = e;
      }, 10), this.$refs.dialogFont.handleShow());
    },
    showDialogOption() {
      this.$refs.dialogOption && this.$refs.dialogOption.handleShow();
    },
    handleImageLayer(e) {
      const t = new Image();
      t.onload = () => {
        const n = t.width, s = t.height, o = (/* @__PURE__ */ new Date()).getTime(), a = this.width / Xn, c = this.width / 2 / a, u = c / n * s;
        let d = (this.width - c) / 2, h = (this.height - u) / 2, m = this.maxZIndex;
        Ti && (d = I.get(Ti, "itemX", 0), h = I.get(Ti, "itemY", 0), m = I.get(Ti, "zIndex", 0), this.handleDelete(I.get(Ti, "id", 0))), this.layerList.push({
          id: o,
          itemW: c,
          itemH: u,
          itemX: d,
          itemY: h,
          itemData: e,
          isFlip: 0,
          itemType: 2,
          scaleNum: a,
          opacity: 1,
          rotate: 0,
          zIndex: m
        }), this.currentLayerID = o, this.drawCanvas(), Ti = null, this.handleHideLoading();
      }, t.onerror = () => {
        this.handleHideLoading();
      }, t.src = e;
    },
    handleCloseResource() {
      Ti = null;
    },
    handleLayer(e) {
      this.currentLayerID = e, this.drawCanvas();
    },
    handleCopy(e) {
      const t = I.find(this.layerList, (n) => e === n.id);
      if (t) {
        const n = (/* @__PURE__ */ new Date()).getTime();
        this.layerList.push({
          ...t,
          id: n,
          itemX: I.get(t, "itemX", 0) - 20 * I.get(t, "scaleNum", 1),
          itemY: I.get(t, "itemY", 0) - 20 * I.get(t, "scaleNum", 1)
        }), this.currentLayerID = n, this.drawCanvas();
      }
    },
    handleDelete(e) {
      const t = I.findIndex(this.layerList, (n) => e === n.id);
      t >= 0 && (this.layerList.splice(t, 1), this.currentLayerID = 0, this.drawCanvas());
    },
    handleReplace(e) {
      var n;
      const t = I.find(this.layerList, (s) => e === s.id);
      t && (I.get(t, "itemType", 1) === 1 ? (n = this.$refs.dialogFont) == null || n.handleShow() : (Ti = t, this.showDialogResource()));
    },
    handleEdit(e) {
      const { id: t, param: n } = e, s = I.findIndex(this.layerList, (o) => t === o.id);
      s >= 0 && (I.set(this.layerList, s, {
        ...this.layerList[s],
        ...n
      }), this.drawCanvas());
    },
    async drawCanvas() {
      this.$refs.canvasMobile && await this.$refs.canvasMobile.drawCanvas({
        options: this.options,
        originOptions: this.originOptions,
        layerList: this.layerList,
        currentLayerID: this.currentLayerID
      });
    },
    async handlePreview() {
      if (this.$refs.canvasMobile && this.$refs.dialogPreview) {
        const e = this.$refs.canvasMobile.getCoverCanvas();
        await this.$refs.dialogPreview.handleShow(e), await this.$refs.canvasMobile.drawPrintCanvas({
          options: this.options,
          originOptions: this.originOptions,
          layerList: this.layerList,
          currentLayerID: this.currentLayerID
        });
      }
    },
    handleHome() {
      const e = this.commodityID, t = JSON.stringify({
        layerList: this.layerList,
        options: this.options,
        selectOptionList: this.selectOptionList
      });
      cp(e, t), window.location.href = "/pages/diy-commodity";
    },
    handleShowLoading() {
      this.isShowLoading = !0;
    },
    handleHideLoading() {
      this.isShowLoading = !1;
    },
    async getPrintBlob() {
      if (this.$refs.canvasMobile) {
        const e = this.$refs.canvasMobile.getPrintCanvasRef(), t = I.get(this.options, ["mask", "width"], 0), n = I.get(this.options, ["mask", "height"], 0), s = I.get(this.options, ["mask", "gapLeft"], 0), o = I.get(this.options, ["mask", "gapRight"], 0), a = I.get(this.options, ["mask", "gapTop"], 0), c = I.get(this.options, ["mask", "gapBottom"], 0);
        return t && n ? new Promise((u) => {
          const d = Number(t) - Number(s) - Number(o), h = Number(n) - Number(a) - Number(c), m = document.createElement("canvas");
          m.width = d, m.height = h, m.getContext("2d").drawImage(e, -Number(s), -Number(a), Number(t), Number(n)), m.toBlob((b) => {
            u(b);
          });
        }) : await this.$refs.canvasMobile.getPrintImageBlob();
      }
    },
    async handleSubmit() {
      if (this.isSubmit = !0, this.$refs.canvasMobile && this.$refs.dialogPreview) {
        const e = await this.$refs.dialogPreview.getImageBlob(), t = await ep(e, `${(/* @__PURE__ */ new Date()).getTime()}.jpeg`), n = await this.getPrintBlob(), s = await ep(n, `${(/* @__PURE__ */ new Date()).getTime()}.png`), o = await qe(), a = this.commodityID, c = JSON.stringify({
          layerList: this.layerList,
          options: this.options,
          selectOptionList: this.selectOptionList
        });
        if (cp(a, c), !o) {
          Ur();
          return;
        }
        oe.request({
          method: "POST",
          url: me + "/diydesign",
          data: {
            commodityID: a,
            userID: o,
            json: c,
            coverUrl: t,
            printUrl: s,
            materialID: I.get(this.options, "material.id", 0),
            maskSkuID: I.get(this.options, "maskSkuID", 0),
            materialSkuID: I.get(this.options, "materialSkuID", 0),
            backgroundSkuID: I.get(this.options, "backgroundSkuID", 0),
            selectOptionName: this.selectOptionName,
            shopID: this.shopID,
            originDiyDesignID: mt("diyDesignID")
          }
        }).then((u) => {
          var d;
          ((d = u == null ? void 0 : u.data) == null ? void 0 : d.code) === 200 ? (window.location.href = "/pages/mydiydesign", console.log(u, "add sucsess!!!")) : this.isSubmit = !1;
        });
      }
    }
  }
}, HI = { class: "selector-main" }, UI = { class: "workbench-header" }, zI = { class: "home" }, WI = ["src"], qI = ["src"];
function jI(e, t, n, s, o, a) {
  const c = Ve("CanvasMobile"), u = Ve("Tools"), d = Ve("DialogResource"), h = Ve("DialogDiyTemplates"), m = Ve("DialogFont"), v = Ve("DialogOption"), b = Ve("DialogPreview"), S = Ve("NavigateBottom"), D = Ve("Loading"), A = Ve("MobileLayout");
  return O(), P("div", null, [
    _e(A, null, {
      default: vt(() => [
        p("div", null, [
          p("div", {
            onClick: t[0] || (t[0] = (...R) => a.showDialogOption && a.showDialogOption(...R)),
            class: "selector"
          }, [
            p("div", HI, fe(o.selectOptionName), 1)
          ]),
          p("div", UI, [
            p("div", zI, [
              p("img", {
                onClick: t[1] || (t[1] = (...R) => a.handleHome && a.handleHome(...R)),
                src: o.ossCdnDmain + "/assets/home.png",
                alt: ""
              }, null, 8, WI)
            ]),
            p("img", {
              class: "logo",
              src: o.workbenchLogo,
              alt: ""
            }, null, 8, qI),
            p("div", {
              class: "preview",
              onClick: t[2] || (t[2] = (...R) => a.handlePreview && a.handlePreview(...R))
            }, "preview")
          ]),
          _e(c, {
            ref: "canvasMobile",
            onHandleLayer: a.handleLayer,
            onHandleDelete: a.handleDelete,
            onHandleCopy: a.handleCopy,
            onHandleReplace: a.handleReplace,
            onHandleEdit: a.handleEdit
          }, null, 8, ["onHandleLayer", "onHandleDelete", "onHandleCopy", "onHandleReplace", "onHandleEdit"]),
          _e(u, {
            layerList: o.layerList,
            currentLayerID: o.currentLayerID,
            onHandleLayer: a.handleLayer
          }, null, 8, ["layerList", "currentLayerID", "onHandleLayer"]),
          _e(d, {
            ref: "dialogResource",
            onHandleImageLayer: a.handleImageLayer,
            onHandleClose: a.handleCloseResource
          }, null, 8, ["onHandleImageLayer", "onHandleClose"]),
          _e(h, {
            ref: "dialogDiyTemplates",
            onHandleImageLayer: a.initByTemplateData,
            onHandleClose: a.handleCloseResource
          }, null, 8, ["onHandleImageLayer", "onHandleClose"]),
          _e(m, {
            ref: "dialogFont",
            layerList: o.layerList,
            currentLayerID: o.currentLayerID,
            onHandleEdit: a.handleEdit
          }, null, 8, ["layerList", "currentLayerID", "onHandleEdit"]),
          _e(v, {
            ref: "dialogOption",
            commodityOptionList: o.commodityOptionList,
            selectOptionList: o.selectOptionList,
            options: o.options,
            onHandleSelectOptions: a.selectOptions
          }, null, 8, ["commodityOptionList", "selectOptionList", "options", "onHandleSelectOptions"]),
          _e(b, {
            ref: "dialogPreview",
            options: o.options,
            isSubmit: o.isSubmit,
            onHandleSubmit: a.handleSubmit
          }, null, 8, ["options", "isSubmit", "onHandleSubmit"]),
          _e(S, {
            currentLayerID: o.currentLayerID,
            layerList: o.layerList,
            onHandleRescouce: a.showDialogResource,
            onHandleTemplates: a.showDialogTemplates,
            onHandleFont: a.showDialogFont,
            onHandleEdit: a.handleEdit,
            onHandleImageLayer: a.handleImageLayer,
            onHandleShowLoading: a.handleShowLoading,
            onHandleHideLoading: a.handleHideLoading
          }, null, 8, ["currentLayerID", "layerList", "onHandleRescouce", "onHandleTemplates", "onHandleFont", "onHandleEdit", "onHandleImageLayer", "onHandleShowLoading", "onHandleHideLoading"]),
          _e(D, { isShow: o.isShowLoading }, null, 8, ["isShow"])
        ])
      ]),
      _: 1
    })
  ]);
}
const VI = /* @__PURE__ */ at($I, [["render", jI], ["__scopeId", "data-v-1fd495c0"]]), GI = {
  name: "DiyDesign",
  components: {
    MobileLayout: cr
  },
  data() {
    return {
      diyDesignList: [],
      statistics: 0,
      discountPrice: 0,
      advertCover: "",
      advertText: "",
      advertOptions: {},
      userID: 0,
      shopID: 0,
      ossCdnDmain: Ct,
      submitLoading: !1
    };
  },
  mounted: function() {
    this.loadAdvert(), this.init();
  },
  methods: {
    async init() {
      if (this.userID = await qe(), !this.userID) {
        Ur();
        return;
      }
      this.getUserDetail(), this.refresh();
    },
    loadAdvert() {
      oe.request({
        method: "GET",
        url: me + "/advert/detail?type=1",
        data: {}
      }).then((e) => {
        e && e.status === 200 && e.data && e.data.code === 200 && (this.advertCover = I.get(e, ["data", "data", "cover"], ""), this.advertText = I.get(e, ["data", "data", "text"], ""), this.advertOptions = I.get(e, ["data", "data"], {}));
      });
    },
    async refresh() {
      this.diyDesignList = [], this.statistics = 0, this.discountPrice = 0, oe.request({
        method: "GET",
        url: me + `/diydesign/all?userID=${this.userID}`,
        data: {}
      }).then((e) => {
        if (e && e.status === 200 && e.data && e.data.code === 200) {
          const t = e.data.data;
          for (let n = 0; n < I.size(t); n++)
            this.diyDesignList.push({
              ...t[n],
              selected: n === 0,
              quantity: 1
            });
          this.resetPrice();
        }
      });
    },
    getUserDetail() {
      oe.request({
        method: "GET",
        url: me + `/users/detail?userID=${this.userID}`,
        data: {}
      }).then((e) => {
        e && e.status === 200 && e.data && e.data.code === 200 && (this.shopID = I.get(e, ["data", "data", "shopID"], 0));
      });
    },
    checkboxChange(e, t) {
      const n = I.get(t, "target._modelValue", !1);
      this.diyDesignList[e].selected = n, this.resetPrice();
    },
    resetPrice() {
      let e = 0, t = 0;
      for (let n = 0; n < I.size(this.diyDesignList); n++)
        if (I.get(this.diyDesignList, [n, "selected"], !1)) {
          e += Number(I.get(this.diyDesignList, [n, "price"], 0)) * Number(I.get(this.diyDesignList, [n, "quantity"], 0));
          const o = Number(I.get(this.diyDesignList, [n, "discountPercent"], 0)) / 100;
          t += Number(I.get(this.diyDesignList, [n, "price"], 0)) * (1 - o) * Number(I.get(this.diyDesignList, [n, "quantity"], 0));
        }
      this.statistics = e, this.discountPrice = t;
    },
    handleHome() {
      window.location.href = "/pages/diy-commodity";
    },
    handleShop() {
      window.location.href = "/pages/mydiyshop?shopID=" + this.shopID;
    },
    handleApply() {
      window.location.href = "/pages/shopApply";
    },
    handleSub(e) {
      this.diyDesignList[e].quantity > 1 && (this.diyDesignList[e].quantity -= 1, this.resetPrice());
    },
    handleAdd(e) {
      this.diyDesignList[e].quantity += 1, this.resetPrice();
    },
    handleCopy(e) {
      const t = `${window.location.origin}/pages/diy-workbench?diyDesignID=${e}`;
      if (navigator && navigator.clipboard)
        navigator.clipboard.writeText(t);
      else {
        const n = document.createElement("input");
        n.setAttribute("value", t), document.body.appendChild(n), n.select(), document.execCommand("copy"), document.body.removeChild(n);
      }
      setTimeout(() => {
        alert("Success. Paste the link to share it!");
      }, 500);
    },
    async hanldeDelete(e) {
      const t = await qe();
      confirm("Are you sure about deleting it?") && oe.request({
        method: "DELETE",
        url: me + `/diydesign/${e}`,
        data: {
          userID: t
        }
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && this.refresh();
      });
    },
    handleAdvert() {
      sm(this.advertOptions);
    },
    async handleSaveShop(e) {
      const t = await qe();
      oe.request({
        method: "POST",
        url: me + `/diydesign/shop/${e}`,
        data: {
          userID: t
        }
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && this.refresh();
      });
    },
    async handleSubmit() {
      if (this.submitLoading) return console.log("Submiting...");
      const e = this;
      e.submitLoading = !0;
      const t = await qe();
      if (!t) {
        Ur();
        return;
      }
      const n = [];
      for (let s = 0; s < I.size(this.diyDesignList); s++) {
        const o = I.get(this.diyDesignList, [s, "selected"], !1), a = I.get(this.diyDesignList, [s, "quantity"], 1);
        o && n.push({
          id: I.get(this.diyDesignList, [s, "id"], 0),
          quantity: a
        });
      }
      I.size(n) && oe.request({
        method: "POST",
        // url: apiDomain+`/order`,
        url: me + "/addToCart",
        data: {
          userID: t,
          diyDesignListJSON: JSON.stringify(n)
        }
      }).then((s) => {
        var o, a, c;
        s && s.status === 200 && s.data && s.data.code === 200 && ((a = (o = s.data) == null ? void 0 : o.data) != null && a.length) && fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
            // Shopify Ajax Cart 要求 Accept: application/json
          },
          body: JSON.stringify({
            items: (c = s.data.data) == null ? void 0 : c.map((u) => ({
              id: u.variantID,
              quantity: u.quantity
            }))
          })
        }).then((u) => {
          if (!u.ok)
            throw new Error("Network response was not ok: " + u.statusText);
          return u.json();
        }).then((u) => (window.location.href = "/cart", u)).catch((u) => {
          console.error("添加购物车失败:", u), e.submitLoading = !1;
        });
      }).catch((s) => {
        console.error("添加购物车失败:", s), e.submitLoading = !1;
      });
    }
  }
}, KI = { class: "page" }, YI = { class: "header" }, XI = { class: "right-btns" }, JI = { class: "diyDesignList" }, ZI = ["src"], QI = ["onUpdate:modelValue", "onChange"], eE = { class: "title" }, tE = { class: "desc" }, nE = { class: "price" }, iE = ["onClick"], rE = ["onClick"], sE = ["onClick"], oE = { class: "floor" }, aE = { class: "submit-btns" }, lE = { class: "statistics" }, cE = { class: "px-[5px] line-through opacity-60" }, uE = { class: "submit-row" };
function fE(e, t, n, s, o, a) {
  const c = Ve("MobileLayout");
  return O(), P("div", null, [
    _e(c, null, {
      default: vt(() => [
        p("div", KI, [
          p("div", YI, [
            t[5] || (t[5] = p("div", null, "My Portfolio", -1)),
            p("div", XI, [
              o.shopID ? le("", !0) : (O(), P("div", {
                key: 0,
                class: "apply",
                onClick: t[0] || (t[0] = (...u) => a.handleApply && a.handleApply(...u))
              }, "Apply a Shop")),
              o.shopID ? (O(), P("div", {
                key: 1,
                class: "shop",
                onClick: t[1] || (t[1] = (...u) => a.handleShop && a.handleShop(...u)),
                style: Lt(`background-image: url('${o.ossCdnDmain}/assets/shop-light.png')`)
              }, null, 4)) : le("", !0),
              p("div", {
                class: "home",
                onClick: t[2] || (t[2] = (...u) => a.handleHome && a.handleHome(...u)),
                style: Lt(`background-image: url('${o.ossCdnDmain}/assets/home-light.png')`)
              }, null, 4)
            ])
          ]),
          p("div", JI, [
            (O(!0), P(Ae, null, ut(o.diyDesignList, (u, d) => (O(), P("div", {
              key: u.id,
              class: "design"
            }, [
              p("img", {
                src: u.coverUrl,
                class: "cover"
              }, null, 8, ZI),
              gt(p("input", {
                type: "checkbox",
                "onUpdate:modelValue": (h) => u.selected = h,
                class: "checkbox",
                onChange: (h) => {
                  this.checkboxChange(d, h);
                }
              }, null, 40, QI), [
                [b2, u.selected]
              ]),
              p("div", eE, fe(u.commodityName), 1),
              p("div", tE, fe(u.selectOptionName), 1),
              p("div", nE, "$" + fe(u.price), 1),
              p("div", {
                class: "share",
                style: Lt(`background-image: url('${o.ossCdnDmain}/assets/diydesign-share.png')`),
                onClick: () => {
                  this.handleCopy(u.id);
                }
              }, null, 12, iE),
              p("div", {
                class: "delete",
                style: Lt(`background-image: url('${o.ossCdnDmain}/assets/dlelete.png')`),
                onClick: () => {
                  this.hanldeDelete(u.id);
                }
              }, null, 12, rE),
              o.shopID ? (O(), P("div", {
                key: 0,
                style: Lt(`background-image: url('${o.ossCdnDmain}/assets/${u.shopID ? "shoped.png" : "unshop.png"}')`),
                class: "addToShop",
                onClick: () => {
                  this.handleSaveShop(u.id);
                }
              }, null, 12, sE)) : le("", !0)
            ]))), 128))
          ])
        ]),
        p("div", oE, [
          t[9] || (t[9] = p("div", { class: "floor-title" }, "180-day free replacement for quality problems.", -1)),
          t[10] || (t[10] = p("div", { class: "floor-subtitle" }, "Orders ≥ 49USD get free shipping", -1)),
          p("div", aE, [
            p("div", lE, [
              t[6] || (t[6] = tn("Total: ")),
              p("span", cE, "$" + fe(o.statistics), 1),
              tn(" $" + fe(o.discountPrice), 1)
            ]),
            p("div", uE, [
              o.submitLoading ? (O(), P("div", {
                key: 0,
                class: "submit submit-loading",
                onClick: t[3] || (t[3] = (...u) => a.handleSubmit && a.handleSubmit(...u))
              }, t[7] || (t[7] = [
                p("svg", {
                  t: "1696395089207",
                  class: "icon-loading floor-animate-rotating",
                  viewBox: "0 0 1024 1024",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "p-id": "15559",
                  width: "1em",
                  height: "1em"
                }, [
                  p("path", {
                    d: "M512 74.666667c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32V106.666667c0-17.066667-14.933333-32-32-32zM693.333333 362.666667c8.533333 0 17.066667-2.133333 23.466667-8.533334l104.533333-104.533333c12.8-12.8 12.8-32 0-44.8-12.8-12.8-32-12.8-44.8 0l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 4.266667 6.4 12.8 8.533333 21.333333 8.533334zM917.333333 480h-149.333333c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32zM714.666667 669.866667c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333zM512 736c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-149.333333c0-17.066667-14.933333-32-32-32zM309.333333 669.866667l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333l104.533334-104.533333c12.8-12.8 12.8-32 0-44.8s-36.266667-12.8-46.933334 0zM288 512c0-17.066667-14.933333-32-32-32H106.666667c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32zM247.466667 202.666667c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333z",
                    "p-id": "15560"
                  })
                ], -1),
                tn(" loading ")
              ]))) : (O(), P("div", {
                key: 1,
                class: "submit",
                onClick: t[4] || (t[4] = (...u) => a.handleSubmit && a.handleSubmit(...u))
              }, "Add to cart")),
              t[8] || (t[8] = p("a", {
                class: "submit-cart",
                href: "/cart"
              }, [
                p("svg", {
                  class: "icon icon-submit-cart",
                  "aria-hidden": "true",
                  focusable: "false",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 40 40",
                  fill: "none"
                }, [
                  p("path", {
                    fill: "currentColor",
                    "fill-rule": "evenodd",
                    d: "M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"
                  })
                ])
              ], -1))
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]);
}
const dE = /* @__PURE__ */ at(GI, [["render", fE], ["__scopeId", "data-v-2944ad6a"]]);
function fm(e) {
  return new Promise((t) => {
    oe.request({
      method: "POST",
      url: me + "/diydesignstatistic/addVisit",
      data: e
    }).then((n) => {
      n && n.status === 200 && n.data && n.data.code === 200 ? t(n.data.data) : t();
    });
  });
}
const hE = {
  name: "Shop",
  components: {
    MobileLayout: cr
  },
  data() {
    return {
      shop: {
        isShopkeeper: !1
      },
      diyDesignList: [],
      isEditTitle: !1,
      isEditNickName: !1,
      isEditDescription: !1,
      isEditAvatar: !1,
      isEditBanner: !1,
      editTitleID: 0,
      dialogTitle: "",
      dialogNickName: "",
      dialogDescription: "",
      dialogAvatar: "",
      dialogBanner: "",
      ossCdnDmain: Ct
    };
  },
  mounted: function() {
    this.refresh();
  },
  methods: {
    discountPrice: function(e) {
      if (e) {
        const t = Number(e.price), n = Number(e.discountPercent) / 100;
        return t * (1 - n);
      }
      return 0;
    },
    async refreshDetail() {
      const e = await qe(), t = mt("shopID");
      oe.request({
        method: "GET",
        url: `${me}/shop/detail?userID=${e}&shopID=${t}`,
        data: {}
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && (this.shop = n.data.data);
      });
    },
    async handleDetail(e) {
      const t = I.get(e, "id", 0);
      t && (await fm({ diyDesignID: t }), window.location.href = `/pages/diy-workbench?diyDesignID=${t}`);
    },
    async handleUp(e) {
      const t = await qe();
      oe.request({
        method: "POST",
        url: `${me}/diydesign/up/${e.id}`,
        data: {
          userID: t
        }
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && this.refresh();
      });
    },
    async handleBelow(e) {
      const t = await qe();
      oe.request({
        method: "POST",
        url: `${me}/diydesign/below/${e.id}`,
        data: {
          userID: t
        }
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && this.refresh();
      });
    },
    resetTime() {
      var e;
      this.leftTimer = 0, (e = this.diyDesignList) != null && e.length && (clearInterval(this.timer), this.timer = setInterval(() => {
        this.diyDesignList.map((t) => {
          (t == null ? void 0 : t.discountSecond) > 0 && (this.leftTimer = 1, t.discountSecond >= 0 && (t.discountSecond -= 1));
        });
      }, 1e3));
    },
    async refresh() {
      this.diyDesignList = [], oe.request({
        method: "GET",
        url: `${me}/diydesignFeatured`,
        data: {}
      }).then((e) => {
        var t, n;
        e && e.status === 200 && e.data && e.data.code === 200 && (this.diyDesignList = (n = (t = e.data) == null ? void 0 : t.data) == null ? void 0 : n.map((s) => {
          if (s != null && s.discountTime) {
            const o = new Date(s == null ? void 0 : s.discountTime);
            s.discountSecond = parseInt((o.getTime() - (/* @__PURE__ */ new Date()).getTime()) / 1e3);
          }
          return s;
        }), this.resetTime());
      });
    },
    handleHome() {
      window.location.href = "/pages/diy-commodity";
    },
    handleBrokerage() {
      const e = mt("shopID");
      window.location.href = `/pages/diy-brokerage?shopID=${e}`;
    },
    handleAvatar() {
      this.shop.isShopkeeper && (this.isEditAvatar = !0);
    },
    closeAvatar() {
      this.isEditAvatar = !1;
    },
    avatarChange() {
      const e = document.createElement("input");
      e.style = "display:none", e.type = "file", e.onchange = async (t) => {
        if (I.size(e.files)) {
          const n = zr(e.files[0].name), s = await As(e.files[0], `${(/* @__PURE__ */ new Date()).getTime()}.${n}`, "user");
          s && (this.dialogAvatar = s);
        }
      }, e.click();
    },
    async saveAvatar() {
      if (this.dialogAvatar) {
        const e = mt("shopID"), t = await qe();
        oe.request({
          method: "POST",
          url: `${me}/shop/update`,
          data: {
            shopID: e,
            userID: t,
            avatar: this.dialogAvatar
          }
        }).then((n) => {
          n && n.status === 200 && n.data && n.data.code === 200 && (this.refreshDetail(), this.closeAvatar());
        });
      }
    },
    handleBanner() {
      this.shop.isShopkeeper && (this.isEditBanner = !0);
    },
    closeBanner() {
      this.isEditBanner = !1;
    },
    bannerChange() {
      const e = document.createElement("input");
      e.style = "display:none", e.type = "file", e.onchange = async (t) => {
        if (I.size(e.files)) {
          const n = zr(e.files[0].name), s = await As(e.files[0], `${(/* @__PURE__ */ new Date()).getTime()}.${n}`, "user");
          s && (this.dialogBanner = s);
        }
      }, e.click();
    },
    async saveBanner() {
      if (this.dialogBanner) {
        const e = mt("shopID"), t = await qe();
        oe.request({
          method: "POST",
          url: `${me}/shop/update`,
          data: {
            shopID: e,
            userID: t,
            banner: this.dialogBanner
          }
        }).then((n) => {
          n && n.status === 200 && n.data && n.data.code === 200 && (this.refreshDetail(), this.closeBanner());
        });
      }
    },
    handleTitle(e, t) {
      this.shop.isShopkeeper && (this.isEditTitle = !0, this.editTitleID = I.get(t, "id", 0), e.stopPropagation());
    },
    closeTitle() {
      this.isEditTitle = !1;
    },
    async saveTitle() {
      if (this.editTitleID) {
        const e = await qe();
        oe.request({
          method: "POST",
          url: `${me}/diydesign/update/${this.editTitleID}`,
          data: {
            userID: e,
            title: this.dialogTitle
          }
        }).then((t) => {
          t && t.status === 200 && t.data && t.data.code === 200 && (this.refresh(), this.closeTitle());
        });
      }
    },
    handleNickName() {
      this.shop.isShopkeeper && (this.isEditNickName = !0);
    },
    async saveNickName() {
      if (this.dialogNickName) {
        const e = mt("shopID"), t = await qe();
        oe.request({
          method: "POST",
          url: `${me}/shop/update`,
          data: {
            shopID: e,
            userID: t,
            nickname: this.dialogNickName
          }
        }).then((n) => {
          n && n.status === 200 && n.data && n.data.code === 200 && (this.refreshDetail(), this.closeNickName());
        });
      }
    },
    closeNickName() {
      this.isEditNickName = !1;
    },
    handleDescription() {
      this.shop.isShopkeeper && (this.isEditDescription = !0);
    },
    async saveDescription() {
      if (this.dialogDescription) {
        const e = mt("shopID"), t = await qe();
        oe.request({
          method: "POST",
          url: `${me}/shop/update`,
          data: {
            shopID: e,
            userID: t,
            description: this.dialogDescription
          }
        }).then((n) => {
          n && n.status === 200 && n.data && n.data.code === 200 && (this.refreshDetail(), this.closeDescription());
        });
      }
    },
    closeDescription() {
      this.isEditDescription = !1;
    },
    discountTime: function(e) {
      if (e) {
        const t = parseInt(e / 60 / 60 / 24), n = parseInt((e - t * 60 * 60 * 24) / 60 / 60), s = parseInt((e - t * 60 * 60 * 24 - n * 60 * 60) / 60), o = e - t * 60 * 60 * 24 - n * 60 * 60 - s * 60;
        return `${t}day ${n}: ${s}:${o}`;
      }
      return "";
    }
  }
}, pE = { class: "page" }, gE = {
  key: 0,
  class: "header"
}, mE = { class: "banner" }, vE = ["src"], yE = ["src"], wE = { class: "diyDesignList" }, bE = ["onClick"], xE = ["src"], _E = ["onClick"], CE = {
  key: 0,
  class: "edit-icon"
}, SE = { class: "design-content" }, LE = {
  key: 0,
  class: "design-price line-through opacity-60"
}, DE = { class: "design-social" }, IE = { class: "social-item" }, EE = { class: "social-item" }, TE = { class: "text-[12px] font-black flex justify-between px-[12px]" }, kE = {
  key: 0,
  class: "font-semibold"
}, RE = ["onClick"], OE = ["onClick"], AE = {
  key: 0,
  class: "dialog"
}, PE = { class: "dialog-content" }, NE = ["src"], ME = {
  key: 1,
  class: "dialog"
}, BE = { class: "dialog-content" }, FE = ["src"], $E = {
  key: 1,
  class: "banner-logo",
  src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/navigateImage.png"
}, HE = {
  key: 2,
  class: "dialog"
}, UE = { class: "dialog-content" }, zE = { class: "dialog-form" }, WE = {
  key: 3,
  class: "dialog"
}, qE = { class: "dialog-content" }, jE = { class: "dialog-form" }, VE = {
  key: 4,
  class: "dialog"
}, GE = { class: "dialog-content" }, KE = { class: "dialog-form" };
function YE(e, t, n, s, o, a) {
  const c = Ve("MobileLayout");
  return O(), P("div", null, [
    _e(c, null, {
      default: vt(() => [
        p("div", pE, [
          o.shop ? (O(), P("div", gE, [
            p("div", mE, [
              p("img", {
                src: o.ossCdnDmain + "/assets/shop-banner.png"
              }, null, 8, vE)
            ]),
            p("div", {
              class: "avatar",
              onClick: t[0] || (t[0] = (...u) => a.handleAvatar && a.handleAvatar(...u))
            }, [
              p("img", {
                src: o.ossCdnDmain + "/assets/pixvoices-shop-av.png"
              }, null, 8, yE)
            ]),
            p("div", {
              class: "nickname",
              onClick: t[1] || (t[1] = (...u) => a.handleNickName && a.handleNickName(...u))
            }, t[23] || (t[23] = [
              p("span", null, "Pixvoices Gallery- Design Templates", -1)
            ])),
            p("div", {
              class: "description",
              onClick: t[2] || (t[2] = (...u) => a.handleDescription && a.handleDescription(...u))
            }, t[24] || (t[24] = [
              p("span", null, "Pix Templates for Your Custom Creations", -1)
            ]))
          ])) : le("", !0),
          p("div", wE, [
            (O(!0), P(Ae, null, ut(o.diyDesignList, (u, d) => (O(), P("div", {
              key: d,
              class: "design",
              onClick: (h) => a.handleDetail(u)
            }, [
              p("img", {
                src: u.coverUrl,
                class: "cover"
              }, null, 8, xE),
              p("div", {
                class: "design-title",
                onClick: (h) => {
                  a.handleTitle(h, u);
                }
              }, [
                p("span", null, fe(u.title || u.commodityName), 1),
                o.shop.isShopkeeper ? (O(), P("span", CE)) : le("", !0)
              ], 8, _E),
              p("div", SE, [
                u.discountSecond ? (O(), P("div", LE, fe(u.price) + " USD", 1)) : le("", !0),
                p("div", DE, [
                  p("div", IE, [
                    t[25] || (t[25] = p("img", { src: "https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/diy-visit.png" }, null, -1)),
                    tn(" " + fe(u.visit || 0), 1)
                  ]),
                  p("div", EE, [
                    t[26] || (t[26] = p("img", { src: "https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/diy-sell.png" }, null, -1)),
                    tn(" " + fe(u.sell || 0), 1)
                  ])
                ])
              ]),
              p("div", TE, [
                p("div", null, fe(a.discountPrice(u)) + " USD", 1),
                u.discountSecond ? (O(), P("div", kE, fe(a.discountTime(u.discountSecond)), 1)) : le("", !0)
              ]),
              o.shop.isShopkeeper && u.status === 2 ? (O(), P("div", {
                key: 0,
                class: "up",
                onClick: (h) => {
                  a.handleUp(u), h.stopPropagation();
                }
              }, null, 8, RE)) : le("", !0),
              o.shop.isShopkeeper && u.status === 1 ? (O(), P("div", {
                key: 1,
                class: "below",
                onClick: (h) => {
                  a.handleBelow(u), h.stopPropagation();
                }
              }, null, 8, OE)) : le("", !0)
            ], 8, bE))), 128))
          ])
        ]),
        o.isEditAvatar ? (O(), P("div", AE, [
          p("div", PE, [
            t[27] || (t[27] = p("div", { class: "dialog-title" }, "Edit Store Logo", -1)),
            p("div", {
              class: "dialog-close",
              onClick: t[3] || (t[3] = (...u) => a.closeAvatar && a.closeAvatar(...u))
            }),
            p("div", {
              class: "dialog-avatar",
              onClick: t[4] || (t[4] = (...u) => a.avatarChange && a.avatarChange(...u))
            }, [
              p("img", {
                src: o.dialogAvatar || "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/navigateImage.png"
              }, null, 8, NE)
            ]),
            t[28] || (t[28] = p("div", { class: "dialog-message" }, "It's recommended to use an image that's at lease 320 x 320 pixels. Must be a jpg, png or gi file, and 10MD or less.", -1)),
            p("div", {
              class: "dialog-save",
              onClick: t[5] || (t[5] = (...u) => a.saveAvatar && a.saveAvatar(...u))
            }, "Save"),
            p("div", {
              class: "dialog-cancel",
              onClick: t[6] || (t[6] = (...u) => a.closeAvatar && a.closeAvatar(...u))
            }, "Cancel")
          ])
        ])) : le("", !0),
        o.isEditBanner ? (O(), P("div", ME, [
          p("div", BE, [
            t[29] || (t[29] = p("div", { class: "dialog-title" }, "Edit Cover Image", -1)),
            p("div", {
              class: "dialog-close",
              onClick: t[7] || (t[7] = (...u) => a.closeBanner && a.closeBanner(...u))
            }),
            p("div", {
              class: "dialog-banner",
              onClick: t[8] || (t[8] = (...u) => a.bannerChange && a.bannerChange(...u))
            }, [
              o.dialogBanner ? (O(), P("img", {
                key: 0,
                src: o.dialogBanner
              }, null, 8, FE)) : (O(), P("img", $E))
            ]),
            t[30] || (t[30] = p("div", { class: "dialog-message" }, "For the best results on all devices, use an image that's at lease 1920 x 549 pixels(3.5:1 aspect ratio). Must be a jpg, png or gi file, and 10MD or less.", -1)),
            p("div", {
              class: "dialog-save",
              onClick: t[9] || (t[9] = (...u) => a.saveBanner && a.saveBanner(...u))
            }, "Save"),
            p("div", {
              class: "dialog-cancel",
              onClick: t[10] || (t[10] = (...u) => a.closeBanner && a.closeBanner(...u))
            }, "Cancel")
          ])
        ])) : le("", !0),
        o.isEditTitle ? (O(), P("div", HE, [
          p("div", UE, [
            t[31] || (t[31] = p("div", { class: "dialog-title" }, "Edit Name", -1)),
            p("div", {
              class: "dialog-close",
              onClick: t[11] || (t[11] = (...u) => a.closeTitle && a.closeTitle(...u))
            }),
            p("div", zE, [
              gt(p("input", {
                "onUpdate:modelValue": t[12] || (t[12] = (u) => o.dialogTitle = u)
              }, null, 512), [
                [St, o.dialogTitle]
              ])
            ]),
            p("div", {
              class: "dialog-save",
              onClick: t[13] || (t[13] = (...u) => a.saveTitle && a.saveTitle(...u))
            }, "Save"),
            p("div", {
              class: "dialog-cancel",
              onClick: t[14] || (t[14] = (...u) => a.closeTitle && a.closeTitle(...u))
            }, "Cancel")
          ])
        ])) : le("", !0),
        o.isEditNickName ? (O(), P("div", WE, [
          p("div", qE, [
            t[32] || (t[32] = p("div", { class: "dialog-title" }, "Edit Store Name", -1)),
            p("div", {
              class: "dialog-close",
              onClick: t[15] || (t[15] = (...u) => a.closeNickName && a.closeNickName(...u))
            }),
            p("div", jE, [
              gt(p("input", {
                "onUpdate:modelValue": t[16] || (t[16] = (u) => o.dialogNickName = u)
              }, null, 512), [
                [St, o.dialogNickName]
              ])
            ]),
            p("div", {
              class: "dialog-save",
              onClick: t[17] || (t[17] = (...u) => a.saveNickName && a.saveNickName(...u))
            }, "Save"),
            p("div", {
              class: "dialog-cancel",
              onClick: t[18] || (t[18] = (...u) => a.closeNickName && a.closeNickName(...u))
            }, "Cancel")
          ])
        ])) : le("", !0),
        o.isEditDescription ? (O(), P("div", VE, [
          p("div", GE, [
            t[33] || (t[33] = p("div", { class: "dialog-title" }, "Edit Store Detail", -1)),
            p("div", {
              class: "dialog-close",
              onClick: t[19] || (t[19] = (...u) => a.closeDescription && a.closeDescription(...u))
            }),
            p("div", KE, [
              gt(p("input", {
                "onUpdate:modelValue": t[20] || (t[20] = (u) => o.dialogDescription = u)
              }, null, 512), [
                [St, o.dialogDescription]
              ])
            ]),
            p("div", {
              class: "dialog-save",
              onClick: t[21] || (t[21] = (...u) => a.saveDescription && a.saveDescription(...u))
            }, "Save"),
            p("div", {
              class: "dialog-cancel",
              onClick: t[22] || (t[22] = (...u) => a.closeDescription && a.closeDescription(...u))
            }, "Cancel")
          ])
        ])) : le("", !0)
      ]),
      _: 1
    })
  ]);
}
const XE = /* @__PURE__ */ at(hE, [["render", YE], ["__scopeId", "data-v-f9a6d7f7"]]), JE = {
  name: "ShopApply",
  components: {
    MobileLayout: cr,
    Loading: um
  },
  data() {
    return {
      isShowLoading: !1,
      userID: 0,
      form: {
        avatar: "",
        nickname: "",
        description: "",
        contactEmail: ""
      },
      shopGuid: MI
    };
  },
  mounted: function() {
    this.init();
  },
  methods: {
    async init() {
      const e = await qe();
      if (!e) {
        Ur();
        return;
      }
      this.getUserDetail(e), this.userID = e;
    },
    getUserDetail(e) {
      oe.request({
        method: "GET",
        url: me + `/users/detail?userID=${e}`,
        data: {}
      }).then((t) => {
        t && t.status === 200 && t.data && t.data.code === 200 && (this.form.contactEmail = I.get(t, ["data", "data", "email"], ""));
      });
    },
    handleShowLoading() {
      this.isShowLoading = !0;
    },
    handleHideLoading() {
      this.isShowLoading = !1;
    },
    handleUpload() {
      const e = document.createElement("input");
      e.style = "display:none", e.type = "file", e.onchange = async (t) => {
        if (this.handleShowLoading(), I.size(e.files)) {
          const n = zr(e.files[0].name), s = await As(e.files[0], `${(/* @__PURE__ */ new Date()).getTime()}.${n}`, "user");
          s && (this.form.avatar = s), this.handleHideLoading();
        } else
          this.handleHideLoading();
      }, e.click();
    },
    handleSubmit() {
      if (!this.isShowLoading) {
        if (!this.form.avatar) {
          alert("please fill in Profile Pic");
          return;
        }
        if (!this.form.nickname) {
          alert("please fill in Store name");
          return;
        }
        if (!this.form.description) {
          alert("please fill in Description");
          return;
        }
        if (!this.form.contactEmail) {
          alert("please fill in Contact emain");
          return;
        }
        this.handleShowLoading(), oe.request({
          method: "POST",
          url: me + "/shop",
          data: {
            ...this.form,
            userID: this.userID
          }
        }).then((e) => {
          if (this.handleHideLoading(), e && e.status === 200 && e.data && e.data.code === 200) {
            const t = I.get(e, ["data", "data", "shopID"], "");
            window.location.href = "/pages/mydiyshop?shopID=" + t;
          }
        });
      }
    }
  }
}, ZE = { class: "page" }, QE = { class: "introduce" }, eT = ["src"], tT = { class: "form" }, nT = ["src"], iT = {
  key: 1,
  src: "https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/upload.png"
};
function rT(e, t, n, s, o, a) {
  const c = Ve("MobileLayout"), u = Ve("Loading");
  return O(), P("div", null, [
    _e(c, null, {
      default: vt(() => [
        p("div", ZE, [
          p("div", QE, [
            p("img", { src: o.shopGuid }, null, 8, eT)
          ]),
          t[9] || (t[9] = p("div", { class: "title" }, "Apply now and we will reach out", -1)),
          t[10] || (t[10] = p("div", { class: "title" }, "you soon!", -1)),
          p("div", tT, [
            t[5] || (t[5] = p("div", { class: "label" }, "Profile Pic", -1)),
            p("div", {
              class: "pic",
              onClick: t[0] || (t[0] = (...d) => a.handleUpload && a.handleUpload(...d))
            }, [
              o.form.avatar ? (O(), P("img", {
                key: 0,
                src: o.form.avatar
              }, null, 8, nT)) : (O(), P("img", iT))
            ]),
            t[6] || (t[6] = p("div", { class: "label" }, "Store name", -1)),
            gt(p("input", {
              "onUpdate:modelValue": t[1] || (t[1] = (d) => o.form.nickname = d),
              class: "text"
            }, null, 512), [
              [St, o.form.nickname]
            ]),
            t[7] || (t[7] = p("div", { class: "label" }, "Description", -1)),
            gt(p("input", {
              "onUpdate:modelValue": t[2] || (t[2] = (d) => o.form.description = d),
              class: "text"
            }, null, 512), [
              [St, o.form.description]
            ]),
            t[8] || (t[8] = p("div", { class: "label" }, "Contact email", -1)),
            gt(p("input", {
              "onUpdate:modelValue": t[3] || (t[3] = (d) => o.form.contactEmail = d),
              class: "text"
            }, null, 512), [
              [St, o.form.contactEmail]
            ]),
            p("div", {
              class: "apply",
              onClick: t[4] || (t[4] = (...d) => a.handleSubmit && a.handleSubmit(...d))
            }, "Apply")
          ])
        ])
      ]),
      _: 1
    }),
    _e(u, { isShow: o.isShowLoading }, null, 8, ["isShow"])
  ]);
}
const sT = /* @__PURE__ */ at(JE, [["render", rT], ["__scopeId", "data-v-a1e2eb5b"]]), oT = {
  name: "Shop",
  components: {
    MobileLayout: cr
  },
  data() {
    return {
      shop: {
        isShopkeeper: !1
      },
      diyDesignList: [],
      isEditTitle: !1,
      isEditNickName: !1,
      isEditDescription: !1,
      isEditAvatar: !1,
      isEditBanner: !1,
      editTitleID: 0,
      dialogTitle: "",
      dialogNickName: "",
      dialogDescription: "",
      dialogAvatar: "",
      dialogBanner: "",
      ossCdnDmain: Ct,
      timer: null,
      leftTimer: 0
    };
  },
  mounted: function() {
    this.refreshDetail(), this.refresh();
  },
  beforeUnmount: () => {
    clearInterval(timer);
  },
  methods: {
    discountPrice: function(e) {
      if (e) {
        const t = Number(e.price), n = Number(e.discountPercent) / 100;
        return t * (1 - n);
      }
      return 0;
    },
    async refreshDetail() {
      const e = await qe(), t = mt("shopID");
      oe.request({
        method: "GET",
        url: `${me}/shop/detail?userID=${e}&shopID=${t}`,
        data: {}
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && (this.shop = n.data.data);
      });
    },
    async handleDetail(e) {
      const t = I.get(e, "id", 0);
      t && (await fm({ diyDesignID: t }), window.location.href = `/pages/diy-workbench?diyDesignID=${t}`);
    },
    async handleUp(e) {
      const t = await qe();
      oe.request({
        method: "POST",
        url: `${me}/diydesign/up/${e.id}`,
        data: {
          userID: t
        }
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && this.refresh();
      });
    },
    async handleBelow(e) {
      const t = await qe();
      oe.request({
        method: "POST",
        url: `${me}/diydesign/below/${e.id}`,
        data: {
          userID: t
        }
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && this.refresh();
      });
    },
    resetTime() {
      var e;
      this.leftTimer = 0, (e = this.diyDesignList) != null && e.length && (clearInterval(this.timer), this.timer = setInterval(() => {
        this.diyDesignList.map((t) => {
          (t == null ? void 0 : t.discountSecond) > 0 && (this.leftTimer = 1, t.discountSecond >= 0 && (t.discountSecond -= 1));
        });
      }, 1e3));
    },
    async refresh() {
      const e = mt("shopID"), t = await qe();
      this.diyDesignList = [], oe.request({
        method: "GET",
        url: `${me}/shop/diyDesign?shopID=${e}&userID=${t}`,
        data: {}
      }).then((n) => {
        var s, o;
        n && n.status === 200 && n.data && n.data.code === 200 && (this.diyDesignList = (o = (s = n.data) == null ? void 0 : s.data) == null ? void 0 : o.map((a) => {
          if (a != null && a.discountTime) {
            const c = new Date(a == null ? void 0 : a.discountTime);
            a.discountSecond = parseInt((c.getTime() - (/* @__PURE__ */ new Date()).getTime()) / 1e3);
          }
          return a;
        }), this.resetTime());
      });
    },
    handleHome() {
      window.location.href = "/pages/diy-commodity";
    },
    handleBrokerage() {
      const e = mt("shopID");
      window.location.href = `/pages/diy-brokerage?shopID=${e}`;
    },
    handleAvatar() {
      this.shop.isShopkeeper && (this.isEditAvatar = !0);
    },
    closeAvatar() {
      this.isEditAvatar = !1;
    },
    avatarChange() {
      const e = document.createElement("input");
      e.style = "display:none", e.type = "file", e.onchange = async (t) => {
        if (I.size(e.files)) {
          const n = zr(e.files[0].name), s = await As(e.files[0], `${(/* @__PURE__ */ new Date()).getTime()}.${n}`, "user");
          s && (this.dialogAvatar = s);
        }
      }, e.click();
    },
    async saveAvatar() {
      if (this.dialogAvatar) {
        const e = mt("shopID"), t = await qe();
        oe.request({
          method: "POST",
          url: `${me}/shop/update`,
          data: {
            shopID: e,
            userID: t,
            avatar: this.dialogAvatar
          }
        }).then((n) => {
          n && n.status === 200 && n.data && n.data.code === 200 && (this.refreshDetail(), this.closeAvatar());
        });
      }
    },
    handleBanner() {
      this.shop.isShopkeeper && (this.isEditBanner = !0);
    },
    closeBanner() {
      this.isEditBanner = !1;
    },
    bannerChange() {
      const e = document.createElement("input");
      e.style = "display:none", e.type = "file", e.onchange = async (t) => {
        if (I.size(e.files)) {
          const n = zr(e.files[0].name), s = await As(e.files[0], `${(/* @__PURE__ */ new Date()).getTime()}.${n}`, "user");
          s && (this.dialogBanner = s);
        }
      }, e.click();
    },
    async saveBanner() {
      if (this.dialogBanner) {
        const e = mt("shopID"), t = await qe();
        oe.request({
          method: "POST",
          url: `${me}/shop/update`,
          data: {
            shopID: e,
            userID: t,
            banner: this.dialogBanner
          }
        }).then((n) => {
          n && n.status === 200 && n.data && n.data.code === 200 && (this.refreshDetail(), this.closeBanner());
        });
      }
    },
    handleTitle(e, t) {
      this.shop.isShopkeeper && (this.isEditTitle = !0, this.editTitleID = I.get(t, "id", 0), e.stopPropagation());
    },
    closeTitle() {
      this.isEditTitle = !1;
    },
    async saveTitle() {
      if (this.editTitleID) {
        const e = await qe();
        oe.request({
          method: "POST",
          url: `${me}/diydesign/update/${this.editTitleID}`,
          data: {
            userID: e,
            title: this.dialogTitle
          }
        }).then((t) => {
          t && t.status === 200 && t.data && t.data.code === 200 && (this.refresh(), this.closeTitle());
        });
      }
    },
    handleNickName() {
      this.shop.isShopkeeper && (this.isEditNickName = !0);
    },
    async saveNickName() {
      if (this.dialogNickName) {
        const e = mt("shopID"), t = await qe();
        oe.request({
          method: "POST",
          url: `${me}/shop/update`,
          data: {
            shopID: e,
            userID: t,
            nickname: this.dialogNickName
          }
        }).then((n) => {
          n && n.status === 200 && n.data && n.data.code === 200 && (this.refreshDetail(), this.closeNickName());
        });
      }
    },
    closeNickName() {
      this.isEditNickName = !1;
    },
    handleDescription() {
      this.shop.isShopkeeper && (this.isEditDescription = !0);
    },
    async saveDescription() {
      if (this.dialogDescription) {
        const e = mt("shopID"), t = await qe();
        oe.request({
          method: "POST",
          url: `${me}/shop/update`,
          data: {
            shopID: e,
            userID: t,
            description: this.dialogDescription
          }
        }).then((n) => {
          n && n.status === 200 && n.data && n.data.code === 200 && (this.refreshDetail(), this.closeDescription());
        });
      }
    },
    closeDescription() {
      this.isEditDescription = !1;
    },
    discountTime: function(e) {
      if (e) {
        const t = parseInt(e / 60 / 60 / 24), n = parseInt((e - t * 60 * 60 * 24) / 60 / 60), s = parseInt((e - t * 60 * 60 * 24 - n * 60 * 60) / 60), o = e - t * 60 * 60 * 24 - n * 60 * 60 - s * 60;
        return `${t}day ${n}: ${s}:${o}`;
      }
      return "";
    }
  }
}, aT = { class: "page" }, lT = {
  key: 0,
  class: "header"
}, cT = { class: "banner" }, uT = ["src"], fT = ["src"], dT = {
  key: 0,
  class: "edit-icon-w"
}, hT = {
  key: 0,
  class: "edit-icon-w"
}, pT = { class: "social-media" }, gT = ["href"], mT = ["src"], vT = ["href"], yT = ["src"], wT = ["href"], bT = ["src"], xT = ["href"], _T = ["src"], CT = ["href"], ST = ["src"], LT = { class: "diyDesignList" }, DT = ["onClick"], IT = ["src"], ET = ["onClick"], TT = {
  key: 0,
  class: "edit-icon"
}, kT = { class: "design-content" }, RT = {
  key: 0,
  class: "design-price line-through opacity-60"
}, OT = { class: "design-social" }, AT = { class: "social-item" }, PT = { class: "social-item" }, NT = { class: "text-[12px] font-black flex justify-between px-[12px]" }, MT = {
  key: 0,
  class: "font-semibold"
}, BT = ["onClick"], FT = ["onClick"], $T = {
  key: 0,
  class: "dialog"
}, HT = { class: "dialog-content" }, UT = ["src"], zT = {
  key: 1,
  class: "dialog"
}, WT = { class: "dialog-content" }, qT = ["src"], jT = {
  key: 1,
  class: "banner-logo",
  src: "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/navigateImage.png"
}, VT = {
  key: 2,
  class: "dialog"
}, GT = { class: "dialog-content" }, KT = { class: "dialog-form" }, YT = {
  key: 3,
  class: "dialog"
}, XT = { class: "dialog-content" }, JT = { class: "dialog-form" }, ZT = {
  key: 4,
  class: "dialog"
}, QT = { class: "dialog-content" }, ek = { class: "dialog-form" };
function tk(e, t, n, s, o, a) {
  const c = Ve("MobileLayout");
  return O(), P("div", null, [
    _e(c, null, {
      default: vt(() => {
        var u, d, h, m, v, b, S, D, A, R, F, K, G, Y, re, be, ue, xe, Ee, lt;
        return [
          p("div", aT, [
            o.shop ? (O(), P("div", lT, [
              p("div", cT, [
                p("img", {
                  src: o.shop.banner
                }, null, 8, uT)
              ]),
              o.shop.isShopkeeper ? (O(), P("div", {
                key: 0,
                class: "edit-banner",
                onClick: t[0] || (t[0] = (...Z) => a.handleBanner && a.handleBanner(...Z))
              }, "Edit Cover")) : le("", !0),
              p("div", {
                class: "avatar",
                onClick: t[1] || (t[1] = (...Z) => a.handleAvatar && a.handleAvatar(...Z))
              }, [
                p("img", {
                  src: o.shop.avatar
                }, null, 8, fT)
              ]),
              p("div", {
                class: "nickname",
                onClick: t[2] || (t[2] = (...Z) => a.handleNickName && a.handleNickName(...Z))
              }, [
                p("span", null, fe(o.shop.nickname), 1),
                o.shop.isShopkeeper ? (O(), P("span", dT)) : le("", !0)
              ]),
              p("div", {
                class: "description",
                onClick: t[3] || (t[3] = (...Z) => a.handleDescription && a.handleDescription(...Z))
              }, [
                p("span", null, fe(o.shop.description), 1),
                o.shop.isShopkeeper ? (O(), P("span", hT)) : le("", !0)
              ]),
              p("div", pT, [
                (d = (u = o.shop) == null ? void 0 : u.facebook) != null && d.trim() ? (O(), P("a", {
                  key: 0,
                  href: (m = (h = o.shop) == null ? void 0 : h.facebook) == null ? void 0 : m.trim(),
                  target: "_blank"
                }, [
                  p("img", {
                    src: o.ossCdnDmain + "/assets/fb.png",
                    alt: ""
                  }, null, 8, mT)
                ], 8, gT)) : le("", !0),
                (b = (v = o.shop) == null ? void 0 : v.instagram) != null && b.trim() ? (O(), P("a", {
                  key: 1,
                  href: (D = (S = o.shop) == null ? void 0 : S.instagram) == null ? void 0 : D.trim(),
                  target: "_blank"
                }, [
                  p("img", {
                    src: o.ossCdnDmain + "/assets/ins.png",
                    alt: ""
                  }, null, 8, yT)
                ], 8, vT)) : le("", !0),
                (R = (A = o.shop) == null ? void 0 : A.tiktok) != null && R.trim() ? (O(), P("a", {
                  key: 2,
                  href: (K = (F = o.shop) == null ? void 0 : F.tiktok) == null ? void 0 : K.trim(),
                  target: "_blank"
                }, [
                  p("img", {
                    src: o.ossCdnDmain + "/assets/tk.png",
                    alt: ""
                  }, null, 8, bT)
                ], 8, wT)) : le("", !0),
                (Y = (G = o.shop) == null ? void 0 : G.youtube) != null && Y.trim() ? (O(), P("a", {
                  key: 3,
                  href: (be = (re = o.shop) == null ? void 0 : re.youtube) == null ? void 0 : be.trim(),
                  target: "_blank"
                }, [
                  p("img", {
                    src: o.ossCdnDmain + "/assets/yt.png",
                    alt: ""
                  }, null, 8, _T)
                ], 8, xT)) : le("", !0),
                (xe = (ue = o.shop) == null ? void 0 : ue.twitter) != null && xe.trim() ? (O(), P("a", {
                  key: 4,
                  href: (lt = (Ee = o.shop) == null ? void 0 : Ee.twitter) == null ? void 0 : lt.trim(),
                  target: "_blank"
                }, [
                  p("img", {
                    src: o.ossCdnDmain + "/assets/tw.png",
                    alt: ""
                  }, null, 8, ST)
                ], 8, CT)) : le("", !0)
              ])
            ])) : le("", !0),
            p("div", LT, [
              (O(!0), P(Ae, null, ut(o.diyDesignList, (Z, kt) => (O(), P("div", {
                key: kt,
                class: "design",
                onClick: (Ue) => a.handleDetail(Z)
              }, [
                p("img", {
                  src: Z.coverUrl,
                  class: "cover"
                }, null, 8, IT),
                p("div", {
                  class: "design-title",
                  onClick: (Ue) => {
                    a.handleTitle(Ue, Z);
                  }
                }, [
                  p("span", null, fe(Z.title || Z.commodityName), 1),
                  o.shop.isShopkeeper ? (O(), P("span", TT)) : le("", !0)
                ], 8, ET),
                p("div", kT, [
                  Z.discountSecond ? (O(), P("div", RT, fe(Z.price) + " USD", 1)) : le("", !0),
                  p("div", OT, [
                    p("div", AT, [
                      t[24] || (t[24] = p("img", { src: "https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/diy-visit.png" }, null, -1)),
                      tn(" " + fe(Z.visit || 0), 1)
                    ]),
                    p("div", PT, [
                      t[25] || (t[25] = p("img", { src: "https://hugifts-oss.s3.us-west-1.amazonaws.com/assest/diy-sell.png" }, null, -1)),
                      tn(" " + fe(Z.sell || 0), 1)
                    ])
                  ])
                ]),
                p("div", NT, [
                  p("div", null, fe(a.discountPrice(Z)) + " USD", 1),
                  Z.discountSecond ? (O(), P("div", MT, fe(a.discountTime(Z.discountSecond)), 1)) : le("", !0)
                ]),
                o.shop.isShopkeeper && Z.status === 2 ? (O(), P("div", {
                  key: 0,
                  class: "up",
                  onClick: (Ue) => {
                    a.handleUp(Z), Ue.stopPropagation();
                  }
                }, null, 8, BT)) : le("", !0),
                o.shop.isShopkeeper && Z.status === 1 ? (O(), P("div", {
                  key: 1,
                  class: "below",
                  onClick: (Ue) => {
                    a.handleBelow(Z), Ue.stopPropagation();
                  }
                }, null, 8, FT)) : le("", !0)
              ], 8, DT))), 128))
            ])
          ]),
          o.isEditAvatar ? (O(), P("div", $T, [
            p("div", HT, [
              t[26] || (t[26] = p("div", { class: "dialog-title" }, "Edit Store Logo", -1)),
              p("div", {
                class: "dialog-close",
                onClick: t[4] || (t[4] = (...Z) => a.closeAvatar && a.closeAvatar(...Z))
              }),
              p("div", {
                class: "dialog-avatar",
                onClick: t[5] || (t[5] = (...Z) => a.avatarChange && a.avatarChange(...Z))
              }, [
                p("img", {
                  src: o.dialogAvatar || "https://indivisual-cn-data.oss-cn-shanghai.aliyuncs.com/diy/static/tool/navigateImage.png"
                }, null, 8, UT)
              ]),
              t[27] || (t[27] = p("div", { class: "dialog-message" }, "It's recommended to use an image that's at lease 320 x 320 pixels. Must be a jpg, png or gi file, and 10MD or less.", -1)),
              p("div", {
                class: "dialog-save",
                onClick: t[6] || (t[6] = (...Z) => a.saveAvatar && a.saveAvatar(...Z))
              }, "Save"),
              p("div", {
                class: "dialog-cancel",
                onClick: t[7] || (t[7] = (...Z) => a.closeAvatar && a.closeAvatar(...Z))
              }, "Cancel")
            ])
          ])) : le("", !0),
          o.isEditBanner ? (O(), P("div", zT, [
            p("div", WT, [
              t[28] || (t[28] = p("div", { class: "dialog-title" }, "Edit Cover Image", -1)),
              p("div", {
                class: "dialog-close",
                onClick: t[8] || (t[8] = (...Z) => a.closeBanner && a.closeBanner(...Z))
              }),
              p("div", {
                class: "dialog-banner",
                onClick: t[9] || (t[9] = (...Z) => a.bannerChange && a.bannerChange(...Z))
              }, [
                o.dialogBanner ? (O(), P("img", {
                  key: 0,
                  src: o.dialogBanner
                }, null, 8, qT)) : (O(), P("img", jT))
              ]),
              t[29] || (t[29] = p("div", { class: "dialog-message" }, "For the best results on all devices, use an image that's at lease 1920 x 549 pixels(3.5:1 aspect ratio). Must be a jpg, png or gi file, and 10MD or less.", -1)),
              p("div", {
                class: "dialog-save",
                onClick: t[10] || (t[10] = (...Z) => a.saveBanner && a.saveBanner(...Z))
              }, "Save"),
              p("div", {
                class: "dialog-cancel",
                onClick: t[11] || (t[11] = (...Z) => a.closeBanner && a.closeBanner(...Z))
              }, "Cancel")
            ])
          ])) : le("", !0),
          o.isEditTitle ? (O(), P("div", VT, [
            p("div", GT, [
              t[30] || (t[30] = p("div", { class: "dialog-title" }, "Edit Name", -1)),
              p("div", {
                class: "dialog-close",
                onClick: t[12] || (t[12] = (...Z) => a.closeTitle && a.closeTitle(...Z))
              }),
              p("div", KT, [
                gt(p("input", {
                  "onUpdate:modelValue": t[13] || (t[13] = (Z) => o.dialogTitle = Z)
                }, null, 512), [
                  [St, o.dialogTitle]
                ])
              ]),
              p("div", {
                class: "dialog-save",
                onClick: t[14] || (t[14] = (...Z) => a.saveTitle && a.saveTitle(...Z))
              }, "Save"),
              p("div", {
                class: "dialog-cancel",
                onClick: t[15] || (t[15] = (...Z) => a.closeTitle && a.closeTitle(...Z))
              }, "Cancel")
            ])
          ])) : le("", !0),
          o.isEditNickName ? (O(), P("div", YT, [
            p("div", XT, [
              t[31] || (t[31] = p("div", { class: "dialog-title" }, "Edit Store Name", -1)),
              p("div", {
                class: "dialog-close",
                onClick: t[16] || (t[16] = (...Z) => a.closeNickName && a.closeNickName(...Z))
              }),
              p("div", JT, [
                gt(p("input", {
                  "onUpdate:modelValue": t[17] || (t[17] = (Z) => o.dialogNickName = Z)
                }, null, 512), [
                  [St, o.dialogNickName]
                ])
              ]),
              p("div", {
                class: "dialog-save",
                onClick: t[18] || (t[18] = (...Z) => a.saveNickName && a.saveNickName(...Z))
              }, "Save"),
              p("div", {
                class: "dialog-cancel",
                onClick: t[19] || (t[19] = (...Z) => a.closeNickName && a.closeNickName(...Z))
              }, "Cancel")
            ])
          ])) : le("", !0),
          o.isEditDescription ? (O(), P("div", ZT, [
            p("div", QT, [
              t[32] || (t[32] = p("div", { class: "dialog-title" }, "Edit Store Detail", -1)),
              p("div", {
                class: "dialog-close",
                onClick: t[20] || (t[20] = (...Z) => a.closeDescription && a.closeDescription(...Z))
              }),
              p("div", ek, [
                gt(p("input", {
                  "onUpdate:modelValue": t[21] || (t[21] = (Z) => o.dialogDescription = Z)
                }, null, 512), [
                  [St, o.dialogDescription]
                ])
              ]),
              p("div", {
                class: "dialog-save",
                onClick: t[22] || (t[22] = (...Z) => a.saveDescription && a.saveDescription(...Z))
              }, "Save"),
              p("div", {
                class: "dialog-cancel",
                onClick: t[23] || (t[23] = (...Z) => a.closeDescription && a.closeDescription(...Z))
              }, "Cancel")
            ])
          ])) : le("", !0)
        ];
      }),
      _: 1
    })
  ]);
}
const nk = /* @__PURE__ */ at(oT, [["render", tk], ["__scopeId", "data-v-70b0e729"]]), ik = { class: "shop-featured-page bg-[#f8f8f8] w-[100dvw]" }, rk = {
  class: "h-[280px] p-[24px] flex items-center justify-center text-black",
  style: {
    backgroundImage: "url(https://cdn.shopify.com/s/files/1/0274/8717/files/ip-listing_banner.gif)",
    backgroundPosition: "50%",
    backgroundSize: "cover"
  }
}, sk = { class: "w-full max-w-[480px]" }, ok = { class: "mt-[15px] relative" }, ak = { class: "px-[24px] py-[20px]" }, lk = {
  key: 0,
  class: "text-center"
}, ck = { class: "shop-list grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 max-w-[1200px] mx-auto gap-[15px]" }, uk = ["href"], fk = { class: "w-[58px] h-[58px] border border-black/20 rounded-sm" }, dk = ["src"], hk = { class: "line-clamp-1 flex-1" }, pk = /* @__PURE__ */ Un({
  __name: "index",
  setup(e) {
    const t = dt(""), n = dt([]), s = (c) => {
      const u = new URLSearchParams(c).toString();
      console.log(u, "query");
      let d = me + "/shopFeatured";
      u && (d += `?${u}`), fetch(d, {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      }).then((h) => h.json()).then((h) => {
        h && h.code === 200 && (n.value = h.data, console.log(h, "data."));
      }).catch((h) => {
        console.error("Error fetching data:", h);
      });
    }, o = I.debounce(() => {
      const c = {};
      t.value && (c.nickname = t.value), s(c);
    }, 800), a = (c) => {
      t.value = c.target.value, o();
    };
    return Zn(() => {
      s();
    }), (c, u) => (O(), P("div", ik, [
      p("div", rk, [
        p("div", sk, [
          u[2] || (u[2] = p("div", { class: "text-center text-[29px] font-bold" }, "Pix Gallery Showcase", -1)),
          u[3] || (u[3] = p("div", { class: "text-center text-[12px] mt-[10px]" }, "Explore creative Pix Galleries built by our amazing designers.", -1)),
          p("div", ok, [
            u[1] || (u[1] = p("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              class: "size-5 absolute left-[10px] top-[50%] -translate-y-[50%]"
            }, [
              p("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M8.75 2.5C5.29822 2.5 2.5 5.29822 2.5 8.75C2.5 12.2018 5.29822 15 8.75 15C10.4761 15 12.0377 14.3011 13.1694 13.1694C14.3011 12.0377 15 10.4761 15 8.75C15 5.29822 12.2018 2.5 8.75 2.5ZM1.25 8.75C1.25 4.60786 4.60786 1.25 8.75 1.25C12.8921 1.25 16.25 4.60786 16.25 8.75C16.25 10.5958 15.5825 12.2867 14.4769 13.593L18.5669 17.6831C18.811 17.9271 18.811 18.3229 18.5669 18.5669C18.3229 18.811 17.9271 18.811 17.6831 18.5669L13.593 14.4769C12.2867 15.5825 10.5958 16.25 8.75 16.25C4.60786 16.25 1.25 12.8921 1.25 8.75Z",
                fill: "currentColor"
              })
            ], -1)),
            gt(p("input", {
              onInput: a,
              "onUpdate:modelValue": u[0] || (u[0] = (d) => t.value = d),
              class: "bg-white w-full border border-black/50 rounded-md h-[40px] pl-[40px] pr-[10px]",
              type: "text",
              placeholder: "Search for the name of the Pix Gallery"
            }, null, 544), [
              [St, t.value]
            ])
          ])
        ])
      ]),
      p("div", ak, [
        t.value && !n.value.length ? (O(), P("div", lk, " No Shop Data")) : le("", !0),
        p("div", ck, [
          (O(!0), P(Ae, null, ut(n.value, (d) => (O(), P("a", {
            href: "/pages/mydiyshop?shopID=" + (d == null ? void 0 : d.shopID),
            class: "shop-item bg-white p-[8px] flex items-center gap-[10px] text-black text-[14px] font-semibold"
          }, [
            p("div", fk, [
              p("img", {
                class: "w-full h-full max-h-full max-w-full",
                src: d == null ? void 0 : d.avatar,
                alt: ""
              }, null, 8, dk)
            ]),
            p("div", hk, fe(d == null ? void 0 : d.nickname), 1)
          ], 8, uk))), 256))
        ])
      ])
    ]));
  }
});
function gk(e) {
  window.addEventListener("scroll", function() {
    const n = document.documentElement.scrollHeight, s = window.innerHeight;
    (window.scrollY || document.documentElement.scrollTop) + s >= n && e();
  });
  const t = document.getElementById("mobileLayout");
  t && t.addEventListener("scroll", function() {
    const n = t.scrollHeight, s = t.clientHeight;
    t.scrollTop + s >= n && e();
  });
}
let ps = 1, Er = 20, Qi = !0;
const mk = {
  name: "Brokerage",
  components: {
    MobileLayout: cr
  },
  data() {
    return {
      collect: null,
      brokerageList: [],
      withdrawList: [],
      monthList: [],
      tabList: [{
        name: "balance"
      }, {
        name: "withdraw"
      }, {
        name: "month"
      }],
      tabIndex: 0
    };
  },
  mounted: async function() {
    await this.getCollect(), await this.getBrokerageList(), this.scrollBottom();
  },
  methods: {
    scrollBottom() {
      gk(() => {
        ps += 1, this.tabIndex === 0 ? this.getBrokerageList() : this.tabIndex === 1 ? this.getWithdrawList() : this.getMonthList();
      });
    },
    async getCollect() {
      const e = await qe(), t = mt("shopID");
      oe.request({
        method: "GET",
        url: me + `/brokerage/collect?userID=${e}&shopID=${t}`,
        data: {}
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && (this.collect = n.data.data);
      });
    },
    async getBrokerageList() {
      if (!Qi)
        return;
      const e = await qe(), t = mt("shopID");
      oe.request({
        method: "GET",
        url: me + `/brokerage/list?userID=${e}&shopID=${t}&currentPage=${ps}&pageSize=${Er}`,
        data: {}
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && (this.brokerageList = this.brokerageList.concat(n.data.data), I.size(n.data.data) < Er && (Qi = !1));
      });
    },
    async getWithdrawList() {
      if (!Qi)
        return;
      const e = await qe(), t = mt("shopID");
      oe.request({
        method: "GET",
        url: me + `/brokerage/withdraw?userID=${e}&shopID=${t}&currentPage=${ps}&pageSize=${Er}`,
        data: {}
      }).then((n) => {
        if (n && n.status === 200 && n.data && n.data.code === 200) {
          const s = I.get(n, ["data", "data"], {});
          for (let o = 0; o < I.size(s); o++)
            this.withdrawList.push({
              ...s[o],
              createTime: I.get(s, [o, "createTime"], "").substring(0, 10)
            });
          I.size(s) < Er && (Qi = !1);
        }
      });
    },
    async getMonthList() {
      if (!Qi)
        return;
      const e = await qe(), t = mt("shopID");
      oe.request({
        method: "GET",
        url: me + `/brokerage/month?userID=${e}&shopID=${t}&currentPage=${ps}&pageSize=${Er}`,
        data: {}
      }).then((n) => {
        n && n.status === 200 && n.data && n.data.code === 200 && (this.monthList = this.monthList.concat(n.data.data), I.size(n.data.data) < Er && (Qi = !1));
      });
    },
    handleTab(e) {
      this.tabIndex = Number(e), ps = 1, Qi = !0, this.tabIndex === 0 ? (this.brokerageList = [], this.getBrokerageList()) : this.tabIndex === 1 ? (this.withdrawList = [], this.getWithdrawList()) : (this.monthList = [], this.getMonthList());
    }
  }
}, vk = { class: "page" }, yk = {
  key: 0,
  class: "header"
}, wk = { class: "collect" }, bk = { class: "collect" }, xk = { class: "collect" }, _k = { class: "collect" }, Ck = { class: "tabs" }, Sk = ["onClick"], Lk = { key: 1 }, Dk = { class: "list-panel" }, Ik = { key: 2 }, Ek = { class: "list-panel" }, Tk = { key: 3 }, kk = { class: "list-panel" };
function Rk(e, t, n, s, o, a) {
  const c = Ve("MobileLayout");
  return O(), P("div", null, [
    _e(c, null, {
      default: vt(() => [
        p("div", vk, [
          o.collect ? (O(), P("div", yk, [
            p("div", wk, [
              t[0] || (t[0] = p("div", { class: "collect-lable" }, "all brokerage:", -1)),
              p("div", null, fe(o.collect.allBrokerage), 1)
            ]),
            p("div", bk, [
              t[1] || (t[1] = p("div", { class: "collect-lable" }, "this month brokerage:", -1)),
              p("div", null, fe(o.collect.monthBrokerage), 1)
            ]),
            p("div", xk, [
              t[2] || (t[2] = p("div", { class: "collect-lable" }, "all withdraw:", -1)),
              p("div", null, fe(o.collect.allWithdraw), 1)
            ]),
            p("div", _k, [
              t[3] || (t[3] = p("div", { class: "collect-lable" }, "balance:", -1)),
              p("div", null, fe(o.collect.balance), 1)
            ])
          ])) : le("", !0),
          p("div", Ck, [
            (O(!0), P(Ae, null, ut(o.tabList, (u, d) => (O(), P("div", {
              class: _t(["tab", { current: d === o.tabIndex }]),
              onClick: (h) => a.handleTab(d)
            }, fe(u.name), 11, Sk))), 256))
          ]),
          o.tabIndex === 0 ? (O(), P("div", Lk, [
            (O(!0), P(Ae, null, ut(o.brokerageList, (u) => (O(), P("div", Dk, [
              p("div", null, "order: " + fe(u.podID), 1),
              p("div", null, "commodity: " + fe(u.commodityName), 1),
              p("div", null, "brokerage: " + fe(u.brokerage), 1)
            ]))), 256))
          ])) : le("", !0),
          o.tabIndex === 1 ? (O(), P("div", Ik, [
            (O(!0), P(Ae, null, ut(o.withdrawList, (u) => (O(), P("div", Ek, [
              p("div", null, "withdraw: " + fe(u.withdraw), 1),
              p("div", null, "time: " + fe(u.createTime), 1)
            ]))), 256))
          ])) : le("", !0),
          o.tabIndex === 2 ? (O(), P("div", Tk, [
            (O(!0), P(Ae, null, ut(o.monthList, (u) => (O(), P("div", kk, [
              p("div", null, "brokerage: " + fe(u.brokerage), 1),
              p("div", null, "month: " + fe(u.month), 1)
            ]))), 256))
          ])) : le("", !0)
        ])
      ]),
      _: 1
    })
  ]);
}
const Ok = /* @__PURE__ */ at(mk, [["render", Rk], ["__scopeId", "data-v-e2753e36"]]);
function Ak(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function au() {
  let e = [], t = { addEventListener(n, s, o, a) {
    return n.addEventListener(s, o, a), t.add(() => n.removeEventListener(s, o, a));
  }, requestAnimationFrame(...n) {
    let s = requestAnimationFrame(...n);
    t.add(() => cancelAnimationFrame(s));
  }, nextFrame(...n) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...n);
    });
  }, setTimeout(...n) {
    let s = setTimeout(...n);
    t.add(() => clearTimeout(s));
  }, microTask(...n) {
    let s = { current: !0 };
    return Ak(() => {
      s.current && n[0]();
    }), t.add(() => {
      s.current = !1;
    });
  }, style(n, s, o) {
    let a = n.style.getPropertyValue(s);
    return Object.assign(n.style, { [s]: o }), this.add(() => {
      Object.assign(n.style, { [s]: a });
    });
  }, group(n) {
    let s = au();
    return n(s), this.add(() => s.dispose());
  }, add(n) {
    return e.push(n), () => {
      let s = e.indexOf(n);
      if (s >= 0) for (let o of e.splice(s, 1)) o();
    };
  }, dispose() {
    for (let n of e.splice(0)) n();
  } };
  return t;
}
var up;
let Pk = Symbol("headlessui.useid"), Nk = 0;
const Mk = (up = Yx) != null ? up : function() {
  return un(Pk, () => `${++Nk}`)();
};
function fp(e) {
  var t;
  if (e == null || e.value == null) return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function Ns(e, t, ...n) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  let s = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(s, Ns), s;
}
var Bk = Object.defineProperty, Fk = (e, t, n) => t in e ? Bk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, dp = (e, t, n) => (Fk(e, typeof t != "symbol" ? t + "" : t, n), n);
let $k = class {
  constructor() {
    dp(this, "current", this.detect()), dp(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, Hk = new $k();
var dm = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(dm || {}), Pi = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Pi || {});
function hm({ visible: e = !0, features: t = 0, ourProps: n, theirProps: s, ...o }) {
  var a;
  let c = gm(s, n), u = Object.assign(o, { props: c });
  if (e || t & 2 && c.static) return ac(u);
  if (t & 1) {
    let d = (a = c.unmount) == null || a ? 0 : 1;
    return Ns(d, { 0() {
      return null;
    }, 1() {
      return ac({ ...o, props: { ...c, hidden: !0, style: { display: "none" } } });
    } });
  }
  return ac(u);
}
function ac({ props: e, attrs: t, slots: n, slot: s, name: o }) {
  var a, c;
  let { as: u, ...d } = mm(e, ["unmount", "static"]), h = (a = n.default) == null ? void 0 : a.call(n, s), m = {};
  if (s) {
    let v = !1, b = [];
    for (let [S, D] of Object.entries(s)) typeof D == "boolean" && (v = !0), D === !0 && b.push(S);
    v && (m["data-headlessui-state"] = b.join(" "));
  }
  if (u === "template") {
    if (h = pm(h ?? []), Object.keys(d).length > 0 || Object.keys(t).length > 0) {
      let [v, ...b] = h ?? [];
      if (!Uk(v) || b.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(d).concat(Object.keys(t)).map((A) => A.trim()).filter((A, R, F) => F.indexOf(A) === R).sort((A, R) => A.localeCompare(R)).map((A) => `  - ${A}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((A) => `  - ${A}`).join(`
`)].join(`
`));
      let S = gm((c = v.props) != null ? c : {}, d, m), D = or(v, S, !0);
      for (let A in S) A.startsWith("on") && (D.props || (D.props = {}), D.props[A] = S[A]);
      return D;
    }
    return Array.isArray(h) && h.length === 1 ? h[0] : h;
  }
  return Hs(u, Object.assign({}, d, m), { default: () => h });
}
function pm(e) {
  return e.flatMap((t) => t.type === Ae ? pm(t.children) : [t]);
}
function gm(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let s of e) for (let o in s) o.startsWith("on") && typeof s[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(s[o])) : t[o] = s[o];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((s) => [s, void 0])));
  for (let s in n) Object.assign(t, { [s](o, ...a) {
    let c = n[s];
    for (let u of c) {
      if (o instanceof Event && o.defaultPrevented) return;
      u(o, ...a);
    }
  } });
  return t;
}
function mm(e, t = []) {
  let n = Object.assign({}, e);
  for (let s of t) s in n && delete n[s];
  return n;
}
function Uk(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
let vm = Symbol("Context");
var pi = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(pi || {});
function zk() {
  return ym() !== null;
}
function ym() {
  return un(vm, null);
}
function Wk(e) {
  Mi(vm, e);
}
function qk(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called) return t.called = !0, e(...n);
  };
}
function lc(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Ho(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var Oc = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(Oc || {});
function jk(e, t) {
  let n = au();
  if (!e) return n.dispose;
  let { transitionDuration: s, transitionDelay: o } = getComputedStyle(e), [a, c] = [s, o].map((u) => {
    let [d = 0] = u.split(",").filter(Boolean).map((h) => h.includes("ms") ? parseFloat(h) : parseFloat(h) * 1e3).sort((h, m) => m - h);
    return d;
  });
  return a !== 0 ? n.setTimeout(() => t("finished"), a + c) : t("finished"), n.add(() => t("cancelled")), n.dispose;
}
function hp(e, t, n, s, o, a) {
  let c = au(), u = a !== void 0 ? qk(a) : () => {
  };
  return Ho(e, ...o), lc(e, ...t, ...n), c.nextFrame(() => {
    Ho(e, ...n), lc(e, ...s), c.add(jk(e, (d) => (Ho(e, ...s, ...t), lc(e, ...o), u(d))));
  }), c.add(() => Ho(e, ...t, ...n, ...s, ...o)), c.add(() => u("cancelled")), c.dispose;
}
function er(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let lu = Symbol("TransitionContext");
var Vk = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(Vk || {});
function Gk() {
  return un(lu, null) !== null;
}
function Kk() {
  let e = un(lu, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function Yk() {
  let e = un(cu, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let cu = Symbol("NestingContext");
function Ea(e) {
  return "children" in e ? Ea(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function wm(e) {
  let t = dt([]), n = dt(!1);
  Zn(() => n.value = !0), ma(() => n.value = !1);
  function s(a, c = Pi.Hidden) {
    let u = t.value.findIndex(({ id: d }) => d === a);
    u !== -1 && (Ns(c, { [Pi.Unmount]() {
      t.value.splice(u, 1);
    }, [Pi.Hidden]() {
      t.value[u].state = "hidden";
    } }), !Ea(t) && n.value && (e == null || e()));
  }
  function o(a) {
    let c = t.value.find(({ id: u }) => u === a);
    return c ? c.state !== "visible" && (c.state = "visible") : t.value.push({ id: a, state: "visible" }), () => s(a, Pi.Unmount);
  }
  return { children: t, register: o, unregister: s };
}
let bm = dm.RenderStrategy, Ko = /* @__PURE__ */ Un({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: s, expose: o }) {
  let a = dt(0);
  function c() {
    a.value |= pi.Opening, t("beforeEnter");
  }
  function u() {
    a.value &= ~pi.Opening, t("afterEnter");
  }
  function d() {
    a.value |= pi.Closing, t("beforeLeave");
  }
  function h() {
    a.value &= ~pi.Closing, t("afterLeave");
  }
  if (!Gk() && zk()) return () => Hs(xm, { ...e, onBeforeEnter: c, onAfterEnter: u, onBeforeLeave: d, onAfterLeave: h }, s);
  let m = dt(null), v = Ut(() => e.unmount ? Pi.Unmount : Pi.Hidden);
  o({ el: m, $el: m });
  let { show: b, appear: S } = Kk(), { register: D, unregister: A } = Yk(), R = dt(b.value ? "visible" : "hidden"), F = { value: !0 }, K = Mk(), G = { value: !1 }, Y = wm(() => {
    !G.value && R.value !== "hidden" && (R.value = "hidden", A(K), h());
  });
  Zn(() => {
    let Ue = D(K);
    ma(Ue);
  }), ta(() => {
    if (v.value === Pi.Hidden && K) {
      if (b.value && R.value !== "visible") {
        R.value = "visible";
        return;
      }
      Ns(R.value, { hidden: () => A(K), visible: () => D(K) });
    }
  });
  let re = er(e.enter), be = er(e.enterFrom), ue = er(e.enterTo), xe = er(e.entered), Ee = er(e.leave), lt = er(e.leaveFrom), Z = er(e.leaveTo);
  Zn(() => {
    ta(() => {
      if (R.value === "visible") {
        let Ue = fp(m);
        if (Ue instanceof Comment && Ue.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function kt(Ue) {
    let Nt = F.value && !S.value, ht = fp(m);
    !ht || !(ht instanceof HTMLElement) || Nt || (G.value = !0, b.value && c(), b.value || d(), Ue(b.value ? hp(ht, re, be, ue, xe, (Pe) => {
      G.value = !1, Pe === Oc.Finished && u();
    }) : hp(ht, Ee, lt, Z, xe, (Pe) => {
      G.value = !1, Pe === Oc.Finished && (Ea(Y) || (R.value = "hidden", A(K), h()));
    })));
  }
  return Zn(() => {
    Br([b], (Ue, Nt, ht) => {
      kt(ht), F.value = !1;
    }, { immediate: !0 });
  }), Mi(cu, Y), Wk(Ut(() => Ns(R.value, { visible: pi.Open, hidden: pi.Closed }) | a.value)), () => {
    let { appear: Ue, show: Nt, enter: ht, enterFrom: Pe, enterTo: ke, entered: Ce, leave: It, leaveFrom: yt, leaveTo: Je, ...tt } = e, ze = { ref: m }, nt = { ...tt, ...S.value && b.value && Hk.isServer ? { class: _t([n.class, tt.class, ...re, ...be]) } : {} };
    return hm({ theirProps: nt, ourProps: ze, slot: {}, slots: s, attrs: n, features: bm, visible: R.value === "visible", name: "TransitionChild" });
  };
} }), Xk = Ko, xm = /* @__PURE__ */ Un({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: s }) {
  let o = ym(), a = Ut(() => e.show === null && o !== null ? (o.value & pi.Open) === pi.Open : e.show);
  ta(() => {
    if (![!0, !1].includes(a.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let c = dt(a.value ? "visible" : "hidden"), u = wm(() => {
    c.value = "hidden";
  }), d = dt(!0), h = { show: a, appear: Ut(() => e.appear || !d.value) };
  return Zn(() => {
    ta(() => {
      d.value = !1, a.value ? c.value = "visible" : Ea(u) || (c.value = "hidden");
    });
  }), Mi(cu, u), Mi(lu, h), () => {
    let m = mm(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), v = { unmount: e.unmount };
    return hm({ ourProps: { ...v, as: "template" }, theirProps: {}, slot: {}, slots: { ...s, default: () => [Hs(Xk, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...n, ...v, ...m }, s.default)] }, attrs: {}, features: bm, visible: c.value === "visible", name: "Transition" });
  };
} });
function Jk(e, t) {
  return O(), P("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    p("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    })
  ]);
}
const Zk = { class: "main-account text-[16px]" }, Qk = { class: "bg-[#242833] text-white flex justify-between items-center px-[20px] pt-[20px] pb-[12px]" }, e4 = { class: "flex gap-[10px]" }, t4 = { class: "w-[40px] h-[40px] bg-white rounded-full" }, n4 = ["src"], i4 = { class: "text-[13px] line-clamp-1" }, r4 = { class: "text-[#2e38e7] px-[32px] py-[12px]" }, s4 = {
  key: 0,
  class: "border-b border-[rgba(46,56,231,0.5)] pb-[12px]"
}, o4 = { class: "grid grid-cols-2 mt-[12px] gap-x-[12px] gap-y-[8px]" }, a4 = { class: "bg-[rgba(46,56,231,0.1)] py-[6px] rounded-full flex flex-col items-center" }, l4 = { class: "text-[14px] font-semibold" }, c4 = { class: "text-[10px] md:text-[12px] font-semibold text-center" }, u4 = { class: "mt-[16px]" }, f4 = ["onClick"], d4 = ["src"], h4 = ["src"], p4 = { class: "mt-[16px]" }, g4 = { class: "cursor-pointer text-[14px] font-bold flex items-center gap-[12px] py-[4px]" }, m4 = ["src"], v4 = /* @__PURE__ */ Un({
  __name: "MainAccount",
  emits: ["goPage"],
  setup(e, { emit: t }) {
    const n = t, s = dt(null), o = dt({}), a = Ut(() => [
      {
        text: "Total Commission",
        value: o.value.allBrokerage || "0.00",
        symbol: "$"
      },
      {
        text: "This Month's Earnings",
        value: o.value.monthBrokerage || "0.00",
        symbol: "$"
      },
      {
        text: "Total Withdrawals",
        value: o.value.allWithdraw || "0.00",
        symbol: "$"
      },
      {
        text: "Pending Withdrawal",
        value: o.value.balance || "0.00",
        symbol: "$"
      }
    ]), c = dt([
      {
        text: "Edit My Gallery",
        icon: Ct + "/shopify-web/edit-shop.png",
        url: "editMyGallery",
        type: "leftPage"
      },
      {
        text: "View My Gallery",
        icon: Ct + "/shopify-web/view-shop.png",
        url: "/pages/mydiyshop?shopID=",
        type: "link"
      },
      {
        text: "My Earnings",
        icon: Ct + "/shopify-web/my-earnings.png",
        url: "/pages/diy-brokerage",
        type: "link"
      }
    ]), u = dt([
      {
        text: "Order History",
        icon: Ct + "/shopify-web/order-history.png",
        url: "/account",
        type: "leftPage"
      },
      {
        text: "Ideas for You",
        icon: Ct + "/shopify-web/ideas.png",
        url: "/",
        type: "link"
      },
      {
        text: "Account Setting",
        icon: Ct + "/shopify-web/account.png",
        url: "/",
        type: "link"
      },
      {
        text: "My Address",
        icon: Ct + "/shopify-web/myaddress.png",
        url: "/account/addresses",
        type: "link"
      },
      {
        text: "Messages",
        icon: Ct + "/shopify-web/msg.png",
        url: "/",
        type: "link"
      },
      {
        text: "Make $1000!",
        icon: Ct + "/shopify-web/make.png",
        url: "/",
        type: "link"
      }
    ]), d = (v) => {
      if ((v == null ? void 0 : v.type) === "leftPage") return n("goPage", v);
      location.href = v.url;
    }, h = async () => {
      const v = await qe(), b = mt("shopID");
      fetch(me + `/brokerage/collect?userID=${v}&shopID=${b}`, {
        method: "GET"
      }).then((S) => {
        if (!S.ok)
          throw new Error(`HTTP error! status: ${S.status}`);
        return S.json();
      }).then((S) => {
        S && S.code === 200 && (o.value = S.data);
      }).catch((S) => {
        console.error("Error fetching data:", S);
      });
    }, m = async () => {
      const v = await qe();
      fetch(me + `/users/detail?userID=${v}`, {
        method: "GET"
      }).then((b) => {
        if (!b.ok)
          throw new Error(`HTTP error! status: ${b.status}`);
        return b.json();
      }).then((b) => {
        var S;
        b && b.code === 200 && (s.value = b.data, c.value[1].url += (S = s.value) == null ? void 0 : S.shopID);
      }).catch((b) => {
        console.error("Error fetching data:", b);
      });
    };
    return Zn(async () => {
      m(), h();
    }), (v, b) => {
      var S, D, A, R;
      return O(), P("div", Zk, [
        p("div", Qk, [
          p("div", e4, [
            p("div", t4, [
              p("img", {
                src: en(Ct) + "/assets/my-avatar.png",
                alt: ""
              }, null, 8, n4)
            ]),
            p("div", null, [
              p("div", null, [
                b[1] || (b[1] = tn("HI,")),
                p("span", null, fe((S = s.value) == null ? void 0 : S.firstName), 1),
                p("span", null, fe((D = s.value) == null ? void 0 : D.lastName), 1)
              ]),
              p("div", i4, fe((A = s.value) == null ? void 0 : A.userID), 1)
            ])
          ]),
          b[2] || (b[2] = p("a", {
            href: "/account/logout",
            class: "log-out font-bold text-white"
          }, "Log Out", -1))
        ]),
        p("div", r4, [
          (R = s.value) != null && R.shopID ? (O(), P("div", s4, [
            b[3] || (b[3] = p("div", { class: "font-bold text-[18px]" }, "Manage Pix Gallery", -1)),
            p("div", o4, [
              (O(!0), P(Ae, null, ut(a.value, (F) => (O(), P("div", a4, [
                p("div", l4, fe(F == null ? void 0 : F.symbol) + fe(F == null ? void 0 : F.value), 1),
                p("div", c4, fe(F == null ? void 0 : F.text), 1)
              ]))), 256))
            ]),
            p("ul", u4, [
              (O(!0), P(Ae, null, ut(c.value, (F) => (O(), P("li", {
                onClick: (K) => d(F),
                class: "cursor-pointer text-[14px] font-bold flex items-center gap-[12px] py-[4px]"
              }, [
                p("img", {
                  class: "w-[28px] h-[28px]",
                  src: F == null ? void 0 : F.icon,
                  alt: ""
                }, null, 8, d4),
                tn(" " + fe(F == null ? void 0 : F.text), 1)
              ], 8, f4))), 256))
            ])
          ])) : le("", !0),
          p("div", null, [
            b[5] || (b[5] = p("div", { class: "font-bold text-[18px] py-[4px]" }, "Account", -1)),
            p("div", {
              onClick: b[0] || (b[0] = (F) => d({ url: "/pages/mydiydesign" })),
              class: "bg-[#2e38e7] text-white flex justify-center items-center text-[14px] font-semibold py-[4px] rounded-full cursor-pointer"
            }, [
              p("img", {
                class: "w-[28px] h-[28px]",
                src: en(Ct) + "/shopify-web/my-portfolio-yellow.png",
                alt: ""
              }, null, 8, h4),
              b[4] || (b[4] = tn(" My Portfolio "))
            ])
          ]),
          p("ul", p4, [
            (O(!0), P(Ae, null, ut(u.value, (F) => (O(), P("li", g4, [
              p("img", {
                class: "w-[28px] h-[28px]",
                src: F == null ? void 0 : F.icon,
                alt: ""
              }, null, 8, m4),
              tn(" " + fe(F == null ? void 0 : F.text), 1)
            ]))), 256))
          ])
        ])
      ]);
    };
  }
}), y4 = ["name", "disabled"], w4 = {
  key: 0,
  class: "flex items-center justify-center"
}, b4 = { key: 0 }, pp = /* @__PURE__ */ Un({
  __name: "MyButton",
  props: {
    type: {
      //按钮类型
      default: ""
    },
    disabled: {
      //按钮类型
      type: Boolean,
      default: !1
    },
    loading: {
      //按钮类型
      type: Boolean,
      default: !1
    },
    hoverOpacity: {
      //按钮类型
      type: Number,
      default: 80
    },
    loadingText: {
      //按钮类型
      type: String,
      default: "Loading"
    },
    name: {
      //按钮类型
      type: String,
      default: "Botton"
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, s = e, o = Ut(() => s.loading), a = dt(null), c = (d) => {
      n("click", d);
    }, u = (d) => {
      d === "down" ? a.value.style.transform = "translateY(1px)" : a.value.style.transform = "translateY(0)";
    };
    return (d, h) => (O(), P("button", {
      name: e.name,
      ref_key: "btnEl",
      ref: a,
      disabled: o.value || e.disabled,
      class: _t([[
        e.hoverOpacity ? `hover:opacity-[${e.hoverOpacity}]` : "hover:opacity-80"
      ], "my-button"]),
      onClick: c,
      onMousedown: h[0] || (h[0] = (m) => u("down")),
      onMouseup: h[1] || (h[1] = (m) => u("up"))
    }, [
      o.value ? (O(), P("div", w4, [
        h[2] || (h[2] = p("svg", {
          t: "1696395089207",
          class: "icon mr-[4px] animate-rotating fill-white w-[20px] h-[20px]",
          viewBox: "0 0 1024 1024",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "p-id": "15559",
          width: "1em",
          height: "1em"
        }, [
          p("path", {
            d: "M512 74.666667c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32V106.666667c0-17.066667-14.933333-32-32-32zM693.333333 362.666667c8.533333 0 17.066667-2.133333 23.466667-8.533334l104.533333-104.533333c12.8-12.8 12.8-32 0-44.8-12.8-12.8-32-12.8-44.8 0l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 4.266667 6.4 12.8 8.533333 21.333333 8.533334zM917.333333 480h-149.333333c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32zM714.666667 669.866667c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333zM512 736c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-149.333333c0-17.066667-14.933333-32-32-32zM309.333333 669.866667l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333l104.533334-104.533333c12.8-12.8 12.8-32 0-44.8s-36.266667-12.8-46.933334 0zM288 512c0-17.066667-14.933333-32-32-32H106.666667c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32zM247.466667 202.666667c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333z",
            "p-id": "15560"
          })
        ], -1)),
        e.loadingText ? (O(), P("span", b4, fe(e.loadingText), 1)) : le("", !0)
      ])) : va(d.$slots, "default", { key: 1 })
    ], 42, y4));
  }
}), x4 = { class: "edit-my-gallery text-[16px] text-black py-[8px]" }, _4 = { class: "px-[4px]" }, C4 = { class: "bg-black/10 rounded-full flex gap-[6px] items-center text-sm font-bold px-[12px] py-[12px]" }, S4 = ["src"], L4 = { class: "px-[16px]" }, D4 = { class: "mt-[8px]" }, I4 = { class: "mt-[8px]" }, E4 = { class: "px-[16px]" }, T4 = { class: "mt-[16px]" }, k4 = { class: "mt-[8px]" }, R4 = { class: "mt-[8px] flex items-center gap-[8px] px-[8px] py-[8px]" }, O4 = ["checked"], A4 = { class: "mt-[16px]" }, P4 = { class: "mt-[28px] px-[16px] pb-[30px]" }, N4 = { class: "mt-[8px]" }, M4 = { class: "mt-[8px]" }, B4 = { class: "mt-[8px]" }, F4 = { class: "mt-[8px]" }, $4 = { class: "mt-[8px]" }, H4 = { class: "mt-[16px]" }, U4 = /* @__PURE__ */ Un({
  __name: "EditMyGallery",
  setup(e) {
    const t = dt(!1), n = dt(!1), s = dt({
      artist: "",
      nickname: "",
      description: "",
      location: "",
      hideLocation: !1
    }), o = dt({
      facebook: "",
      instagram: "",
      tiktok: "",
      youtube: "",
      twitter: ""
    }), a = (d) => {
      s.value.hideLocation = d.target.checked;
    }, c = async (d) => {
      if (n.value || t.value) return console.log("submiting...");
      const h = await qe(), m = await Xh();
      if (console.log(m, "shopID"), !h) {
        Ur();
        return;
      }
      let v = { shopID: m, userID: h };
      d === "shopinfo" && (n.value = !0, v = Object.assign(v, s.value)), d === "social" && (v = Object.assign(v, o.value), t.value = !0), fetch(me + "/shop/update", {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(v)
      }).then((b) => {
        if (!b.ok)
          throw n.value = !1, t.value = !1, new Error(`HTTP error! status: ${b.status}`);
        return b.json();
      }).then((b) => {
        b && b.code === 200 && console.log(b, "data."), n.value = !1, t.value = !1;
      }).catch((b) => {
        n.value = !1, t.value = !1, console.error("Error fetching data:", b);
      }), console.log("submit-888");
    }, u = async () => {
      const d = await qe(), h = await Xh();
      fetch(me + `/shop/detail?userID=${d}&shopID=${h}`, {
        method: "GET"
      }).then((m) => {
        if (!m.ok)
          throw new Error(`HTTP error! status: ${m.status}`);
        return m.json();
      }).then((m) => {
        if (m && m.code === 200) {
          const v = m.data;
          s.value.artist = v == null ? void 0 : v.artist, s.value.nickname = v == null ? void 0 : v.nickname, s.value.description = v == null ? void 0 : v.description, s.value.location = v == null ? void 0 : v.location, o.value.facebook = v == null ? void 0 : v.facebook, o.value.instagram = v == null ? void 0 : v.instagram, o.value.tiktok = v == null ? void 0 : v.tiktok, o.value.youtube = v == null ? void 0 : v.youtube, o.value.twitter = v == null ? void 0 : v.twitter, console.log(v, "resData");
        }
      }).catch((m) => {
        console.error("Error fetching data:", m);
      });
    };
    return Zn(() => {
      u();
    }), (d, h) => {
      var m;
      return O(), P("div", x4, [
        h[29] || (h[29] = U_('<div class="px-[8px]"><div><div class="text-[20px] font-bold flex items-center gap-[16px]">My Account <span class="rounded-full text-[12px] px-[6px] border border-black flex items-center">Pending</span></div></div><div class="py-[12px]"><div class="border-[2px] border-black inline-flex text-base py-[2px] font-bold rounded-full px-[12px]">My Pix Gallery</div></div></div>', 1)),
        p("div", _4, [
          p("div", C4, [
            p("img", {
              class: "w-6 h-6",
              src: en(Ct) + "/shopify-web/edit-shop.png",
              alt: ""
            }, null, 8, S4),
            h[11] || (h[11] = tn(" Edit My Pix Gallery "))
          ]),
          p("div", L4, [
            p("div", D4, [
              h[12] || (h[12] = p("div", { class: "text-[14px] font-bold" }, "Artist Name", -1)),
              h[13] || (h[13] = p("div", { class: "text-[11px]" }, "Appears next to your designs on product and search pages", -1)),
              gt(p("input", {
                "onUpdate:modelValue": h[0] || (h[0] = (v) => s.value.artist = v),
                class: "mt-[4px] outline-0 border-[2px] border-black rounded-full w-full px-[12px] py-[6px] font-semibold",
                type: "text"
              }, null, 512), [
                [St, s.value.artist]
              ])
            ]),
            p("div", I4, [
              h[14] || (h[14] = p("div", { class: "text-[14px] font-bold" }, "Store Name", -1)),
              h[15] || (h[15] = p("div", { class: "text-[11px]" }, "This is the public display name of your store.", -1)),
              gt(p("input", {
                "onUpdate:modelValue": h[1] || (h[1] = (v) => s.value.nickname = v),
                class: "mt-[4px] outline-0 border-[2px] border-black rounded-full w-full px-[12px] py-[6px] font-semibold",
                type: "text"
              }, null, 512), [
                [St, s.value.nickname]
              ])
            ])
          ]),
          p("div", E4, [
            h[21] || (h[21] = p("div", { class: "text-[20px] font-bold mt-[8px]" }, " Store Details ", -1)),
            p("div", T4, [
              h[16] || (h[16] = p("div", { class: "text-[14px] font-bold" }, "About (optional)", -1)),
              h[17] || (h[17] = p("div", { class: "text-[11px]" }, "150 character limit. Leave blank to hide.", -1)),
              gt(p("textarea", {
                "onUpdate:modelValue": h[2] || (h[2] = (v) => s.value.description = v),
                type: "",
                class: "leading-[20px] resize-none mt-[4px] outline-0 border-2 border-black rounded-full w-full px-[12px] py-[6px] font-semibold"
              }, null, 512), [
                [St, s.value.description]
              ])
            ]),
            p("div", k4, [
              h[18] || (h[18] = p("div", { class: "text-[14px] font-bold" }, "Location (optional)", -1)),
              gt(p("input", {
                "onUpdate:modelValue": h[3] || (h[3] = (v) => s.value.location = v),
                class: "mt-[4px] outline-0 border-2 border-black rounded-full w-full px-[12px] py-[6px] font-semibold",
                type: "text"
              }, null, 512), [
                [St, s.value.location]
              ])
            ]),
            p("div", R4, [
              p("input", {
                checked: (m = s.value) == null ? void 0 : m.hideLocation,
                onChange: a,
                class: "my-checkbox h-[20px] w-[20px] rounded-md border-2",
                type: "checkbox"
              }, null, 40, O4),
              h[19] || (h[19] = p("div", { class: "text-[18px] font-bold" }, "Hide Location", -1))
            ]),
            p("div", A4, [
              _e(pp, {
                onClick: h[4] || (h[4] = (v) => c("shopinfo")),
                loading: n.value,
                class: "bg-[#2e38e7] text-white font-semibold px-[12px] py-[8px] rounded-full"
              }, {
                default: vt(() => h[20] || (h[20] = [
                  tn(" Save All Changes ")
                ])),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          p("div", P4, [
            h[28] || (h[28] = p("hr", { class: "mb-[20px] w-[93%] mx-auto border-black/30" }, null, -1)),
            p("div", N4, [
              h[22] || (h[22] = p("div", { class: "text-[14px] font-bold" }, "Facebook (optional)", -1)),
              gt(p("input", {
                "onUpdate:modelValue": h[5] || (h[5] = (v) => o.value.facebook = v),
                placeholder: "https://www.facebook.com/pixvoices",
                class: "mt-[4px] outline-0 border-2 border-black rounded-full w-full px-[12px] py-[6px] font-semibold",
                type: "text"
              }, null, 512), [
                [St, o.value.facebook]
              ])
            ]),
            p("div", M4, [
              h[23] || (h[23] = p("div", { class: "text-[14px] font-bold" }, "instagram (optional)", -1)),
              gt(p("input", {
                "onUpdate:modelValue": h[6] || (h[6] = (v) => o.value.instagram = v),
                placeholder: "https://www.instagram.com/pixvoices/",
                class: "mt-[4px] outline-0 border-2 border-black rounded-full w-full px-[12px] py-[6px] font-semibold",
                type: "text"
              }, null, 512), [
                [St, o.value.instagram]
              ])
            ]),
            p("div", B4, [
              h[24] || (h[24] = p("div", { class: "text-[14px] font-bold" }, "TikTok (Optional)", -1)),
              gt(p("input", {
                "onUpdate:modelValue": h[7] || (h[7] = (v) => o.value.tiktok = v),
                placeholder: "https://www.tiktok.com/@pixvoices",
                class: "mt-[4px] outline-0 border-2 border-black rounded-full w-full px-[12px] py-[6px] font-semibold",
                type: "text"
              }, null, 512), [
                [St, o.value.tiktok]
              ])
            ]),
            p("div", F4, [
              h[25] || (h[25] = p("div", { class: "text-[14px] font-bold" }, "YouTube (optional)", -1)),
              gt(p("input", {
                "onUpdate:modelValue": h[8] || (h[8] = (v) => o.value.youtube = v),
                placeholder: "https://www.youtube.com/@PIXVOICES",
                class: "mt-[4px] outline-0 border-2 border-black rounded-full w-full px-[12px] py-[6px] font-semibold",
                type: "text"
              }, null, 512), [
                [St, o.value.youtube]
              ])
            ]),
            p("div", $4, [
              h[26] || (h[26] = p("div", { class: "text-[14px] font-bold" }, "Twitter (optional)", -1)),
              gt(p("input", {
                "onUpdate:modelValue": h[9] || (h[9] = (v) => o.value.twitter = v),
                placeholder: "https://x.com/pixvoices",
                class: "mt-[4px] outline-0 border-2 border-black rounded-full w-full px-[12px] py-[6px] font-semibold",
                type: "text"
              }, null, 512), [
                [St, o.value.twitter]
              ])
            ]),
            p("div", H4, [
              _e(pp, {
                onClick: h[10] || (h[10] = (v) => c("social")),
                loading: t.value,
                class: "bg-[#2e38e7] text-white font-semibold px-[12px] py-[8px] rounded-full"
              }, {
                default: vt(() => h[27] || (h[27] = [
                  tn(" Save All Changes ")
                ])),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ])
      ]);
    };
  }
}), z4 = { class: "relative z-10" }, W4 = { class: "fixed inset-0 overflow-hidden" }, q4 = { class: "absolute inset-0 overflow-hidden" }, j4 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-[40px]" }, V4 = { class: "pointer-events-auto relative w-[384px]" }, G4 = { class: "absolute left-0 top-0 -ml-[32px] flex pr-[8px] pt-[16px] sm:-ml-[40px] sm:pr-[16px]" }, K4 = { class: "h-full overflow-y-auto bg-white" }, _m = /* @__PURE__ */ Un({
  __name: "Index",
  props: {
    openState: { type: Boolean }
  },
  emits: ["update:openState"],
  setup(e, { expose: t, emit: n }) {
    const s = n, o = e, a = dt("main"), c = dt(!1), u = () => {
      c.value = !1, s("update:openState", c.value);
    };
    return Br(() => o.openState, (h, m) => {
      h !== c.value && (c.value = h), c.value && (a.value = "main");
    }, {
      // deep: true,
      immediate: !0
    }), t({ showAccountMenu: (h) => {
      h && (a.value = "main"), c.value = h;
    } }), Zn(() => {
    }), (h, m) => (O(), fn(en(xm), {
      as: "template",
      show: c.value
    }, {
      default: vt(() => [
        p("div", z4, [
          _e(en(Ko), {
            as: "template",
            enter: "ease-in-out duration-500",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in-out duration-500",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: vt(() => m[1] || (m[1] = [
              p("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
            ])),
            _: 1
          }),
          p("div", W4, [
            p("div", q4, [
              p("div", j4, [
                _e(en(Ko), {
                  as: "template",
                  enter: "transform transition ease-in-out duration-500 sm:duration-700",
                  "enter-from": "translate-x-full",
                  "enter-to": "translate-x-0",
                  leave: "transform transition ease-in-out duration-500 sm:duration-700",
                  "leave-from": "translate-x-0",
                  "leave-to": "translate-x-full"
                }, {
                  default: vt(() => [
                    p("div", V4, [
                      _e(en(Ko), {
                        as: "template",
                        enter: "ease-in-out duration-500",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-500",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: vt(() => [
                          p("div", G4, [
                            p("button", {
                              type: "button",
                              class: "relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white",
                              onClick: u
                            }, [
                              m[2] || (m[2] = p("span", { class: "absolute -inset-[10px]" }, null, -1)),
                              m[3] || (m[3] = p("span", { class: "sr-only" }, "Close panel", -1)),
                              _e(en(Jk), {
                                class: "size-[24px]",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      p("div", K4, [
                        a.value === "main" ? (O(), fn(v4, {
                          key: 0,
                          onGoPage: m[0] || (m[0] = (v) => a.value = v.url)
                        })) : le("", !0),
                        a.value === "editMyGallery" ? (O(), fn(U4, { key: 1 })) : le("", !0)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]));
  }
}), Y4 = { class: "pt-10" }, X4 = /* @__PURE__ */ Un({
  __name: "index",
  setup(e) {
    const t = dt(!1), n = () => {
      t.value = !t.value, console.log(t.value, " openState.value");
    };
    return (s, o) => (O(), P("div", Y4, [
      p("span", {
        class: "text-red-500 text-xl font-bold",
        onClick: n
      }, "Open Menu - " + fe(t.value), 1),
      _e(_m, {
        openState: t.value,
        "onUpdate:openState": o[0] || (o[0] = (a) => t.value = a)
      }, null, 8, ["openState"])
    ]));
  }
}), J4 = EC({
  history: rC("/"),
  routes: [
    {
      path: "/pages/diy-commodity",
      name: "commodity",
      component: C6
    },
    {
      path: "/pages/diy-workbench",
      name: "workbench",
      component: VI
    },
    {
      path: "/pages/mydiydesign",
      name: "diyDesign",
      component: dE
    },
    {
      path: "/pages/diydesignFeatured",
      name: "diyDesignFeatured",
      component: XE
    },
    {
      path: "/pages/shopApply",
      name: "shopApply",
      component: sT
    },
    {
      path: "/pages/mydiyshop",
      name: "shop",
      component: nk
    },
    {
      path: "/pages/shopFeatured",
      name: "ShopFeatured",
      component: pk
    },
    {
      path: "/pages/diy-brokerage",
      name: "brokerage",
      component: Ok
    },
    {
      path: "/pages/cusAccountMenu",
      name: "cusAccountMenu",
      component: X4
    }
  ]
});
Jc(Pg);
function tR(e, t) {
  const n = Jc(Pg);
  n.use(I2()), n.use(J4), t != null && t.onTokenExpired && (n.config.globalProperties.$onTokenExpired = t.onTokenExpired);
  const s = document.createElement("div"), o = e.attachShadow({ mode: "open" });
  function a() {
    return [...document.querySelectorAll("style")].map((u) => u.textContent).join(`
`);
  }
  const c = document.createElement("style");
  return c.textContent = rx + `
` + a(), o.appendChild(c), o.appendChild(s), n.mount(s), n;
}
const Z4 = '/*! tailwindcss v4.0.14 | MIT License | https://tailwindcss.com */:root{--vt-c-white:#fff;--vt-c-white-soft:#f8f8f8;--vt-c-white-mute:#f2f2f2;--vt-c-black:#181818;--vt-c-black-soft:#222;--vt-c-black-mute:#282828;--vt-c-indigo:#2c3e50;--vt-c-divider-light-1:#3c3c3c4a;--vt-c-divider-light-2:#3c3c3c1f;--vt-c-divider-dark-1:#545454a6;--vt-c-divider-dark-2:#5454547a;--vt-c-text-light-1:var(--vt-c-indigo);--vt-c-text-light-2:#3c3c3ca8;--vt-c-text-dark-1:var(--vt-c-white);--vt-c-text-dark-2:#ebebeba3;--color-background:var(--vt-c-white);--color-background-soft:var(--vt-c-white-soft);--color-background-mute:var(--vt-c-white-mute);--color-border:var(--vt-c-divider-light-2);--color-border-hover:var(--vt-c-divider-light-1);--color-heading:var(--vt-c-text-light-1);--color-text:var(--vt-c-text-light-1);--section-gap:160px}@media (prefers-color-scheme:dark){:root{--color-background:var(--vt-c-black);--color-background-soft:var(--vt-c-black-soft);--color-background-mute:var(--vt-c-black-mute);--color-border:var(--vt-c-divider-dark-2);--color-border-hover:var(--vt-c-divider-dark-1);--color-heading:var(--vt-c-text-dark-1);--color-text:var(--vt-c-text-dark-2)}}body{min-height:100vh;color:var(--color-text);background:var(--color-background);text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;font-size:15px;line-height:1.6;transition:color .5s,background-color .5s}@layer theme{:root,:host{--font-sans:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";--font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--color-red-500:oklch(.637 .237 25.331);--color-gray-300:oklch(.872 .01 258.338);--color-gray-500:oklch(.551 .027 264.364);--color-black:#000;--color-white:#fff;--spacing:.25rem;--text-sm:.875rem;--text-sm--line-height:calc(1.25/.875);--text-base:1rem;--text-base--line-height: 1.5 ;--text-xl:1.25rem;--text-xl--line-height:calc(1.75/1.25);--font-weight-semibold:600;--font-weight-bold:700;--font-weight-black:900;--radius-sm:.25rem;--radius-md:.375rem;--ease-in-out:cubic-bezier(.4,0,.2,1);--default-transition-duration:.15s;--default-transition-timing-function:cubic-bezier(.4,0,.2,1);--default-font-family:var(--font-sans);--default-font-feature-settings:var(--font-sans--font-feature-settings);--default-font-variation-settings:var(--font-sans--font-variation-settings);--default-mono-font-family:var(--font-mono);--default-mono-font-feature-settings:var(--font-mono--font-feature-settings);--default-mono-font-variation-settings:var(--font-mono--font-variation-settings)}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}body{line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::-moz-placeholder{opacity:1;color:color-mix(in oklab,currentColor 50%,transparent)}::placeholder{opacity:1;color:color-mix(in oklab,currentColor 50%,transparent)}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){-webkit-appearance:button;-moz-appearance:button;appearance:button}::file-selector-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}}@layer components;@layer utilities{.pointer-events-auto{pointer-events:auto}.pointer-events-none{pointer-events:none}.sr-only{clip:rect(0,0,0,0);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.absolute{position:absolute}.fixed{position:fixed}.relative{position:relative}.-inset-\\[10px\\]{top:-10px;right:-10px;bottom:-10px;left:-10px}.inset-0{inset:calc(var(--spacing)*0)}.inset-y-0{inset-block:calc(var(--spacing)*0)}.top-0{top:calc(var(--spacing)*0)}.top-\\[50\\%\\]{top:50%}.right-0{right:calc(var(--spacing)*0)}.bottom-\\[50\\%\\]{bottom:50%}.left-0{left:calc(var(--spacing)*0)}.left-1\\/2{left:50%}.left-\\[10px\\]{left:10px}.left-\\[50\\%\\]{left:50%}.z-10{z-index:10}.mx-auto{margin-inline:auto}.mt-1{margin-top:calc(var(--spacing)*1)}.mt-2{margin-top:calc(var(--spacing)*2)}.mt-\\[4px\\]{margin-top:4px}.mt-\\[8px\\]{margin-top:8px}.mt-\\[10px\\]{margin-top:10px}.mt-\\[12px\\]{margin-top:12px}.mt-\\[15px\\]{margin-top:15px}.mt-\\[16px\\]{margin-top:16px}.mt-\\[28px\\]{margin-top:28px}.mr-\\[4px\\]{margin-right:4px}.mb-\\[20px\\]{margin-bottom:20px}.-ml-\\[32px\\]{margin-left:-32px}.line-clamp-1{-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.block{display:block}.flex{display:flex}.grid{display:grid}.hidden{display:none}.inline-flex{display:inline-flex}.size-5{width:calc(var(--spacing)*5);height:calc(var(--spacing)*5)}.size-\\[24px\\]{width:24px;height:24px}.h-6{height:calc(var(--spacing)*6)}.h-\\[20px\\]{height:20px}.h-\\[28px\\]{height:28px}.h-\\[40px\\]{height:40px}.h-\\[58px\\]{height:58px}.h-\\[280px\\]{height:280px}.h-full{height:100%}.max-h-full{max-height:100%}.w-6{width:calc(var(--spacing)*6)}.w-\\[20px\\]{width:20px}.w-\\[28px\\]{width:28px}.w-\\[40px\\]{width:40px}.w-\\[58px\\]{width:58px}.w-\\[80\\%\\]{width:80%}.w-\\[93\\%\\]{width:93%}.w-\\[100dvw\\]{width:100dvw}.w-\\[384px\\]{width:384px}.w-full{width:100%}.max-w-\\[480px\\]{max-width:480px}.max-w-\\[1200px\\]{max-width:1200px}.max-w-full{max-width:100%}.flex-1{flex:1}.flex-grow{flex-grow:1}.-translate-x-1\\/2,.-translate-x-2\\/4{--tw-translate-x: -50% ;translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-x-0{--tw-translate-x:calc(var(--spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-x-full{--tw-translate-x:100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.-translate-y-\\[50\\%\\]{--tw-translate-y: -50% ;translate:var(--tw-translate-x)var(--tw-translate-y)}.rotate-\\[40deg\\]{rotate:40deg}.transform{transform:var(--tw-rotate-x)var(--tw-rotate-y)var(--tw-rotate-z)var(--tw-skew-x)var(--tw-skew-y)}.cursor-pointer{cursor:pointer}.resize{resize:both}.resize-none{resize:none}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-center{align-items:center}.justify-between{justify-content:space-between}.justify-center{justify-content:center}.gap-\\[6px\\]{gap:6px}.gap-\\[8px\\]{gap:8px}.gap-\\[10px\\]{gap:10px}.gap-\\[12px\\]{gap:12px}.gap-\\[15px\\]{gap:15px}.gap-\\[16px\\]{gap:16px}.gap-x-\\[12px\\]{-moz-column-gap:12px;column-gap:12px}.gap-y-\\[8px\\]{row-gap:8px}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.rounded-full{border-radius:3.40282e38px}.rounded-md{border-radius:var(--radius-md)}.rounded-sm{border-radius:var(--radius-sm)}.border{border-style:var(--tw-border-style);border-width:1px}.border-2,.border-\\[2px\\]{border-style:var(--tw-border-style);border-width:2px}.border-r{border-right-style:var(--tw-border-style);border-right-width:1px}.border-b{border-bottom-style:var(--tw-border-style);border-bottom-width:1px}.border-\\[rgba\\(46\\,56\\,231\\,0\\.5\\)\\]{border-color:#2e38e780}.border-black{border-color:var(--color-black)}.border-black\\/20{border-color:color-mix(in oklab,var(--color-black)20%,transparent)}.border-black\\/30{border-color:color-mix(in oklab,var(--color-black)30%,transparent)}.border-black\\/50{border-color:color-mix(in oklab,var(--color-black)50%,transparent)}.bg-\\[\\#2e38e7\\]{background-color:#2e38e7}.bg-\\[\\#242833\\]{background-color:#242833}.bg-\\[\\#f8f8f8\\]{background-color:#f8f8f8}.bg-\\[rgba\\(46\\,56\\,231\\,0\\.1\\)\\]{background-color:#2e38e71a}.bg-black\\/10{background-color:color-mix(in oklab,var(--color-black)10%,transparent)}.bg-gray-500\\/75{background-color:color-mix(in oklab,var(--color-gray-500)75%,transparent)}.bg-white{background-color:var(--color-white)}.fill-black{fill:var(--color-black)}.fill-white{fill:var(--color-white)}.p-\\[8px\\]{padding:8px}.p-\\[24px\\]{padding:24px}.px-3{padding-inline:calc(var(--spacing)*3)}.px-\\[4px\\]{padding-inline:4px}.px-\\[5px\\]{padding-inline:5px}.px-\\[6px\\]{padding-inline:6px}.px-\\[8px\\]{padding-inline:8px}.px-\\[12px\\]{padding-inline:12px}.px-\\[16px\\]{padding-inline:16px}.px-\\[20px\\]{padding-inline:20px}.px-\\[24px\\]{padding-inline:24px}.px-\\[32px\\]{padding-inline:32px}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-\\[2px\\]{padding-block:2px}.py-\\[4px\\]{padding-block:4px}.py-\\[6px\\]{padding-block:6px}.py-\\[8px\\]{padding-block:8px}.py-\\[12px\\]{padding-block:12px}.py-\\[20px\\]{padding-block:20px}.pt-10{padding-top:calc(var(--spacing)*10)}.pt-\\[16px\\]{padding-top:16px}.pt-\\[20px\\]{padding-top:20px}.pr-\\[8px\\]{padding-right:8px}.pr-\\[10px\\]{padding-right:10px}.pr-\\[40px\\]{padding-right:40px}.pb-\\[12px\\]{padding-bottom:12px}.pb-\\[30px\\]{padding-bottom:30px}.pl-\\[10px\\]{padding-left:10px}.pl-\\[40px\\]{padding-left:40px}.text-center{text-align:center}.text-base{font-size:var(--text-base);line-height:var(--tw-leading,var(--text-base--line-height))}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.text-xl{font-size:var(--text-xl);line-height:var(--tw-leading,var(--text-xl--line-height))}.text-\\[0\\.7rem\\]{font-size:.7rem}.text-\\[10px\\]{font-size:10px}.text-\\[11px\\]{font-size:11px}.text-\\[12px\\]{font-size:12px}.text-\\[13px\\]{font-size:13px}.text-\\[14px\\]{font-size:14px}.text-\\[16px\\]{font-size:16px}.text-\\[18px\\]{font-size:18px}.text-\\[20px\\]{font-size:20px}.text-\\[29px\\]{font-size:29px}.leading-\\[20px\\]{--tw-leading:20px;line-height:20px}.font-black{--tw-font-weight:var(--font-weight-black);font-weight:var(--font-weight-black)}.font-bold{--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.text-\\[\\#2e38e7\\]{color:#2e38e7}.text-black{color:var(--color-black)}.text-gray-300{color:var(--color-gray-300)}.text-red-500{color:var(--color-red-500)}.text-white{color:var(--color-white)}.italic{font-style:italic}.line-through{text-decoration-line:line-through}.opacity-0{opacity:0}.opacity-60{opacity:.6}.opacity-100{opacity:1}.outline{outline-style:var(--tw-outline-style);outline-width:1px}.outline-0{outline-style:var(--tw-outline-style);outline-width:0}.transition{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,-webkit-backdrop-filter,backdrop-filter;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-opacity{transition-property:opacity;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.duration-500{--tw-duration:.5s;transition-duration:.5s}.ease-in-out{--tw-ease:var(--ease-in-out);transition-timing-function:var(--ease-in-out)}@media (hover:hover){.hover\\:text-white:hover{color:var(--color-white)}.hover\\:opacity-80:hover{opacity:.8}}.focus\\:ring-2:focus{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(2px + var(--tw-ring-offset-width))var(--tw-ring-color,currentColor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus\\:ring-white:focus{--tw-ring-color:var(--color-white)}.focus\\:outline-none:focus{--tw-outline-style:none;outline-style:none}@media (width>=40rem){.sm\\:-ml-\\[40px\\]{margin-left:-40px}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:pr-\\[16px\\]{padding-right:16px}.sm\\:duration-700{--tw-duration:.7s;transition-duration:.7s}}@media (width>=48rem){.md\\:text-\\[12px\\]{font-size:12px}}@media (width>=64rem){.lg\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}}}.animate-rotating{animation:1.5s linear infinite rotating}@keyframes rotating{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@property --tw-translate-x{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-y{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-z{syntax:"*";inherits:false;initial-value:0}@property --tw-rotate-x{syntax:"*";inherits:false;initial-value:rotateX(0)}@property --tw-rotate-y{syntax:"*";inherits:false;initial-value:rotateY(0)}@property --tw-rotate-z{syntax:"*";inherits:false;initial-value:rotateZ(0)}@property --tw-skew-x{syntax:"*";inherits:false;initial-value:skewX(0)}@property --tw-skew-y{syntax:"*";inherits:false;initial-value:skewY(0)}@property --tw-border-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-outline-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-duration{syntax:"*";inherits:false}@property --tw-ease{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}';
function nR(e, t) {
  const n = Jc(_m);
  t != null && t.onTokenExpired && (n.config.globalProperties.$onTokenExpired = t.onTokenExpired);
  const s = document.createElement("div"), o = e.attachShadow({ mode: "open" });
  function a() {
    return [...document.querySelectorAll("style")].map((u) => u.textContent).join(`
`);
  }
  const c = document.createElement("style");
  return c.textContent = Z4 + `
` + a(), o.appendChild(c), o.appendChild(s), n.mount(s);
}
export {
  nR as renderAccountMenu,
  tR as renderApp
};
